
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("48Eol", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $b9k8w = parcelRequire("b9k8w");


var $9Zall = parcelRequire("9Zall");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $gyUf8 = parcelRequire("gyUf8");


var $gtMdU = parcelRequire("gtMdU");










const $db51e5cdbc5c7da8$export$79cc7820899d3234 = /*#__PURE__*/ (0, $cozmU.createContext)(false);



var $fvwa0 = parcelRequire("fvwa0");

const $71c85943ef41ca73$export$797f6437373337da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, value: value } = t0;
    const isCustomIsFhsEnabled = (0, $cozmU.useContext)((0, $db51e5cdbc5c7da8$export$79cc7820899d3234));
    if (isCustomIsFhsEnabled) throw new Error("A custom value for IsFhsEnabledContext has already been provided");
    let t1;
    if ($[0] !== children || $[1] !== value) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db51e5cdbc5c7da8$export$79cc7820899d3234).Provider, {
            value: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fvwa0.IsFhsEnabledContext).Provider, {
            value: value
        }, children));
        $[0] = children;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, value: value })=>{
    const isCustomIsFhsEnabled = (0, $cozmU.useContext)((0, $db51e5cdbc5c7da8$export$79cc7820899d3234));
    if (isCustomIsFhsEnabled) throw new Error('A custom value for IsFhsEnabledContext has already been provided');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db51e5cdbc5c7da8$export$79cc7820899d3234).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fvwa0.IsFhsEnabledContext).Provider, {
        value: value
    }, children));
};



var $b0qTi = parcelRequire("b0qTi");











var $hekY6 = parcelRequire("hekY6");


var $ixfCV = parcelRequire("ixfCV");


var $eaAhc = parcelRequire("eaAhc");


var $1fHIr = parcelRequire("1fHIr");


var $liCgE = parcelRequire("liCgE");


var $4aMCy = parcelRequire("4aMCy");


var $kPxjF = parcelRequire("kPxjF");


var $b24kF = parcelRequire("b24kF");


var $eyPWA = parcelRequire("eyPWA");

const $5660beed5219c07c$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat",
    fullHeightSidebar: "_1pby11wp"
}; /**
    * The banner layout area. It will always be displayed at the top of the screen.
    *
    * Should be used to render a `Banner` component from `@atlaskit/banner`.
    */ 
const $5660beed5219c07c$export$3b4e64e77073e307 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Banner(t0) {
    const $ = (0, $bDgLe.c)(23);
    const { children: children, xcss: xcss, height: t1, skipLinkLabel: t2, testId: testId, id: providedId } = t0;
    const height = t1 === undefined ? 48 : t1;
    const skipLinkLabel = t2 === undefined ? "Banner" : t2;
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    let t3;
    if ($[0] !== providedId) {
        t3 = {
            providedId: providedId
        };
        $[0] = providedId;
        $[1] = t3;
    } else t3 = $[1];
    const id = (0, $eyPWA.useLayoutId)(t3);
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    let t4;
    if ($[2] !== height) {
        t4 = height === 0 || (0, $ixfCV.fg)("platform_dst_nav4_skip_link_a11y_1");
        $[2] = height;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== id || $[5] !== skipLinkLabel || $[6] !== t4) {
        t5 = {
            id: id,
            label: skipLinkLabel,
            isHidden: t4
        };
        $[4] = id;
        $[5] = skipLinkLabel;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    (0, $eaAhc.useSkipLinkInternal)(t5);
    const t6 = isFhsEnabled && $5660beed5219c07c$var$styles.fullHeightSidebar;
    let t7;
    if ($[8] !== t6 || $[9] !== xcss) {
        t7 = (0, $hekY6.default)([
            $5660beed5219c07c$var$styles.root,
            t6,
            xcss
        ]);
        $[8] = t6;
        $[9] = xcss;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== height) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $kPxjF.HoistCssVarToLocalGrid), {
            variableName: (0, $liCgE.bannerMountedVar),
            value: height
        });
        $[11] = height;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== dangerouslyHoistSlotSizes || $[14] !== height) {
        t9 = dangerouslyHoistSlotSizes && /*#__PURE__*/ $cozmU.createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, $liCgE.UNSAFE_bannerVar),
            value: height
        });
        $[13] = dangerouslyHoistSlotSizes;
        $[14] = height;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== children || $[17] !== id || $[18] !== t7 || $[19] !== t8 || $[20] !== t9 || $[21] !== testId) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: id,
            "data-layout-slot": true,
            className: t7,
            "data-testid": testId
        }, t8, t9, children);
        $[16] = children;
        $[17] = id;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
        $[21] = testId;
        $[22] = t10;
    } else t10 = $[22];
    return t10;
} : function Banner({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = 48, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    const id = (0, $eyPWA.useLayoutId)({
        providedId: providedId
    });
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)(); /**
                                           * Don't show the skip link if the slot has 0 height.
                                           *
                                           * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
                                           */ 
    (0, $eaAhc.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0 || (0, $ixfCV.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $hekY6.default)([
            $5660beed5219c07c$var$styles.root,
            isFhsEnabled && $5660beed5219c07c$var$styles.fullHeightSidebar,
            xcss
        ]),
        "data-testid": testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $kPxjF.HoistCssVarToLocalGrid), {
        variableName: (0, $liCgE.bannerMountedVar),
        value: height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ $cozmU.createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $liCgE.UNSAFE_bannerVar),
        value: height
    }), children);
};



var $dyjRd = parcelRequire("dyjRd");


var $31TvY = parcelRequire("31TvY");


var $9wGTI = parcelRequire("9wGTI");


var $58PBI = parcelRequire("58PBI");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7xVCs = parcelRequire("7xVCs");


var $5XPyz = parcelRequire("5XPyz");


var $hrAmX = parcelRequire("hrAmX");


var $cgsIj = parcelRequire("cgsIj");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $1C7kY = parcelRequire("1C7kY");


var $3u0dr = parcelRequire("3u0dr");











var $2ot3O = parcelRequire("2ot3O");





var $jsuJ9 = parcelRequire("jsuJ9");


var $28WJb = parcelRequire("28WJb");


var $lRhY3 = parcelRequire("lRhY3");




const $36b11f7822ba6f88$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    panelSplitter: {
        id: "preview-panel-api.resize.label",
        defaultMessage: "Resize panel"
    }
});


const $2c25ef82052c394f$var$PreviewPanelSplitter = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const intl = (0, $kSwu1.useIntl)();
    const { setPanelWidth: setPanelWidth } = (0, $lRhY3.usePreviewPanelsActions)();
    let t0;
    if ($[0] !== setPanelWidth) {
        t0 = (t1)=>{
            const { finalWidth: finalWidth } = t1;
            setPanelWidth(finalWidth);
        };
        $[0] = setPanelWidth;
        $[1] = t0;
    } else t0 = $[1];
    const onResizeEnd = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage((0, $36b11f7822ba6f88$export$defe85febe8b728c).panelSplitter);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== onResizeEnd || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), {
            label: t1,
            onResizeEnd: onResizeEnd
        });
        $[4] = onResizeEnd;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const { setPanelWidth: setPanelWidth } = (0, $lRhY3.usePreviewPanelsActions)();
    const onResizeEnd = (0, $cozmU.useCallback)(({ finalWidth: finalWidth })=>{
        setPanelWidth(finalWidth);
    }, [
        setPanelWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), {
        label: intl.formatMessage((0, $36b11f7822ba6f88$export$defe85febe8b728c).panelSplitter),
        onResizeEnd: onResizeEnd
    });
};
const $2c25ef82052c394f$var$NavWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, width: width } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c25ef82052c394f$var$PreviewPanelSplitter, null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== width) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0qTi.Panel), {
            defaultWidth: width
        }, t1, children);
        $[1] = children;
        $[2] = width;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0qTi.Panel), {
        defaultWidth: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c25ef82052c394f$var$PreviewPanelSplitter, null), children);
const $2c25ef82052c394f$export$f143b4bd86d1e004 = (0, $3u0dr.isReactCompilerActiveV2)() ? function PreviewPanelContainer() {
    const $ = (0, $bDgLe.c)(5);
    const panel = (0, $28WJb.useCurrentPreviewPanel)();
    if (panel == null) return null;
    const { content: PanelContent, width: width } = panel;
    let t0;
    if ($[0] !== PanelContent) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ot3O.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PanelContent, null));
        $[0] = PanelContent;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0 || $[3] !== width) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c25ef82052c394f$var$NavWrapper, {
            width: width
        }, t0);
        $[2] = t0;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : function PreviewPanelContainer() {
    const panel = (0, $28WJb.useCurrentPreviewPanel)();
    if (panel == null) return null;
    const { content: PanelContent, width: width } = panel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c25ef82052c394f$var$NavWrapper, {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ot3O.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PanelContent, null)));
};



var $6mKj3 = parcelRequire("6mKj3");


var $4vI1F = parcelRequire("4vI1F");


var $jvYFk = parcelRequire("jvYFk");


var $aWwYt = parcelRequire("aWwYt");


var $2vuKf = parcelRequire("2vuKf");


var $8zMP3 = parcelRequire("8zMP3");


var $fZAJP = parcelRequire("fZAJP");


var $jAOzg = parcelRequire("jAOzg");





var $ep3mz = parcelRequire("ep3mz");








var $bpufi = parcelRequire("bpufi");


var $ftFOj = parcelRequire("ftFOj");

/**
 * Inner component that runs the sync hook. Kept separate so the ErrorBoundary
 * above it can catch any errors thrown during the hook's execution without
 * taking down the rest of the page layout.
 */ const $3260f1cb149f21d4$var$SmartFolderAncestorSyncInner = ({ contentId: contentId })=>{
    (0, $bpufi.useSmartFolderAncestorSync)(contentId);
    return null;
};
const $3260f1cb149f21d4$export$2e1f52d6d7a935bc = ({ contentId: contentId })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isSmartFoldersEnabled: isSmartFoldersEnabled } = (0, $ftFOj.useIsSmartFoldersEnabled)(spaceKey);
    if (!isSmartFoldersEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3260f1cb149f21d4$var$SmartFolderAncestorSyncInner, {
        contentId: contentId
    }));
};









var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $lFjPc = parcelRequire("lFjPc");

const $bd996ec529999f47$export$ac3e7903e24ee02d = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { view: view, children: children, navVersion: navVersion } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== experienceTracker || $[1] !== navVersion) {
        t1 = (name)=>experienceTracker.abort({
                name: name,
                reason: "navigation container view changed",
                attributes: {
                    navVersion: navVersion
                }
            });
        $[0] = experienceTracker;
        $[1] = navVersion;
        $[2] = t1;
    } else t1 = $[2];
    const abortExp = t1;
    let t2;
    if ($[3] !== experienceTracker || $[4] !== navVersion) {
        t2 = (name_0)=>experienceTracker.start({
                name: name_0,
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: navVersion
                }
            });
        $[3] = experienceTracker;
        $[4] = navVersion;
        $[5] = t2;
    } else t2 = $[5];
    const startExp = t2;
    let t3;
    let t4;
    if ($[6] !== abortExp || $[7] !== startExp || $[8] !== view) {
        t3 = ()=>{
            bb6: switch(view){
                case 0, $lFjPc.CONTAINER_HOME_ID:
                    startExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    break bb6;
                case 0, $lFjPc.PRODUCT_HOME_ID:
                case 0, $lFjPc.PRODUCT_ADDONS_ID:
                    abortExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    break bb6;
                case 0, $lFjPc.ADMIN_HOME_ID:
                    startExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
            }
        };
        t4 = [
            view,
            startExp,
            abortExp
        ];
        $[6] = abortExp;
        $[7] = startExp;
        $[8] = view;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    let t6;
    if ($[11] !== startExp) {
        t5 = ()=>{
            startExp((0, $irVI7.APP_NAV_GLOBAL_EXPERIENCE));
        };
        t6 = [
            startExp
        ];
        $[11] = startExp;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $cozmU.useLayoutEffect)(t5, t6);
    let t7;
    if ($[14] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[14] = children;
        $[15] = t7;
    } else t7 = $[15];
    return t7;
};












var $9DHhW = parcelRequire("9DHhW");


var $a1L5E = parcelRequire("a1L5E");


var $kz1Yj = parcelRequire("kz1Yj");














var $jYwSK = parcelRequire("jYwSK");


var $1o3CH = parcelRequire("1o3CH");











var $9EOlJ = parcelRequire("9EOlJ");


var $64VTj = parcelRequire("64VTj");


var $9bYqt = parcelRequire("9bYqt");

// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)

























const $d7827ca4fe42bedf$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("9z9Sl")),
    da: ()=>(parcelRequire("kdftj")),
    de: ()=>(parcelRequire("Is4v8")),
    en: ()=>Promise.resolve((parcelRequire("9bYqt"))),
    'en-GB': ()=>(parcelRequire("78Q3c")),
    'en-ZZ': ()=>(parcelRequire("1bED2")),
    es: ()=>(parcelRequire("7qcoz")),
    fi: ()=>(parcelRequire("aruDH")),
    fr: ()=>(parcelRequire("ebEFX")),
    hu: ()=>(parcelRequire("j1P3i")),
    it: ()=>(parcelRequire("96lDB")),
    ja: ()=>(parcelRequire("7xpIz")),
    ko: ()=>(parcelRequire("kDdpi")),
    nb: ()=>(parcelRequire("furxn")),
    nl: ()=>(parcelRequire("1xorX")),
    pl: ()=>(parcelRequire("a8BIS")),
    'pt-BR': ()=>(parcelRequire("2L1sx")),
    ru: ()=>(parcelRequire("ctn08")),
    sv: ()=>(parcelRequire("abBcf")),
    th: ()=>(parcelRequire("9XDV4")),
    tr: ()=>(parcelRequire("7p3hh")),
    uk: ()=>(parcelRequire("gqOnY")),
    vi: ()=>(parcelRequire("gMVzI")),
    zh: ()=>(parcelRequire("fnG5V")),
    'zh-TW': ()=>(parcelRequire("d3dgL"))
};


const $62d8f7e2bf3ae1c6$export$e4882a930a0d91f2 = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $d7827ca4fe42bedf$export$3770c7a7737d463c) ? locale : locale.replace(/-/g, '_') in (0, $d7827ca4fe42bedf$export$3770c7a7737d463c) ? locale.replace(/-/g, '_') : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $d7827ca4fe42bedf$export$3770c7a7737d463c)[languageLocale]?.();
        return localeMessages?.default ?? (0, $9bYqt.default);
    } catch (e) {
    // ignore
    }
    return 0, $9bYqt.default;
};


















var $I7hWB = parcelRequire("I7hWB");


var $2wCqQ = parcelRequire("2wCqQ");

var $6Pqow = parcelRequire("6Pqow");






const $f40e5e073a099109$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    errorStateHeading: {
        id: "navigation.global-invite.error-state-heading",
        defaultMessage: "We can't load the invite list right now"
    },
    errorStateDescription: {
        id: "navigation.global-invite.error-state-description",
        defaultMessage: "Try refreshing the page or contact us if the problem persists."
    }
});


const $07d827fb36a0f134$var$styles = (0, $buxP3.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100',
    textAlign: 'center'
});
const $07d827fb36a0f134$export$c1ed4f415b9e7023 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorState() {
    const $ = (0, $bDgLe.c)(11);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $f40e5e073a099109$export$defe85febe8b728c).errorStateHeading);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage((0, $f40e5e073a099109$export$defe85febe8b728c).errorStateDescription);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.default), {
            size: "small",
            color: "color.text.subtle"
        }, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $2wCqQ.default), {
            space: "space.050",
            testId: "global-invite--error-state",
            xcss: $07d827fb36a0f134$var$styles
        }, t1, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : function ErrorState() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $2wCqQ.default), {
        space: "space.050",
        testId: "global-invite--error-state",
        xcss: $07d827fb36a0f134$var$styles
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $f40e5e073a099109$export$defe85febe8b728c).errorStateHeading)), /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $f40e5e073a099109$export$defe85febe8b728c).errorStateDescription)));
};






















var $a9aSv = parcelRequire("a9aSv");


var $9GVkD = parcelRequire("9GVkD");




const $c8d51695e79dec85$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    loadingLabel: {
        id: "navigation.global-invite.loading-visually-hidden-label",
        defaultMessage: "Loading"
    }
});


const $4a6133b8f42476bc$var$styles = (0, $buxP3.xcss)({
    paddingBlock: 'space.500',
    paddingInline: 'space.300'
});
const $4a6133b8f42476bc$export$62aa48085237e36f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoadingState() {
    const $ = (0, $bDgLe.c)(8);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = Array.from({
            length: 5
        }, $4a6133b8f42476bc$var$_temp);
        $[0] = t0;
    } else t0 = $[0];
    const items = t0;
    let t1;
    if ($[1] !== formatMessage) {
        t1 = formatMessage((0, $c8d51695e79dec85$export$defe85febe8b728c).loadingLabel);
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $2wCqQ.default), {
            space: "space.100",
            testId: "skeleton-group"
        }, items);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t2) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $3izAL.default), {
            xcss: $4a6133b8f42476bc$var$styles,
            testId: "global-invite--loading-state"
        }, t2, t3);
        $[6] = t2;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : function LoadingState() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            isShimmering: true,
            width: "100%",
            height: "var(--ds-space-200, 16px)",
            testId: "skeleton-shimmering",
            key: index
        }));
    return /*#__PURE__*/ $cozmU.createElement((0, $3izAL.default), {
        xcss: $4a6133b8f42476bc$var$styles,
        testId: "global-invite--loading-state"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, formatMessage((0, $c8d51695e79dec85$export$defe85febe8b728c).loadingLabel)), /*#__PURE__*/ $cozmU.createElement((0, $2wCqQ.default), {
        space: "space.100",
        testId: "skeleton-group"
    }, items));
};
function $4a6133b8f42476bc$var$_temp(_, index) {
    return /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        isShimmering: true,
        width: "100%",
        height: "var(--ds-space-200, 16px)",
        testId: "skeleton-shimmering",
        key: index
    });
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $852mP = parcelRequire("852mP");





var $ad7Ou = parcelRequire("ad7Ou");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $aRGok = parcelRequire("aRGok");

const $ec4769fe605d5191$export$bb76aeb9f599715c = 'global-invite';
const $ec4769fe605d5191$export$7622d28bacf170d1 = 'modal-dialog';
const $ec4769fe605d5191$export$1dab7caa4b20a4cc = 'trigger-element';
const $ec4769fe605d5191$export$85183a312807388d = 'navigation';


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 



var $eq1BO = parcelRequire("eq1BO");

function $11f1795bb9e02885$export$804bcbe0913c6ba3({ product: product, children: children }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $eq1BO.NavigationAnalyticsContext), {
        data: {
            componentName: 'globalInvite',
            source: 'globalInviteButton',
            product: product
        }
    }, children);
}





const $65fb141c89aa0f68$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    modalDialogLabel: {
        id: "navigation.global-invite.modal-dialog-label",
        defaultMessage: "Invite people"
    }
});


function $87f81968be2f8255$export$2d7d84d397d9a585(Content) {
    return function ModalDialog({ testId: testId = (0, $ec4769fe605d5191$export$bb76aeb9f599715c), triggerElement: TriggerElement, children: children, ...props }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const [isModalDialogOpen, setIsModalDialogOpen] = (0, $cozmU.useState)(false);
        const [adminHasNavigatedAway, setAdminHasNavigatedAway] = (0, $cozmU.useState)(false);
        const openModalDialog = (0, $cozmU.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'globalInviteButton',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $ec4769fe605d5191$export$85183a312807388d));
            setIsModalDialogOpen(true);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const onAdminMenuItemClick = (0, $cozmU.useCallback)((event)=>{
            // See packages/people-and-teams/invite-people/src/components/DropdownMenu/AdminMenuGroup.tsx for where these items are created.
            // Handle the click event happening on a link directly, or on an inner <span> or similar
            const isLink = event?.target?.tagName === 'A';
            const link = isLink ? event?.target : event?.target?.closest('a');
            if (link && (link?.getAttribute('target') === 'new' || link?.getAttribute('target') === '_blank')) setAdminHasNavigatedAway(true);
        }, []);
        const onCancel = (0, $cozmU.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: adminHasNavigatedAway ? 'closed' : 'cancelled',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $ec4769fe605d5191$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product,
            adminHasNavigatedAway
        ]);
        const onInviteCompleted = (0, $cozmU.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: 'completed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $ec4769fe605d5191$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const focusDialog = (0, $cozmU.useCallback)((node)=>{
            // Focus the dialog's container when it finishes opening
            node.focus();
        }, []);
        return /*#__PURE__*/ $cozmU.createElement((0, $11f1795bb9e02885$export$804bcbe0913c6ba3), {
            product: props.product
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId
        }, TriggerElement ? /*#__PURE__*/ $cozmU.createElement(TriggerElement, {
            onClick: openModalDialog
        }) : /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            shouldFitContainer: true,
            onClick: openModalDialog,
            testId: `${testId}--${(0, $ec4769fe605d5191$export$1dab7caa4b20a4cc)}`
        }, children), /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isModalDialogOpen ? /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            width: "small",
            shouldScrollInViewport: true,
            shouldReturnFocus: true,
            onClose: onCancel,
            onOpenComplete: focusDialog,
            label: formatMessage((0, $65fb141c89aa0f68$export$defe85febe8b728c).modalDialogLabel),
            testId: `${testId}--${(0, $ec4769fe605d5191$export$7622d28bacf170d1)}`
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement(Content, {
            onAdminMenuItemClick: onAdminMenuItemClick,
            onCancel: onCancel,
            onInviteCompleted: onInviteCompleted,
            ...props
        }))) : null)));
    };
}



const $f329be46c63c86a6$var$LazyGlobalInviteModalDialogContentWithRelayProvider = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("1WtoY")).then((module)=>({
            default: module.ModalDialogContentWithRelayProvider
        })));
const $f329be46c63c86a6$var$AsyncGlobalInviteModalDialogContentWithRelayProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AsyncGlobalInviteModalDialogContentWithRelayProvider(props) {
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $07d827fb36a0f134$export$c1ed4f415b9e7023), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $4a6133b8f42476bc$export$62aa48085237e36f), null);
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        const modalContent = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t0
        }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: t1
        }, /*#__PURE__*/ $cozmU.createElement($f329be46c63c86a6$var$LazyGlobalInviteModalDialogContentWithRelayProvider, props)));
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $64VTj.default), {
            defaultMessages: (0, $9bYqt.default),
            loaderFn: (0, $62d8f7e2bf3ae1c6$export$e4882a930a0d91f2)
        }, modalContent);
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function AsyncGlobalInviteModalDialogContentWithRelayProvider(props) {
    const modalContent = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $07d827fb36a0f134$export$c1ed4f415b9e7023), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $4a6133b8f42476bc$export$62aa48085237e36f), null)
    }, /*#__PURE__*/ $cozmU.createElement($f329be46c63c86a6$var$LazyGlobalInviteModalDialogContentWithRelayProvider, props)));
    return /*#__PURE__*/ $cozmU.createElement((0, $64VTj.default), {
        defaultMessages: (0, $9bYqt.default),
        loaderFn: (0, $62d8f7e2bf3ae1c6$export$e4882a930a0d91f2)
    }, modalContent);
};
const $f329be46c63c86a6$export$73b6b212789f5472 = (0, $87f81968be2f8255$export$2d7d84d397d9a585)($f329be46c63c86a6$var$AsyncGlobalInviteModalDialogContentWithRelayProvider);




// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $i834V = parcelRequire("i834V");




var $b3j2Y = parcelRequire("b3j2Y");





var $hSqtY = parcelRequire("hSqtY");


var $1uFM6 = parcelRequire("1uFM6");





var $8YePs = parcelRequire("8YePs");


var $7aRa9 = parcelRequire("7aRa9");


var $jFFx4 = parcelRequire("jFFx4");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $de2j9 = parcelRequire("de2j9");


var $jmjWc = parcelRequire("jmjWc");


const $f92bf53981932d65$export$347b3004b45f815 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "x9Mbz",
    name: "AdminNavigationLoader",
    loader: async ()=>(await (parcelRequire("7PhZc"))).AdminNavigation
});












var $f922E = parcelRequire("f922E");








var $5avUB = parcelRequire("5avUB");





var $gmhHk = parcelRequire("gmhHk");

var $4X3mP = parcelRequire("4X3mP");


var $huaOC = parcelRequire("huaOC");





var $dVkip = parcelRequire("dVkip");





var $iKskQ = parcelRequire("iKskQ");


var $bQm3c = parcelRequire("bQm3c");





var $hXDOc = parcelRequire("hXDOc");














var $eKMV3 = parcelRequire("eKMV3");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");




var $428fe8ea2d2b2297$exports = {};
$428fe8ea2d2b2297$exports = new URL("starred-spaces-telescope.6256ddfc.svg", import.meta.url).toString();


const $4a3f9d0dfa2492b5$var$SOURCE = 'starredSpacesEmptyState';
const $4a3f9d0dfa2492b5$var$styles = {
    emptyState: "_2rko1mok _bfhkhfxm _1bsb1osq",
    emptyStateContent: "_1bsb1osq",
    emptyStateIcon: "_1reoewfl _18m9ewfl _4cvr1h6o _1e0c1txw _1o9zidpf _4t3izwfg _1bah1h6o _kqswh2mm _1bsbzwfg",
    emptyStateIconImage: "_1e0c1ule _1ltvze3t _kqswstnw _154ir5cr",
    emptyStateText: "_16jlkb7n _1ul9idpf",
    emptyStateAction: "_1bsb1osq"
};
const $4a3f9d0dfa2492b5$var$i18n = (0, $kSwu1.defineMessages)({
    emptyStateExploreSpacesDescription: {
        id: "side-navigation.starred-spaces-list.empty-state-explore-spaces-description",
        defaultMessage: "Star spaces to keep them here for quick access."
    },
    exploreSpaces: {
        id: "side-navigation.starred-spaces-list.empty-state-explore-spaces",
        defaultMessage: "Explore spaces"
    }
});
const $4a3f9d0dfa2492b5$export$3f0aa198e68feb23 = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { onExploreSpacesClick: onExploreSpacesClick } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "starredSpacesEmptyStateScreen",
                    source: $4a3f9d0dfa2492b5$var$SOURCE,
                    attributes: {
                        navVersion: "4"
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent
        ];
        $[0] = createAnalyticsEvent;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyStateIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            as: "img",
            alt: "",
            "aria-hidden": "true",
            height: "39",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($428fe8ea2d2b2297$exports))),
            width: "41",
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyStateIconImage
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            space: "space.200",
            shouldWrap: false,
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyStateContent
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyStateText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4a3f9d0dfa2492b5$var$i18n.emptyStateExploreSpacesDescription))));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $1NBp8.SPACE_DIRECTORY).toUrl();
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== intl) {
        t6 = intl.formatMessage($4a3f9d0dfa2492b5$var$i18n.exploreSpaces);
        $[6] = intl;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== onExploreSpacesClick || $[9] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            paddingBlock: "space.150",
            paddingInline: "space.150",
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            alignInline: "center",
            space: "space.100"
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $4a3f9d0dfa2492b5$var$styles.emptyStateAction
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            spacing: "compact",
            shouldFitContainer: true,
            href: t5,
            onClick: onExploreSpacesClick
        }, t6))));
        $[8] = onExploreSpacesClick;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    return t7;
};

















const $60de7f0fe776e4b8$export$a6ddf69d627430ea = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            paddingBlockStart: "space.075",
            paddingInlineStart: "space.075",
            testId: "loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};


const $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics = (createAnalyticsEvent, navVersion, options = {})=>{
    const { componentType: componentType, itemId: itemId, itemType: itemType, section: section } = options;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'spacesNavigationMenuItem',
            source: 'globalNavigation',
            attributes: {
                navigationLayer: 'global',
                navigationContainer: 'sidebar',
                navVersion: navVersion,
                componentType: componentType,
                itemId: itemId,
                itemType: itemType,
                section: section
            }
        }
    }).fire();
};
const $38b2da651c37b412$var$StarredSpacesListComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { flags: flags } = t0;
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== isLicensed) {
        t1 = {
            isLicensed: isLicensed
        };
        $[0] = isLicensed;
        $[1] = t1;
    } else t1 = $[1];
    const { starredSpaces: starredSpaces, error: error, loading: loading } = (0, $dVkip.useStarredData)(t1);
    const isStarredSpacesEmpty = !loading && starredSpaces.length === 0;
    let t2;
    if ($[2] !== isStarredSpacesEmpty) {
        t2 = isStarredSpacesEmpty && (0, $6mKj3.expVal)("cc_mohiti_nav_empty_states", "isEnabled", false);
        $[2] = isStarredSpacesEmpty;
        $[3] = t2;
    } else t2 = $[3];
    const isMohitiEmptyStateEnabled = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent) {
        t3 = ()=>{
            $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics(createAnalyticsEvent, "4", {
                componentType: "fixedItem",
                itemId: "viewAllSpaces",
                section: "starredSpaces"
            });
        };
        $[4] = createAnalyticsEvent;
        $[5] = t3;
    } else t3 = $[5];
    const onViewAllClick = t3;
    let t4;
    if ($[6] !== createAnalyticsEvent) {
        t4 = ()=>{
            $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics(createAnalyticsEvent, "4", {
                componentType: "fixedItem",
                itemId: "exploreSpaces",
                section: "starredSpaces"
            });
        };
        $[6] = createAnalyticsEvent;
        $[7] = t4;
    } else t4 = $[7];
    const onExploreSpacesClick = t4;
    let t5;
    if ($[8] !== createAnalyticsEvent) {
        t5 = (spaceId)=>{
            $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics(createAnalyticsEvent, "4", {
                componentType: "customItem",
                itemType: "space",
                itemId: spaceId,
                section: "starredSpaces"
            });
        };
        $[8] = createAnalyticsEvent;
        $[9] = t5;
    } else t5 = $[9];
    const onStarredSpaceItemClick = t5;
    let t6;
    let t7;
    if ($[10] !== error || $[11] !== flags || $[12] !== loading) {
        t6 = ()=>{
            if (!loading && error) flags.showErrorFlag({
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $38b2da651c37b412$var$i18n.errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $38b2da651c37b412$var$i18n.errorFlagDescription),
                isAutoDismiss: true
            });
        };
        t7 = [
            loading,
            error,
            flags
        ];
        $[10] = error;
        $[11] = flags;
        $[12] = loading;
        $[13] = t6;
        $[14] = t7;
    } else {
        t6 = $[13];
        t7 = $[14];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4X3mP.MenuSectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $38b2da651c37b412$var$i18n.title));
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== loading) {
        t9 = loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60de7f0fe776e4b8$export$a6ddf69d627430ea), null);
        $[16] = loading;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== intl || $[19] !== isMohitiEmptyStateEnabled || $[20] !== isStarredSpacesEmpty || $[21] !== onExploreSpacesClick) {
        t10 = isStarredSpacesEmpty && (isMohitiEmptyStateEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a3f9d0dfa2492b5$export$3f0aa198e68feb23), {
            onExploreSpacesClick: onExploreSpacesClick
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            padding: "space.100",
            xcss: $38b2da651c37b412$var$emptySpacesTextStyles
        }, intl.formatMessage($38b2da651c37b412$var$i18n.empty)));
        $[18] = intl;
        $[19] = isMohitiEmptyStateEnabled;
        $[20] = isStarredSpacesEmpty;
        $[21] = onExploreSpacesClick;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== loading || $[24] !== onStarredSpaceItemClick || $[25] !== starredSpaces) {
        t11 = !loading && starredSpaces && starredSpaces.map((space)=>{
            const spaceAlias = space.alias || space.key;
            const url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                spaceKey: spaceAlias
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
                key: space.id,
                name: "starred-spaces",
                preloadUrl: url,
                preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
                key: space.id,
                href: url,
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKskQ.SpaceIcon), {
                    size: "xsmall",
                    src: space.icon?.path
                }),
                onClick: ()=>onStarredSpaceItemClick(space.id)
            }, space.name));
        });
        $[23] = loading;
        $[24] = onStarredSpaceItemClick;
        $[25] = starredSpaces;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== isMohitiEmptyStateEnabled || $[28] !== isStarredSpacesEmpty || $[29] !== loading || $[30] !== onViewAllClick) {
        t12 = !loading && (!isMohitiEmptyStateEnabled || !isStarredSpacesEmpty) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: (0, $1NBp8.SPACE_DIRECTORY).toUrl(),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onViewAllClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $38b2da651c37b412$var$i18n.viewAll));
        $[27] = isMohitiEmptyStateEnabled;
        $[28] = isStarredSpacesEmpty;
        $[29] = loading;
        $[30] = onViewAllClick;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmhHk.MenuSection), null, t8, t9, t10, t11, t12);
        $[32] = t10;
        $[33] = t11;
        $[34] = t12;
        $[35] = t9;
        $[36] = t13;
    } else t13 = $[36];
    return t13;
};
const $38b2da651c37b412$export$79ffca654f6ab234 = (0, $7aRa9.withFlags)($38b2da651c37b412$var$StarredSpacesListComponent);
const $38b2da651c37b412$var$emptySpacesTextStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small'
});
const $38b2da651c37b412$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "side-navigation.starred-spaces-list.title",
        defaultMessage: "Starred spaces"
    },
    viewAll: {
        id: "side-navigation.starred-spaces-list.view-all",
        defaultMessage: "View all spaces"
    },
    empty: {
        id: "side-navigation.starred-spaces-list.empty-message",
        defaultMessage: "Spaces you star will appear here"
    },
    errorFlagTitle: {
        id: "side-navigation.starred-spaces-list.error-flag-title",
        defaultMessage: "We couldn\u2019t load starred spaces"
    },
    errorFlagDescription: {
        id: "side-navigation.starred-spaces-list.error-flag-description",
        defaultMessage: "We are unable to show your spaces at this time. Refresh the page or try again."
    }
});






const $4ad4ea954990a797$export$9c64eb3c7e74d13c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zC56Y",
    loader: async ()=>(await (parcelRequire("gx8UM"))).HubSettingsNavigation,
    name: 'HubSettingsNavigation'
});









var $37EF7 = parcelRequire("37EF7");














var $feuG2 = parcelRequire("feuG2");


var $cLo2u = parcelRequire("cLo2u");

const $5a5cd25c242b4596$var$SpaceAdminNavigationInternal = ()=>{
    const $ = (0, $bDgLe.c)(13);
    const spaceAlias = (0, $cLo2u.useSpaceKey)();
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = (0, $37EF7.usePageLayoutResize)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { location: location, matchRoute: matchRoute } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const t0 = location?.pathname || "";
    let t1;
    if ($[0] !== matchRoute || $[1] !== t0) {
        t1 = matchRoute(t0);
        $[0] = matchRoute;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const route = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent || $[4] !== isLeftSidebarCollapsed || $[5] !== route?.name) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "spaceAdminSideNavigation",
                    attributes: {
                        tab: route?.name || "",
                        isVisible: !isLeftSidebarCollapsed
                    }
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = isLeftSidebarCollapsed;
        $[5] = route?.name;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = route?.name;
    let t4;
    if ($[7] !== createAnalyticsEvent || $[8] !== isLeftSidebarCollapsed || $[9] !== t3) {
        t4 = [
            createAnalyticsEvent,
            isLeftSidebarCollapsed,
            t3
        ];
        $[7] = createAnalyticsEvent;
        $[8] = isLeftSidebarCollapsed;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    (0, $cozmU.useEffect)(t2, t4);
    const t5 = spaceAlias || "";
    let t6;
    if ($[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $feuG2.SpaceSettingsSideNavigation), {
            spaceAlias: t5
        });
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
};
const $5a5cd25c242b4596$export$a5608b5e4da20698 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a5cd25c242b4596$var$SpaceAdminNavigationInternal, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};












var $7boqA = parcelRequire("7boqA");


var $1uFsv = parcelRequire("1uFsv");


const $4ccde8579962336f$var$GlobalNavigationLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6E8ob",
    name: "GlobalNavigationLoader",
    loader: async ()=>(await (parcelRequire("6cDI5"))).GlobalNavigationComponent
});
const $4ccde8579962336f$export$796d3395e4dcf32b = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $1uFsv.GLOBAL_NAVIGATION_METRIC)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ccde8579962336f$var$GlobalNavigationLoader, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};



var $2qRJj = parcelRequire("2qRJj");


var $l65Bo = parcelRequire("l65Bo");


var $6GD8y = parcelRequire("6GD8y");


var $bflGB = parcelRequire("bflGB");


var $gnkil = parcelRequire("gnkil");





var $cEgMD = parcelRequire("cEgMD");





var $hQnHK = parcelRequire("hQnHK");





var $efvKr = parcelRequire("efvKr");








var $l3wuH = parcelRequire("l3wuH");


var $4ez2K = parcelRequire("4ez2K");


var $1sCHt = parcelRequire("1sCHt");







const $ba0fa5890838b7bb$export$ee8ecac8c80214c1 = ()=>{
    const [closedMessage, setClosedMessage] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    (0, $cozmU.useEffect)(()=>{
        if (closedMessage) setClosedMessage(false);
    // Should only fire when spaceKey changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceKey
    ]);
    if (closedMessage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNavFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        justifyContent: "space-between",
        testId: "anonymous-access-side-nav-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ba0fa5890838b7bb$var$i18n.anonymousAccessMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        onClick: ()=>setClosedMessage(true),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                size: "small"
            }),
        label: intl.formatMessage($ba0fa5890838b7bb$var$i18n.close),
        appearance: "subtle",
        spacing: "compact"
    })));
};
const $ba0fa5890838b7bb$var$i18n = (0, $kSwu1.defineMessages)({
    anonymousAccessMessage: {
        id: "anonymous-access.anonymous-access-side-nav-message.text",
        // TODO: Fix the direction of the curly quote below. (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "You\u2018re viewing this with anonymous access, so some content might be blocked."
    },
    close: {
        id: "anonymous-access.anonymous-access-side-nav-message.close",
        defaultMessage: "Close"
    }
});



var $gsSsC = parcelRequire("gsSsC");


var $jMyy4 = parcelRequire("jMyy4");

const $da0a91219ee54603$export$b1d9964175452d0b = ({ spaceKey: spaceKey, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $gsSsC.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skipQuery || !spaceKey,
        __callerPackage__: "@confluence/anonymous-access"
    });
    // For restricted spaces the preloader's query returns a 403 which Apollo evicts from
    // its cache. This leaves `useQueryInterop` in a perpetual `loading: true` state during
    // SSR, while on the client the same query resolves with `loading: false` and
    // `space: null`. The resulting mismatch causes a hydration error in the SideNav footer.
    //
    // The preloader detects this case and persists the space key in a global
    // (`__RESTRICTED_SPACES_FROM_PRELOAD__`). When present, we short-circuit here so both
    // SSR and client agree on `{ loading: false, isUserViewingSpaceAsAnon: false }`.
    const restrictedSpaces = typeof window !== 'undefined' ? window.__RESTRICTED_SPACES_FROM_PRELOAD__ : globalThis.__RESTRICTED_SPACES_FROM_PRELOAD__;
    if (restrictedSpaces?.[spaceKey]) return {
        isUserViewingSpaceAsAnon: false,
        loading: false,
        error: undefined
    };
    return {
        isUserViewingSpaceAsAnon: Boolean(data?.space?.currentUser?.isAnonymouslyAuthorized),
        loading: loading,
        error: error
    };
};


/**
 * @generated SignedSource<<b48ad5572e4ea5894a5dcaf2de279ab8>>
 * @relayHash a912afe2fbea3fe5bd99ea14ca3598df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80dee9f42627028b3fd3b3f9eb8acb3b8bd154a05615cec731d0c14c85c65b4b
const $068b1fe48e1495bf$var$node = function() {
    var v0 = [
        {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "licenseConsumingUserCount"
                },
                {
                    "kind": "ScalarField",
                    "name": "trialEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a912afe2fbea3fe5bd99ea14ca3598df",
            "id": "80dee9f42627028b3fd3b3f9eb8acb3b8bd154a05615cec731d0c14c85c65b4b",
            "metadata": {},
            "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
            "operationKind": "query",
            "text": "query usePersistentInviteButtonEligibleLicenseDetailsQuery{license{licenseConsumingUserCount,trialEndDate}}"
        }
    };
}();
$068b1fe48e1495bf$var$node.hash = "ba822387cdd604c4581f577b0c57ca7a";
var $068b1fe48e1495bf$export$2e2bcd8739ae039 = $068b1fe48e1495bf$var$node;






var $2Zz3q = parcelRequire("2Zz3q");





var $euL71 = parcelRequire("euL71");


var $dPJCf = parcelRequire("dPJCf");




function $463b48fb68db8bff$export$b3cda0b328199f72() {
    const { edition: edition, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const skipLicenseQuery = isFreeEdition || !isLoggedIn || !isLicensed;
    const { refetch: refetch, data: licenseDetailsData, loading: licenseDetailsLoading, error: licenseDetailsDataError } = (0, $jMyy4.useQueryInterop)((0, $068b1fe48e1495bf$export$2e2bcd8739ae039), {
        skip: skipLicenseQuery,
        __callerPackage__: "@confluence/persistent-invite-button"
    });
    const trialDaysLeft = (0, $2Zz3q.getTrialDaysLeftFromTrialEndDate)(licenseDetailsData?.license?.trialEndDate);
    const isInTrial = trialDaysLeft ? trialDaysLeft > 0 : false;
    // Sometimes, the trial end date is not set on the initial load for a new tenant, even though they have been put into a trial.
    // This can lead to the invite button not appearing. To mitigate this, we refetch the license details on page transition if we
    // suspect the user is in a trial, but the trial end date is null.
    const transitionId = (0, $dPJCf.useTransitionId)();
    const hasRefetched = (0, $cozmU.useRef)(false);
    const initialTransitionId = (0, $cozmU.useRef)(transitionId);
    (0, $cozmU.useEffect)(()=>{
        if (isInTrial || skipLicenseQuery || licenseDetailsLoading || licenseDetailsDataError) return;
        const trialSuspected = Boolean(licenseDetailsData?.license?.trialEndDate === null && licenseDetailsData?.license?.licenseConsumingUserCount === 1 && !isFreeEdition);
        if (!hasRefetched.current && trialSuspected && transitionId > initialTransitionId.current) {
            refetch();
            hasRefetched.current = true;
        }
    }, [
        edition,
        isFreeEdition,
        isInTrial,
        isLicensed,
        isLoggedIn,
        licenseDetailsData,
        licenseDetailsDataError,
        licenseDetailsLoading,
        refetch,
        skipLicenseQuery,
        transitionId
    ]);
    return {
        loading: licenseDetailsLoading,
        error: licenseDetailsDataError,
        isEligible: isInTrial || isFreeEdition
    };
}



var $7Sm4c = parcelRequire("7Sm4c");













var $92JEG = parcelRequire("92JEG");


const $f542602a6e0f4176$export$4283c4ef2b834aa2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "USWMG",
    name: "Nav4CollapseReminderSpotlightLoader",
    loader: async ()=>(await (parcelRequire("6ZrZD"))).Nav4CollapseReminderSpotlight
});



var $4q9NN = parcelRequire("4q9NN");


var $gEtAQ = parcelRequire("gEtAQ");


var $b0EGa = parcelRequire("b0EGa");











const $95859b7288e22ff6$var$PlatformNavigationLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xsgSo",
    name: "PlatformNavigationLoader",
    loader: async ()=>(await (parcelRequire("kMYBP"))).PlatformNavigationComponent
});
const $95859b7288e22ff6$export$446e292f3fdcabd = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95859b7288e22ff6$var$PlatformNavigationLoader, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};



var $hrvfP = parcelRequire("hrvfP");











var $i3jcY = parcelRequire("i3jcY");








var $3jwuS = parcelRequire("3jwuS");










const $e486084baed62696$var$useShowRecap2025QueryParam = (0, $dPJCf.createSingleQueryParamHook)('showRecap2025');
const $e486084baed62696$export$7b73ec245f6c47f8 = ()=>{
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const showRecap2025QueryParam = $e486084baed62696$var$useShowRecap2025QueryParam();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEligible = showRecap2025QueryParam === 'open' && !isLivePage && isEditorPage;
    // Check if user has already collapsed the sidebar for recap before
    const hasCollapsedBefore = (0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_RECAP_SIDEBAR_COLLAPSED) === 'true';
    const shouldCollapse = isEligible && !hasCollapsedBefore;
    // Set the persisted flag when we determine we should collapse
    // This marks that the user has seen this behavior (first visit)
    (0, $cozmU.useEffect)(()=>{
        if (shouldCollapse && (0, $17wUi.confluenceLocalStorageInstance)) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_RECAP_SIDEBAR_COLLAPSED, 'true');
    }, [
        shouldCollapse
    ]);
    return shouldCollapse;
};



var $e4o8D = parcelRequire("e4o8D");




const $1b5aa9dc12e56400$export$444990cc7caeb4e0 = 320;
const $1b5aa9dc12e56400$export$6deddaa54d32585b = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const shouldCollapseForRecap = (0, $e486084baed62696$export$7b73ec245f6c47f8)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isAnonymousUser = !userId;
    if ((0, $i3jcY.isStableUIEnabledForTests)()) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                initialCollapsedState: "expanded",
                initialWidth: $1b5aa9dc12e56400$export$444990cc7caeb4e0,
                shouldForceExpand: true,
                needsPostHydrationCollapse: false
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) ?? "expanded";
        $[1] = t0;
    } else t0 = $[1];
    const persistedCollapseState = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH) || $1b5aa9dc12e56400$export$444990cc7caeb4e0;
        $[2] = t1;
    } else t1 = $[2];
    let persistedWidth = parseInt(t1, 10);
    if (Number.isNaN(persistedWidth)) persistedWidth = $1b5aa9dc12e56400$export$444990cc7caeb4e0;
    const isWidthTooLarge = persistedWidth > window.innerWidth;
    const fittedSidebarWidth = isWidthTooLarge ? $1b5aa9dc12e56400$export$444990cc7caeb4e0 : persistedWidth;
    if (isAnonymousUser && renderServerPlaceholder) {
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                initialCollapsedState: "expanded",
                initialWidth: fittedSidebarWidth,
                shouldForceExpand: false,
                needsPostHydrationCollapse: persistedCollapseState === "collapsed"
            };
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let initialCollapsedState;
    if (shouldCollapseForRecap) initialCollapsedState = "collapsed";
    else initialCollapsedState = persistedCollapseState;
    let t2;
    if ($[4] !== initialCollapsedState) {
        t2 = {
            initialCollapsedState: initialCollapsedState,
            initialWidth: fittedSidebarWidth,
            shouldForceExpand: false,
            needsPostHydrationCollapse: false
        };
        $[4] = initialCollapsedState;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};





// Paths
const $ba0a4d7f1b78ed67$export$4b542de2568592b5 = 'container/home/loading';
const $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae = 'container/home';
const $ba0a4d7f1b78ed67$export$c3f826fbea17177 = 'container/admin/home';
const $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b = 'container/admin/company-hub';
const $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1 = 'admin/home';
const $ba0a4d7f1b78ed67$export$823dfce5c2bceecb = 'product/home';


const $ad0ecba6dc7e91fa$export$ccd8c615ba434dec = ({ view: view })=>{
    const pageTreeUpdater = (0, $cozmU.useRef)();
    const scrollTree = (0, $cozmU.useCallback)(()=>{
        if (view === (0, $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae) && pageTreeUpdater.current) pageTreeUpdater.current.scrollToCurrentPage();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        view,
        pageTreeUpdater.current
    ]);
    return {
        pageTreeUpdater: pageTreeUpdater,
        scrollTree: scrollTree
    };
};




var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $6be64d70b45c3bb0$var$initialState = {
    isCollapsed: false
};
const $6be64d70b45c3bb0$var$actions = {
    setIsCollapsed: (collapsed)=>({ setState: setState })=>{
            setState({
                isCollapsed: collapsed
            });
        }
};
const $6be64d70b45c3bb0$export$c0c3c6fb1b0fe561 = (0, $8s9DV.createStore)({
    initialState: $6be64d70b45c3bb0$var$initialState,
    actions: $6be64d70b45c3bb0$var$actions
});
const $6be64d70b45c3bb0$export$7d924aef7db527f0 = (0, $kBr4q.createHook)($6be64d70b45c3bb0$export$c0c3c6fb1b0fe561);
const $6be64d70b45c3bb0$export$ee6f665bc19ef05d = (0, $kBr4q.createActionsHook)($6be64d70b45c3bb0$export$c0c3c6fb1b0fe561);









var $eGUIL = parcelRequire("eGUIL");




const $b524a1c7212bd91f$export$fc95973351613945 = ({ children: children })=>{
    const sideNavRef = (0, $cozmU.useRef)(null);
    const handleScrollToTop = (0, $cozmU.useCallback)(()=>{
        if (sideNavRef.current) sideNavRef.current.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [
        sideNavRef
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            sideNavRef: sideNavRef,
            handleScrollToTop: handleScrollToTop
        }), [
        sideNavRef,
        handleScrollToTop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eGUIL.SideNavigationContext).Provider, {
        value: contextValue
    }, (0, $9wGTI.fg)('navx-global-side-nav-confluence') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(children, {
        sideNavContentRef: sideNavRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNavBody), {
        testId: "side-navigation-content",
        ref: sideNavRef
    }, children));
};


const $b56ca6efd7e1c0fa$var$i18n = (0, $kSwu1.defineMessages)({
    dragHandle: {
        id: "page-layout.side-navigation.drag-handle",
        defaultMessage: "Side Navigation Drag Handle"
    },
    sideNavPanelSplitterTooltipContent: {
        id: "page-layout.side-navigation.side-nav-panel-splitter-tooltip-content",
        defaultMessage: "Double click to collapse"
    },
    globalInviteButtonLabel: {
        id: "page-layout.side-navigation.global-invite-button-label",
        defaultMessage: "Invite people"
    }
});
const $b56ca6efd7e1c0fa$var$resize = ()=>{
    window.dispatchEvent(new Event('resize'));
};
const $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcut = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { onToggleFromShortcut: onToggleFromShortcut } = t0;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const toggleSideNav = (0, $jYwSK.useToggleSideNav)();
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    let t2;
    if ($[0] !== onToggleFromShortcut || $[1] !== toggleSideNav) {
        t2 = ()=>{
            if (!(0, $l65Bo.isDialogShown)()) {
                onToggleFromShortcut();
                toggleSideNav();
            }
        };
        $[0] = onToggleFromShortcut;
        $[1] = toggleSideNav;
        $[2] = t2;
    } else t2 = $[2];
    const toggle = t2;
    let t3;
    if ($[3] !== isLiveEditMode || $[4] !== isOnEditRoute || $[5] !== toggle) {
        t3 = isLiveEditMode || isOnEditRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bflGB.ShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
            listener: toggle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
            deprecatedAccelerator: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT),
            listener: toggle
        });
        $[3] = isLiveEditMode;
        $[4] = isOnEditRoute;
        $[5] = toggle;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
/**
 * Used when full height sidebar (FHS) is enabled.
 * Uses the `Ctrl+[` shortcut that is built into the ADS navigation system, instead of Confluence's
 * own `Ctrl+[` shortcut (UNIVERSAL_SIDE_NAVIGATION_SHORTCUT).
 * But, we keep Confluence's `[` shortcut (SIDE_NAVIGATION_SHORTCUT) on non-edit routes, and display
 * an educational flag pointing to the new shortcut.
 */ const $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutFHS = (0, $7aRa9.withFlags)(({ flags: flags, onToggleFromShortcut: onToggleFromShortcut })=>{
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const toggleSideNav = (0, $jYwSK.useToggleSideNav)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const toggle = (0, $cozmU.useCallback)(()=>{
        if (!(0, $l65Bo.isDialogShown)()) {
            onToggleFromShortcut();
            toggleSideNav();
            // Show the educational flag for the `Ctrl+[` shortcut, when the `[` shortcut is used.
            (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT),
                accelerator: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
                deprecatedAccelerator: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT)
            });
        }
    }, [
        flags,
        onToggleFromShortcut,
        toggleSideNav
    ]);
    if (isLiveEditMode || isOnEditRoute) // Edit routes will still have the side nav shortcut that is built into the ADS SideNav component.
    return null;
    // Non-edit routes still have the `[` shortcut, which will eventually be deprecated.
    // An educational flag is shown during the transition process.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT),
        listener: toggle
    });
});
const $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutWithFG = (0, $8YePs.componentWithCondition)(()=>(0, $1fHIr.useIsFhsEnabled)(), $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutFHS, $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcut);
// When full height sidebar is enabled, the SideNavPanelSplitter component should be used.
// It supports double clicking to collapse the side nav.
const $b56ca6efd7e1c0fa$var$PanelSplitterWithFG = (0, $8YePs.componentWithCondition)(()=>(0, $1fHIr.useIsFhsEnabled)(), (0, $jYwSK.SideNavPanelSplitter), (0, $jsuJ9.PanelSplitter));
const $b56ca6efd7e1c0fa$var$useIsModeGlobal = ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] !== match?.query?.mode || $[1] !== spaceKey) {
        t0 = match?.query?.mode === "global" || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        $[0] = match?.query?.mode;
        $[1] = spaceKey;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
//todo: are all these views still relevant? I'm not certain they are
const $b56ca6efd7e1c0fa$var$getProductSideNavigation = (view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, unhandledError, isLicensed)=>{
    // hide product nav if mode=global unless we're on a settings page
    if (isModeGlobal && !isOnAnySettingsScreen) return null;
    switch(view){
        case 0, $ba0a4d7f1b78ed67$export$4b542de2568592b5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qRJj.SpaceNavigationLoadingSkeleton), null);
        case 0, $ba0a4d7f1b78ed67$export$c3f826fbea17177:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a5cd25c242b4596$export$a5608b5e4da20698), null);
        case 0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ad4ea954990a797$export$9c64eb3c7e74d13c), null);
        case 0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f92bf53981932d65$export$347b3004b45f815), null);
        case 0, $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qRJj.SpaceNavigation), {
                isSpaceSettingsScreen: isSpaceSettingsScreen,
                ...unhandledError && {
                    unhandledError: unhandledError
                },
                isBlogNavigation: (0, $gEtAQ.isBlogPage)()
            });
        default:
            return isLicensed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38b2da651c37b412$export$79ffca654f6ab234), null) : null;
    }
};
const $b56ca6efd7e1c0fa$var$PlatformNavigationInner = (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { view: view, isSpaceSettingsScreen: isSpaceSettingsScreen, onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd } = t0;
    let t1;
    if ($[0] !== view) {
        t1 = {
            view: view
        };
        $[0] = view;
        $[1] = t1;
    } else t1 = $[1];
    const { scrollTree: scrollTree } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t1);
    const isModeGlobal = $b56ca6efd7e1c0fa$var$useIsModeGlobal();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const isPageWithinSpaceSettings = view === (0, $ba0a4d7f1b78ed67$export$c3f826fbea17177);
    const isPageWithinSiteSettings = view === (0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1);
    const isHubSettingsScreen = view === (0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b);
    const isOnAnySettingsScreen = isPageWithinSpaceSettings || isPageWithinSiteSettings || isHubSettingsScreen;
    const t2 = spaceKey || "";
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon, loading: anonymousAccessQueryLoading, error: anonymousAccessQueryError } = (0, $da0a91219ee54603$export$b1d9964175452d0b)(t3);
    let t4;
    if ($[4] !== anonymousAccessQueryError || $[5] !== isLicensed || $[6] !== isModeGlobal || $[7] !== isOnAnySettingsScreen || $[8] !== isSpaceSettingsScreen || $[9] !== view) {
        t4 = $b56ca6efd7e1c0fa$var$getProductSideNavigation(view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, anonymousAccessQueryError, isLicensed);
        $[4] = anonymousAccessQueryError;
        $[5] = isLicensed;
        $[6] = isModeGlobal;
        $[7] = isOnAnySettingsScreen;
        $[8] = isSpaceSettingsScreen;
        $[9] = view;
        $[10] = t4;
    } else t4 = $[10];
    const productSideNavigation = t4;
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hrvfP.ConnectorPromoSidebarEntry), {
            isNav4: true
        });
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== anonymousAccessQueryError || $[13] !== anonymousAccessQueryLoading || $[14] !== isUserViewingSpaceAsAnon) {
        t6 = isUserViewingSpaceAsAnon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ba0fa5890838b7bb$export$ee8ecac8c80214c1), null) : !anonymousAccessQueryLoading && !anonymousAccessQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterWrapped, null);
        $[12] = anonymousAccessQueryError;
        $[13] = anonymousAccessQueryLoading;
        $[14] = isUserViewingSpaceAsAnon;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== productSideNavigation || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, productSideNavigation, t5, t6);
        $[16] = productSideNavigation;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $9wGTI.fg)("navx-global-side-nav-confluence") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i834V.PostOfficeConfluenceSideNavPlacement), null) : undefined;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== isOnAnySettingsScreen || $[21] !== onCollapse || $[22] !== onExpand || $[23] !== onPeekEnd || $[24] !== onPeekStart || $[25] !== scrollTree || $[26] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "side-nav"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95859b7288e22ff6$export$446e292f3fdcabd), {
            content: t7,
            hideGSN: isOnAnySettingsScreen,
            scrollTreeToCurrent: scrollTree,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            bottomElem: t8
        })));
        $[20] = isOnAnySettingsScreen;
        $[21] = onCollapse;
        $[22] = onExpand;
        $[23] = onPeekEnd;
        $[24] = onPeekStart;
        $[25] = scrollTree;
        $[26] = t7;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
};
const $b56ca6efd7e1c0fa$export$440c2b67033b2fbd = (t0)=>{
    const $ = (0, $bDgLe.c)(63);
    const { view: view, isSpaceSettingsScreen: isSpaceSettingsScreen, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, setTriggeredByShortcut: setTriggeredByShortcut } = t0;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const intl = (0, $kSwu1.useIntl)();
    const isModeGlobal = $b56ca6efd7e1c0fa$var$useIsModeGlobal();
    const { initialCollapsedState: initialCollapsedState, initialWidth: initialWidth, shouldForceExpand: shouldForceExpand, needsPostHydrationCollapse: needsPostHydrationCollapse } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const { saveCurrentRoute: saveCurrentRoute } = (0, $jFFx4.useSettingsBackButtonUtils)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isPageWithinSpaceSettings = view === (0, $ba0a4d7f1b78ed67$export$c3f826fbea17177);
    const isPageWithinSiteSettings = view === (0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1);
    const isHubSettingsScreen = view === (0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b);
    const isOnAnySettingsScreen = isPageWithinSpaceSettings || isPageWithinSiteSettings || isHubSettingsScreen;
    const toggleSideNav = (0, $jYwSK.useToggleSideNav)();
    let t1;
    let t2;
    if ($[0] !== needsPostHydrationCollapse || $[1] !== toggleSideNav) {
        t1 = ()=>{
            if (needsPostHydrationCollapse) toggleSideNav();
        };
        t2 = [
            needsPostHydrationCollapse,
            toggleSideNav
        ];
        $[0] = needsPostHydrationCollapse;
        $[1] = toggleSideNav;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const pressTracing = (0, $1o3CH.default)("side-nav-collapse-reminder-spotlight");
    const t3 = spaceKey || "";
    let t4;
    if ($[4] !== t3) {
        t4 = {
            spaceKey: t3
        };
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const { isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon, loading: anonymousAccessQueryLoading, error: anonymousAccessQueryError } = (0, $da0a91219ee54603$export$b1d9964175452d0b)(t4);
    const [t5] = (0, $6be64d70b45c3bb0$export$7d924aef7db527f0)();
    const { isCollapsed: isCollapsed } = t5;
    let t6;
    if ($[6] !== anonymousAccessQueryError || $[7] !== isLicensed || $[8] !== isModeGlobal || $[9] !== isOnAnySettingsScreen || $[10] !== isSpaceSettingsScreen || $[11] !== view) {
        t6 = $b56ca6efd7e1c0fa$var$getProductSideNavigation(view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, anonymousAccessQueryError, isLicensed);
        $[6] = anonymousAccessQueryError;
        $[7] = isLicensed;
        $[8] = isModeGlobal;
        $[9] = isOnAnySettingsScreen;
        $[10] = isSpaceSettingsScreen;
        $[11] = view;
        $[12] = t6;
    } else t6 = $[12];
    const productSideNavigation = t6;
    let t7;
    if ($[13] !== createAnalyticsEvent) {
        t7 = (t8)=>{
            const { initialWidth: initialWidth_0, finalWidth: finalWidth } = t8;
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "resized",
                    actionSubject: "spaceNavigation",
                    source: "containerNavigation",
                    attributes: {
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        initialWidth: initialWidth_0,
                        finalWidth: finalWidth
                    }
                }
            }).fire();
        };
        $[13] = createAnalyticsEvent;
        $[14] = t7;
    } else t7 = $[14];
    const fireSidebarResizeEndAnalytics = t7;
    let t8;
    if ($[15] !== setTriggeredByShortcut) {
        t8 = ()=>{
            setTriggeredByShortcut(true);
        };
        $[15] = setTriggeredByShortcut;
        $[16] = t8;
    } else t8 = $[16];
    const handleToggleFromShortcut = t8;
    if (!isPageWithinSpaceSettings && !isPageWithinSiteSettings && !isHubSettingsScreen) saveCurrentRoute();
    const { isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed } = (0, $92JEG.useHasDismissedNav4CollapseReminderSpotlight)();
    const canToggleWithShortcut = $b56ca6efd7e1c0fa$var$_temp;
    const t9 = isFhsEnabled ? undefined : initialCollapsedState === "collapsed";
    let t10;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = {
            errorBoundaryId: "sideNavigation-globalNavigation"
        };
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== isCollapsed || $[19] !== isOnAnySettingsScreen || $[20] !== productSideNavigation) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO,
            attributes: t10
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ccde8579962336f$export$796d3395e4dcf32b), {
            productSideNavigation: productSideNavigation,
            isOnAnySettingsScreen: isOnAnySettingsScreen,
            isCollapsed: isCollapsed
        }));
        $[18] = isCollapsed;
        $[19] = isOnAnySettingsScreen;
        $[20] = productSideNavigation;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== isNav4CollapseReminderSpotlightActive || $[23] !== setIsNav4CollapseReminderSpotlightActive) {
        t12 = isNav4CollapseReminderSpotlightActive && setIsNav4CollapseReminderSpotlightActive && !(0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f542602a6e0f4176$export$4283c4ef2b834aa2), {
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        });
        $[22] = isNav4CollapseReminderSpotlightActive;
        $[23] = setIsNav4CollapseReminderSpotlightActive;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== handleToggleFromShortcut || $[26] !== shouldForceExpand) {
        t13 = !shouldForceExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutWithFG, {
            onToggleFromShortcut: handleToggleFromShortcut
        });
        $[25] = handleToggleFromShortcut;
        $[26] = shouldForceExpand;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== fireSidebarResizeEndAnalytics || $[29] !== isNav4CollapseReminderSpotlightActive || $[30] !== isNav4CollapseReminderSpotlightDismissed || $[31] !== pressTracing || $[32] !== setIsNav4CollapseReminderSpotlightActive) {
        t14 = (t15)=>{
            const { initialWidth: initialWidth_1, finalWidth: finalWidth_0 } = t15;
            $b56ca6efd7e1c0fa$var$handleResizeEnd({
                finalWidth: finalWidth_0,
                eligibleForCollapseReminderSpotlight: !isNav4CollapseReminderSpotlightActive && !isNav4CollapseReminderSpotlightDismissed,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
                pressTracing: pressTracing
            });
            fireSidebarResizeEndAnalytics({
                initialWidth: initialWidth_1,
                finalWidth: finalWidth_0
            });
        };
        $[28] = fireSidebarResizeEndAnalytics;
        $[29] = isNav4CollapseReminderSpotlightActive;
        $[30] = isNav4CollapseReminderSpotlightDismissed;
        $[31] = pressTracing;
        $[32] = setIsNav4CollapseReminderSpotlightActive;
        $[33] = t14;
    } else t14 = $[33];
    let t15;
    if ($[34] !== intl) {
        t15 = intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.dragHandle);
        $[34] = intl;
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== intl || $[37] !== isFhsEnabled) {
        t16 = isFhsEnabled ? intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.sideNavPanelSplitterTooltipContent) : undefined;
        $[36] = intl;
        $[37] = isFhsEnabled;
        $[38] = t16;
    } else t16 = $[38];
    let t17;
    if ($[39] !== t14 || $[40] !== t15 || $[41] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$PanelSplitterWithFG, {
            onResizeEnd: t14,
            onResizeStart: $b56ca6efd7e1c0fa$var$onResizeStart,
            label: t15,
            testId: "side-navigation-panel-splitter",
            tooltipContent: t16
        });
        $[39] = t14;
        $[40] = t15;
        $[41] = t16;
        $[42] = t17;
    } else t17 = $[42];
    let t18;
    if ($[43] !== t11 || $[44] !== t12 || $[45] !== t13 || $[46] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, t11, t12, t13, t17);
        $[43] = t11;
        $[44] = t12;
        $[45] = t13;
        $[46] = t17;
        $[47] = t18;
    } else t18 = $[47];
    let t19;
    if ($[48] !== anonymousAccessQueryError || $[49] !== anonymousAccessQueryLoading || $[50] !== isUserViewingSpaceAsAnon) {
        t19 = isUserViewingSpaceAsAnon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ba0fa5890838b7bb$export$ee8ecac8c80214c1), null) : !anonymousAccessQueryLoading && !anonymousAccessQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterWrapped, null);
        $[48] = anonymousAccessQueryError;
        $[49] = anonymousAccessQueryLoading;
        $[50] = isUserViewingSpaceAsAnon;
        $[51] = t19;
    } else t19 = $[51];
    let t20;
    if ($[52] !== t18 || $[53] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "side-nav"
        }, t18, t19);
        $[52] = t18;
        $[53] = t19;
        $[54] = t20;
    } else t20 = $[54];
    let t21;
    if ($[55] !== initialWidth || $[56] !== onCollapse || $[57] !== onExpand || $[58] !== onPeekEnd || $[59] !== onPeekStart || $[60] !== t20 || $[61] !== t9) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNav), {
            defaultWidth: initialWidth,
            defaultCollapsed: t9,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            id: "side-navigation",
            canToggleWithShortcut: canToggleWithShortcut
        }, t20);
        $[55] = initialWidth;
        $[56] = onCollapse;
        $[57] = onExpand;
        $[58] = onPeekEnd;
        $[59] = onPeekStart;
        $[60] = t20;
        $[61] = t9;
        $[62] = t21;
    } else t21 = $[62];
    return t21;
};
const $b56ca6efd7e1c0fa$var$SideNavigationSkeleton = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const { initialCollapsedState: initialCollapsedState, initialWidth: initialWidth } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const t0 = isFhsEnabled ? undefined : initialCollapsedState === "collapsed";
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "side-nav-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qRJj.SpaceNavigationLoadingSkeleton), null)));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== initialWidth || $[2] !== t0) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNav), {
            defaultWidth: initialWidth,
            defaultCollapsed: t0,
            id: "side-navigation-skeleton"
        }, t1);
        $[1] = initialWidth;
        $[2] = t0;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $b56ca6efd7e1c0fa$export$cc4f63927c41742f = (props)=>{
    const $ = (0, $bDgLe.c)(27);
    const { setIsCollapsed: setIsCollapsed } = (0, $6be64d70b45c3bb0$export$ee6f665bc19ef05d)();
    const [triggeredByShortcut, setTriggeredByShortcut] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] !== props.view) {
        t0 = {
            view: props.view
        };
        $[0] = props.view;
        $[1] = t0;
    } else t0 = $[1];
    const { scrollTree: scrollTree } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t0);
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== isOnEditRoute) {
        t1 = (action, triggeredBy)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: action,
                    actionSubject: "spaceNavigation",
                    source: "containerNavigation",
                    attributes: {
                        isOnEditRoute: isOnEditRoute,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = isOnEditRoute;
        $[4] = t1;
    } else t1 = $[4];
    const fireSidebarToggleAnalytics = t1;
    let t2;
    if ($[5] !== fireSidebarToggleAnalytics || $[6] !== setIsCollapsed || $[7] !== triggeredByShortcut) {
        t2 = ()=>{
            if (!(0, $9wGTI.fg)("navx-global-side-nav-confluence")) {
                setIsCollapsed(true);
                (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, "collapsed");
            }
            $b56ca6efd7e1c0fa$var$resize();
            fireSidebarToggleAnalytics("collapsed", triggeredByShortcut ? "keyboardShortcut" : "click");
            setTriggeredByShortcut(false);
        };
        $[5] = fireSidebarToggleAnalytics;
        $[6] = setIsCollapsed;
        $[7] = triggeredByShortcut;
        $[8] = t2;
    } else t2 = $[8];
    const onCollapse = t2;
    let t3;
    if ($[9] !== fireSidebarToggleAnalytics || $[10] !== scrollTree || $[11] !== setIsCollapsed || $[12] !== triggeredByShortcut) {
        t3 = ()=>{
            if (!(0, $9wGTI.fg)("navx-global-side-nav-confluence")) {
                setIsCollapsed(false);
                (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, "expanded");
            }
            scrollTree();
            $b56ca6efd7e1c0fa$var$resize();
            fireSidebarToggleAnalytics("expanded", triggeredByShortcut ? "keyboardShortcut" : "click");
            setTriggeredByShortcut(false);
        };
        $[9] = fireSidebarToggleAnalytics;
        $[10] = scrollTree;
        $[11] = setIsCollapsed;
        $[12] = triggeredByShortcut;
        $[13] = t3;
    } else t3 = $[13];
    const onExpand = t3;
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    let t4;
    if ($[14] !== requestHideOmniBar) {
        t4 = ()=>{
            if ((0, $9wGTI.fg)("cc-engagement-omnibar-hide-sidebar-flyout")) requestHideOmniBar();
        };
        $[14] = requestHideOmniBar;
        $[15] = t4;
    } else t4 = $[15];
    const onPeekStart = t4;
    let t5;
    if ($[16] !== releaseHideOmniBar) {
        t5 = ()=>{
            if ((0, $9wGTI.fg)("cc-engagement-omnibar-hide-sidebar-flyout")) releaseHideOmniBar();
        };
        $[16] = releaseHideOmniBar;
        $[17] = t5;
    } else t5 = $[17];
    const onPeekEnd = t5;
    let t6;
    let t7;
    if ($[18] !== releaseHideOmniBar) {
        t6 = ()=>()=>{
                if ((0, $9wGTI.fg)("cc-engagement-omnibar-hide-sidebar-flyout")) releaseHideOmniBar();
            };
        t7 = [
            releaseHideOmniBar
        ];
        $[18] = releaseHideOmniBar;
        $[19] = t6;
        $[20] = t7;
    } else {
        t6 = $[19];
        t7 = $[20];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[21] !== onCollapse || $[22] !== onExpand || $[23] !== onPeekEnd || $[24] !== onPeekStart || $[25] !== props) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $9wGTI.fg)("navx-global-side-nav-confluence") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "side-navigation",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavigationSkeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$PlatformNavigationInner, {
            view: props.view,
            isSpaceSettingsScreen: props.isSpaceSettingsScreen,
            onCollapse: onCollapse,
            onExpand: onExpand,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "side-navigation",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavigationSkeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$export$440c2b67033b2fbd, {
            ...props,
            onCollapse: onCollapse,
            onExpand: onExpand,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            setTriggeredByShortcut: setTriggeredByShortcut
        })));
        $[21] = onCollapse;
        $[22] = onExpand;
        $[23] = onPeekEnd;
        $[24] = onPeekStart;
        $[25] = props;
        $[26] = t8;
    } else t8 = $[26];
    return t8;
};
const $b56ca6efd7e1c0fa$var$getSideNavContent = ()=>{
    // Because we render the PostOfficeConfluenceSideNavPlacement in the bottomElem of the PlatformNavigation when navx-global-side-nav-confluence is enabled, we don't want to render it twice in the SideNavFooter.
    return !(0, $9wGTI.fg)('navx-global-side-nav-confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i834V.PostOfficeConfluenceSideNavPlacement), null);
};
const $b56ca6efd7e1c0fa$var$SideNavFooterWrapped = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, $b56ca6efd7e1c0fa$var$getSideNavContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterContent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $b56ca6efd7e1c0fa$var$globalInviteButtonStyles = (0, $buxP3.xcss)({
    flexGrow: 1
});
const $b56ca6efd7e1c0fa$var$Nav4SideNavFooterContent = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b56ca6efd7e1c0fa$var$globalInviteButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f329be46c63c86a6$export$73b6b212789f5472), {
        product: "confluence",
        showFlag: flags.showFlag
    }, intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.globalInviteButtonLabel))));
});
const $b56ca6efd7e1c0fa$var$SideNavFooterContent = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { error: error, loading: loading, isEligible: isEligible } = (0, $463b48fb68db8bff$export$b3cda0b328199f72)();
    if (loading) return null;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else {
            let t0;
            if ($[0] !== error) {
                t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
                $[0] = error;
                $[1] = t0;
            } else t0 = $[1];
            return t0;
        }
    }
    let t0;
    if ($[2] !== isEligible) {
        t0 = isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNavFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NAVX
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56ca6efd7e1c0fa$var$Nav4SideNavFooterContent, null)));
        $[2] = isEligible;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
// CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
// Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
const $b56ca6efd7e1c0fa$var$onResizeStart = ()=>{
    if (typeof document !== 'undefined') document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.setProperty('pointer-events', 'none');
};
const $b56ca6efd7e1c0fa$var$handleResizeEnd = ({ finalWidth: finalWidth, eligibleForCollapseReminderSpotlight: eligibleForCollapseReminderSpotlight, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, pressTracing: pressTracing })=>{
    // CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
    // Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
    if (typeof document !== 'undefined') document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.removeProperty('pointer-events');
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH, finalWidth);
    if (eligibleForCollapseReminderSpotlight) {
        pressTracing();
        setIsNav4CollapseReminderSpotlightActive?.(true);
    }
};
function $b56ca6efd7e1c0fa$var$_temp() {
    return !(0, $l65Bo.isDialogShown)();
}




var $lpfM9 = parcelRequire("lpfM9");




const $5fff77e1c664da88$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    TopNav: {
        id: "page-layout.top.nav",
        defaultMessage: "Confluence navigation"
    },
    Banner: {
        id: "page-layout.banner",
        defaultMessage: "Banner"
    },
    SideNav: {
        id: "page-layout.side.nav",
        defaultMessage: "Side navigation"
    },
    Main: {
        id: "page-layout.main",
        defaultMessage: "Page"
    },
    SkipLinks: {
        id: "page-layout.skip.links",
        defaultMessage: "Jump to"
    }
});











var $9aYkv = parcelRequire("9aYkv");


var $ek5IE = parcelRequire("ek5IE");




const $234a7212b3053f5f$export$f6b09748eb1e2d30 = 'data-main-content';
const $234a7212b3053f5f$export$2306961d40008e49 = 'data-flex-container'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
const $234a7212b3053f5f$export$712225703044cda = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showBreadcrumbNavHeader: showBreadcrumbNavHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1bgi _c3a01fl4 _1u5916n6 _2iuc1fl4 _ylxn1v5u _moiv16n6",
            __cmplp.showBreadcrumbNavHeader ? "_17gl1wqb" : "_17glidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $234a7212b3053f5f$export$6bdda512681a5774 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { zIndex: zIndex, showQuickStart: showQuickStart, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ $cozmU.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_w6mvmh": (0, $9aYkv.default)(__cmplp.zIndex)
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1pby1fcb _e1qhidpf",
                __cmplp.showQuickStart ? "_1e0c1ule" : "_1e0cglyw",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}); // This uses CCS variables from atlaskit/page-layout to make sure
const $234a7212b3053f5f$export$d1bb8697b964b9c = `
#ui-global-sidebar-section {
	z-index: auto !important;
	width: 100%;
}

[${$234a7212b3053f5f$export$f6b09748eb1e2d30}], [${$234a7212b3053f5f$export$2306961d40008e49}] {
	width: calc(
		100% - ${(0, $ek5IE.LEFT_PANEL_WIDTH)} - ${(0, $ek5IE.LEFT_SIDEBAR_WIDTH)} - ${(0, $ek5IE.RIGHT_PANEL_WIDTH)} -
			${(0, $ek5IE.RIGHT_SIDEBAR_WIDTH)}
	) !important;
	position: absolute;
	left: calc(${(0, $ek5IE.LEFT_PANEL_WIDTH)} + ${(0, $ek5IE.LEFT_SIDEBAR_WIDTH)});
	z-index: auto;
	box-sizing: border-box;
	bottom: 0px;
	overflow: auto;
	top: ${(0, $liCgE.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)};

	&#admin-content {
		/* admin nav -> manage apps */
		.upm-manage {
			#upm-manage-type, /* app type dropdown filter */
		.upm-details .upm-plugin-info .upm-column {
				/* expand accordion to show app detail -> 3 column info table */
				z-index: 1;
			}
		}
	}
}
[${$234a7212b3053f5f$export$2306961d40008e49}] > [${$234a7212b3053f5f$export$f6b09748eb1e2d30}] {
	display: none;
}

/* add overflow scrolling to ssred pages with heights longer than side navigation */
[${$234a7212b3053f5f$export$2306961d40008e49}] > main#main.aui-page-panel {
	overflow: hidden;
	overflow-y: auto;
	height: calc(100vh - ${(0, $liCgE.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px);
	min-height: calc(
		100vh - ${(0, $liCgE.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px
	); /* for responsiveness in small height windows */
}
`;
const $234a7212b3053f5f$export$191b652ca0b16b3f = `
	/* CSS hack for code block */
	.code-block.right-shadow {
		z-index: 2;
	}
	/* CSS hack for noPrint */
	[data-ds--page-layout--slot='top-navigation'],
	[data-ds--page-layout--slot='left-sidebar'] {
		@media print {
			display: none !important;
		}
	}
	/* To make sure we are using the same font family set by atlassian-frontend theme. */
	.PageContent {
		font-family: ${"var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	}
	/* To remove cls from more action dropdown */
	[data-testid='content-tools-dropdown-menu--content'] {
		width: 220px;
	}

	/* CSS hack to override batch CSS h3 styling for account menu */
	[data-testid='confluence-account-menu--content--details--name'] {
		font: ${"var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	}
`;
const $234a7212b3053f5f$export$fd1a59daeb9a7e85 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4t3i1osq _1bsb1osq _10pb1osq _9m3z1osq _16tepfqs",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});













var $2E1ay = parcelRequire("2E1ay");


var $eaL9e = parcelRequire("eaL9e");





var $j5cB3 = parcelRequire("j5cB3");


var $89bON = parcelRequire("89bON");


var $k3d9G = parcelRequire("k3d9G");

const $4773940cc2485ba5$var$rgbOffset = {
    red: 0,
    // Pure red has a hue of 0 degrees
    green: 120,
    // Pure green has a hue of 120 degrees
    blue: 240 // Pure blue has a hue of 240 degrees
};
/**
 * Returns the contribution of the given RGB channel to the provided hue.
 *
 * Maximum value is 1, meaning it's the main channel for the hue
 * Minimum value is -1, meaning it doesn't contribute to the hue at all
 *
 * The function looks like a single trapezoidal wave that is
 * horizontally shifted according to the hue offset of the given channel.
 */ const $4773940cc2485ba5$var$getChannelContributionToHue = ({ rgbChannel: rgbChannel, hue: hue })=>{
    const k = (360 - $4773940cc2485ba5$var$rgbOffset[rgbChannel] + hue) / 30 % 12;
    return Math.max(-1, Math.min(k - 3, 9 - k, 1));
};
/**
 * Derived from Wikipedia article on HSL:
 * https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative
 *
 * You can think of it as taking an RGB channel, and the saturation and lightness values
 * to construct a function mapping hue to channel intensity.
 *
 * It then evaluates the function for the given hue.
 */ const $4773940cc2485ba5$var$getRgbChannel = ({ rgbChannel: rgbChannel, color: { h: hue, s: saturation, l: lightness } })=>{
    const shiftY = lightness;
    const scaleY = -1 * saturation * Math.min(lightness, 1 - lightness);
    /**
   * Value between 0-1 describing how much the RGB channel contributes to the given HSL color.
   *
   * `getChannelContributionToHue` is the channel contribution for the pure hue,
   * which is why we need to adjust and scale according to saturation and lightness.
   */ const channelContribution = shiftY + scaleY * $4773940cc2485ba5$var$getChannelContributionToHue({
        rgbChannel: rgbChannel,
        hue: hue
    });
    return Math.round(255 * channelContribution);
};
function $4773940cc2485ba5$export$cbd2e6c3c3c00218(color) {
    /**
   * I was creating increasingly complex regular expressions, aiming for correct parsing.
   *
   * I decided to be pragmatic and just opt for what Nav 3 does (through the `chromatism` library),
   * with some slight improvements.
   *
   * We can refine it as needed.
   *
   * Known limitations of this approach:
   *
   * - It is overly permissive and will allow some invalid syntax,
   *   for example `hsl(1, 2, 3, 4, 5, 6, 7)` where it would just extract the first 3 parameters
   * - Only the integer parts of non-integers will be parsed
   * - Only supports the legacy, comma-separated syntax
   */ const [h, s, l] = color.replace(/hsl\(|[)%\s]/g, '').split(',').map((value)=>parseInt(value, 10));
    if ([
        h,
        s,
        l
    ].some((channel)=>!Number.isInteger(channel))) return null;
    /**
   * Normalized HSL value so that:
   *
   * - hue angle is from 0 (inclusive) to 360 (not inclusive)
   * - saturation and lightness percentages are expressed as fractional values from 0 to 1
   */ const normal = {
        h: h % 360,
        s: Math.min(s / 100, 1),
        l: Math.min(l / 100, 1)
    };
    return {
        r: $4773940cc2485ba5$var$getRgbChannel({
            rgbChannel: 'red',
            color: normal
        }),
        g: $4773940cc2485ba5$var$getRgbChannel({
            rgbChannel: 'green',
            color: normal
        }),
        b: $4773940cc2485ba5$var$getRgbChannel({
            rgbChannel: 'blue',
            color: normal
        })
    };
}


function $d204618c89e145c4$export$3f3b9febf881d58b(color) {
    /**
   * I was creating increasingly complex regular expressions, aiming for correct parsing.
   *
   * I decided to be pragmatic and just opt for what Nav 3 does (through the `chromatism` library),
   * with some slight improvements.
   *
   * We can refine it as needed.
   *
   * Known limitations of this approach:
   *
   * - It is overly permissive and will allow some invalid syntax,
   *   for example `rgb(1, 2, 3, 4, 5, 6, 7)` where it would just extract the first 3 parameters
   * - Only the integer parts of non-integers will be parsed
   * - Only supports the legacy, comma-separated syntax
   */ const [r, g, b] = color.replace(/rgb\(|[)\s]/g, '').split(',').map((value)=>parseInt(value, 10))// Clamping to align with CSS behavior
    .map((value)=>Math.max(0, Math.min(value, 255)));
    if ([
        r,
        g,
        b
    ].some((n)=>!Number.isInteger(n))) return null;
    return {
        r: r,
        g: g,
        b: b
    };
}


function $528d260c17b7be38$export$1d30bac67697545c(color) {
    if (color.startsWith('#')) return (0, $k3d9G.parseHex)(color);
    if (color.startsWith('rgb(')) return (0, $d204618c89e145c4$export$3f3b9febf881d58b)(color);
    if (color.startsWith('hsl(')) return (0, $4773940cc2485ba5$export$cbd2e6c3c3c00218)(color);
    return null;
}



var $iRKv3 = parcelRequire("iRKv3");




const $1b7b278c93e24711$var$NULL_THEME_RESULT = {
    backgroundColor: null,
    highlightColor: null
};
const $1b7b278c93e24711$var$DEFAULT_HIGHLIGHT_COLOR_CODES = [
    '0052CC',
    // ADG3,
    '0C66E4' // ADG4
];
const $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX = 35;
const $1b7b278c93e24711$export$3fd3fe4aa4f2fd3e = ({ backgroundColorRaw: backgroundColorRaw, highlightColorRaw: highlightColorRaw, isDarkMode: isDarkMode })=>{
    if (!backgroundColorRaw || !highlightColorRaw) return $1b7b278c93e24711$var$NULL_THEME_RESULT;
    const backgroundColor = $1b7b278c93e24711$var$parseColor(backgroundColorRaw);
    const highlightColor = $1b7b278c93e24711$var$parseColor(highlightColorRaw);
    if ($1b7b278c93e24711$var$isDefaultTheme(backgroundColor, highlightColor)) return $1b7b278c93e24711$var$NULL_THEME_RESULT;
    return {
        backgroundColor: isDarkMode && backgroundColor ? $1b7b278c93e24711$var$applyDarkModeTransformation(backgroundColor) : backgroundColor,
        highlightColor: highlightColor
    };
};
/**
 * Determines if the given colors match the default theme.
 */ const $1b7b278c93e24711$var$isDefaultTheme = (backgroundColor, highlightColor)=>{
    if (!backgroundColor || !highlightColor) return false;
    const currentDefaultBackground = $1b7b278c93e24711$var$parseColor((0, $89bON.default)('elevation.surface', '#ffffff'));
    const isDefaultBackground = $1b7b278c93e24711$var$areColorsEqual(backgroundColor, currentDefaultBackground);
    const highlightColorCodes = (0, $6mKj3.expVal)('confluence_frontend_fix_topnav_styling_hydration', 'isEnabled', false) ? [
        ...$1b7b278c93e24711$var$DEFAULT_HIGHLIGHT_COLOR_CODES,
        '1868DB'
    ] : $1b7b278c93e24711$var$DEFAULT_HIGHLIGHT_COLOR_CODES;
    const isDefaultHighlight = highlightColorCodes.some((color)=>{
        const currentDefaultColor = $1b7b278c93e24711$var$parseColor((0, $89bON.default)('color.text.brand', `#${color}`));
        return $1b7b278c93e24711$var$areColorsEqual(highlightColor, currentDefaultColor);
    });
    return isDefaultBackground && isDefaultHighlight;
};
/**
 * Parses and validates a color string using platform utilities.
 * Returns RGB object or null if invalid.
 */ const $1b7b278c93e24711$var$parseColor = (colorToParse)=>{
    if (colorToParse.startsWith('rgba(') && colorToParse.split(',').length === 4) colorToParse = `rgb(${colorToParse.substring(5, colorToParse.lastIndexOf(','))})`;
    else if (colorToParse.startsWith('var(')) colorToParse = $1b7b278c93e24711$var$getCSSVariableValue(colorToParse); // Will only get re-calculated if the variable is from ADS
    return (0, $528d260c17b7be38$export$1d30bac67697545c)(colorToParse);
};
/**
 * Transforms a background color for dark mode by either using the dark surface token
 * or reducing lightness for custom colors.
 */ const $1b7b278c93e24711$var$getDarkModeBackgroundColor = (currentBackgroundColor)=>{
    if (currentBackgroundColor.toLowerCase() === '#ffffff') // getTokenValue doesn't work in SSR thus hardcode fallback to current surface value, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    return (0, $89bON.default)('elevation.surface', '#1d2125');
    else {
        const lightnessPercentage = (0, $iRKv3.getLightnessPercentage)(currentBackgroundColor);
        if (lightnessPercentage === undefined) return currentBackgroundColor;
        return lightnessPercentage > $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX ? (0, $iRKv3.reduceLightness)(currentBackgroundColor, $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX) : currentBackgroundColor;
    }
};
const $1b7b278c93e24711$var$applyDarkModeTransformation = (color)=>{
    const hexColor = $1b7b278c93e24711$var$rgbToHex(color); // utility functions require hex colors
    const darkHex = $1b7b278c93e24711$var$getDarkModeBackgroundColor(hexColor);
    return (0, $528d260c17b7be38$export$1d30bac67697545c)(darkHex);
};
const $1b7b278c93e24711$var$areColorsEqual = (color1, color2)=>{
    if (!color1 || !color2) return color1 === color2;
    return color1.r === color2.r && color1.g === color2.g && color1.b === color2.b;
};
const $1b7b278c93e24711$var$rgbToHex = (rgb)=>{
    const toHex = (n)=>{
        const hex = Math.round(n).toString(16);
        return hex.length === 1 ? `0${hex}` : hex;
    };
    return `#${toHex(rgb.r)}${toHex(rgb.g)}${toHex(rgb.b)}`.toUpperCase();
};
const $1b7b278c93e24711$var$getCSSVariableValue = (variableExpression)=>{
    const matcher = variableExpression.match(/var\(([^,\)]+)(,.*)?\)/);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        if (typeof document === 'undefined') return fallback;
        const value = window// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        .getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};


const $a61833f951c42c7b$export$c0c5f5b297b77726 = (backgroundColorRaw, highlightColorRaw)=>{
    const $ = (0, $bDgLe.c)(4);
    const isDarkMode = (0, $j5cB3.useIsDarkMode)();
    let t0;
    if ($[0] !== backgroundColorRaw || $[1] !== highlightColorRaw || $[2] !== isDarkMode) {
        t0 = (0, $1b7b278c93e24711$export$3fd3fe4aa4f2fd3e)({
            backgroundColorRaw: backgroundColorRaw,
            highlightColorRaw: highlightColorRaw,
            isDarkMode: isDarkMode
        });
        $[0] = backgroundColorRaw;
        $[1] = highlightColorRaw;
        $[2] = isDarkMode;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};


















var $aJv6Q = parcelRequire("aJv6Q");


const $3183c72dd59199f3$var$ImpersonationFlagV2Loader = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "61Lty",
    name: "ImpersonationFlagV2Loader",
    loader: async ()=>(await (parcelRequire("b2F0e"))).ImpersonationFlag
});
const $3183c72dd59199f3$var$LazyImpersonationFlagComponent = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3183c72dd59199f3$var$ImpersonationFlagV2Loader, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $3183c72dd59199f3$export$4fca365a8ad2f625 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})($3183c72dd59199f3$var$LazyImpersonationFlagComponent);



var $emNvf = parcelRequire("emNvf");




const $f06013f8e99ab858$export$41d0d88a6b0e456f = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { defaultCollapsed: defaultCollapsed, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive } = t0;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $emNvf.default), {
        __callerPackage__: "@confluence/page-layout"
    });
    const horizontalHeader = data?.lookAndFeel?.custom?.horizontalHeader;
    const customTheme = (0, $a61833f951c42c7b$export$c0c5f5b297b77726)(horizontalHeader?.backgroundColor, horizontalHeader?.primaryNavigation?.highlightColor);
    let t1;
    if ($[0] !== customTheme || $[1] !== defaultCollapsed || $[2] !== isNav4CollapseReminderSpotlightActive || $[3] !== setIsNav4CollapseReminderSpotlightActive) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaL9e.TopNavigationBase), {
            defaultCollapsed: defaultCollapsed,
            customTheme: customTheme,
            isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        });
        $[0] = customTheme;
        $[1] = defaultCollapsed;
        $[2] = isNav4CollapseReminderSpotlightActive;
        $[3] = setIsNav4CollapseReminderSpotlightActive;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3183c72dd59199f3$export$4fca365a8ad2f625), null);
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "top-nav"
        }, t1, t2);
        $[6] = t1;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== error) {
        t4 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[8] = error;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== customTheme || $[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2E1ay.TopNav), {
            testId: "grid-topNav",
            customTheme: customTheme
        }, t3, t4);
        $[10] = customTheme;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};









var $iDE8i = parcelRequire("iDE8i");


var $jln20 = parcelRequire("jln20");


var $cLgYq = parcelRequire("cLgYq");

















var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");














var $5NAso = parcelRequire("5NAso");




const $76328abce97d8d37$export$fae700fb5dfcb093 = ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    let t0;
    let t1;
    if ($[0] !== fireFailedAnalytic) {
        t0 = ()=>{
            if (!(0, $9wGTI.fg)("platform_editor_blocks_patch_4")) return;
            (0, $5NAso.setOnCreateError)((info)=>{
                fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_CREATE, {
                    reason: info.reason,
                    ...info.statusCode !== undefined && {
                        statusCode: info.statusCode
                    }
                });
            });
            return $76328abce97d8d37$var$_temp;
        };
        t1 = [
            fireFailedAnalytic
        ];
        $[0] = fireFailedAnalytic;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
function $76328abce97d8d37$var$_temp() {
    (0, $5NAso.setOnCreateError)(null);
}















var $2Qxf3 = parcelRequire("2Qxf3");




const $37d6b5f846525abd$export$f43ff4d4aa562c2f = ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { fireOperationalAnalytic: fireOperationalAnalytic, fireFailedAnalytic: fireFailedAnalytic, fireSuccessAnalytic: fireSuccessAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    let t0;
    let t1;
    if ($[0] !== fireFailedAnalytic || $[1] !== fireOperationalAnalytic || $[2] !== fireSuccessAnalytic) {
        t0 = ()=>{
            (0, $2Qxf3.setOnFetchComplete)((metrics)=>{
                fireOperationalAnalytic({
                    actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).SNIPPETS,
                    action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).FETCHED,
                    attributes: metrics
                });
                if ((0, $9wGTI.fg)("platform_editor_blocks_patch_5")) fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_FETCH);
            });
            if ((0, $9wGTI.fg)("platform_editor_blocks_patch_3")) (0, $2Qxf3.setOnFetchScopeError)((info)=>{
                fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_FETCH, {
                    scope: info.scope,
                    ...(0, $9wGTI.fg)("platform_editor_blocks_patch_5") && {
                        reason: info.reason
                    },
                    ...info.statusCode !== undefined && {
                        statusCode: info.statusCode
                    }
                });
            });
            return $37d6b5f846525abd$var$_temp;
        };
        t1 = [
            fireOperationalAnalytic,
            fireFailedAnalytic,
            fireSuccessAnalytic
        ];
        $[0] = fireFailedAnalytic;
        $[1] = fireOperationalAnalytic;
        $[2] = fireSuccessAnalytic;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
function $37d6b5f846525abd$var$_temp() {
    (0, $2Qxf3.setOnFetchComplete)(null);
    (0, $2Qxf3.setOnFetchScopeError)(null);
}



var $cYuYM = parcelRequire("cYuYM");


var $5vi32 = parcelRequire("5vi32");


var $dZUkS = parcelRequire("dZUkS");

const $326f6c6e797b3c09$export$607850563f346b34 = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children } = t0;
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intlLocale) {
        t1 = (0, $9wGTI.fg)("platform_editor_block_template_i18n") ? intlLocale : undefined;
        $[0] = intlLocale;
        $[1] = t1;
    } else t1 = $[1];
    const locale = t1;
    const { fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    (0, $37d6b5f846525abd$export$f43ff4d4aa562c2f)();
    (0, $76328abce97d8d37$export$fae700fb5dfcb093)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isSnippetCreateEnabled = (0, $cYuYM.useIsSnippetCreateEnabled)();
    let t2;
    let t3;
    if ($[2] !== fireFailedAnalytic || $[3] !== isEmbeddedConfluence || $[4] !== isSnippetCreateEnabled || $[5] !== locale || $[6] !== snippetsActions) {
        t2 = ()=>{
            if (!(0, $6mKj3.expVal)("platform_editor_blocks_conf", "isEnabled", false)) return;
            if (isEmbeddedConfluence && !isSnippetCreateEnabled) return;
            snippetsActions.fetchSnippets(locale).catch(()=>{
                fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_FETCH, {});
            });
        };
        t3 = [
            snippetsActions,
            fireFailedAnalytic,
            isEmbeddedConfluence,
            isSnippetCreateEnabled,
            locale
        ];
        $[2] = fireFailedAnalytic;
        $[3] = isEmbeddedConfluence;
        $[4] = isSnippetCreateEnabled;
        $[5] = locale;
        $[6] = snippetsActions;
        $[7] = t2;
        $[8] = t3;
    } else {
        t2 = $[7];
        t3 = $[8];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[9] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[9] = children;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};



var $laFNM = parcelRequire("laFNM");

const $e33908ef21162ab8$export$968a8c4aa27e5f45 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jln20.RightSidebarContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDE8i.PostOfficeSideNavMessageProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cLgYq.InProductHelpProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $326f6c6e797b3c09$export$607850563f346b34), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $laFNM.ApprovalsProvider), null, children)))));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};


const $ba2ff1d1fd865be7$var$isRoute = (pathname, route)=>Boolean(route.match(pathname || ''));
const $ba2ff1d1fd865be7$var$routesToShowPageLayoutBreadcrumbNav = [
    (0, $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST),
    (0, $1NBp8.SPACE_PAGES),
    (0, $1NBp8.SPACE_CALENDARS),
    (0, $1NBp8.DATABASE_CUSTOM_OVERVIEW),
    (0, $1NBp8.SPACE_QUESTIONS)
];
const $ba2ff1d1fd865be7$var$PopoverSpotlightWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $ba2ff1d1fd865be7$var$SpotlightManagerSpotlightWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), {
            blanketIsTinted: true
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $ba2ff1d1fd865be7$export$6d1402fb58384e4f = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, view: view, standalone: standalone, isSpaceSettingsScreen: isSpaceSettingsScreen, editorPreloader: editorPreloader } = t0;
    let t1;
    if ($[0] !== children || $[1] !== editorPreloader || $[2] !== isSpaceSettingsScreen || $[3] !== standalone || $[4] !== view) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE,
            attributes: $ba2ff1d1fd865be7$var$outerErrorBoundaryAttributes
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ba2ff1d1fd865be7$export$f94607b1528a8807, {
            children: children,
            view: view,
            standalone: standalone,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            editorPreloader: editorPreloader
        }));
        $[0] = children;
        $[1] = editorPreloader;
        $[2] = isSpaceSettingsScreen;
        $[3] = standalone;
        $[4] = view;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
});
const $ba2ff1d1fd865be7$export$f94607b1528a8807 = (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    const { children: children, view: view, standalone: standalone, isSpaceSettingsScreen: t1, editorPreloader: t2 } = t0;
    const isSpaceSettingsScreen = t1 === undefined ? false : t1;
    const editorPreloader = t2 === undefined ? $ba2ff1d1fd865be7$var$noopEditorPreloader : t2;
    let t3;
    if ($[0] !== view) {
        t3 = {
            view: view
        };
        $[0] = view;
        $[1] = t3;
    } else t3 = $[1];
    const { pageTreeUpdater: pageTreeUpdater } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t3);
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $kSwu1.useIntl)();
    const { location: location, match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t4;
    if ($[2] !== location?.pathname) {
        t4 = $ba2ff1d1fd865be7$var$routesToShowPageLayoutBreadcrumbNav.some((route)=>$ba2ff1d1fd865be7$var$isRoute(location?.pathname, route));
        $[2] = location?.pathname;
        $[3] = t4;
    } else t4 = $[3];
    const showBreadcrumbNavHeader = t4;
    let t5;
    if ($[4] !== intl) {
        t5 = intl.formatMessage((0, $5fff77e1c664da88$export$a7357cdd1f0b0168).SideNav);
        $[4] = intl;
        $[5] = t5;
    } else t5 = $[5];
    const SideNavSkiplinkText = t5;
    const nonceValue = window.__SSR_NONCE_VALUE__;
    let t6;
    if ($[6] !== standalone) {
        t6 = ()=>standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", {
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: (0, $234a7212b3053f5f$export$d1bb8697b964b9c)
                },
                "data-testid": "global-styles-SSR"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", {
                ...nonceValue !== undefined ? {
                    nonce: nonceValue
                } : {},
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: (0, $234a7212b3053f5f$export$191b652ca0b16b3f)
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", {
                "data-testid": "global-styles",
                ...nonceValue !== undefined ? {
                    nonce: nonceValue
                } : {},
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: (0, $234a7212b3053f5f$export$191b652ca0b16b3f)
                }
            });
        $[6] = standalone;
        $[7] = t6;
    } else t6 = $[7];
    const standaloneGlobalStylesCompiled = t6;
    const [isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive] = (0, $cozmU.useState)(false);
    const { initialCollapsedState: initialCollapsedState } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const currentContentId = match?.params?.contentId ?? null;
    const isContentRoute = Boolean(currentContentId);
    let t7;
    if ($[8] !== location?.pathname || $[9] !== match?.name) {
        t7 = match?.name === (0, $1NBp8.SPACE_SUGGESTIONS).name || $ba2ff1d1fd865be7$var$isRoute(location?.pathname, (0, $1NBp8.SPACE_SUGGESTIONS));
        $[8] = location?.pathname;
        $[9] = match?.name;
        $[10] = t7;
    } else t7 = $[10];
    const isSpaceSuggestionsRoute = t7;
    const isSpaceSuggestionReviewPanel = panel?.id === (0, $jvYFk.PanelName).SpaceSuggestionReviewPanel;
    let t8;
    if ($[11] !== isContentRoute || $[12] !== isSpaceSuggestionReviewPanel || $[13] !== isSpaceSuggestionsRoute || $[14] !== panel?.id) {
        t8 = (0, $jvYFk.isMigratedToPanelSystem)(panel?.id) && (isContentRoute || isSpaceSuggestionsRoute && isSpaceSuggestionReviewPanel);
        $[11] = isContentRoute;
        $[12] = isSpaceSuggestionReviewPanel;
        $[13] = isSpaceSuggestionsRoute;
        $[14] = panel?.id;
        $[15] = t8;
    } else t8 = $[15];
    const canRenderObjectSidebarPanel = t8;
    const shouldRenderObjectSidebarPanel = isObjectSidebarShown && canRenderObjectSidebarPanel;
    const SpaceSuggestionReviewPanelBodyComponent = isSpaceSuggestionReviewPanel ? panel?.BodyComponent : undefined;
    let t10;
    let t9;
    if ($[16] !== canRenderObjectSidebarPanel || $[17] !== hideObjectSidebar || $[18] !== isObjectSidebarShown) {
        t9 = ()=>{
            if (isObjectSidebarShown && !canRenderObjectSidebarPanel && (0, $9wGTI.fg)("ads-panel-system-confluence-object-sidebar")) hideObjectSidebar();
        };
        t10 = [
            canRenderObjectSidebarPanel,
            hideObjectSidebar,
            isObjectSidebarShown
        ];
        $[16] = canRenderObjectSidebarPanel;
        $[17] = hideObjectSidebar;
        $[18] = isObjectSidebarShown;
        $[19] = t10;
        $[20] = t9;
    } else {
        t10 = $[19];
        t9 = $[20];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[21] !== currentContentId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3260f1cb149f21d4$export$2e1f52d6d7a935bc), {
            contentId: currentContentId
        });
        $[21] = currentContentId;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6CEg5.PerformanceStart), {
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
            subjectId: "NavigationLoading"
        });
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== SideNavSkiplinkText || $[25] !== SpaceSuggestionReviewPanelBodyComponent || $[26] !== areKeyboardShortcutsEnabled || $[27] !== children || $[28] !== initialCollapsedState || $[29] !== isNav4CollapseReminderSpotlightActive || $[30] !== isSpaceSettingsScreen || $[31] !== isSpaceSuggestionReviewPanel || $[32] !== pageTreeUpdater || $[33] !== shouldRenderObjectSidebarPanel || $[34] !== showBreadcrumbNavHeader || $[35] !== standalone || $[36] !== standaloneGlobalStylesCompiled || $[37] !== view) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: $ba2ff1d1fd865be7$var$bannerStateContainerArray
        }, (bannerState)=>{
            const bannerHeight = bannerState.getTotalHeight(false);
            const SpotlightWrapper = (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? $ba2ff1d1fd865be7$var$PopoverSpotlightWrapper : $ba2ff1d1fd865be7$var$SpotlightManagerSpotlightWrapper;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpotlightWrapper, null, standaloneGlobalStylesCompiled(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e33908ef21162ab8$export$968a8c4aa27e5f45), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $71c85943ef41ca73$export$797f6437373337da), {
                value: (0, $6mKj3.expVal)("navx-full-height-sidebar-exp", "isEnabled", false)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31TvY.Root), {
                UNSAFE_dangerouslyHoistSlotSizes: true,
                testId: "page-layout-root",
                defaultSideNavCollapsed: (0, $6mKj3.expVal)("navx-full-height-sidebar-exp", "isEnabled", false) ? initialCollapsedState === "collapsed" : undefined,
                isSideNavShortcutEnabled: areKeyboardShortcutsEnabled && (0, $6mKj3.expVal)("navx-full-height-sidebar-exp", "isEnabled", false)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5660beed5219c07c$export$3b4e64e77073e307), {
                height: bannerHeight,
                id: "AkBanner"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5XPyz.BannerContainer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
                dataFetcherName: "top-nav"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f06013f8e99ab858$export$41d0d88a6b0e456f), {
                defaultCollapsed: initialCollapsedState === "collapsed",
                isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b56ca6efd7e1c0fa$export$cc4f63927c41742f), {
                view: view,
                skiplinkText: SideNavSkiplinkText,
                isSpaceSettingsScreen: isSpaceSettingsScreen,
                isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
                setTriggeredByShortcut: $ba2ff1d1fd865be7$var$_temp
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dyjRd.Main), {
                testId: "grid-main-container",
                id: "AkMainContent"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ba2ff1d1fd865be7$var$ContentTreeMultiSelectOverlay, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $234a7212b3053f5f$export$712225703044cda), {
                id: "layout-main-wrapper",
                showBreadcrumbNavHeader: showBreadcrumbNavHeader
            }, showBreadcrumbNavHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cgsIj.FixedBreadcrumbsNavForPageLayoutLoader), null), children && !standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, showBreadcrumbNavHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $ba2ff1d1fd865be7$var$breadcrumbsOffsetStyles
            }, children) : children) : null)), shouldRenderObjectSidebarPanel && ((0, $9wGTI.fg)("ads-panel-system-confluence-object-sidebar") || isSpaceSuggestionReviewPanel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0qTi.Panel), {
                defaultWidth: 400,
                label: "Object Sidebar"
            }, SpaceSuggestionReviewPanelBodyComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpaceSuggestionReviewPanelBodyComponent, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vI1F.ObjectSidebarContent), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpfM9.PanelLoader), {
                toggleInProductHelp: $ba2ff1d1fd865be7$var$_temp2
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $7xVCs.PageTreeStateUpdater)
                ]
            }, (pageTreeStateUpdatesContainer)=>{
                pageTreeUpdater.current = pageTreeStateUpdatesContainer;
                return null;
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c25ef82052c394f$export$f143b4bd86d1e004), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1C7kY.GlobalComponentsLoader), null))));
        });
        $[24] = SideNavSkiplinkText;
        $[25] = SpaceSuggestionReviewPanelBodyComponent;
        $[26] = areKeyboardShortcutsEnabled;
        $[27] = children;
        $[28] = initialCollapsedState;
        $[29] = isNav4CollapseReminderSpotlightActive;
        $[30] = isSpaceSettingsScreen;
        $[31] = isSpaceSuggestionReviewPanel;
        $[32] = pageTreeUpdater;
        $[33] = shouldRenderObjectSidebarPanel;
        $[34] = showBreadcrumbNavHeader;
        $[35] = standalone;
        $[36] = standaloneGlobalStylesCompiled;
        $[37] = view;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== editorPreloader || $[40] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58PBI.EditContentButtonPreloaderContext).Provider, {
            value: editorPreloader
        }, t13);
        $[39] = editorPreloader;
        $[40] = t13;
        $[41] = t14;
    } else t14 = $[41];
    let t15;
    if ($[42] !== t14 || $[43] !== view) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd996ec529999f47$export$ac3e7903e24ee02d), {
            view: view,
            navVersion: "4"
        }, t12, t14);
        $[42] = t14;
        $[43] = view;
        $[44] = t15;
    } else t15 = $[44];
    let t16;
    if ($[45] !== t11 || $[46] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE,
            attributes: $ba2ff1d1fd865be7$var$innerErrorBoundaryAttributes
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jAOzg.SmartFolderSyncProvider), null, t11, t15));
        $[45] = t11;
        $[46] = t15;
        $[47] = t16;
    } else t16 = $[47];
    return t16;
};
const $ba2ff1d1fd865be7$var$ContentTreeMultiSelectOverlay = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    let t0;
    if ($[0] !== isMultiSelectActive) {
        t0 = isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyUf8.default), {
            isTinted: true,
            testId: "content-tree-multi-select-blanket"
        }) : null;
        $[0] = isMultiSelectActive;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $ba2ff1d1fd865be7$var$breadcrumbsOffsetStyles = (0, $buxP3.xcss)({
    // @ts-ignore This specific value is necessary to ensure the breadcrumbs are offset correctly
    marginTop: '60px'
});
const $ba2ff1d1fd865be7$var$outerErrorBoundaryAttributes = {
    errorBoundaryId: 'PageLayout-outer'
};
const $ba2ff1d1fd865be7$var$innerErrorBoundaryAttributes = {
    errorBoundaryId: 'PageLayoutInner'
};
const $ba2ff1d1fd865be7$var$bannerStateContainerArray = [
    (0, $hrAmX.BannerStateContainer)
];
const $ba2ff1d1fd865be7$var$noopEditorPreloader = ()=>null;
function $ba2ff1d1fd865be7$var$_temp() {}
function $ba2ff1d1fd865be7$var$_temp2() {}
module.exports["PageLayout"] = $ba2ff1d1fd865be7$export$6d1402fb58384e4f;
module.exports["PageLayoutInner"] = $ba2ff1d1fd865be7$export$f94607b1528a8807;

});

parcelRegister("b0qTi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ixfCV = parcelRequire("ixfCV");


var $45mGg = parcelRequire("45mGg");


var $eaAhc = parcelRequire("eaAhc");


var $liCgE = parcelRequire("liCgE");


var $4aMCy = parcelRequire("4aMCy");


var $b24kF = parcelRequire("b24kF");


var $iynkA = parcelRequire("iynkA");


var $1gX7M = parcelRequire("1gX7M");


var $eyPWA = parcelRequire("eyPWA");


var $IRNbu = parcelRequire("IRNbu");


var $6iHsT = parcelRequire("6iHsT");

const $b9784ecf350f165c$var$panelSplitterResizingVar = '--n_pnlRsz';
const $b9784ecf350f165c$var$fallbackDefaultWidth = 365; /**
                                   * We typically use the `defaultWidth` as the minimum resizing width,
                                   * but for large default widths we fallback to a standard value.
                                   *
                                   * This standard value of `400px` is to align with the Global Preview Panels.
                                   */ 
const $b9784ecf350f165c$var$fallbackResizeMinWidth = 400;
const $b9784ecf350f165c$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3ieqxy _kqsw1if8 _152timx3 _bfhk1bhr _1bsb1dxx _14b54rrg _4ap3vuon _1dhy1c6w _9sns1wug",
    border: "_191wglyw _16qs130s _1w6eia51 _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw"
}; /**
    * The Panel layout area is rendered to the right (inline end) of the Main area, or the Aside area if it is present.
    *
    * On small viewports (below 64rem, or 1024px), the Panel slot will become an overlay.
    *
    * You can optionally render a `PanelSplitter` as a child to make the panel area resizable.
    */ 
const $b9784ecf350f165c$export$2ddb90ad54e5f587 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Panel(t0) {
    const $ = (0, $bDgLe.c)(45);
    const { children: children, defaultWidth: t1, label: t2, skipLinkLabel: t3, testId: testId, id: providedId, xcss: xcss, hasBorder: t4 } = t0;
    const defaultWidthProp = t1 === undefined ? $b9784ecf350f165c$var$fallbackDefaultWidth : t1;
    const label = t2 === undefined ? "Panel" : t2;
    const skipLinkLabel = t3 === undefined ? label : t3;
    const hasBorder = t4 === undefined ? true : t4;
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    let t5;
    if ($[0] !== providedId) {
        t5 = {
            providedId: providedId
        };
        $[0] = providedId;
        $[1] = t5;
    } else t5 = $[1];
    const id = (0, $eyPWA.useLayoutId)(t5);
    let t6;
    if ($[2] !== defaultWidthProp) {
        t6 = {
            defaultWidthProp: defaultWidthProp,
            fallbackDefaultWidth: $b9784ecf350f165c$var$fallbackDefaultWidth,
            slotName: "Panel"
        };
        $[2] = defaultWidthProp;
        $[3] = t6;
    } else t6 = $[3];
    const defaultWidth = (0, $6iHsT.useSafeDefaultWidth)(t6);
    let t7;
    if ($[4] !== defaultWidth) {
        t7 = defaultWidth === 0 || (0, $ixfCV.fg)("platform_dst_nav4_skip_link_a11y_1");
        $[4] = defaultWidth;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== id || $[7] !== skipLinkLabel || $[8] !== t7) {
        t8 = {
            id: id,
            label: skipLinkLabel,
            isHidden: t7
        };
        $[6] = id;
        $[7] = skipLinkLabel;
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    (0, $eaAhc.useSkipLinkInternal)(t8);
    const ref = (0, $cozmU.useRef)(null);
    const [width, setWidth] = (0, $cozmU.useState)(defaultWidth);
    const defaultWidthRef = (0, $cozmU.useRef)(defaultWidth);
    let t10;
    let t9;
    if ($[10] !== defaultWidth) {
        t9 = ()=>{
            if (defaultWidthRef.current === defaultWidth) return;
            defaultWidthRef.current = defaultWidth;
            setWidth(defaultWidth);
        };
        t10 = [
            defaultWidth
        ];
        $[10] = defaultWidth;
        $[11] = t10;
        $[12] = t9;
    } else {
        t10 = $[11];
        t9 = $[12];
    }
    (0, $cozmU.useEffect)(t9, t10);
    const sideNavRef = (0, $1gX7M.useSideNavRef)();
    const minWidth = Math.min(defaultWidth, $b9784ecf350f165c$var$fallbackResizeMinWidth);
    let t11;
    if ($[13] !== minWidth || $[14] !== sideNavRef) {
        t11 = ()=>{
            const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0;
            const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
            return {
                min: `${minWidth}px`,
                max: `${maxWidth}px`
            };
        };
        $[13] = minWidth;
        $[14] = sideNavRef;
        $[15] = t11;
    } else t11 = $[15];
    const getResizeBounds = t11;
    const t12 = `${minWidth}px`;
    let t13;
    if ($[16] !== t12) {
        t13 = {
            min: t12,
            max: `round(nearest, calc((100vw - var(${0, $liCgE.sideNavLiveWidthVar}, 0px)) / 2), 1px)`
        };
        $[16] = t12;
        $[17] = t13;
    } else t13 = $[17];
    const panelWidthSlotBounds = t13;
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    let t14;
    if ($[18] !== dangerouslyHoistSlotSizes) {
        t14 = {
            isEnabled: dangerouslyHoistSlotSizes,
            cssVar: $b9784ecf350f165c$var$panelSplitterResizingVar,
            panelId: (0, $liCgE.panelPanelSplitterId)
        };
        $[18] = dangerouslyHoistSlotSizes;
        $[19] = t14;
    } else t14 = $[19];
    (0, $IRNbu.useResizingWidthCssVarOnRootElement)(t14);
    const t15 = defaultWidth === 0 && $b9784ecf350f165c$var$styles.hidden;
    const t16 = hasBorder && $b9784ecf350f165c$var$styles.border;
    let t17;
    if ($[20] !== t15 || $[21] !== t16 || $[22] !== xcss) {
        t17 = (0, $hekY6.default)([
            $b9784ecf350f165c$var$styles.root,
            t15,
            t16,
            xcss
        ]);
        $[20] = t15;
        $[21] = t16;
        $[22] = xcss;
        $[23] = t17;
    } else t17 = $[23];
    const t18 = `${minWidth}px`;
    let t19;
    if ($[24] !== panelVariableWidth || $[25] !== t18) {
        t19 = {
            [(0, $liCgE.panelVar)]: panelVariableWidth,
            "--minWidth": t18
        };
        $[24] = panelVariableWidth;
        $[25] = t18;
        $[26] = t19;
    } else t19 = $[26];
    const t20 = t19;
    let t21;
    if ($[27] !== dangerouslyHoistSlotSizes || $[28] !== panelVariableWidth) {
        t21 = dangerouslyHoistSlotSizes && /*#__PURE__*/ $cozmU.createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, $liCgE.UNSAFE_panelLayoutVar),
            value: "0px",
            mediaQuery: (0, $45mGg.media).above.lg,
            responsiveValue: `var(${$b9784ecf350f165c$var$panelSplitterResizingVar}, ${panelVariableWidth})`
        });
        $[27] = dangerouslyHoistSlotSizes;
        $[28] = panelVariableWidth;
        $[29] = t21;
    } else t21 = $[29];
    let t22;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = (0, $hekY6.default)([
            $b9784ecf350f165c$var$styles.scrollContainer
        ]);
        $[30] = t22;
    } else t22 = $[30];
    let t23;
    if ($[31] !== children) {
        t23 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t22
        }, children);
        $[31] = children;
        $[32] = t23;
    } else t23 = $[32];
    let t24;
    if ($[33] !== getResizeBounds || $[34] !== t23 || $[35] !== width) {
        t24 = /*#__PURE__*/ $cozmU.createElement((0, $iynkA.PanelSplitterProvider), {
            panelId: (0, $liCgE.panelPanelSplitterId),
            panelRef: ref,
            panelWidth: width,
            onCompleteResize: setWidth,
            getResizeBounds: getResizeBounds,
            resizingCssVar: $b9784ecf350f165c$var$panelSplitterResizingVar,
            position: "start"
        }, t23);
        $[33] = getResizeBounds;
        $[34] = t23;
        $[35] = width;
        $[36] = t24;
    } else t24 = $[36];
    let t25;
    if ($[37] !== id || $[38] !== label || $[39] !== t17 || $[40] !== t20 || $[41] !== t21 || $[42] !== t24 || $[43] !== testId) {
        t25 = /*#__PURE__*/ $cozmU.createElement("section", {
            id: id,
            "data-layout-slot": true,
            "aria-label": label,
            className: t17,
            style: t20,
            "data-testid": testId,
            ref: ref
        }, t21, t24);
        $[37] = id;
        $[38] = label;
        $[39] = t17;
        $[40] = t20;
        $[41] = t21;
        $[42] = t24;
        $[43] = testId;
        $[44] = t25;
    } else t25 = $[44];
    return t25;
} : function Panel({ children: children, defaultWidth: defaultWidthProp = $b9784ecf350f165c$var$fallbackDefaultWidth, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = true }) {
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    const id = (0, $eyPWA.useLayoutId)({
        providedId: providedId
    });
    const defaultWidth = (0, $6iHsT.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $b9784ecf350f165c$var$fallbackDefaultWidth,
        slotName: 'Panel'
    }); /**
       * Don't show the skip link if the slot has 0 width.
       *
       * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
       *
       * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
       */ 
    (0, $eaAhc.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 || (0, $ixfCV.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const ref = (0, $cozmU.useRef)(null);
    const [width, setWidth] = (0, $cozmU.useState)(defaultWidth); // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $cozmU.useRef)(defaultWidth); /**
                                                 * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
                                                 * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
                                                 * https://jplat.atlassian.net/browse/BLU-3951
                                                 */ 
    (0, $cozmU.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const sideNavRef = (0, $1gX7M.useSideNavRef)(); /**
                                       * The minimum width that the panel can be resized to by the user.
                                       *
                                       * We only use the `defaultWidth` up to a point to avoid huge panels.
                                       */ 
    const minWidth = Math.min(defaultWidth, $b9784ecf350f165c$var$fallbackResizeMinWidth); /**
                                                                    * Returns the bounds for resizing, evaluated lazily when needed.
                                                                    *
                                                                    * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
                                                                    * and the panel's slot bounds use a complex CSS expression.
                                                                    */ 
    const getResizeBounds = (0, $cozmU.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0; /**
                                                                * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
                                                                *
                                                                * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
                                                                */ 
        const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: `${minWidth}px`,
            max: `${maxWidth}px`
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: `round(nearest, calc((100vw - var(${(0, $liCgE.sideNavLiveWidthVar)}, 0px)) / 2), 1px)`
    };
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $IRNbu.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        cssVar: $b9784ecf350f165c$var$panelSplitterResizingVar,
        panelId: (0, $liCgE.panelPanelSplitterId)
    });
    return /*#__PURE__*/ $cozmU.createElement("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $hekY6.default)([
            $b9784ecf350f165c$var$styles.root,
            defaultWidth === 0 && $b9784ecf350f165c$var$styles.hidden,
            hasBorder && $b9784ecf350f165c$var$styles.border,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $liCgE.panelVar)]: panelVariableWidth,
            '--minWidth': `${minWidth}px`
        },
        "data-testid": testId,
        ref: ref
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ $cozmU.createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $liCgE.UNSAFE_panelLayoutVar),
        value: "0px",
        mediaQuery: (0, $45mGg.media).above.lg,
        responsiveValue: `var(${$b9784ecf350f165c$var$panelSplitterResizingVar}, ${panelVariableWidth})`
    }), /*#__PURE__*/ $cozmU.createElement((0, $iynkA.PanelSplitterProvider), {
        panelId: (0, $liCgE.panelPanelSplitterId),
        panelRef: ref,
        panelWidth: width,
        onCompleteResize: setWidth,
        getResizeBounds: getResizeBounds,
        resizingCssVar: $b9784ecf350f165c$var$panelSplitterResizingVar,
        position: "start"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $b9784ecf350f165c$var$styles.scrollContainer
        ])
    }, children)));
};
module.exports["Panel"] = $b9784ecf350f165c$export$2ddb90ad54e5f587;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("6CEg5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $9eE57 = parcelRequire("9eE57");

class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $cozmU.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};
module.exports["PerformanceStart"] = $dc6daeb5b2d3b455$export$616e8efc277d5c6;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("5XPyz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e36ff8521eaa3fdf$export$f316edcbf748c37b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bTjE2",
    name: "BannerContainer",
    loader: async ()=>(await (parcelRequire("l3S3Z"))).BannerContainer
});
module.exports["BannerContainer"] = $e36ff8521eaa3fdf$export$f316edcbf748c37b;

});

parcelRegister("l3S3Z", function(module, exports) {

let $f553d0a1beac54be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f553d0a1beac54be$var$load("ghNAx"),
    $f553d0a1beac54be$var$load("hhss7"),
    $f553d0a1beac54be$var$load("d2O2V"),
    $f553d0a1beac54be$var$load("avZlC")
]).then(()=>parcelRequire('9ZNsj'));

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $i3jcY = parcelRequire("i3jcY");


var $6mKj3 = parcelRequire("6mKj3");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $kNIYN.Container) {
    constructor(props = {}){
        super();
        // Nav4 is fully rolled out; top nav height is always 48px unless FHS is enabled
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        let navHeight = 48;
        if (// The increased height change is only applied when FHS is enabled.
        // Ideally we could check `useIsFhsEnabled()` but we can't use hooks here.
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false)) navHeight = 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("1C7kY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c9ec1f4c06aad517$export$23822a00be419508 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KYiA6",
    name: "GlobalComponentsLoader",
    loader: async ()=>(await (parcelRequire("cS2u6"))).GlobalComponents
});
module.exports["GlobalComponentsLoader"] = $c9ec1f4c06aad517$export$23822a00be419508;

});

parcelRegister("cS2u6", function(module, exports) {

let $95ec748e3902bc49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $95ec748e3902bc49$var$load("lNePA"),
    $95ec748e3902bc49$var$load("cFvW1"),
    $95ec748e3902bc49$var$load("dBHUb"),
    $95ec748e3902bc49$var$load("5Rx9J"),
    $95ec748e3902bc49$var$load("6wr18"),
    $95ec748e3902bc49$var$load("bb3WM"),
    $95ec748e3902bc49$var$load("jhqTy"),
    $95ec748e3902bc49$var$load("8zMmc"),
    $95ec748e3902bc49$var$load("4x9Jx"),
    $95ec748e3902bc49$var$load("ffEVr"),
    $95ec748e3902bc49$var$load("7EorR"),
    $95ec748e3902bc49$var$load("3kVph"),
    $95ec748e3902bc49$var$load("daX4F"),
    $95ec748e3902bc49$var$load("hhss7"),
    $95ec748e3902bc49$var$load("jryQt")
]).then(()=>parcelRequire('73TCo'));

});

parcelRegister("2ot3O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $lqtHz = parcelRequire("lqtHz");

const $1deb345019a8d437$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
const $1deb345019a8d437$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)($1deb345019a8d437$var$FlagContext);
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)($1deb345019a8d437$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
const $1deb345019a8d437$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $1deb345019a8d437$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $1deb345019a8d437$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1deb345019a8d437$var$FlagContext.Provider, {
            value: api
        }, children);
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($1deb345019a8d437$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent
        }, t5);
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t6);
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $1deb345019a8d437$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1deb345019a8d437$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map((flag_1)=>{
        const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
        const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FlagType, {
            ...restProps,
            key: flag_1.id
        });
    })));
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $1deb345019a8d437$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
const $1deb345019a8d437$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1deb345019a8d437$export$a4270ab432ac8a58, null, fn());
module.exports["useFlags"] = $1deb345019a8d437$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $1deb345019a8d437$export$a4270ab432ac8a58;

});

parcelRegister("lRhY3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $bc35f8d5f81a3a68$var$noop = (props)=>{};
const $bc35f8d5f81a3a68$export$5f5debba1692bf40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bc35f8d5f81a3a68$var$noop,
                close: $bc35f8d5f81a3a68$var$noop,
                setPanelWidth: $bc35f8d5f81a3a68$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) return {
        open: $bc35f8d5f81a3a68$var$noop,
        close: $bc35f8d5f81a3a68$var$noop,
        setPanelWidth: $bc35f8d5f81a3a68$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bc35f8d5f81a3a68$export$5f5debba1692bf40;

});

parcelRegister("3Ap09", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $63gyv = parcelRequire("63gyv");


var $7ssWV = parcelRequire("7ssWV");

const $4db84584556d15be$var$noop = ()=>{};
const $4db84584556d15be$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $4db84584556d15be$var$noop,
    onClose: $4db84584556d15be$var$noop
};
const $4db84584556d15be$export$f473d225913e225d = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $4db84584556d15be$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $4db84584556d15be$var$noop,
                onClose: $4db84584556d15be$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $7ssWV.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $4db84584556d15be$var$initialState.onOpen,
                onClose: params.onClose || $4db84584556d15be$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $4db84584556d15be$export$65ae37e9c61321f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $ixfCV.fg)("nin_glance_panel_initial_width_ssr") ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel && (0, $ixfCV.fg)("preview_panel_initial_state") ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$4db84584556d15be$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)((0, $ixfCV.fg)('nin_glance_panel_initial_width_ssr') ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, {
        ...$4db84584556d15be$var$initialState,
        ...initialPanel && (0, $ixfCV.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $cozmU.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $cozmU.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $cozmU.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $cozmU.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $4db84584556d15be$export$609db4be92d0fad8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
} : ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $4db84584556d15be$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $4db84584556d15be$export$609db4be92d0fad8;

});

parcelRegister("63gyv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $55fM8 = parcelRequire("55fM8");


var $9DHhW = parcelRequire("9DHhW");


var $7y9ez = parcelRequire("7y9ez");

const $4ad8ebf5df3a3b12$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $cozmU.useState)((0, $7y9ez.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $cozmU.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $cozmU.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $cozmU.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $cozmU.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $cozmU.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $cozmU.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $7y9ez.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $4ad8ebf5df3a3b12$export$82b270f291af5a5;

});

parcelRegister("7y9ez", function(module, exports) {
const $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH = 400;
const $c1ed100d044a4357$var$PANEL_MAX_WIDTH = 1000;
const $c1ed100d044a4357$var$MINIMUM_WIDTH = 1800;
const $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $c1ed100d044a4357$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $c1ed100d044a4357$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $c1ed100d044a4357$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $c1ed100d044a4357$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $c1ed100d044a4357$export$29ceecbfeef33bfc;

});

parcelRegister("7ssWV", function(module, exports) {

var $7avaU = parcelRequire("7avaU");

const $2fea0aef81deca52$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $7avaU.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $7avaU.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $2fea0aef81deca52$export$eb89e687f2b278d7;

});

parcelRegister("4vI1F", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");



const $c3bd0aed1e73a4d2$export$cb9ee4d1dffdc955 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zbjaW",
    name: "ObjectSidebarContent",
    loader: async ()=>(await (parcelRequire("4HrcI"))).ObjectSidebarContent
});
module.exports["ObjectSidebarContent"] = $c3bd0aed1e73a4d2$export$cb9ee4d1dffdc955;

});

parcelRegister("4HrcI", function(module, exports) {

let $36c047bf189dee55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $36c047bf189dee55$var$load("houtd"),
    $36c047bf189dee55$var$load("g9l6t"),
    $36c047bf189dee55$var$load("3alGb")
]).then(()=>parcelRequire('23xdA'));

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["AgentReceiptPanel"] = "agentReceiptPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    PanelName["SpaceSuggestionReviewPanel"] = "space-suggestion-review-panel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    "agentReceiptPanel",
    "space-suggestion-review-panel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("aWwYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $lRhY3 = parcelRequire("lRhY3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $8s9DV.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $kBr4q.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $cozmU.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = showObjectSidebarWrapper;
    const memoizedActions = (0, $cozmU.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $cozmU.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("2vuKf", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $kBr4q.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $kBr4q.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $kBr4q.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("jAOzg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $9612d889a12dc002$var$createSyncStore() {
    let syncingFolderIds = new Set();
    const listeners = new Set();
    const notify = ()=>{
        listeners.forEach((listener)=>listener());
    };
    return {
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        },
        getSnapshot: ()=>syncingFolderIds,
        addSyncingFolder: (folderId)=>{
            if (syncingFolderIds.has(folderId)) return;
            const next = new Set(syncingFolderIds);
            next.add(folderId);
            syncingFolderIds = next;
            notify();
        },
        removeSyncingFolder: (folderId)=>{
            if (!syncingFolderIds.has(folderId)) return;
            const next = new Set(syncingFolderIds);
            next.delete(folderId);
            syncingFolderIds = next;
            notify();
        }
    };
}
/**
 * A store-based context for tracking which folders are syncing.
 *
 * Uses `useSyncExternalStore` so that each `useIsFolderSyncing(folderId)`
 * subscriber only re-renders when their specific folder's sync boolean
 * changes — not when any arbitrary folder starts/stops syncing.
 *
 * - `SmartFolderSyncStoreContext` holds the store instance.
 * - `SmartFolderSyncActionsContext` holds stable `add`/`remove` callbacks
 *   for writers (e.g. `useSmartFolderSync`) that never re-render on state change.
 */ const $9612d889a12dc002$var$SmartFolderSyncStoreContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $9612d889a12dc002$var$SmartFolderSyncActionsContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    addSyncingFolder: ()=>{},
    removeSyncingFolder: ()=>{}
});
const $9612d889a12dc002$export$a225af674c9c7799 = ({ children: children })=>{
    const storeRef = (0, $cozmU.useRef)(null);
    if (storeRef.current === null) storeRef.current = $9612d889a12dc002$var$createSyncStore();
    const store = storeRef.current;
    const actions = (0, $cozmU.useMemo)(()=>({
            addSyncingFolder: store.addSyncingFolder,
            removeSyncingFolder: store.removeSyncingFolder
        }), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9612d889a12dc002$var$SmartFolderSyncStoreContext.Provider, {
        value: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9612d889a12dc002$var$SmartFolderSyncActionsContext.Provider, {
        value: actions
    }, children));
};
const $9612d889a12dc002$var$EMPTY_SET = new Set();
const $9612d889a12dc002$var$EMPTY_SUBSCRIBE = (_cb)=>()=>{};
const $9612d889a12dc002$var$EMPTY_SNAPSHOT = ()=>$9612d889a12dc002$var$EMPTY_SET;
const $9612d889a12dc002$var$SERVER_SNAPSHOT_BOOL = ()=>false;
const $9612d889a12dc002$export$35a8d8248145227a = ()=>{
    const store = (0, $cozmU.useContext)($9612d889a12dc002$var$SmartFolderSyncStoreContext);
    return (0, $cozmU.useSyncExternalStore)(store?.subscribe ?? $9612d889a12dc002$var$EMPTY_SUBSCRIBE, store?.getSnapshot ?? $9612d889a12dc002$var$EMPTY_SNAPSHOT, $9612d889a12dc002$var$EMPTY_SNAPSHOT);
};
const $9612d889a12dc002$export$4cd077b71db9ec99 = (folderId)=>{
    const store = (0, $cozmU.useContext)($9612d889a12dc002$var$SmartFolderSyncStoreContext);
    const subscribe = store?.subscribe ?? $9612d889a12dc002$var$EMPTY_SUBSCRIBE;
    const getSnapshot = (0, $cozmU.useCallback)(()=>store ? store.getSnapshot().has(folderId) : false, [
        store,
        folderId
    ]);
    return (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, $9612d889a12dc002$var$SERVER_SNAPSHOT_BOOL);
};
const $9612d889a12dc002$export$8a3c75bc060e9cf8 = ()=>{
    return (0, $cozmU.useContext)($9612d889a12dc002$var$SmartFolderSyncActionsContext);
};
const $9612d889a12dc002$export$f1204087fc222a72 = (folderId, isSyncing)=>{
    const { addSyncingFolder: addSyncingFolder, removeSyncingFolder: removeSyncingFolder } = $9612d889a12dc002$export$8a3c75bc060e9cf8();
    (0, $cozmU.useEffect)(()=>{
        if (!isSyncing) return;
        addSyncingFolder(folderId);
        return ()=>{
            removeSyncingFolder(folderId);
        };
    }, [
        addSyncingFolder,
        folderId,
        isSyncing,
        removeSyncingFolder
    ]);
};
module.exports["SmartFolderSyncProvider"] = $9612d889a12dc002$export$a225af674c9c7799;
module.exports["useIsFolderSyncing"] = $9612d889a12dc002$export$4cd077b71db9ec99;
module.exports["useFolderSyncActions"] = $9612d889a12dc002$export$8a3c75bc060e9cf8;
module.exports["usePublishSmartFolderSyncState"] = $9612d889a12dc002$export$f1204087fc222a72;

});

parcelRegister("bpufi", function(module, exports) {

var $84kyw = parcelRequire("84kyw");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $hT3jf = parcelRequire("hT3jf");


var $9B4kz = parcelRequire("9B4kz");

const $20c8471b6a70899f$var$SmartFolderAncestorsQuery = (0, $84kyw.default);
const $20c8471b6a70899f$export$96af50927b5249f0 = (contentId)=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)($20c8471b6a70899f$var$SmartFolderAncestorsQuery, {
        variables: {
            contentId: contentId ?? ''
        },
        skip: !contentId,
        // cache-first avoids unnecessary network requests — the page tree query
        // typically already loaded the ptpage data we need.
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/smart-folder"
    });
    const { triggerSync: triggerSync } = (0, $9B4kz.useSmartFolderSync)({
        triggerSurface: 'ancestorView'
    });
    const lastTriggeredSyncKeyRef = (0, $cozmU.useRef)(null);
    const syncTargetId = (0, $cozmU.useMemo)(()=>{
        if (!contentId) return null;
        const ptpage = data?.ptpage;
        if (!ptpage || ptpage.id !== contentId) return null;
        // If the current content IS itself a smart folder, FolderOverview
        // will handle the sync; this hook only covers content nested inside
        // a smart folder.
        if ((0, $hT3jf.isSmartFolder)(ptpage)) return null;
        const ancestors = ptpage?.nearestAncestors?.nodes;
        if (!ancestors || ancestors.length === 0) return null;
        // Find the highest (root) MANAGED ancestor, if any.
        // `nearestAncestors` is ordered nearest-first, so iterate in reverse
        // to find the topmost smart folder.
        for(let i = ancestors.length - 1; i >= 0; i--){
            const ancestor = ancestors[i];
            if (ancestor && (0, $hT3jf.isSmartFolder)(ancestor)) return ancestor.id;
        }
        return null;
    }, [
        contentId,
        data?.ptpage
    ]);
    // syncTargetId is non-null iff a smart folder ancestor exists;
    // also handle the case where the content itself IS a smart folder.
    const isInSmartFolderTree = (0, $cozmU.useMemo)(()=>(data?.ptpage ? (0, $hT3jf.isSmartFolder)(data.ptpage) : false) || syncTargetId !== null, [
        data?.ptpage,
        syncTargetId
    ]);
    // Include `contentId` so that navigating away from and back to a page
    // nested inside the same smart folder re-triggers sync even though
    // `syncTargetId` resolves to the same root folder ID both times.
    (0, $cozmU.useEffect)(()=>{
        if (!syncTargetId) {
            lastTriggeredSyncKeyRef.current = null;
            return;
        }
        const syncKey = `${contentId}:${syncTargetId}`;
        if (lastTriggeredSyncKeyRef.current === syncKey) return;
        lastTriggeredSyncKeyRef.current = syncKey;
        triggerSync(syncTargetId);
    }, [
        contentId,
        syncTargetId,
        triggerSync
    ]);
    return {
        isInSmartFolderTree: isInSmartFolderTree
    };
};
module.exports["useSmartFolderAncestorSync"] = $20c8471b6a70899f$export$96af50927b5249f0;

});

parcelRegister("84kyw", function(module, exports) {
/**
 * @generated SignedSource<<3d2d56fdc053aa2d3639c1f34cea6843>>
 * @relayHash 701de8d25c0615cd65d074a2d0d26386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e4874aa6f1795a40140739a4ef2d22670502e0aa0add7ff9834458df2767c17
const $ee303482ff843c0d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "CURRENT",
                        "DRAFT"
                    ]
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSmartFolderAncestorSyncQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSmartFolderAncestorSyncQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "701de8d25c0615cd65d074a2d0d26386",
            "id": "9e4874aa6f1795a40140739a4ef2d22670502e0aa0add7ff9834458df2767c17",
            "metadata": {},
            "name": "useSmartFolderAncestorSyncQuery",
            "operationKind": "query",
            "text": "query useSmartFolderAncestorSyncQuery($contentId:ID!){ptpage(id:$contentId,status:[CURRENT,DRAFT]){id,type,subType,nearestAncestors{nodes{id,type,subType}}}}"
        }
    };
}();
$ee303482ff843c0d$var$node.hash = "3feebc26cc696b75c6544fb3f45823b7";
var $ee303482ff843c0d$export$2e2bcd8739ae039 = $ee303482ff843c0d$var$node;
module.exports["default"] = $ee303482ff843c0d$export$2e2bcd8739ae039;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("9B4kz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kcIQr = parcelRequire("kcIQr");


var $kCXmK = parcelRequire("kCXmK");


var $jAOzg = parcelRequire("jAOzg");


var $7TqMU = parcelRequire("7TqMU");

const $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_SUCCESS = 'success';
const $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_FAILED = 'failed';
const $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_SKIPPED_TTL = 'skippedTtl';
const $5a800d6d1cd2f48a$var$SMART_FOLDER_ANALYTICS_SOURCE = 'smartFolder';
const $5a800d6d1cd2f48a$var$getAutoSyncResult = ({ errors: errors, success: success })=>{
    const wasSkippedDueToTtl = errors?.some(({ message: message })=>message?.toLowerCase().includes('ttl')) ?? false;
    if (success && wasSkippedDueToTtl) return $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_SKIPPED_TTL;
    return success ? $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_SUCCESS : $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_FAILED;
};
const $5a800d6d1cd2f48a$export$f90756b916c77239 = (options)=>{
    const { onSyncComplete: onSyncComplete, triggerSurface: triggerSurface = 'folderView', journeyId: journeyId, provider: provider = 'unknown' } = options ?? {};
    const { syncSmartFolder: syncSmartFolder, loading: loading } = (0, $kCXmK.useSyncSmartFolder)();
    const { addSyncingFolder: addSyncingFolder, removeSyncingFolder: removeSyncingFolder } = (0, $jAOzg.useFolderSyncActions)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const syncingFolderRef = (0, $cozmU.useRef)(null);
    const statusRef = (0, $cozmU.useRef)('idle');
    const [syncErrorState, setSyncErrorState] = (0, $cozmU.useState)(null);
    // Derive a simple status from the mutation state + our local tracking
    const status = loading ? 'syncing' : statusRef.current;
    const fireAutoSyncAnalytics = (0, $cozmU.useCallback)(({ durationMs: durationMs, folderId: folderId, result: result })=>{
        const journeyAttribute = journeyId ? {
            journeyId: journeyId
        } : {};
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                source: $5a800d6d1cd2f48a$var$SMART_FOLDER_ANALYTICS_SOURCE,
                action: 'completed',
                actionSubject: 'smartFolderAutoSync',
                attributes: {
                    folderId: folderId,
                    provider: provider,
                    triggerSurface: triggerSurface,
                    result: result,
                    durationMs: durationMs,
                    ...journeyAttribute
                }
            }
        }).fire();
    }, [
        createEvent,
        journeyId,
        provider,
        triggerSurface
    ]);
    const triggerSync = (0, $cozmU.useCallback)((folderId, triggerOptions)=>{
        // De-duplicate: don't fire another request if we're already syncing this folder
        if (syncingFolderRef.current === folderId) return;
        const startedAt = Date.now();
        syncingFolderRef.current = folderId;
        statusRef.current = 'syncing';
        setSyncErrorState(null);
        addSyncingFolder(folderId);
        const { force: force } = triggerOptions ?? {};
        syncSmartFolder({
            folderId: folderId,
            ...force !== undefined ? {
                force: force
            } : {}
        }).then((result)=>{
            const payload = result?.data?.confluence_syncSmartFolder;
            const success = payload?.success ?? false;
            const syncResult = $5a800d6d1cd2f48a$var$getAutoSyncResult({
                errors: payload?.errors,
                success: success
            });
            statusRef.current = syncResult === 'success' ? 'success' : 'error';
            fireAutoSyncAnalytics({
                durationMs: Date.now() - startedAt,
                folderId: folderId,
                result: syncResult
            });
            if (syncResult === $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_SUCCESS) onSyncComplete?.();
            else {
                const rawErrorType = payload?.errors?.find((error)=>typeof error.extensions?.errorType === 'string')?.extensions?.errorType;
                // Prefer a mapped BE error state, but show generic retry UI for failed
                // mutation responses that do not include a FE-known errorType.
                const structuredErrorState = typeof rawErrorType === 'string' ? (0, $7TqMU.getSyncErrorState)(rawErrorType) : null;
                const fallbackErrorState = syncResult === $5a800d6d1cd2f48a$var$AUTO_SYNC_RESULT_FAILED ? (0, $7TqMU.SmartFolderErrorState).SyncTransientError : null;
                setSyncErrorState(structuredErrorState ?? fallbackErrorState);
            }
        }).catch(()=>{
            statusRef.current = 'error';
            fireAutoSyncAnalytics({
                durationMs: Date.now() - startedAt,
                folderId: folderId,
                result: 'failed'
            });
        }).finally(()=>{
            const finishedId = syncingFolderRef.current;
            syncingFolderRef.current = null;
            if (finishedId) removeSyncingFolder(finishedId);
            statusRef.current = 'idle';
        });
    }, [
        syncSmartFolder,
        addSyncingFolder,
        fireAutoSyncAnalytics,
        onSyncComplete,
        removeSyncingFolder
    ]);
    return {
        triggerSync: triggerSync,
        status: status,
        syncErrorState: syncErrorState
    };
};
module.exports["useSmartFolderSync"] = $5a800d6d1cd2f48a$export$f90756b916c77239;

});

parcelRegister("kcIQr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("kCXmK", function(module, exports) {

var $eY1jG = parcelRequire("eY1jG");


var $cozmU = parcelRequire("cozmU");


var $lEAnc = parcelRequire("lEAnc");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $fPTGf = parcelRequire("fPTGf");

const $a02f9f88b53bbb7f$export$f99b955ffb3c1231 = ()=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [syncSmartFolderMutation, { called: called, data: data, error: error, loading: loading }] = (0, $308Wd.useMutationInterop)((0, $eY1jG.default), {
        __callerPackage__: "@confluence/smart-folder"
    });
    const applySmartFolderSubTypeChange = (0, $fPTGf.useApplySmartFolderSubTypeChange)();
    const syncSmartFolder = (0, $cozmU.useCallback)(async ({ folderId: folderId, force: force })=>{
        const folderAri = (0, $lEAnc.ConfluenceFolderAri).create({
            activationId: activationId,
            folderId: folderId,
            siteId: cloudId
        }).toString();
        const result = await syncSmartFolderMutation({
            variables: {
                cloudId: cloudId,
                input: {
                    folderId: folderAri,
                    ...force !== undefined ? {
                        force: force
                    } : {}
                }
            }
        });
        const payload = result.data?.confluence_syncSmartFolder;
        const hasErrors = Boolean(payload?.errors?.length);
        if (payload?.success && !hasErrors) applySmartFolderSubTypeChange({
            folderId: folderId,
            subType: 'managed'
        });
        return result;
    }, [
        activationId,
        cloudId,
        syncSmartFolderMutation,
        applySmartFolderSubTypeChange
    ]);
    return {
        syncSmartFolder: syncSmartFolder,
        called: called,
        data: data,
        error: error,
        loading: loading
    };
};
module.exports["useSyncSmartFolder"] = $a02f9f88b53bbb7f$export$f99b955ffb3c1231;

});

parcelRegister("eY1jG", function(module, exports) {
/**
 * @generated SignedSource<<c21c68650ab28a19dbd692aa0c303a4d>>
 * @relayHash 6ef31550f1a84f52975ad108912b1bc5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55c51a3d63ff16775569e2936a90afe4aa4aa392c08de3ea8c4c25d05adf75fc
const $394869d03facb960$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "message"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "success"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSyncSmartFolderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceSyncSmartFolderPayload",
                    "kind": "LinkedField",
                    "name": "confluence_syncSmartFolder",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSyncSmartFolderMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceSyncSmartFolderPayload",
                    "kind": "LinkedField",
                    "name": "confluence_syncSmartFolder",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "6ef31550f1a84f52975ad108912b1bc5",
            "id": "55c51a3d63ff16775569e2936a90afe4aa4aa392c08de3ea8c4c25d05adf75fc",
            "metadata": {},
            "name": "useSyncSmartFolderMutation",
            "operationKind": "mutation",
            "text": "mutation useSyncSmartFolderMutation($cloudId:ID!,$input:ConfluenceSyncSmartFolderInput!){confluence_syncSmartFolder(cloudId:$cloudId,input:$input){errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}},success}}"
        }
    };
}();
$394869d03facb960$var$node.hash = "dec225cf1fdd258fa67d70013e7073ba";
var $394869d03facb960$export$2e2bcd8739ae039 = $394869d03facb960$var$node;
module.exports["default"] = $394869d03facb960$export$2e2bcd8739ae039;

});

parcelRegister("lEAnc", function(module, exports) {

var $7SOnZ = parcelRequire("7SOnZ");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/folder/manifest.ts
var $fc398c589f411de7$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7SOnZ.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $7SOnZ.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $fc398c589f411de7$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $fc398c589f411de7$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $fc398c589f411de7$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $fc398c589f411de7$export$501a782385a3f485;

});

parcelRegister("7SOnZ", function(module, exports) {
// src/confluence/folder/types.ts
var $5bd4a92be6836a9b$export$77cf4e1b17902bfa = "confluence", $5bd4a92be6836a9b$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $5bd4a92be6836a9b$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $5bd4a92be6836a9b$export$6256ff329bc25a9c;

});

parcelRegister("fPTGf", function(module, exports) {

var $8EdIy = parcelRequire("8EdIy");


var $cozmU = parcelRequire("cozmU");


var $ij4CE = parcelRequire("ij4CE");


var $ficwO = parcelRequire("ficwO");




const $ad18477d67abe91f$export$d0da2224ce3d22b8 = ()=>{
    const writeContentSubType = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $8EdIy.default),
        fragmentSpec: (0, $8EdIy.default),
        __callerPackage__: "@confluence/smart-folder"
    });
    const publishSyncStateChange = (0, $ficwO.useMessagePublisher)((0, $ficwO.Message).SmartFolderSyncStateChanged);
    return (0, $cozmU.useCallback)(({ folderId: folderId, subType: subType })=>{
        writeContentSubType({
            fragmentId: `Content:${folderId}`,
            data: {
                id: folderId,
                subType: subType,
                __typename: 'Content'
            }
        });
        publishSyncStateChange({
            contentId: folderId,
            subType: subType
        });
    }, [
        writeContentSubType,
        publishSyncStateChange
    ]);
};
module.exports["useApplySmartFolderSubTypeChange"] = $ad18477d67abe91f$export$d0da2224ce3d22b8;

});

parcelRegister("8EdIy", function(module, exports) {
/**
 * @generated SignedSource<<c12a07177dc0008a71c9fab7207e5c95>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4ae4c44658947c5d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useApplySmartFolderSubTypeChangeContentWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$4ae4c44658947c5d$var$node.hash = "7b1e91c800d1490b419afc4c6e95fb79";
var $4ae4c44658947c5d$export$2e2bcd8739ae039 = $4ae4c44658947c5d$var$node;
module.exports["default"] = $4ae4c44658947c5d$export$2e2bcd8739ae039;

});

parcelRegister("ficwO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

var $6c05dda517103510$export$f69c19e57285b83a = /*#__PURE__*/ function(Message) {
    Message[Message["ContentCreated"] = 0] = "ContentCreated";
    Message[Message["ContentUnarchived"] = 1] = "ContentUnarchived";
    Message[Message["SmartFolderSyncStateChanged"] = 2] = "SmartFolderSyncStateChanged";
    Message[Message["PageTreeRefreshRequested"] = 3] = "PageTreeRefreshRequested";
    return Message;
}({});
class $6c05dda517103510$var$MessageBus {
    publish(type, data) {
        if (!this.subscribers[type]) return;
        this.subscribers[type].forEach((subscriber)=>subscriber(data));
    }
    subscribe(type, callback) {
        if (!this.subscribers[type]) this.subscribers[type] = [];
        this.subscribers[type].push(callback);
    }
    unsubscribe(type, callback) {
        this.subscribers[type] = this.subscribers[type].filter((subscriber)=>subscriber !== callback);
    }
    constructor(){
        this.subscribers = {};
    }
}
const $6c05dda517103510$var$messageBus = new $6c05dda517103510$var$MessageBus();
const $6c05dda517103510$export$c4ca85b4851515e2 = (type)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== type) {
        t0 = (data)=>{
            $6c05dda517103510$var$messageBus.publish(type, data);
        };
        $[0] = type;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $6c05dda517103510$export$5ecf0545a6d326d0 = (type, data)=>{
    $6c05dda517103510$var$messageBus.publish(type, data);
};
const $6c05dda517103510$export$99473f2ba2f9f18 = (type, callback)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] !== callback || $[1] !== type) {
        t0 = ()=>{
            $6c05dda517103510$var$messageBus.subscribe(type, callback);
            return ()=>{
                $6c05dda517103510$var$messageBus.unsubscribe(type, callback);
            };
        };
        t1 = [
            callback,
            type
        ];
        $[0] = callback;
        $[1] = type;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
module.exports["Message"] = $6c05dda517103510$export$f69c19e57285b83a;
module.exports["useMessagePublisher"] = $6c05dda517103510$export$c4ca85b4851515e2;
module.exports["publishMessage"] = $6c05dda517103510$export$5ecf0545a6d326d0;
module.exports["useMessageSubscriber"] = $6c05dda517103510$export$99473f2ba2f9f18;

});

parcelRegister("7TqMU", function(module, exports) {
const $41e745ed0b19850d$export$ea09da326533f6e = {
    OwnerDeactivated: 'owner-deactivated',
    OwnerLostAccess: 'owner-lost-access',
    FolderDeleted: 'folder-deleted',
    SyncTransientError: 'sync-transient-error',
    Empty3PFolder: 'empty-3p-folder',
    IndexingInProgress: 'indexing-in-progress'
};
const $41e745ed0b19850d$export$99646b515a29a915 = (errorType)=>{
    switch(errorType){
        case 'SYNC_CONFLUENCE_OWNER_INELIGIBLE':
        case 'SYNC_REMOTE_OWNER_DEACTIVATED':
            return $41e745ed0b19850d$export$ea09da326533f6e.OwnerDeactivated;
        case 'SYNC_REMOTE_OWNER_LOST_ACCESS':
            return $41e745ed0b19850d$export$ea09da326533f6e.OwnerLostAccess;
        case 'SYNC_REMOTE_FOLDER_DELETED':
            return $41e745ed0b19850d$export$ea09da326533f6e.FolderDeleted;
        case 'SYNC_TRANSIENT_ERROR':
            return $41e745ed0b19850d$export$ea09da326533f6e.SyncTransientError;
        case 'SYNC_SOURCE_FOLDER_EMPTY':
            return $41e745ed0b19850d$export$ea09da326533f6e.Empty3PFolder;
        case 'SYNC_INDEXING_IN_PROGRESS':
            return $41e745ed0b19850d$export$ea09da326533f6e.IndexingInProgress;
        default:
            return null;
    }
};
module.exports["SmartFolderErrorState"] = $41e745ed0b19850d$export$ea09da326533f6e;
module.exports["getSyncErrorState"] = $41e745ed0b19850d$export$99646b515a29a915;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("64VTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fKN6m = parcelRequire("fKN6m");


var $471nw = parcelRequire("471nw");

const $8ae958986c8c799d$var$IntlMessagesProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $8ae958986c8c799d$export$2e2bcd8739ae039 = $8ae958986c8c799d$var$IntlMessagesProvider;
module.exports["default"] = $8ae958986c8c799d$export$2e2bcd8739ae039;

});

parcelRegister("fKN6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ezgjU = parcelRequire("ezgjU");

const $8781597542fb3a9a$export$4d17e2d9c5348842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $bDgLe.c)(4);
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $8781597542fb3a9a$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    (0, $cozmU.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $8781597542fb3a9a$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $8781597542fb3a9a$export$4d17e2d9c5348842;

});

parcelRegister("ezgjU", function(module, exports) {
const $c69670c8f17f7b27$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $c69670c8f17f7b27$export$79618bef82c02d4c;

});

parcelRegister("471nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ezgjU = parcelRequire("ezgjU");

// Prevents memory leaks
const $2a38add47fc8c1ad$var$cache = (0, $kSwu1.createIntlCache)();
const $2a38add47fc8c1ad$export$f752ac21ea3960a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) return (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $2a38add47fc8c1ad$export$f752ac21ea3960a5;

});

parcelRegister("9bYqt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6ebeb54b6dd4e1b6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $04900d7fce8c855a$export$2e2bcd8739ae039 = {
    'navigation.global-invite.error-state-description': 'Try refreshing the page or contact us if the problem persists.',
    'navigation.global-invite.error-state-heading': "We can't load the invite list right now",
    'navigation.global-invite.loading-visually-hidden-label': 'Loading',
    'navigation.global-invite.modal-dialog-label': 'Invite people'
};


var $6ebeb54b6dd4e1b6$export$2e2bcd8739ae039 = (0, $04900d7fce8c855a$export$2e2bcd8739ae039);

});

parcelRegister("9z9Sl", function(module, exports) {

let $6f6f0b0752b9a0b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6f6f0b0752b9a0b8$var$load("3xGk3").then(()=>parcelRequire('6aGGK'));

});

parcelRegister("kdftj", function(module, exports) {

let $eb7105f08e058163$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb7105f08e058163$var$load("6UvAM").then(()=>parcelRequire('9K8Or'));

});

parcelRegister("Is4v8", function(module, exports) {

let $0859e29c49d04aca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0859e29c49d04aca$var$load("deCnX").then(()=>parcelRequire('4bjH0'));

});

parcelRegister("78Q3c", function(module, exports) {

let $5331a7f198e46f3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5331a7f198e46f3c$var$load("cRXHQ").then(()=>parcelRequire('9hlv4'));

});

parcelRegister("1bED2", function(module, exports) {

let $0dd6558cf822ec29$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0dd6558cf822ec29$var$load("8y8Lu").then(()=>parcelRequire('ftvNl'));

});

parcelRegister("7qcoz", function(module, exports) {

let $56749394b0186549$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56749394b0186549$var$load("qstvS").then(()=>parcelRequire('7jOgP'));

});

parcelRegister("aruDH", function(module, exports) {

let $79a43156bd6ba3fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79a43156bd6ba3fc$var$load("ikk15").then(()=>parcelRequire('fDO36'));

});

parcelRegister("ebEFX", function(module, exports) {

let $a541a51b39c14bd1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a541a51b39c14bd1$var$load("gpMM6").then(()=>parcelRequire('6g5yJ'));

});

parcelRegister("j1P3i", function(module, exports) {

let $dda5b63215b083e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dda5b63215b083e0$var$load("3nWtY").then(()=>parcelRequire('19CEc'));

});

parcelRegister("96lDB", function(module, exports) {

let $6a05756d4af10282$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a05756d4af10282$var$load("liFDI").then(()=>parcelRequire('6cgit'));

});

parcelRegister("7xpIz", function(module, exports) {

let $57cf908394a74bf6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57cf908394a74bf6$var$load("imuyR").then(()=>parcelRequire('lMyRe'));

});

parcelRegister("kDdpi", function(module, exports) {

let $f051d97f0752dbbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f051d97f0752dbbb$var$load("eRuEp").then(()=>parcelRequire('i4TtY'));

});

parcelRegister("furxn", function(module, exports) {

let $b46f04ad987e6123$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b46f04ad987e6123$var$load("769BO").then(()=>parcelRequire('k8ECO'));

});

parcelRegister("1xorX", function(module, exports) {

let $11ebd6c775a6afbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11ebd6c775a6afbb$var$load("c72lo").then(()=>parcelRequire('2sPLo'));

});

parcelRegister("a8BIS", function(module, exports) {

let $7617e9b676ce80f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7617e9b676ce80f7$var$load("9puyy").then(()=>parcelRequire('gDLwU'));

});

parcelRegister("2L1sx", function(module, exports) {

let $20211a54b060a3fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20211a54b060a3fd$var$load("6DJB1").then(()=>parcelRequire('4o7FX'));

});

parcelRegister("ctn08", function(module, exports) {

let $914a090474d74ca4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $914a090474d74ca4$var$load("jf3Df").then(()=>parcelRequire('cDFPo'));

});

parcelRegister("abBcf", function(module, exports) {

let $76a7c8ed21e23a68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76a7c8ed21e23a68$var$load("beTW0").then(()=>parcelRequire('8maa8'));

});

parcelRegister("9XDV4", function(module, exports) {

let $740896ed4d14992c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $740896ed4d14992c$var$load("aTIh7").then(()=>parcelRequire('4E2ml'));

});

parcelRegister("7p3hh", function(module, exports) {

let $563d6914de543839$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $563d6914de543839$var$load("bdS5p").then(()=>parcelRequire('5rrGC'));

});

parcelRegister("gqOnY", function(module, exports) {

let $bf6628921bd0ac3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf6628921bd0ac3b$var$load("cvsqT").then(()=>parcelRequire('kTYCB'));

});

parcelRegister("gMVzI", function(module, exports) {

let $c38dca40d60e7516$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c38dca40d60e7516$var$load("1Scrf").then(()=>parcelRequire('iCTIC'));

});

parcelRegister("fnG5V", function(module, exports) {

let $b329a816c356ec60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b329a816c356ec60$var$load("gn448").then(()=>parcelRequire('jgpvp'));

});

parcelRegister("d3dgL", function(module, exports) {

let $9805d930718d6687$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9805d930718d6687$var$load("1szEl").then(()=>parcelRequire('2HMk5'));

});

parcelRegister("1WtoY", function(module, exports) {

let $16a203c90b05c9c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $16a203c90b05c9c9$var$load("ddvkk"),
    $16a203c90b05c9c9$var$load("3upHR"),
    $16a203c90b05c9c9$var$load("6wr18"),
    $16a203c90b05c9c9$var$load("6bg7L"),
    $16a203c90b05c9c9$var$load("9WR9l"),
    $16a203c90b05c9c9$var$load("aHDfe"),
    $16a203c90b05c9c9$var$load("gbaDy"),
    $16a203c90b05c9c9$var$load("gbejv"),
    $16a203c90b05c9c9$var$load("GD9EA"),
    $16a203c90b05c9c9$var$load("kHXvF"),
    $16a203c90b05c9c9$var$load("hhss7"),
    $16a203c90b05c9c9$var$load("ffEVr"),
    $16a203c90b05c9c9$var$load("Wowvf"),
    $16a203c90b05c9c9$var$load("eRhBr"),
    $16a203c90b05c9c9$var$load("7EorR"),
    $16a203c90b05c9c9$var$load("kJLMk")
]).then(()=>parcelRequire('b419Y'));

});

parcelRegister("iDE8i", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $c75ab09004f335b3$var$PostOfficeSideNavMessageContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $c75ab09004f335b3$export$730cc5718beea0d0 = ()=>{
    return (0, $cozmU.useContext)($c75ab09004f335b3$var$PostOfficeSideNavMessageContext);
};
const $c75ab09004f335b3$export$1a1a764f5b0fd0ac = ({ children: children })=>{
    const [enabledMessages, setEnabledMessages] = (0, $cozmU.useState)([]);
    const enablePostOfficeSideNavMessage = (0, $cozmU.useCallback)((message)=>{
        setEnabledMessages((prev)=>{
            if (prev.includes(message)) return prev;
            return [
                ...prev,
                message
            ];
        });
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            enabledMessages: enabledMessages,
            enablePostOfficeSideNavMessage: enablePostOfficeSideNavMessage
        }), [
        enabledMessages,
        enablePostOfficeSideNavMessage
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c75ab09004f335b3$var$PostOfficeSideNavMessageContext.Provider, {
        value: value,
        children: children
    });
};
module.exports["usePostOfficeSideNavMessages"] = $c75ab09004f335b3$export$730cc5718beea0d0;
module.exports["PostOfficeSideNavMessageProvider"] = $c75ab09004f335b3$export$1a1a764f5b0fd0ac;

});

parcelRegister("kB4yd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AssertError = void 0;
class $efeacb103f5d21a9$var$AssertError extends Error {
    constructor(method, path, expected, value){
        const message = path ? `Error on ${method}(): invalid type on ${path}, expect to be ${expected}` : `Error on ${method}(): invalid type, expect to be ${expected}`;
        super(message);
        this.method = method;
        this.path = path;
        this.expected = expected;
        this.value = value;
    }
}
module.exports.AssertError = $efeacb103f5d21a9$var$AssertError;

});

parcelRegister("aePf0", function(module, exports) {
"use strict";
var $7742f59926144658$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7742f59926144658$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7742f59926144658$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7742f59926144658$var$__exportStar((parcelRequire("5OGxy")), module.exports);

});

parcelRegister("5OGxy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("i1t43", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $ixfCV = parcelRequire("ixfCV");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $ixfCV.fg)("platform-dst-shape-theme-default") && $7e44050607850249$var$styles.baseT26Shape, appearance === "default" && $7e44050607850249$var$styles.defaultAppearance, appearance === "subtle" && $7e44050607850249$var$styles.subtleAppearance, appearance === "inverse" && $7e44050607850249$var$styles.inverseAppearance, appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== target || $[10] !== testId) {
        t3 = target === "_blank" && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`
        }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            className: (0, $hekY6.default)([
                "_1bsbgm0b _4t3igm0b _ahbqzjw7"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
            fill: "currentColor"
        })));
        $[9] = target;
        $[10] = testId;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== children || $[13] !== htmlAttributes || $[14] !== newWindowLabel || $[15] !== ref || $[16] !== t2 || $[17] !== t3 || $[18] !== target || $[19] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t2,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel
        }, children, t3);
        $[12] = children;
        $[13] = htmlAttributes;
        $[14] = newWindowLabel;
        $[15] = ref;
        $[16] = t2;
        $[17] = t3;
        $[18] = target;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $ixfCV.fg)('platform-dst-shape-theme-default') && $7e44050607850249$var$styles.baseT26Shape, appearance === 'default' && $7e44050607850249$var$styles.defaultAppearance, appearance === 'subtle' && $7e44050607850249$var$styles.subtleAppearance, appearance === 'inverse' && $7e44050607850249$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $7e44050607850249$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $hekY6.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("fR63l", function(module, exports) {
/**
 * Product keys for third-party connectors.
 * Each key maps to a unique identifier used throughout the search system.
 */ const $dce31c4071a2ecfb$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    JsmDC: 'jsm-dc',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Zoom: 'zoom'
};
const $dce31c4071a2ecfb$export$5378b945bea99ba3 = {
    AtlassianWebCrawler: 'webcrawler-connector',
    Figma: 'figma-connector',
    Github: 'github-connector',
    GoogleDrive: 'google-drive-connector',
    OneDrive: 'onedrive-connector',
    Dropbox: 'dropbox-connector',
    Slack: 'slack-connector',
    Sharepoint: 'sharepoint-connector',
    Teams: 'microsoft-teams-connector',
    GoogleCalendar: 'google-calendar-connector',
    OutlookCalendar: 'outlook-calendar-connector',
    OutlookMail: 'outlook-mail-connector',
    Gmail: 'gmail-connector',
    AdobeSign: 'adobe-sign-connector',
    Asana: 'asana-connector',
    Zendesk: 'zendesk-connector',
    Airtable: 'airtable-connector',
    Smartsheet: 'smartsheet-connector',
    Notion: 'notion-connector',
    Miro: 'miro-connector',
    Docusign: 'docusign-connector',
    Lucid: 'lucid-connector',
    Monday: 'monday-connector',
    AzureDevops: 'azure-devops-connector',
    Gitlab: 'gitlab-connector',
    ConfluenceDC: 'confluence-dc-connector',
    JiraDC: 'jira-dc-connector',
    JsmDC: 'jsm-dc-connector',
    Canva: 'canva-connector',
    Box: 'box-connector',
    Zeplin: 'smartlinks-connector-zeplin',
    ServiceNow: 'servicenow-connector',
    Freshservice: 'freshservice-connector',
    PowerBI: 'smartlinks-connector-power-bi',
    ClickUp: 'smartlinks-connector-clickup',
    Amplitude: 'smartlinks-connector-amplitude',
    Stripe: 'smartlinks-connector-stripe',
    AdobeXD: 'smartlinks-connector-adobexd',
    Aha: 'aha-connector',
    Mural: 'smartlinks-connector-mural',
    Webex: 'smartlinks-connector-webex',
    Todoist: 'smartlinks-connector-todoist',
    PagerDuty: 'smartlinks-connector-pagerduty',
    Pipedrive: 'smartlinks-connector-pipedrive',
    Hubspot: 'hubspot-connector',
    Dovetail: 'smartlinks-connector-dovetail',
    LaunchDarkly: 'smartlinks-connector-launchdarkly',
    Salesforce: 'salesforce-connector',
    Sentry: 'smartlinks-connector-sentry',
    Gitbook: 'gitbook-connector',
    AWSS3: 'aws-s3-connector',
    Databricks: 'databricks-connector',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Zoom: 'zoom-connector'
};
module.exports["ProductKeys3P"] = $dce31c4071a2ecfb$export$93aa518ca2694c2d;
module.exports["ProductResourceTypes3P"] = $dce31c4071a2ecfb$export$5378b945bea99ba3;

});

parcelRegister("8dynS", function(module, exports) {

var $fR63l = parcelRequire("fR63l");

const $06fddef4acfae0a8$export$9a80c24535b38e83 = 'confluence_3p_smartlink_connection_link_count';
const $06fddef4acfae0a8$export$d02d73057c4016d5 = 'confluence_3p_smartlink_connection_link_count_by_team_type_';
const $06fddef4acfae0a8$var$SUFFICIENCY_THRESHOLD = 20;
const $06fddef4acfae0a8$export$545eb843b77efaec = 3;
const $06fddef4acfae0a8$export$8594dab83de99a34 = [
    'google-drive',
    'slack',
    'github'
];
const $06fddef4acfae0a8$export$5dbf4404d8d730eb = {
    c_suite: [
        'google-drive',
        'slack',
        'github'
    ],
    customer_service: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    data_science: [
        'google-drive',
        'github',
        'slack'
    ],
    design: [
        'google-drive',
        'figma',
        'slack'
    ],
    engineering: [
        'google-drive',
        'github',
        'slack'
    ],
    finance: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    human_resources: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    information_technology: [
        'google-drive',
        'slack',
        'github'
    ],
    legal: [
        'google-drive',
        'slack',
        'sharepoint'
    ],
    marketing: [
        'google-drive',
        'slack',
        'figma'
    ],
    // `na` is the "no signal" floor row — kept in sync with the standalone
    // `DEFAULT_FALLBACK_APPS` export above by referencing the same constant.
    na: $06fddef4acfae0a8$export$8594dab83de99a34,
    operations: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    other: [
        'google-drive',
        'github',
        'slack'
    ],
    product_management: [
        'google-drive',
        'figma',
        'slack'
    ],
    program_management: [
        'google-drive',
        'onedrive',
        'sharepoint'
    ],
    sales: [
        'google-drive',
        'slack',
        'sharepoint'
    ]
};
const $06fddef4acfae0a8$export$db8c8b18ca3de852 = 'na';
const $06fddef4acfae0a8$var$APP_ID_TO_PRODUCT_KEY_ALIASES = {
    drive: (0, $fR63l.ProductKeys3P).GoogleDrive,
    figma: (0, $fR63l.ProductKeys3P).Figma,
    github: (0, $fR63l.ProductKeys3P).Github,
    'google-drive': (0, $fR63l.ProductKeys3P).GoogleDrive,
    onedrive: (0, $fR63l.ProductKeys3P).OneDrive,
    sharepoint: (0, $fR63l.ProductKeys3P).Sharepoint,
    slack: (0, $fR63l.ProductKeys3P).Slack
};
const $06fddef4acfae0a8$export$acda930d8972381e = (raw)=>{
    if (!raw || raw.trim().length === 0) return [];
    return raw.split(',').map((entry)=>entry.trim()).filter((entry)=>entry.length > 0).map((entry)=>{
        const separatorIndex = entry.indexOf(':');
        if (separatorIndex <= 0 || separatorIndex === entry.length - 1) return undefined;
        const appId = entry.slice(0, separatorIndex).trim();
        const count = Number(entry.slice(separatorIndex + 1).trim());
        if (appId.length === 0 || !Number.isFinite(count)) return undefined;
        return {
            appId: appId,
            count: count
        };
    }).filter((entry)=>entry !== undefined);
};
const $06fddef4acfae0a8$export$299a268eb011b7ef = (raw)=>{
    if (raw === undefined || raw.trim() === '') return undefined;
    const scalarCount = Number(raw);
    if (Number.isInteger(scalarCount) && scalarCount >= 0) return scalarCount;
    const appCounts = $06fddef4acfae0a8$export$acda930d8972381e(raw);
    if (appCounts.length === 0) return undefined;
    // parseAppCounts only guarantees isFinite; re-filter to positive integers before summing.
    const totalCount = appCounts.reduce((total, { count: count })=>{
        if (!Number.isInteger(count) || count <= 0) return total;
        return total + count;
    }, 0);
    return totalCount > 0 ? totalCount : undefined;
};
const $06fddef4acfae0a8$export$fe68bf06dd562208 = (parsed)=>parsed.map((entry, index)=>({
            ...entry,
            index: index
        })).filter((entry)=>entry.count > 0).sort((a, b)=>{
        if (b.count !== a.count) return b.count - a.count;
        return a.index - b.index;
    }).map((entry)=>entry.appId);
const $06fddef4acfae0a8$export$f9f1f4a4ade7c6e2 = (appId)=>{
    return $06fddef4acfae0a8$var$APP_ID_TO_PRODUCT_KEY_ALIASES[appId.toLowerCase()];
};
const $06fddef4acfae0a8$export$551da10284cad191 = (apps)=>apps.map($06fddef4acfae0a8$export$f9f1f4a4ade7c6e2).filter((productKey)=>productKey !== undefined);
const $06fddef4acfae0a8$export$7cc148373d70b178 = (existing, incoming, max)=>{
    const result = [];
    const seen = new Set();
    for (const productKey of [
        ...existing,
        ...incoming
    ])if (!seen.has(productKey)) {
        seen.add(productKey);
        result.push(productKey);
        if (result.length >= max) return result;
    }
    return result;
};
const $06fddef4acfae0a8$export$5d0c03a62d0c5b9f = ({ siteWideSmartlinkAppCounts: siteWideSmartlinkAppCounts, teamTypeSmartlinkAppCounts: teamTypeSmartlinkAppCounts, teamTypeKey: teamTypeKey } = {}, maxRecommendedApps = $06fddef4acfae0a8$export$545eb843b77efaec, options = {})=>{
    let productKeys = [];
    // Tier 1 — per-team-type TAP trait, gated on sufficiency.
    //
    // The sufficiency check is intentionally performed against the raw
    // (pre-filter) sum: it reflects whether the site as a whole has enough
    // activity for this team type to trust the signal, independent of which
    // apps we happen to support today. Only positive counts contribute so a
    // malformed TAP row with negatives (`"github:50, x:-40"`) cannot drag the
    // total below the threshold.
    const teamTypeParsed = $06fddef4acfae0a8$export$acda930d8972381e(teamTypeSmartlinkAppCounts);
    const teamTypePositiveSum = teamTypeParsed.reduce((sum, entry)=>sum + Math.max(0, entry.count), 0);
    if (teamTypePositiveSum >= $06fddef4acfae0a8$var$SUFFICIENCY_THRESHOLD) productKeys = $06fddef4acfae0a8$export$7cc148373d70b178([], $06fddef4acfae0a8$export$551da10284cad191($06fddef4acfae0a8$export$fe68bf06dd562208(teamTypeParsed)), maxRecommendedApps);
    // Tier 2 — site-wide TAP trait backfill.
    if (productKeys.length < maxRecommendedApps) {
        const siteWideParsed = $06fddef4acfae0a8$export$acda930d8972381e(siteWideSmartlinkAppCounts);
        productKeys = $06fddef4acfae0a8$export$7cc148373d70b178(productKeys, $06fddef4acfae0a8$export$551da10284cad191($06fddef4acfae0a8$export$fe68bf06dd562208(siteWideParsed)), maxRecommendedApps);
    }
    // Tier 3 — HARDCODED_DEFAULTS for the user's team type.
    //
    // If the caller didn't pass a teamTypeKey, or passed one we don't have
    // a curated row for, fall through to the `na` row. Because
    // HARDCODED_DEFAULTS.na references DEFAULT_FALLBACK_APPS by identity,
    // this single tier covers both the team-type-known case and the
    // "no signal at all" floor — no separate Tier 4 is needed.
    //
    // Skipped when `options.traitOnly` is set so animation callers (which
    // have their own department-based fallback) can distinguish "real signal"
    // from "cold-start defaults".
    if (!options.traitOnly && productKeys.length < maxRecommendedApps) {
        const tier3AppIds = (teamTypeKey ? $06fddef4acfae0a8$export$5dbf4404d8d730eb[teamTypeKey] : undefined) ?? $06fddef4acfae0a8$export$5dbf4404d8d730eb[$06fddef4acfae0a8$export$db8c8b18ca3de852] ?? [];
        productKeys = $06fddef4acfae0a8$export$7cc148373d70b178(productKeys, $06fddef4acfae0a8$export$551da10284cad191(tier3AppIds), maxRecommendedApps);
    }
    return productKeys;
};
module.exports["SMARTLINK_CONNECTION_LINK_COUNT_TRAIT"] = $06fddef4acfae0a8$export$9a80c24535b38e83;
module.exports["SMARTLINK_CONNECTION_LINK_COUNT_BY_TEAM_TYPE_TRAIT_PREFIX"] = $06fddef4acfae0a8$export$d02d73057c4016d5;
module.exports["DEFAULT_FALLBACK_APPS"] = $06fddef4acfae0a8$export$8594dab83de99a34;
module.exports["parseAppCounts"] = $06fddef4acfae0a8$export$acda930d8972381e;
module.exports["parseSmartlinkConnectionLinkCount"] = $06fddef4acfae0a8$export$299a268eb011b7ef;
module.exports["canonicalizeAppIdToProductKey"] = $06fddef4acfae0a8$export$f9f1f4a4ade7c6e2;
module.exports["resolveRecommendedProductKeys"] = $06fddef4acfae0a8$export$5d0c03a62d0c5b9f;

});

parcelRegister("4YcXR", function(module, exports) {
const $a0771ee7650ea498$export$995d9440dbc2c5f1 = {
    onboarding: 'onboarding',
    sideNav: 'side-nav'
};
module.exports["SMARTLINK_CONNECTION_TOUCHPOINTS"] = $a0771ee7650ea498$export$995d9440dbc2c5f1;

});

parcelRegister("9oJIg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gswTK = parcelRequire("gswTK");


var $MyxIQ = parcelRequire("MyxIQ");

const $5176b2e7fefe99e5$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $MyxIQ.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gswTK.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $5176b2e7fefe99e5$export$9be10e5cc29463c9;

});

parcelRegister("MyxIQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $apw3A = parcelRequire("apw3A");


var $4PX6o = parcelRequire("4PX6o");


var $bkTet = parcelRequire("bkTet");


var $6mKj3 = parcelRequire("6mKj3");


var $xwvlW = parcelRequire("xwvlW");


var $wPrRK = parcelRequire("wPrRK");


var $1xpoY = parcelRequire("1xpoY");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");



var $d5fg6 = parcelRequire("d5fg6");


var $0VKZa = parcelRequire("0VKZa");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $cdd1e9f9feeb24fd$var$postOfficeClient = new (0, $d5fg6.PostOfficeCacheClient)($cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE);
const $cdd1e9f9feeb24fd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cdd1e9f9feeb24fd$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($cdd1e9f9feeb24fd$export$18a0019e5439b209(res));
};
const $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $cdd1e9f9feeb24fd$var$getIsSSR = ()=>Boolean(undefined);
const $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME = 'post-office';
const $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME = 'post-office-archetype';
const $cdd1e9f9feeb24fd$var$confluenceFetcher = async (url, headers, requestInit)=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
        const cachedFetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $4PX6o.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($cdd1e9f9feeb24fd$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data);
        return $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) $cdd1e9f9feeb24fd$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $cdd1e9f9feeb24fd$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    return Array.from($cdd1e9f9feeb24fd$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    // Mirror client-side guard in Placement.tsx (useInitialDataIfEnabled → isPostOfficePlacementsGloballyDisabled)
    // to prevent SSR/client mismatch when placements are globally disabled (e.g. stableUI=1).
    if (postOfficeContext.disableAllPlacements) return;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, isBifrostIcRequest: isBifrostIcRequest } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME,
                // Tells Tesseract to S2S with `post-office`
                ...isBifrostIcRequest === true && (0, $6mKj3.expVal)('confluence_ssr_bifrost_ic', 'isEnabled', false) ? {
                    'x-archetype-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME
                } : {},
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $cdd1e9f9feeb24fd$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit);
        }
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit);
    };
    const basePath = (0, $apw3A.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $4PX6o.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $cdd1e9f9feeb24fd$export$420f2f91a928b3b6 = ()=>{
    return (0, $cozmU.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
            const fetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $cdd1e9f9feeb24fd$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $cozmU.useState)(()=>{
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $cozmU.useCallback)((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $cdd1e9f9feeb24fd$export$1d2f4123d64ba093 = async (placementId, extraFetchOptions)=>{
    const sessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const postOfficeTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_postoffice_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return (0, $wPrRK.slowQueryGuard)(`preloadPostOfficePlacement:${placementId}`, ()=>$cdd1e9f9feeb24fd$var$preloadPostOfficePlacement(placementId, {
            postOfficeContext: (0, $0VKZa.sessionToPostOfficeContext)(sessionContext),
            environment: {
                currentEnv: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(sessionContext.environment)
            }
        }, extraFetchOptions), postOfficeTimeout);
};
module.exports["usePlacementSSRFetch"] = $cdd1e9f9feeb24fd$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $cdd1e9f9feeb24fd$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $cdd1e9f9feeb24fd$export$1d2f4123d64ba093;

});

parcelRegister("apw3A", function(module, exports) {

var $3rMm0 = parcelRequire("3rMm0");


var $jdpvF = parcelRequire("jdpvF");

const $9fbb603c3fc74986$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $jdpvF.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $3rMm0.API_PATHNAME_STG_PROD);
    return {
        baseUrl: baseUrl,
        path: path
    };
};
module.exports["buildBasePath"] = $9fbb603c3fc74986$export$e8b30f9c4a80230f;

});

parcelRegister("4PX6o", function(module, exports) {
const $dc9030da747a3f79$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $dc9030da747a3f79$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $dc9030da747a3f79$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};
module.exports["defaultFetcher"] = $dc9030da747a3f79$export$77754e0ac9f8aba3;
module.exports["requestInitialData"] = $dc9030da747a3f79$export$c4c39037cc4b06ab;

});

parcelRegister("wPrRK", function(module, exports) {


var $9WAeG = parcelRequire("9WAeG");


var $1xpoY = parcelRequire("1xpoY");



const $0a25e88d230f5014$export$df0dc85e162077fe = 500;
const $0a25e88d230f5014$export$e4579551e9b7b973 = async (name, task, timeout, skipSignal)=>{
    let timer = null;
    const slowQueryGuardTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_slow_query_guard_timeout', $0a25e88d230f5014$export$df0dc85e162077fe);
    const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
    const timeoutPromise = new Promise((resolve)=>{
        timer = setTimeout(()=>{
            resolve(false);
        }, finalTimeout);
    });
    const runTask = async ()=>{
        const run = async ()=>{
            await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
            if (timer) clearTimeout(timer);
            return true;
        };
        return run();
    };
    return Promise.race(skipSignal ? [
        timeoutPromise,
        skipSignal.then(()=>true),
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};
module.exports["SLOW_QUERY_DEFAULT_TIMEOUT"] = $0a25e88d230f5014$export$df0dc85e162077fe;
module.exports["slowQueryGuard"] = $0a25e88d230f5014$export$e4579551e9b7b973;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("d5fg6", function(module, exports) {
class $2eb32372f08d498d$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get('placements/' + this.getKey(url))?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $2eb32372f08d498d$export$11e1da55bed53d18;

});

parcelRegister("0VKZa", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");


var $d9tcB = parcelRequire("d9tcB");

const $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT = 'confluence';
const $e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $e888fb1bd5b30926$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $e888fb1bd5b30926$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $e888fb1bd5b30926$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined,
        disableAllPlacements: (0, $i3jcY.isStableUIEnabledForTests)() ? true : undefined
    };
};
const $e888fb1bd5b30926$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $e888fb1bd5b30926$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $e888fb1bd5b30926$export$76d03739bfe0286a;

});

parcelRegister("bZSO8", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");


var $98wxI = parcelRequire("98wxI");

const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    // used by createpage.action endpoint.
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    autoImportJiraIssues: (0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM),
    jiraImportJql: (0, $hQnHK.JIRA_IMPORT_JQL),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker',
    journeyId: 'journeyId',
    templateKey: 'templateKey',
    onboardingEntryPoint: 'onboardingEntryPoint',
    cwrWelcome: 'cwrWelcome'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM) in options && options.autoImportJiraIssues) queryParams[$e7afa99020494478$var$queryParamKeys.autoImportJiraIssues] = options.autoImportJiraIssues;
    if ((0, $hQnHK.JIRA_IMPORT_JQL) in options && options.jiraImportJql) queryParams[$e7afa99020494478$var$queryParamKeys.jiraImportJql] = options.jiraImportJql;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    if ('journeyId' in options && options.journeyId) queryParams[$e7afa99020494478$var$queryParamKeys.journeyId] = options.journeyId;
    if ('templateKey' in options && options.templateKey) queryParams[$e7afa99020494478$var$queryParamKeys.templateKey] = options.templateKey;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) {
        if (contentType === "folder") return;
        return contentType;
    }
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId);
    const projectUuid = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid);
    const autoImportJiraIssues = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.autoImportJiraIssues) ? true : undefined;
    const jiraImportJql = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.jiraImportJql);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const journeyId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.journeyId);
    const onboardingEntryPoint = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.onboardingEntryPoint);
    const cwrWelcome = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cwrWelcome);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateKey);
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: // prefer new parameter over old parameter
        title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        autoImportJiraIssues: autoImportJiraIssues,
        jiraImportJql: jiraImportJql,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker,
        journeyId: journeyId,
        onboardingEntryPoint: onboardingEntryPoint,
        templateKey: templateKey,
        cwrWelcome: cwrWelcome
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});
module.exports["buildCreationLink"] = $e7afa99020494478$export$b3086acbf0304043;
module.exports["useCreateRouteSupportedContentType"] = $e7afa99020494478$export$963d972ae7433a64;
module.exports["parseQueryParams"] = $e7afa99020494478$export$67c4cee80a3410cd;
module.exports["ExperienceResolution"] = $e7afa99020494478$export$f9ad0711e89cafb5;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("98wxI", function(module, exports) {
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});
module.exports["PaywallStatus"] = $5046ea0ba58442ff$export$d9669dcdbd1161d9;

});

parcelRegister("bAyaS", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $kBr4q.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $kBr4q.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $kBr4q.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $kBr4q.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useShouldRenderDrawer"] = $8eabddf4fe78ba91$export$34596812152477bc;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("8YePs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $b3ddd992633db411$export$6e8ea24b15199873;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("jFFx4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dPJCf = parcelRequire("dPJCf");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $3194c63c7e99e1cb$export$2537d74141d57f9e = ()=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const saveCurrentRoute = (0, $cozmU.useCallback)(()=>{
        const currentRoute = routeDataRef.current?.href;
        if (currentRoute) (0, $17wUi.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).NAV4_SETTINGS_BACK_BUTTON_URL, currentRoute);
    }, [
        routeDataRef
    ]);
    const getRoute = (0, $cozmU.useCallback)((defaultPath)=>{
        const previousPath = (0, $17wUi.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).NAV4_SETTINGS_BACK_BUTTON_URL);
        return previousPath ?? defaultPath;
    }, []);
    return {
        saveCurrentRoute: saveCurrentRoute,
        getRoute: getRoute
    };
};
module.exports["useSettingsBackButtonUtils"] = $3194c63c7e99e1cb$export$2537d74141d57f9e;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("7PhZc", function(module, exports) {

let $5b2b3f76084c465d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5b2b3f76084c465d$var$load("6wr18"),
    $5b2b3f76084c465d$var$load("4zjgJ"),
    $5b2b3f76084c465d$var$load("9WR9l"),
    $5b2b3f76084c465d$var$load("e00ow"),
    $5b2b3f76084c465d$var$load("iN26T"),
    $5b2b3f76084c465d$var$load("Wowvf"),
    $5b2b3f76084c465d$var$load("ffEVr"),
    $5b2b3f76084c465d$var$load("geh8r")
]).then(()=>parcelRequire('8oHcg'));

});

parcelRegister("gmhHk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $h11I1 = parcelRequire("h11I1");


var $5tUtl = parcelRequire("5tUtl");

const $61ed3f7435f1fd68$export$4b1545b4f2016d26 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, testId: testId, ariaLabel: ariaLabel, isMenuListItem: t1 } = t0;
    const isMenuListItem = t1 === undefined ? false : t1;
    const id = (0, $6JrSr.useId)();
    const t2 = `${id}-heading`;
    let t3;
    if ($[0] !== ariaLabel || $[1] !== children || $[2] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "group",
            "aria-labelledby": t2,
            "aria-label": ariaLabel
        }, children);
        $[0] = ariaLabel;
        $[1] = children;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== id || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tUtl.MenuSectionContext).Provider, {
            value: id
        }, t3);
        $[4] = id;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const content = t4;
    if (isMenuListItem) {
        let t5;
        if ($[7] !== content || $[8] !== testId) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
                testId: testId
            }, content);
            $[7] = content;
            $[8] = testId;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    return content;
} : ({ children: children, testId: testId, ariaLabel: ariaLabel, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $6JrSr.useId)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tUtl.MenuSectionContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "group",
        "aria-labelledby": `${id}-heading`,
        "aria-label": ariaLabel
    }, children));
    if (isMenuListItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
        testId: testId
    }, content);
    // Legacy. isMenuListItem should become default.
    return content;
};
module.exports["MenuSection"] = $61ed3f7435f1fd68$export$4b1545b4f2016d26;

});

parcelRegister("5tUtl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");

const $f8fd377d923f47fb$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $f8fd377d923f47fb$export$8100cda602411810 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($f8fd377d923f47fb$export$728ac99b9c7eea8a);
    (0, $bB0i2.default)(context, "useMenuSectionContext must be used within a MenuSection");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($f8fd377d923f47fb$export$728ac99b9c7eea8a);
    (0, $bB0i2.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};
module.exports["MenuSectionContext"] = $f8fd377d923f47fb$export$728ac99b9c7eea8a;
module.exports["useMenuSectionContext"] = $f8fd377d923f47fb$export$8100cda602411810;

});

parcelRegister("4X3mP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $5tUtl = parcelRequire("5tUtl");

const $81e6b252f2c7d20c$var$styles = {
    root: "_11c8i4vh _1rjcu2gc _syaz1rpy _bozg12x7"
}; /**
    * __MenuSectionHeading__
    *
    * The label for the menu section group.
    */ 
const $81e6b252f2c7d20c$export$5d3acdbf9237a364 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    const id = (0, $5tUtl.useMenuSectionContext)();
    const t1 = `${id}-heading`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $81e6b252f2c7d20c$var$styles.root
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== t1) {
        t3 = /*#__PURE__*/ $cozmU.createElement("p", {
            id: t1,
            className: t2
        }, children);
        $[1] = children;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children })=>{
    const id = (0, $5tUtl.useMenuSectionContext)();
    return /*#__PURE__*/ $cozmU.createElement("p", {
        id: `${id}-heading`,
        className: (0, $hekY6.default)([
            $81e6b252f2c7d20c$var$styles.root
        ])
    }, children);
};
module.exports["MenuSectionHeading"] = $81e6b252f2c7d20c$export$5d3acdbf9237a364;

});

parcelRegister("huaOC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4Qc44 = parcelRequire("4Qc44");


var $lmzCg = parcelRequire("lmzCg");


var $hLtfj = parcelRequire("hLtfj");


var $KuePV = parcelRequire("KuePV");


var $4o9cR = parcelRequire("4o9cR");

const $e30c6d4ea2de4ef1$var$listItemStyles = {
    root: "_10m98stt"
};
const $e30c6d4ea2de4ef1$var$LinkMenuItemNoRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(26);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const itemRef = (0, $cozmU.useRef)(null);
    const t1 = isSelected ?? false;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            elementRef: itemRef,
            isSelected: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    (0, $4o9cR.useScrollMenuItemIntoView)(t2);
    const t3 = listItemRef ?? null;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $lmzCg.default)([
            itemRef,
            t3
        ]);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const ref = t4;
    let t5;
    if ($[4] !== actions || $[5] !== actionsOnHover || $[6] !== children || $[7] !== description || $[8] !== dropIndicator || $[9] !== elemAfter || $[10] !== elemBefore || $[11] !== forwardedRef || $[12] !== hasDragIndicator || $[13] !== href || $[14] !== interactionName || $[15] !== isContentTooltipDisabled || $[16] !== isDragging || $[17] !== isSelected || $[18] !== onClick || $[19] !== target || $[20] !== testId || $[21] !== visualContentRef) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children);
        $[4] = actions;
        $[5] = actionsOnHover;
        $[6] = children;
        $[7] = description;
        $[8] = dropIndicator;
        $[9] = elemAfter;
        $[10] = elemBefore;
        $[11] = forwardedRef;
        $[12] = hasDragIndicator;
        $[13] = href;
        $[14] = interactionName;
        $[15] = isContentTooltipDisabled;
        $[16] = isDragging;
        $[17] = isSelected;
        $[18] = onClick;
        $[19] = target;
        $[20] = testId;
        $[21] = visualContentRef;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== ref || $[24] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $hLtfj.ListItem), {
            ref: ref,
            xcss: $e30c6d4ea2de4ef1$var$listItemStyles.root
        }, t5);
        $[23] = ref;
        $[24] = t5;
        $[25] = t6;
    } else t6 = $[25];
    return t6;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $4o9cR.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $cozmU.useMemo)(()=>{
        return (0, $lmzCg.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $hLtfj.ListItem), {
        ref: ref,
        xcss: $e30c6d4ea2de4ef1$var$listItemStyles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
};
const $e30c6d4ea2de4ef1$export$d2cad7a1cce7b35f = (0, $4Qc44.default)($e30c6d4ea2de4ef1$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $e30c6d4ea2de4ef1$export$d2cad7a1cce7b35f;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("4o9cR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $8AWCX = parcelRequire("8AWCX");

function $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element) {
    /**
   * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
   * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
   * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
   *
   * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
const $9fe3f1218f1710c7$export$2c52ec851fcc6058 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useScrollMenuItemIntoView(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { elementRef: elementRef, isSelected: isSelected } = t0;
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            type: "waiting-to-be-selected-and-all-ancestors-expanded"
        };
        $[0] = t1;
    } else t1 = $[0];
    const waitingStateRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[1] !== areAllAncestorsExpanded || $[2] !== elementRef || $[3] !== isSelected) {
        t2 = ()=>{
            if (waitingStateRef.current.type === "waiting-to-be-selected-and-all-ancestors-expanded") {
                const shouldScroll = areAllAncestorsExpanded && isSelected;
                if (!shouldScroll) return;
                const element = elementRef.current;
                (0, $bB0i2.default)(element, "Element ref must be set");
                $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element);
                waitingStateRef.current.type = "waiting-to-be-unselected";
                return;
            }
            if (waitingStateRef.current.type === "waiting-to-be-unselected") {
                if (!isSelected) waitingStateRef.current.type = "waiting-to-be-selected-and-all-ancestors-expanded";
                return;
            }
        };
        t3 = [
            areAllAncestorsExpanded,
            elementRef,
            isSelected
        ];
        $[1] = areAllAncestorsExpanded;
        $[2] = elementRef;
        $[3] = isSelected;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useScrollMenuItemIntoView({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $cozmU.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $cozmU.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $bB0i2.default)(element, 'Element ref must be set');
            $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
};
module.exports["useScrollMenuItemIntoView"] = $9fe3f1218f1710c7$export$2c52ec851fcc6058;

});

parcelRegister("dVkip", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $j3b2C = parcelRequire("j3b2C");


var $5t9S7 = parcelRequire("5t9S7");


var $4eIcx = parcelRequire("4eIcx");


var $4H4Pj = parcelRequire("4H4Pj");


var $gW6rh = parcelRequire("gW6rh");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $lvOsp = parcelRequire("lvOsp");


var $ep3mz = parcelRequire("ep3mz");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");

const $568e72a32d90ae8c$export$927df7988fec803 = (0, $gW6rh.default);
const $568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesQuery = (0, $4H4Pj.default);
const $568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery = (0, $4eIcx.default);
const $568e72a32d90ae8c$var$useSpacesDataAnonymousSpacesQuery = (0, $5t9S7.default);
const $568e72a32d90ae8c$var$useSpacesDataSearchSpacesQuery = (0, $j3b2C.default);
const $568e72a32d90ae8c$var$hasCurrentSpace = (data)=>'space' in data;
const $568e72a32d90ae8c$var$isCurrentSpaceNotFoundError = (gqlError)=>gqlError.path?.[0] === 'space' && gqlError.extensions?.['statusCode'] === 404;
const $568e72a32d90ae8c$var$processStarredError = (error)=>{
    if (!error) return undefined;
    if ((0, $1uFM6.isUnauthorizedError)(error)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return error;
};
const $568e72a32d90ae8c$var$processRecentError = (error)=>{
    if (!error) return undefined;
    /**
   * space
   *    403: Expected to occur when the user is on a restricted space
   *    404: Expected to occur when the user is on an invalid space
   * recentSpaces
   *    403: Harmless error temporarily being ignored to mitigate CONFDEV-71458.
   *         Removing in CONFDEV-71656.
   */ if ((0, $1uFM6.isUnauthorizedError)(error) || !error.networkError && error.graphQLErrors.every($568e72a32d90ae8c$var$isCurrentSpaceNotFoundError)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return error;
};
const $568e72a32d90ae8c$export$e3e9588fd2c1abdd = ({ isLicensed: isLicensed })=>{
    const { data: starredSpacesData, loading: starredSpacesLoading, error: starredSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$export$927df7988fec803, {
        skip: !isLicensed,
        __callerPackage__: "@confluence/space-utils"
    });
    const { data: anonymousSpacesData, loading: anonymousSpacesLoading, error: anonymousSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataAnonymousSpacesQuery, {
        skip: isLicensed,
        __callerPackage__: "@confluence/space-utils"
    });
    const data = isLicensed ? starredSpacesData : anonymousSpacesData;
    const loading = isLicensed ? starredSpacesLoading : anonymousSpacesLoading;
    const error = isLicensed ? starredSpacesError : anonymousSpacesError;
    const starredSpaces = (data?.spaces?.nodes || []).filter((space)=>space != null).map((space_0)=>({
            ...space_0,
            currentUser: {
                isFavourited: isLicensed
            }
        }));
    const unexpectedError = $568e72a32d90ae8c$var$processStarredError(error);
    return {
        starredSpaces: starredSpaces,
        loading: loading,
        error: unexpectedError
    };
};
const $568e72a32d90ae8c$var$useRecentData = (isLicensed)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: myVisitedSpacesWithCurrentSpaceData, loading: myVisitedSpacesWithCurrentSpaceLoading, error: myVisitedSpacesWithCurrentSpaceError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery, {
        skip: !isLicensed || !spaceKey,
        variables: {
            selectedSpaceKey: spaceKey
        },
        errorPolicy: 'all',
        __callerPackage__: "@confluence/space-utils"
    });
    const { data: myVisitedSpacesData, loading: myVisitedSpacesLoading, error: myVisitedSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesQuery, {
        skip: !isLicensed || !!spaceKey,
        errorPolicy: 'all',
        __callerPackage__: "@confluence/space-utils"
    });
    const data = spaceKey ? myVisitedSpacesWithCurrentSpaceData : myVisitedSpacesData;
    const loading = spaceKey ? myVisitedSpacesWithCurrentSpaceLoading : myVisitedSpacesLoading;
    const error = spaceKey ? myVisitedSpacesWithCurrentSpaceError : myVisitedSpacesError;
    const currentSpace = data && $568e72a32d90ae8c$var$hasCurrentSpace(data) && data.space || undefined;
    const recentData = data?.myVisitedSpaces?.nodes?.spaces;
    const recentSpaces = (recentData || []).filter((space)=>space != null && (!currentSpace || currentSpace.id !== space.id));
    const unexpectedError = $568e72a32d90ae8c$var$processRecentError(error);
    return {
        recentSpaces: recentSpaces,
        currentSpace: currentSpace,
        loading: loading,
        error: unexpectedError
    };
};
const $568e72a32d90ae8c$export$680b01e9499af50d = ()=>{
    const $ = (0, $bDgLe.c)(18);
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== isLicensed) {
        t0 = {
            isLicensed: isLicensed
        };
        $[0] = isLicensed;
        $[1] = t0;
    } else t0 = $[1];
    const { starredSpaces: starredSpaces, loading: starredLoading, error: starredError } = $568e72a32d90ae8c$export$e3e9588fd2c1abdd(t0);
    const { recentSpaces: unfilteredRecents, currentSpace: currentSpace, loading: recentLoading, error: recentError } = $568e72a32d90ae8c$var$useRecentData(isLicensed);
    let t1;
    if ($[2] !== starredSpaces) {
        t1 = new Set(starredSpaces.map($568e72a32d90ae8c$var$_temp));
        $[2] = starredSpaces;
        $[3] = t1;
    } else t1 = $[3];
    const starredIds = t1;
    let t2;
    if ($[4] !== starredIds || $[5] !== unfilteredRecents) {
        let t3;
        if ($[7] !== starredIds) {
            t3 = (recent)=>!starredIds.has(recent.id);
            $[7] = starredIds;
            $[8] = t3;
        } else t3 = $[8];
        t2 = unfilteredRecents.filter(t3).slice(0, 5);
        $[4] = starredIds;
        $[5] = unfilteredRecents;
        $[6] = t2;
    } else t2 = $[6];
    const recentSpaces = t2;
    let errors;
    if ($[9] !== recentError || $[10] !== starredError) {
        errors = [];
        if (starredError) errors.push(starredError);
        if (recentError) errors.push(recentError);
        $[9] = recentError;
        $[10] = starredError;
        $[11] = errors;
    } else errors = $[11];
    const t3 = starredLoading || recentLoading;
    let t4;
    if ($[12] !== currentSpace || $[13] !== errors || $[14] !== recentSpaces || $[15] !== starredSpaces || $[16] !== t3) {
        t4 = {
            errors: errors,
            loading: t3,
            starredSpaces: starredSpaces,
            recentSpaces: recentSpaces,
            currentSpace: currentSpace
        };
        $[12] = currentSpace;
        $[13] = errors;
        $[14] = recentSpaces;
        $[15] = starredSpaces;
        $[16] = t3;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
};
const $568e72a32d90ae8c$export$ecaaf759b72f2f3d = ()=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const [executeSearch, { data: data, loading: loading, error: error }] = (0, $lvOsp.useLazyQueryInterop)($568e72a32d90ae8c$var$useSpacesDataSearchSpacesQuery, {
        __callerPackage__: "@confluence/space-utils"
    });
    const spaceSearchResults = (data?.spaces?.nodes || []).filter((space)=>space != null);
    const searchSpaces = (0, $cozmU.useCallback)((pattern)=>{
        if (pattern) executeSearch({
            variables: {
                spaceNamePattern: pattern,
                isLicensed: isLicensed
            }
        });
    }, [
        executeSearch,
        isLicensed
    ]);
    return {
        spaceSearchResults: spaceSearchResults,
        loading: loading,
        error: error,
        searchSpaces: searchSpaces
    };
};
function $568e72a32d90ae8c$var$_temp(starred) {
    return starred.id;
}
module.exports["useStarredData"] = $568e72a32d90ae8c$export$e3e9588fd2c1abdd;
module.exports["useSpacesData"] = $568e72a32d90ae8c$export$680b01e9499af50d;
module.exports["useSpaceSearchData"] = $568e72a32d90ae8c$export$ecaaf759b72f2f3d;

});

parcelRegister("j3b2C", function(module, exports) {
/**
 * @generated SignedSource<<05b9969d72cde883b714d417571da65a>>
 * @relayHash 807f0e620b159313dc25553268599830
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70861de93bb2fad274e766975466ed85401ffa7b0e25a315a6d6b3de43a390ee
const $abc61d7dc008195d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceNamePattern"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30
                },
                {
                    "kind": "Variable",
                    "name": "spaceNamePattern",
                    "variableName": "spaceNamePattern"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "current"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "SpaceUserMetadata",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourited"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpacesDataSearchSpacesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpacesDataSearchSpacesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "807f0e620b159313dc25553268599830",
            "id": "70861de93bb2fad274e766975466ed85401ffa7b0e25a315a6d6b3de43a390ee",
            "metadata": {},
            "name": "useSpacesDataSearchSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataSearchSpacesQuery($spaceNamePattern:String!,$isLicensed:Boolean!){spaces(first:30,status:\"current\",spaceNamePattern:$spaceNamePattern){nodes{alias,id,name,key,status,icon{path},currentUser@include(if:$isLicensed){isFavourited}}}}"
        }
    };
}();
$abc61d7dc008195d$var$node.hash = "414c959dafecb5d27ba9ddb5658cc68d";
var $abc61d7dc008195d$export$2e2bcd8739ae039 = $abc61d7dc008195d$var$node;
module.exports["default"] = $abc61d7dc008195d$export$2e2bcd8739ae039;

});

parcelRegister("5t9S7", function(module, exports) {
/**
 * @generated SignedSource<<834023d7f0314fe8e5962f6e892c4636>>
 * @relayHash 6a42dba0e2f55d85a4e53a29287ca269
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476
const $410f901cf69fac5d$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(first:10)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "6a42dba0e2f55d85a4e53a29287ca269",
            "id": "5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476",
            "metadata": {},
            "name": "useSpacesDataAnonymousSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataAnonymousSpacesQuery{spaces(first:10){nodes{alias,id,name,key,status,icon{path}}}}"
        }
    };
}();
$410f901cf69fac5d$var$node.hash = "7f837e22c8d2b27a827944523b07b786";
var $410f901cf69fac5d$export$2e2bcd8739ae039 = $410f901cf69fac5d$var$node;
module.exports["default"] = $410f901cf69fac5d$export$2e2bcd8739ae039;

});

parcelRegister("4eIcx", function(module, exports) {
/**
 * @generated SignedSource<<2801721cb0c85e92874b08f85a0ef8ee>>
 * @relayHash e0d0ca312e455dd89cba54cfb1984fbb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e
const $f0042d2ade0da40c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "selectedSpaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "alias"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "selectedSpaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "e0d0ca312e455dd89cba54cfb1984fbb",
            "id": "526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey:String){space(key:$selectedSpaceKey){alias,id,name,key,status,icon{path},currentUser{isFavourited}},myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$f0042d2ade0da40c$var$node.hash = "24da03b127211694c7ed862f0d6a1ac9";
var $f0042d2ade0da40c$export$2e2bcd8739ae039 = $f0042d2ade0da40c$var$node;
module.exports["default"] = $f0042d2ade0da40c$export$2e2bcd8739ae039;

});

parcelRegister("4H4Pj", function(module, exports) {
/**
 * @generated SignedSource<<522284270ccae9ff37ff7a08efdc694a>>
 * @relayHash 0f8f1589411c8c2d9b98218fe1edd493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79
const $893f79462ca6be46$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f8f1589411c8c2d9b98218fe1edd493",
            "id": "68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesQuery{myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$893f79462ca6be46$var$node.hash = "7082555a280d4e2eb838dda87a12b019";
var $893f79462ca6be46$export$2e2bcd8739ae039 = $893f79462ca6be46$var$node;
module.exports["default"] = $893f79462ca6be46$export$2e2bcd8739ae039;

});

parcelRegister("gW6rh", function(module, exports) {
/**
 * @generated SignedSource<<6731d778ac5ebb58b720918619ebf00d>>
 * @relayHash 3aa9658e6db0cb9714f9e327bc6d5bd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8
const $af8a2f26164bd677$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "favourite",
                    "value": true
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "current"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(favourite:true,first:30,status:\"current\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "3aa9658e6db0cb9714f9e327bc6d5bd0",
            "id": "9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8",
            "metadata": {},
            "name": "useSpacesDataStarredSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataStarredSpacesQuery{spaces(favourite:true,first:30,status:\"current\"){__typename,nodes{alias,id,name,key,status,icon{path}}}}"
        }
    };
}();
$af8a2f26164bd677$var$node.hash = "519f9d02cbfeb4f3f118821c02e3a7b9";
var $af8a2f26164bd677$export$2e2bcd8739ae039 = $af8a2f26164bd677$var$node;
module.exports["default"] = $af8a2f26164bd677$export$2e2bcd8739ae039;

});

parcelRegister("lvOsp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $7EPz1 = parcelRequire("7EPz1");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $8BQV6 = parcelRequire("8BQV6");


var $422HI = parcelRequire("422HI");


var $26Yfd = parcelRequire("26Yfd");


var $kczYx = parcelRequire("kczYx");


var $iffSy = parcelRequire("iffSy");


var $3NBsC = parcelRequire("3NBsC");


var $5T18X = parcelRequire("5T18X");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");


var $bFdYQ = parcelRequire("bFdYQ");


var $3VgTg = parcelRequire("3VgTg");

/** Synced-each-render ref; no microtask lag. */ function $278c8d04dad7bc1d$var$useSyncedRef(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
/**
 * Coerce an unknown thrown value into an ApolloErrorInterop so callers can
 * read Apollo's `graphQLErrors` / `networkError` fields uniformly across the
 * Apollo and Relay branches.
 */ function $278c8d04dad7bc1d$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $278c8d04dad7bc1d$var$getOperationName(node) {
    if ('definitions' in node) {
        const def = node.definitions?.find((d)=>d.kind === 'OperationDefinition' && 'name' in d);
        return def?.name?.value ?? 'unknown';
    }
    return 'unknown';
}
function $278c8d04dad7bc1d$export$363a8d7f501f3769(query, options) {
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__)) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $278c8d04dad7bc1d$var$useLazyQueryInteropApollo(query, options);
}
const $278c8d04dad7bc1d$var$useLazyQueryInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(49);
    let t0;
    if ($[0] !== options) {
        t0 = options ?? {};
        $[0] = options;
        $[1] = t0;
    } else t0 = $[1];
    let apolloOptions;
    let interopApolloAggClient;
    if ($[2] !== t0) {
        ({ interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = t0);
        $[2] = t0;
        $[3] = apolloOptions;
        $[4] = interopApolloAggClient;
    } else {
        apolloOptions = $[3];
        interopApolloAggClient = $[4];
    }
    const t1 = options?.__callerPackage__;
    let t2;
    if ($[5] !== apolloOptions.fetchPolicy || $[6] !== apolloOptions.onCompleted || $[7] !== apolloOptions.variables || $[8] !== interopApolloAggClient || $[9] !== query || $[10] !== t1) {
        t2 = {
            query: query,
            variables: apolloOptions.variables,
            fetchPolicy: apolloOptions.fetchPolicy,
            useAggClient: interopApolloAggClient,
            onCompleted: apolloOptions.onCompleted,
            callerPackage: t1
        };
        $[5] = apolloOptions.fetchPolicy;
        $[6] = apolloOptions.onCompleted;
        $[7] = apolloOptions.variables;
        $[8] = interopApolloAggClient;
        $[9] = query;
        $[10] = t1;
        $[11] = t2;
    } else t2 = $[11];
    const { getLatestVariables: getLatestVariables, getVariables: getCacheBridgeVariables, isEnabled: isCacheBridgeEnabled, onCompleted: onApolloCompletedWithCacheBridge, syncObservedResult: syncObservedResult, updateLatestVariables: updateLatestVariables } = (0, $3VgTg.useApolloQueryCacheBridgeSync)(t2);
    const onApolloCompleted = isCacheBridgeEnabled ? onApolloCompletedWithCacheBridge : apolloOptions.onCompleted;
    let t3;
    if ($[12] !== query) {
        t3 = (0, $86okN.toDocumentNode)(query);
        $[12] = query;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== onApolloCompleted) {
        t4 = onApolloCompleted ? {
            onCompleted: onApolloCompleted
        } : {};
        $[14] = onApolloCompleted;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== interopApolloAggClient) {
        t5 = interopApolloAggClient ? {
            client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
        } : {};
        $[16] = interopApolloAggClient;
        $[17] = t5;
    } else t5 = $[17];
    const t6 = apolloOptions?.context;
    const t7 = query.params?.id;
    let t8;
    if ($[18] !== t6 || $[19] !== t7) {
        t8 = {
            ...t6,
            requestId: t7
        };
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== apolloOptions || $[22] !== t4 || $[23] !== t5 || $[24] !== t8) {
        t9 = {
            ...apolloOptions,
            ...t4,
            ...t5,
            context: t8
        };
        $[21] = apolloOptions;
        $[22] = t4;
        $[23] = t5;
        $[24] = t8;
        $[25] = t9;
    } else t9 = $[25];
    const lazyQueryResult = (0, $7EPz1.useLazyQuery)(t3, t9);
    const [executeLazyQuery, apolloResult] = lazyQueryResult;
    const apolloData = apolloResult.data;
    const apolloError = apolloResult.error;
    const apolloCalled = apolloResult.called;
    let t10;
    if ($[26] !== apolloResult.variables || $[27] !== getCacheBridgeVariables) {
        t10 = getCacheBridgeVariables(apolloResult.variables);
        $[26] = apolloResult.variables;
        $[27] = getCacheBridgeVariables;
        $[28] = t10;
    } else t10 = $[28];
    const apolloVariables = t10;
    let t11;
    let t12;
    if ($[29] !== apolloVariables || $[30] !== isCacheBridgeEnabled || $[31] !== updateLatestVariables) {
        t11 = ()=>{
            if (!isCacheBridgeEnabled) return;
            updateLatestVariables(apolloVariables);
        };
        t12 = [
            apolloVariables,
            isCacheBridgeEnabled,
            updateLatestVariables
        ];
        $[29] = apolloVariables;
        $[30] = isCacheBridgeEnabled;
        $[31] = updateLatestVariables;
        $[32] = t11;
        $[33] = t12;
    } else {
        t11 = $[32];
        t12 = $[33];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    let t14;
    if ($[34] !== apolloCalled || $[35] !== apolloData || $[36] !== apolloError || $[37] !== apolloVariables || $[38] !== isCacheBridgeEnabled || $[39] !== syncObservedResult) {
        t13 = ()=>{
            if (!isCacheBridgeEnabled) return;
            syncObservedResult({
                skip: !apolloCalled,
                variables: apolloVariables,
                data: apolloData,
                error: apolloError
            });
        };
        t14 = [
            apolloCalled,
            apolloData,
            apolloError,
            apolloVariables,
            isCacheBridgeEnabled,
            syncObservedResult
        ];
        $[34] = apolloCalled;
        $[35] = apolloData;
        $[36] = apolloError;
        $[37] = apolloVariables;
        $[38] = isCacheBridgeEnabled;
        $[39] = syncObservedResult;
        $[40] = t13;
        $[41] = t14;
    } else {
        t13 = $[40];
        t14 = $[41];
    }
    (0, $cozmU.useEffect)(t13, t14);
    let t15;
    if ($[42] !== executeLazyQuery || $[43] !== getLatestVariables || $[44] !== updateLatestVariables) {
        t15 = (executeOptions)=>{
            updateLatestVariables(executeOptions?.variables ?? getLatestVariables());
            return executeLazyQuery(executeOptions);
        };
        $[42] = executeLazyQuery;
        $[43] = getLatestVariables;
        $[44] = updateLatestVariables;
        $[45] = t15;
    } else t15 = $[45];
    const executeLazyQueryWithCacheBridgeVariables = t15;
    if (!isCacheBridgeEnabled) return lazyQueryResult;
    let t16;
    if ($[46] !== apolloResult || $[47] !== executeLazyQueryWithCacheBridgeVariables) {
        t16 = [
            executeLazyQueryWithCacheBridgeVariables,
            apolloResult
        ];
        $[46] = apolloResult;
        $[47] = executeLazyQueryWithCacheBridgeVariables;
        $[48] = t16;
    } else t16 = $[48];
    return t16;
} : function useLazyQueryInteropApollo(query, options) {
    const { interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {};
    const { getLatestVariables: getLatestVariables, getVariables: getCacheBridgeVariables, isEnabled: isCacheBridgeEnabled, onCompleted: onApolloCompletedWithCacheBridge, syncObservedResult: syncObservedResult, updateLatestVariables: updateLatestVariables } = (0, $3VgTg.useApolloQueryCacheBridgeSync)({
        query: query,
        variables: apolloOptions.variables,
        fetchPolicy: apolloOptions.fetchPolicy,
        useAggClient: interopApolloAggClient,
        onCompleted: apolloOptions.onCompleted,
        callerPackage: options?.__callerPackage__
    });
    const onApolloCompleted = isCacheBridgeEnabled ? onApolloCompletedWithCacheBridge : apolloOptions.onCompleted;
    const lazyQueryResult = (0, $7EPz1.useLazyQuery)((0, $86okN.toDocumentNode)(query), {
        ...apolloOptions,
        ...onApolloCompleted ? {
            onCompleted: onApolloCompleted
        } : {},
        ...interopApolloAggClient ? {
            client: window['GLOBAL_APOLLO_AGG_CLIENT'] ?? window['MOCK_GATEWAY_APOLLO_CLIENT']
        } : {},
        context: {
            ...apolloOptions?.context,
            requestId: query.params?.id
        }
    });
    const [executeLazyQuery, apolloResult] = lazyQueryResult;
    const apolloData = apolloResult.data;
    const apolloError = apolloResult.error;
    const apolloCalled = apolloResult.called;
    const apolloVariables = getCacheBridgeVariables(apolloResult.variables);
    (0, $cozmU.useEffect)(()=>{
        if (!isCacheBridgeEnabled) return;
        updateLatestVariables(apolloVariables);
    }, [
        apolloVariables,
        isCacheBridgeEnabled,
        updateLatestVariables
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isCacheBridgeEnabled) return;
        syncObservedResult({
            skip: !apolloCalled,
            variables: apolloVariables,
            data: apolloData,
            error: apolloError
        });
    }, [
        apolloCalled,
        apolloData,
        apolloError,
        apolloVariables,
        isCacheBridgeEnabled,
        syncObservedResult
    ]);
    const executeLazyQueryWithCacheBridgeVariables = (0, $cozmU.useCallback)((executeOptions)=>{
        updateLatestVariables(executeOptions?.variables ?? getLatestVariables());
        return executeLazyQuery(executeOptions);
    }, [
        executeLazyQuery,
        getLatestVariables,
        updateLatestVariables
    ]);
    if (!isCacheBridgeEnabled) return lazyQueryResult;
    return [
        executeLazyQueryWithCacheBridgeVariables,
        apolloResult
    ];
};
function $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${$278c8d04dad7bc1d$var$getOperationName(query)}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__);
    const hookContext = options?.context;
    const initialFetchPolicy = options?.fetchPolicy ? (0, $3NBsC.mapFetchPolicyForQuery)(options.fetchPolicy) : undefined;
    const subsequentFetchPolicy = options?.nextFetchPolicy ? (0, $3NBsC.mapFetchPolicyForQuery)(options.nextFetchPolicy) : initialFetchPolicy;
    const cacheBridgeFetchPolicy = options?.fetchPolicy;
    const cacheBridgeSubsequentFetchPolicy = options?.nextFetchPolicy ?? cacheBridgeFetchPolicy;
    const interopApolloAggClient = options?.interopApolloAggClient;
    const onError = (0, $26Yfd.useStableCallback)(options?.onError ?? function noop() {});
    const onCompleted = (0, $26Yfd.useStableCallback)(options?.onCompleted ?? function noop() {});
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [called, setCalled] = (0, $cozmU.useState)(false);
    // Mirrors Apollo's `variables` from the most recent invocation.
    const [activeVariables, setActiveVariables] = (0, $cozmU.useState)(hookVariables);
    const isMountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // Subscribe to cache updates after query is called to keep data reactive.
    // This ensures that when mutations update the cache, components using this
    // lazy query will automatically re-render with the fresh data, matching
    // Apollo's behavior where useLazyQuery subscribes to cache changes.
    // See: https://hello.atlassian.net/browse/COPPER-XXXXX (Star menu bug)
    (0, $cozmU.useEffect)(()=>{
        if (!called) return;
        // Subscribe to the Relay store to watch for cache updates (e.g., from mutations).
        // This matches the pattern used in useQueryInterop for reactive cache updates.
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), activeVariables);
        const retainDisposable = environment.retain(operation);
        const storeSubscription = environment.subscribe(environment.lookup(operation.fragment), (snapshot)=>{
            // Only update if mounted and data is not missing from cache
            if (isMountedRef.current && !snapshot.isMissingData) setData(snapshot.data);
        });
        return ()=>{
            storeSubscription.dispose();
            retainDisposable.dispose();
        };
    }, [
        called,
        environment,
        query,
        activeVariables
    ]);
    // Sequencing counters discard out-of-order responses.
    const executeIdRef = (0, $cozmU.useRef)(0);
    const fetchMoreIdRef = (0, $cozmU.useRef)(0);
    // hookContext is unmemoised; data/activeVariables can change mid-fetchMore via a concurrent execute.
    const hookContextRef = $278c8d04dad7bc1d$var$useSyncedRef(hookContext);
    const dataRef = $278c8d04dad7bc1d$var$useSyncedRef(data);
    const activeVarsRef = $278c8d04dad7bc1d$var$useSyncedRef(activeVariables);
    const mirrorRelayResultToApollo = (0, $cozmU.useCallback)((relayResult, resultVariables, fetchPolicy)=>{
        // Lazy Relay execution remains the original source of truth; mirror
        // successful payloads into Apollo with the variables from that run.
        (0, $bFdYQ.syncQueryCacheBridge)({
            source: 'relay',
            query: query,
            variables: resultVariables,
            data: relayResult,
            fetchPolicy: fetchPolicy,
            useAggClient: interopApolloAggClient
        });
    }, [
        interopApolloAggClient,
        query
    ]);
    const ufoContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const operationName = `relay_${query.params?.name ?? 'unnamed'}`;
    (0, $cozmU.useEffect)(()=>{
        if (called && loading) return ufoContext?.hold(operationName);
    }, [
        called,
        loading,
        operationName,
        ufoContext
    ]);
    const execute = (0, $cozmU.useCallback)((executeOptions)=>{
        const variables = executeOptions?.variables ?? hookVariables;
        const context = {
            ...hookContextRef.current,
            ...executeOptions?.context
        };
        // First execute uses fetchPolicy, re-invocations use nextFetchPolicy.
        const isFirstCall = executeIdRef.current === 0;
        const cacheBridgeResultFetchPolicy = isFirstCall ? cacheBridgeFetchPolicy : cacheBridgeSubsequentFetchPolicy;
        executeIdRef.current += 1;
        // Invalidate any in-flight fetchMore so it can't merge into fresh execute data.
        fetchMoreIdRef.current += 1;
        const id = executeIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === executeIdRef.current;
        setCalled(true);
        setActiveVariables(variables);
        setLoading(true);
        setError(undefined);
        (0, $kczYx.fetchQuery)(environment, query, variables, {
            fetchPolicy: isFirstCall ? initialFetchPolicy : subsequentFetchPolicy,
            networkCacheConfig: {
                metadata: context
            }
        }).toPromise().then((result)=>{
            if (!isStillCurrent()) return;
            setLoading(false);
            if (result !== undefined) {
                mirrorRelayResultToApollo(result, variables, cacheBridgeResultFetchPolicy);
                setData(result);
                setError(undefined);
                onCompleted(result);
                return;
            }
            // Store-only cache miss: surface so callers aren't left indeterminate.
            const err = $278c8d04dad7bc1d$var$toApolloError(new Error('[Relay migration] fetchQuery resolved with no data (likely a store-only cache miss)'));
            setError(err);
            onError(err);
        }).catch((rawErr)=>{
            if (!isStillCurrent()) return;
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            setError(err);
            setLoading(false);
            onError(err);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        hookVariables,
        initialFetchPolicy,
        subsequentFetchPolicy,
        cacheBridgeFetchPolicy,
        cacheBridgeSubsequentFetchPolicy,
        mirrorRelayResultToApollo,
        onCompleted,
        onError
    ]);
    const fetchMore = (0, $cozmU.useCallback)((fetchMoreOpts)=>{
        const baseVariables = activeVarsRef.current;
        const variables = {
            ...baseVariables,
            ...fetchMoreOpts.variables
        };
        fetchMoreIdRef.current += 1;
        const id = fetchMoreIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === fetchMoreIdRef.current;
        setLoading(true);
        return (0, $kczYx.fetchQuery)(environment, query, variables, {
            // fetchMore must always hit the network (matches Apollo); cached pages would be stale.
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: hookContextRef.current
            }
        }).toPromise().then((fetchMoreResult)=>{
            // Throw so .catch handles it (avoids double onError).
            if (fetchMoreResult === undefined) throw new Error('[Relay migration] fetchMore resolved with no data (likely a store-only cache miss)');
            const merged = fetchMoreOpts.updateQuery(dataRef.current ?? {}, {
                fetchMoreResult: fetchMoreResult,
                variables: variables
            });
            if (isStillCurrent()) {
                mirrorRelayResultToApollo(merged, baseVariables, cacheBridgeSubsequentFetchPolicy);
                setData(merged);
                setLoading(false);
                setError(undefined);
            }
            return {
                data: merged,
                loading: false,
                networkStatus: (0, $5T18X.NetworkStatus).ready,
                stale: false
            };
        }).catch((rawErr)=>{
            // onError gated by isStillCurrent (matches execute); re-throw for Apollo's contract.
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            if (isStillCurrent()) {
                setError(err);
                setLoading(false);
                onError(err);
            }
            throw err;
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (activeVarsRef, dataRef, hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        cacheBridgeSubsequentFetchPolicy,
        mirrorRelayResultToApollo,
        onError
    ]);
    // Lazy hooks don't auto-poll; no-op for Apollo signature parity.
    const stopPolling = (0, $cozmU.useCallback)(()=>{}, []);
    // Cast: Apollo's overloaded fetchMore is structurally a superset of FetchMoreType.
    return [
        execute,
        {
            data: data,
            loading: loading,
            error: error,
            called: called,
            variables: activeVariables,
            fetchMore: fetchMore,
            stopPolling: stopPolling
        }
    ];
}
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("iKskQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $krxYo = parcelRequire("krxYo");


var $iITVA = parcelRequire("iITVA");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkizff",
    loaded: "_bfhk1j28"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko12b0 _1bsbgktf _4t3igktf",
    small: "_2rkolb4i _1bsb1tcg _4t3i1tcg",
    medium: "_2rkofajl _1bsbzwfg _4t3izwfg",
    large: "_2rkofajl _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rko1qi0 _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($krxYo))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($iITVA)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { type: type, label: t1, size: t2, src: src, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const [imgLoaded, setImgLoaded] = (0, $cozmU.useState)(!src);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setImgLoaded(true);
        };
        $[0] = t3;
    } else t3 = $[0];
    const setLoaded = t3;
    if (src) {
        const t4 = src?.includes("/wiki") || src?.startsWith("http") ? src : `/wiki${src}`;
        const t5 = imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles.loaded;
        const t6 = $b378bfc9d198c46c$var$AvatarStyles[size];
        let t7;
        if ($[1] !== t5 || $[2] !== t6) {
            t7 = (0, $hekY6.default)([
                $b378bfc9d198c46c$var$spaceImgStyles["default"],
                t5,
                t6
            ]);
            $[1] = t5;
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== label || $[5] !== t4 || $[6] !== t7 || $[7] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                src: t4,
                alt: label,
                onLoad: setLoaded,
                onError: setLoaded,
                "data-testid": testId,
                className: t7
            });
            $[4] = label;
            $[5] = t4;
            $[6] = t7;
            $[7] = testId;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($krxYo)));
    let t4;
    if ($[9] !== Icon || $[10] !== label || $[11] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: label,
            testId: testId
        });
        $[9] = Icon;
        $[10] = label;
        $[11] = testId;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $cozmU.useState)(!src);
    const setLoaded = (0, $cozmU.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($krxYo)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("gx8UM", function(module, exports) {

let $c096a4b9df7de379$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c096a4b9df7de379$var$load("6wr18"),
    $c096a4b9df7de379$var$load("e00ow"),
    $c096a4b9df7de379$var$load("ffEVr"),
    $c096a4b9df7de379$var$load("830Zv")
]).then(()=>parcelRequire('lC5h8'));

});

parcelRegister("37EF7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $fIgvJ = parcelRequire("fIgvJ");

const $3b5e6a1c243f1225$export$10c7104037a7af62 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const t0 = (0, $cozmU.useContext)((0, $fIgvJ.SidebarResizeContext));
    let context;
    if ($[0] !== t0) {
        const { setLeftSidebarState: setLeftSidebarState, ...t1 } = t0;
        context = t1;
        $[0] = t0;
        $[1] = context;
    } else context = $[1];
    return context;
} : ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $cozmU.useContext)((0, $fIgvJ.SidebarResizeContext));
    return context;
};
module.exports["usePageLayoutResize"] = $3b5e6a1c243f1225$export$10c7104037a7af62;

});

parcelRegister("fIgvJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $cd6789f37761681f$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $cd6789f37761681f$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $dpsRj.default),
    collapseLeftSidebar: (0, $dpsRj.default),
    leftSidebarState: $cd6789f37761681f$var$leftSidebarState,
    setLeftSidebarState: (0, $dpsRj.default),
    toggleLeftSidebar: (0, $dpsRj.default)
});
module.exports["SidebarResizeContext"] = $cd6789f37761681f$export$aa5a712eea4c2ae8;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("7boqA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l6Cdg = parcelRequire("l6Cdg");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $cozmU.useCallback)(()=>{
        (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("1uFsv", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $ee0fdcfc2b35384d$export$b79a5979472006ce = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.GLOBAL_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["GLOBAL_NAVIGATION_METRIC"] = $ee0fdcfc2b35384d$export$b79a5979472006ce;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $3PNw6 = parcelRequire("3PNw6");


var $l6Cdg = parcelRequire("l6Cdg");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $3PNw6.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b94r6 = parcelRequire("b94r6");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $b94r6.pageLoad,
    pageSegmentLoad: $b94r6.pageSegmentLoad,
    interaction: $b94r6.interaction,
    custom: $b94r6.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b94r6 = parcelRequire("b94r6");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b94r6.interaction) : (0, $b94r6.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b94r6", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $3L5Pu = parcelRequire("3L5Pu");


var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $01df368966019ba1$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
const $01df368966019ba1$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $01df368966019ba1$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
const $01df368966019ba1$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $01df368966019ba1$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $01df368966019ba1$export$94114666844d5f66;
module.exports["interaction"] = $01df368966019ba1$export$92473e6020ad89b4;
module.exports["custom"] = $01df368966019ba1$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("6cDI5", function(module, exports) {

let $4842aaa33b504b7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4842aaa33b504b7b$var$load("lNePA"),
    $4842aaa33b504b7b$var$load("iWnyc"),
    $4842aaa33b504b7b$var$load("6wr18"),
    $4842aaa33b504b7b$var$load("bX3pK"),
    $4842aaa33b504b7b$var$load("3jKKg"),
    $4842aaa33b504b7b$var$load("cQZE2"),
    $4842aaa33b504b7b$var$load("bx5S2"),
    $4842aaa33b504b7b$var$load("k0Z8C"),
    $4842aaa33b504b7b$var$load("3RQq6"),
    $4842aaa33b504b7b$var$load("Wowvf"),
    $4842aaa33b504b7b$var$load("ffEVr"),
    $4842aaa33b504b7b$var$load("4x9Jx"),
    $4842aaa33b504b7b$var$load("1NGPq"),
    $4842aaa33b504b7b$var$load("kFiBp"),
    $4842aaa33b504b7b$var$load("ddvkk"),
    $4842aaa33b504b7b$var$load("3upHR"),
    $4842aaa33b504b7b$var$load("dBHUb"),
    $4842aaa33b504b7b$var$load("5Rx9J"),
    $4842aaa33b504b7b$var$load("cD5e0")
]).then(()=>parcelRequire('C9t7g'));

});

parcelRegister("2qRJj", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


var $7boqA = parcelRequire("7boqA");


var $ENihE = parcelRequire("ENihE");


var $aWrnw = parcelRequire("aWrnw");

const $662218afe73e5a2d$var$separatorStyles = null;
const $662218afe73e5a2d$var$separatorStylesFallback = null;

const $662218afe73e5a2d$export$d97a74b7c2565df0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NcP7O",
    name: "SpaceNavigationLoader",
    loader: async ()=>(await (parcelRequire("ht55A"))).SpaceNavigation,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ENihE.ContainerSkeleton), {
            loader: true
        })
});
const $662218afe73e5a2d$export$a91923d0186f609a = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $hekY6.default)([
                "_19itze3t _1mouze3t _195gxmi2 _n7zlia51"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $hekY6.default)([
                "_19itidpf _1mouze3t _195gxmi2 _n7zlia51"
            ])
        });
        $[0] = t0;
    } else t0 = $[0];
    const separatorHr = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $aWrnw.SPACE_NAVIGATION_METRIC)
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, separatorHr, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($662218afe73e5a2d$export$d97a74b7c2565df0, props));
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $662218afe73e5a2d$export$d4aec89b198b6129 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ENihE.ContainerSkeleton), {
            loader: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["SpaceNavigationLoader"] = $662218afe73e5a2d$export$d97a74b7c2565df0;
module.exports["SpaceNavigation"] = $662218afe73e5a2d$export$a91923d0186f609a;
module.exports["SpaceNavigationLoadingSkeleton"] = $662218afe73e5a2d$export$d4aec89b198b6129;

});

parcelRegister("ENihE", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $a0Wth = parcelRequire("a0Wth");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a59a0b51f845364$var$Wrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _bfhkvuon _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _1bah1y6m",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$SkeletonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_vchhusvi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$SkeletonLine = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isloadingState: isloadingState, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _2lx286ug _4t3i1ylp _u5f3u2gc",
            __cmplp.isloadingState ? "_19bvf6fq" : "_19bv19bv",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$Circle = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko1rr0 _bfhkvkf5 _1o9zidpf _4t3i1tcg _2hwxpxbi _1bsb1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$Line = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko12b0 _4t3i7vkz _1bsb68cl _bfhkvkf5",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$export$73d04a98c9062109 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { header: t1, loader: loader } = t0;
    const header = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== header || $[1] !== loader) {
        t2 = loader && header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a0Wth.SpaceHeaderSkeleton), null) : null;
        $[0] = header;
        $[1] = loader;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Circle, null);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Line, null);
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    if ($[5] !== loader) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t3, t4);
        $[5] = loader;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Circle, null);
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Line, null);
        $[7] = t6;
        $[8] = t7;
    } else {
        t6 = $[7];
        t7 = $[8];
    }
    let t8;
    if ($[9] !== loader) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t6, t7);
        $[9] = loader;
        $[10] = t8;
    } else t8 = $[10];
    let t10;
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Circle, null);
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Line, null);
        $[11] = t10;
        $[12] = t9;
    } else {
        t10 = $[11];
        t9 = $[12];
    }
    let t11;
    if ($[13] !== loader) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t9, t10);
        $[13] = loader;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Circle, null);
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Line, null);
        $[15] = t12;
        $[16] = t13;
    } else {
        t12 = $[15];
        t13 = $[16];
    }
    let t14;
    if ($[17] !== loader) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t12, t13);
        $[17] = loader;
        $[18] = t14;
    } else t14 = $[18];
    let t15;
    let t16;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Circle, null);
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Line, null);
        $[19] = t15;
        $[20] = t16;
    } else {
        t15 = $[19];
        t16 = $[20];
    }
    let t17;
    if ($[21] !== loader) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t15, t16);
        $[21] = loader;
        $[22] = t17;
    } else t17 = $[22];
    let t18;
    if ($[23] !== t11 || $[24] !== t14 || $[25] !== t17 || $[26] !== t2 || $[27] !== t5 || $[28] !== t8) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a59a0b51f845364$var$SkeletonContainer, {
            "data-testid": "sidebar-skeleton"
        }, t2, t5, t8, t11, t14, t17));
        $[23] = t11;
        $[24] = t14;
        $[25] = t17;
        $[26] = t2;
        $[27] = t5;
        $[28] = t8;
        $[29] = t18;
    } else t18 = $[29];
    return t18;
});
module.exports["ContainerSkeleton"] = $2a59a0b51f845364$export$73d04a98c9062109;

});

parcelRegister("a0Wth", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fd8870c1509e72c$var$SkeletonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4183j _4cvr1h6o _vchhusvi _1e0c1txw _1bsb1ijo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $4fd8870c1509e72c$var$SpaceIconSkeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko1qi0 _1bsb1tcg _4t3i1tcg _bfhkvkf5 _2hwxf6fq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $4fd8870c1509e72c$var$SpaceTitleSkeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko12b0 _1bsb1w81 _4t3i7vkz _bfhkvkf5",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $4fd8870c1509e72c$export$76f5179c9c39352c() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4fd8870c1509e72c$var$SkeletonContainer, {
            "data-testid": "space-header-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4fd8870c1509e72c$var$SpaceIconSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4fd8870c1509e72c$var$SpaceTitleSkeleton, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}
module.exports["SpaceHeaderSkeleton"] = $4fd8870c1509e72c$export$76f5179c9c39352c;

});

parcelRegister("ht55A", function(module, exports) {

let $cb7917b0574b94ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cb7917b0574b94ff$var$load("3kVph"),
    $cb7917b0574b94ff$var$load("e4XZ1"),
    $cb7917b0574b94ff$var$load("1NGPq"),
    $cb7917b0574b94ff$var$load("ddvkk"),
    $cb7917b0574b94ff$var$load("3upHR"),
    $cb7917b0574b94ff$var$load("daX4F"),
    $cb7917b0574b94ff$var$load("7EorR"),
    $cb7917b0574b94ff$var$load("aYgZt")
]).then(()=>parcelRequire('absYu'));

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("cPt0K"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("cPt0K", function(module, exports) {

let $9570c06e3b725460$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9570c06e3b725460$var$load("3kVph"),
    $9570c06e3b725460$var$load("hhss7"),
    $9570c06e3b725460$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gsSsC", function(module, exports) {
/**
 * @generated SignedSource<<1d6d8b72f5cf1c6f95545e0cb79a843c>>
 * @relayHash 1b389961e5e66b422fc68105162ea2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05
const $64636a4927b33bd4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAnonymouslyAuthorized"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b389961e5e66b422fc68105162ea2a7",
            "id": "8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05",
            "metadata": {},
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "operationKind": "query",
            "text": "query useIsUserViewingSpaceAsAnonQuery($spaceKey:String){space(key:$spaceKey){id,currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$64636a4927b33bd4$var$node.hash = "7c791401f0e963cfa78bdcff70a3c87c";
var $64636a4927b33bd4$export$2e2bcd8739ae039 = $64636a4927b33bd4$var$node;
module.exports["default"] = $64636a4927b33bd4$export$2e2bcd8739ae039;

});

parcelRegister("2Zz3q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g4vf3 = parcelRequire("g4vf3");

function $9d9e360fdbb0177e$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $g4vf3.MILLISECONDS_IN_A_DAY));
}
function $9d9e360fdbb0177e$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $9d9e360fdbb0177e$export$954628993bf3188e(trialEndTime - Date.now());
}
function $9d9e360fdbb0177e$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $cozmU.useMemo)(()=>$9d9e360fdbb0177e$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $9d9e360fdbb0177e$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $9d9e360fdbb0177e$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $9d9e360fdbb0177e$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $cozmU.useMemo)(()=>$9d9e360fdbb0177e$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $9d9e360fdbb0177e$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $9d9e360fdbb0177e$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $9d9e360fdbb0177e$export$ee6c4faab08346c;

});

parcelRegister("g4vf3", function(module, exports) {
const $d163a47e1480b111$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $d163a47e1480b111$export$98a7370239de6730;

});

parcelRegister("6ZrZD", function(module, exports) {

let $516e276a52fd828c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $516e276a52fd828c$var$load("fSc0b").then(()=>parcelRequire('vavBY'));

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $cbOce = parcelRequire("cbOce");


var $1cHqV = parcelRequire("1cHqV");


var $8Z78B = parcelRequire("8Z78B");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");

const $6fc4b7bb962289cc$var$isOnboardingStateEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return !a && !b;
    if (a.length !== b.length) return false;
    return a.every((item, i)=>item.key === b[i].key && item.value === b[i].value);
};
// Hook to check if we're on a view page route
const $6fc4b7bb962289cc$var$useIsViewPageRoute = ()=>(0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
// Get the combined onboarding state from cache, returns null if not cached
const $6fc4b7bb962289cc$var$getCombinedQueryFromCache = ()=>{
    try {
        return (0, $l1uFv.readQueryInterop)({
            query: (0, $8Z78B.default),
            variables: {
                key: []
            },
            __callerPackage__: "@confluence/onboarding-helpers"
        });
    } catch  {
        return null;
    }
};
// Updates the combined query cache with new onboarding state values.
// This ensures components using the centralized cache see updates on next mount/navigation.
const $6fc4b7bb962289cc$var$updateCombinedQueryCache = (updatedStates)=>{
    if (!(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return;
    const currentData = $6fc4b7bb962289cc$var$getCombinedQueryFromCache();
    if (!currentData?.onboardingState) return;
    const updatedMap = new Map(updatedStates.map((s)=>[
            s.key,
            s.value
        ]));
    const newOnboardingState = currentData.onboardingState.map((item)=>updatedMap.has(item.key) ? {
            ...item,
            value: updatedMap.get(item.key) ?? item.value
        } : item);
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        },
        data: {
            onboardingState: newOnboardingState
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "@confluence/onboarding-helpers"
                });
            });
            // Update the combined query cache for centralized onboarding state
            $6fc4b7bb962289cc$var$updateCombinedQueryCache(states ?? []);
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false, reactive = true)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const isViewPageRoute = $6fc4b7bb962289cc$var$useIsViewPageRoute();
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    // Check if centralized cache should be used (experiment enabled + on view page route)
    const useCentralizedCache = isViewPageRoute && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false);
    // For non-reactive mode: read from cache once (no subscription)
    // This is a one-time synchronous read that doesn't trigger re-renders on cache changes
    const cachedCombinedData = !reactive && useCentralizedCache ? $6fc4b7bb962289cc$var$getCombinedQueryFromCache() : null;
    const hasCachedCombinedData = cachedCombinedData !== null;
    // For reactive mode: use useQueryInterop with cache-only to subscribe to cache changes
    // This subscribes to the centralized cache and re-renders when it changes (no network requests)
    const { data: reactiveCacheData, error: reactiveCacheError, loading: reactiveCacheLoading } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: []
        },
        skip: skipQuery || !reactive || !useCentralizedCache,
        fetchPolicy: 'cache-only',
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    // Memoize the filtered reactive cache result so filterOnboardingState is only called
    // when reactiveCacheData or key actually changes — not on every render.
    //
    // We must not skip the fallback just because reactiveCacheData is truthy — the centralized
    // cache may not contain the specific keys this consumer requested (e.g. the preload fetched
    // a different set of keys). We only skip the fallback when the filtered reactive cache data
    // actually has entries for the requested keys.
    const { reactiveFilteredData: reactiveFilteredData, reactiveFilteredHasData: reactiveFilteredHasData } = (0, $cozmU.useMemo)(()=>{
        if (!(reactive && useCentralizedCache && reactiveCacheData)) return {
            reactiveFilteredData: null,
            reactiveFilteredHasData: false
        };
        const filtered = (0, $1cHqV.filterOnboardingState)(reactiveCacheData, key);
        return {
            reactiveFilteredData: filtered,
            reactiveFilteredHasData: (filtered?.onboardingState?.length ?? 0) > 0
        };
    }, [
        reactive,
        useCentralizedCache,
        reactiveCacheData,
        key
    ]);
    const { data: fallbackQueryData, error: fallbackError, loading: fallbackLoading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery || hasCachedCombinedData || reactiveFilteredHasData,
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    // Determine which data source to use:
    // 1. Non-reactive with cached data: use cachedCombinedData (filtered)
    // 2. Reactive with centralized cache and keys found: use reactiveFilteredData
    // 3. Fallback: use fallbackQueryData
    // For reactive path: skip re-render if filtered data for our keys hasn't changed
    const prevFilteredDataRef = (0, $cozmU.useRef)(undefined);
    const data = (0, $cozmU.useMemo)(()=>{
        if (hasCachedCombinedData) return (0, $1cHqV.filterOnboardingState)(cachedCombinedData, key);
        if (reactiveFilteredHasData && reactiveFilteredData) {
            if (prevFilteredDataRef.current && $6fc4b7bb962289cc$var$isOnboardingStateEqual(prevFilteredDataRef.current.onboardingState, reactiveFilteredData.onboardingState)) return prevFilteredDataRef.current;
            prevFilteredDataRef.current = reactiveFilteredData;
            return reactiveFilteredData;
        }
        return fallbackQueryData;
    }, [
        hasCachedCombinedData,
        cachedCombinedData,
        reactiveFilteredHasData,
        reactiveFilteredData,
        fallbackQueryData,
        key
    ]);
    // Combine error and loading states from both queries
    const error = reactiveCacheError || fallbackError;
    // When centralized cache is enabled in reactive mode but the preload hasn't populated
    // the cache yet, cache-only returns loading: false with data: undefined. Without this
    // guard, consumers interpret undefined data as "user never saw this onboarding" and
    // incorrectly show spotlights/changeboarding that was already dismissed.
    // We report loading: true until either the reactive cache or fallback has actual data.
    //
    // Also guard the case where the reactive cache is populated but doesn't contain the
    // specific keys this consumer requested (reactiveFilteredHasData is false). In that
    // scenario the fallback query has been allowed to run — keep loading: true until it
    // either returns data or an error, so consumers don't prematurely see empty state.
    const isCentralizedCacheWaitingForPreload = reactive && useCentralizedCache && (!reactiveCacheData || !reactiveFilteredHasData) && !fallbackQueryData && !skipQuery && !reactiveCacheError && !fallbackError;
    const loading = isCentralizedCacheWaitingForPreload || (reactive && useCentralizedCache ? reactiveCacheLoading : false) || fallbackLoading;
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("1cHqV", function(module, exports) {
// Cache for filtered onboarding state results.
// Uses WeakMap keyed by data object (auto-clears when data is garbage collected),
// with nested Map keyed by keys string for O(1) lookup.
const $e7b7b792910c4288$var$filteredStateCache = new WeakMap();
/**
 * Creates a cache key from the requested keys.
 */ const $e7b7b792910c4288$var$createCacheKey = (keys)=>{
    return Array.isArray(keys) ? keys.join(',') : keys;
};
/**
 * Performs the actual filtering of onboarding state data.
 */ const $e7b7b792910c4288$var$filterData = (data, requestedKeys)=>{
    const keysArray = Array.isArray(requestedKeys) ? requestedKeys : [
        requestedKeys
    ];
    const keySet = new Set(keysArray);
    return {
        ...data,
        onboardingState: data.onboardingState?.filter(({ key: key })=>{
            // Check both the full key and the parsed key (without prefix)
            // Keys come back as "{prefix}:{property}" format
            const parsedKey = key.split(':')[1] || key;
            return keySet.has(key) || keySet.has(parsedKey);
        })
    };
};
const $e7b7b792910c4288$export$c1dd389f39afa62f = (data, requestedKeys)=>{
    if (!data?.onboardingState) // Convert null to undefined to maintain backward compatibility with consumers
    // that expect `T | undefined` rather than `T | null | undefined`
    return data ?? undefined;
    const cacheKey = $e7b7b792910c4288$var$createCacheKey(requestedKeys);
    let dataCache = $e7b7b792910c4288$var$filteredStateCache.get(data);
    if (!dataCache) {
        dataCache = new Map();
        $e7b7b792910c4288$var$filteredStateCache.set(data, dataCache);
    }
    if (dataCache.has(cacheKey)) return dataCache.get(cacheKey);
    const filteredResult = $e7b7b792910c4288$var$filterData(data, requestedKeys);
    dataCache.set(cacheKey, filteredResult);
    return filteredResult;
};
module.exports["filterOnboardingState"] = $e7b7b792910c4288$export$c1dd389f39afa62f;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("dBcar", function(module, exports) {
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$31a43870c77aad50 = {
    NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE: 'simplify-nav-new-user:nthUserD0SimplifiedNavEligible',
    NTH_USER_D0_SIMPLIFIED_NAV_START_AT: 'simplify-nav-new-user:nthUserD0SimplifiedNavStartAt'
};
const $3c94963df51c0e13$export$400b215814bf3fc0 = {
    CHECKED_ELIGIBLE: 'creation-focused-nav-xflow:creationFocusedNavXflowCheckedEligible',
    START_AT: 'creation-focused-nav-xflow:creationFocusedNavXflowStartAt'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_START_AT
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$31a43870c77aad50),
    ...Object.values($3c94963df51c0e13$export$400b215814bf3fc0),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["SIMPLIFY_NAV_NEW_USER"] = $3c94963df51c0e13$export$31a43870c77aad50;
module.exports["CFIND_5565_CREATION_FOCUSED_NAV_XFLOW"] = $3c94963df51c0e13$export$400b215814bf3fc0;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("b0EGa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $6d5fb7464c13acdf$var$initialState = {
    hideRequestCount: 0,
    hasReceivedHideRequest: false
};
const $6d5fb7464c13acdf$var$actions = {
    /**
	 * Request to hide the OmniBar. Call this when your component/popup opens.
	 * Must be paired with releaseHideOmniBar when the component closes.
	 */ requestHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            setState({
                hideRequestCount: hideRequestCount + 1,
                hasReceivedHideRequest: true
            });
        },
    /**
	 * Release a hide request. Call this when your component/popup closes.
	 * Must be paired with a previous requestHideOmniBar call.
	 */ releaseHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            if (hideRequestCount > 0) setState({
                hideRequestCount: hideRequestCount - 1
            });
        }
};
const $6d5fb7464c13acdf$export$11b4e542b178c9bc = (0, $8s9DV.createStore)({
    initialState: $6d5fb7464c13acdf$var$initialState,
    actions: $6d5fb7464c13acdf$var$actions,
    name: 'OmniBarVisibilityStore'
});
const $6d5fb7464c13acdf$export$c640b7434448a8d = (0, $kBr4q.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hideRequestCount > 0
});
const $6d5fb7464c13acdf$export$13aafec54f1ab41c = (0, $kBr4q.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hasReceivedHideRequest
});
const $6d5fb7464c13acdf$export$6c29083870fa1fac = (0, $kBr4q.createActionsHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc);
module.exports["useShouldHideOmniBar"] = $6d5fb7464c13acdf$export$c640b7434448a8d;
module.exports["useHasReceivedOmniBarHideRequest"] = $6d5fb7464c13acdf$export$13aafec54f1ab41c;
module.exports["useOmniBarVisibilityActions"] = $6d5fb7464c13acdf$export$6c29083870fa1fac;

});

parcelRegister("kMYBP", function(module, exports) {

let $f2274e0cd163e44a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f2274e0cd163e44a$var$load("lNePA"),
    $f2274e0cd163e44a$var$load("iWnyc"),
    $f2274e0cd163e44a$var$load("60m6Z"),
    $f2274e0cd163e44a$var$load("6wr18"),
    $f2274e0cd163e44a$var$load("bX3pK"),
    $f2274e0cd163e44a$var$load("cQZE2"),
    $f2274e0cd163e44a$var$load("bx5S2"),
    $f2274e0cd163e44a$var$load("knuqf"),
    $f2274e0cd163e44a$var$load("7EorR"),
    $f2274e0cd163e44a$var$load("k0Z8C"),
    $f2274e0cd163e44a$var$load("hxVzR"),
    $f2274e0cd163e44a$var$load("3RQq6"),
    $f2274e0cd163e44a$var$load("Wowvf"),
    $f2274e0cd163e44a$var$load("hhss7"),
    $f2274e0cd163e44a$var$load("ffEVr"),
    $f2274e0cd163e44a$var$load("4x9Jx"),
    $f2274e0cd163e44a$var$load("1NGPq"),
    $f2274e0cd163e44a$var$load("kFiBp"),
    $f2274e0cd163e44a$var$load("dBHUb"),
    $f2274e0cd163e44a$var$load("5Rx9J"),
    $f2274e0cd163e44a$var$load("9IEev")
]).then(()=>parcelRequire('7dXG0'));

});

parcelRegister("hrvfP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $hSHFH = parcelRequire("hSHFH");


var $jmjWc = parcelRequire("jmjWc");


const $29b721c4c738c525$export$decbed6147e4374b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "67V1_",
    name: "ConnectorPromoSidebarLoader",
    loader: async ()=>(await (parcelRequire("11YyD"))).ConnectorPromoSidebar
});


/**
 * Number of days from enrolment during which the sidebar connector promo is
 * eligible to render. Shared by every side-nav consumer (legacy global nav and
 * nav4/GSN side nav) so the two navs stay in lock-step. Intentionally shorter
 * than the hook's default 30-day window used by the search surfaces.
 */ const $fd2f508bb96e47e2$var$SIDEBAR_PROMO_DAYS = 14;
function $fd2f508bb96e47e2$export$89d5931071c38802({ isNav4: isNav4 } = {}) {
    const { isEnabled: isEnabled } = (0, $hSHFH.useIsConnectorOnboardingEnabled)($fd2f508bb96e47e2$var$SIDEBAR_PROMO_DAYS);
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_CFIND
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29b721c4c738c525$export$decbed6147e4374b), {
        isNav4: isNav4
    }));
}
module.exports["ConnectorPromoSidebarEntry"] = $fd2f508bb96e47e2$export$89d5931071c38802;

});

parcelRegister("hSHFH", function(module, exports) {

var $jb2R2 = parcelRequire("jb2R2");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $kKl1I = parcelRequire("kKl1I");

const $7753a4d6370fffc0$var$FIRST_THIRTY_DAYS_THRESHOLD = 30;
function $7753a4d6370fffc0$export$d19426ed5c8e7319(numberOfDays = $7753a4d6370fffc0$var$FIRST_THIRTY_DAYS_THRESHOLD) {
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    const isAdmin = (0, $8Lx5S.useIsAdmin)();
    const shouldSkipForPreConditions = !isRovoEnabled || !isAdmin;
    const { onboardingState: onboardingState, loading: isOnboardingStateLoading, error: onboardingStateError } = (0, $kKl1I.useConnectorOnboardingState)({
        skip: !(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-fg') || shouldSkipForPreConditions
    });
    if (shouldSkipForPreConditions || isOnboardingStateLoading) return {
        isEnabled: false
    };
    // Unauthorized errors are already marked as handled inside useConnectorOnboardingState.
    // Non-unauthorized errors are left unhandled so they reach error monitoring.
    if (onboardingStateError) return {
        isEnabled: false
    };
    const { enrolmentDate: enrolmentDate, promoDismissed: promoDismissed } = onboardingState ?? {};
    // Skip when the user has dismissed both promo surfaces
    if (promoDismissed === 'both') return {
        isEnabled: false
    };
    // Only show to users within the first 30 days of their experiment enrolment
    const isWithinFirstThirtyDays = Boolean(enrolmentDate) && (0, $jb2R2.default)(new Date(), new Date(enrolmentDate)) < numberOfDays;
    if (!isWithinFirstThirtyDays) return {
        isEnabled: false
    };
    return {
        isEnabled: (0, $6mKj3.expVal)('twcg-1489-cc-3p-connector-onboarding', 'isEnabled', false)
    };
}
module.exports["useIsConnectorOnboardingEnabled"] = $7753a4d6370fffc0$export$d19426ed5c8e7319;

});

parcelRegister("kKl1I", function(module, exports) {

var $gikGR = parcelRequire("gikGR");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $jMyy4 = parcelRequire("jMyy4");


var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iQzVo = parcelRequire("iQzVo");

const $28cbb6f1931650bc$var$EMPTY_ENTRIES = [];
const $28cbb6f1931650bc$var$connectorOnboardingStateQuery = (0, $gikGR.default);
// Optimistic local overrides layered on top of the AGG query result, so dismiss
// and spotlight updates apply immediately without waiting for a refetch.
const $28cbb6f1931650bc$var$LocalOnboardingStateStore = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        updateLocalOnboardingState: ({ key: key, value: value })=>({ setState: setState })=>{
                switch(key){
                    case (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).ENROLMENT_DATE:
                        setState({
                            enrolmentDate: value
                        });
                        break;
                    case (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).SPOTLIGHT_SHOWN:
                        setState({
                            spotlightShown: value === 'true'
                        });
                        break;
                    case (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).PROMO_DISMISSED:
                        setState({
                            promoDismissed: value
                        });
                        break;
                }
            }
    },
    name: 'Twcg1489LocalOnboardingStateStore'
});
const $28cbb6f1931650bc$var$useLocalOnboardingState = (0, $kBr4q.createStateHook)($28cbb6f1931650bc$var$LocalOnboardingStateStore);
const $28cbb6f1931650bc$var$useLocalOnboardingStateActions = (0, $kBr4q.createActionsHook)($28cbb6f1931650bc$var$LocalOnboardingStateStore);
function $28cbb6f1931650bc$export$f605414f82afac1e({ skip: skip } = {}) {
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($28cbb6f1931650bc$var$connectorOnboardingStateQuery, {
        variables: {},
        skip: skip || !isLicensed,
        interopApolloAggClient: true,
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/experiment-twcg-1489-cc-3p-connector-onboarding"
    });
    const entries = data?.userPreferences?.onboardingState ?? $28cbb6f1931650bc$var$EMPTY_ENTRIES;
    const localOnboardingStateSnapshot = $28cbb6f1931650bc$var$useLocalOnboardingState();
    const { updateLocalOnboardingState: updateOnboardingState } = $28cbb6f1931650bc$var$useLocalOnboardingStateActions();
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        return {
            onboardingState: undefined,
            loading: false,
            error: error,
            updateOnboardingState: updateOnboardingState
        };
    }
    if (loading) return {
        onboardingState: undefined,
        loading: true,
        updateOnboardingState: updateOnboardingState
    };
    const findValue = (key)=>entries.find((e)=>e.key === key)?.value ?? undefined;
    const queryOnboardingState = {
        enrolmentDate: findValue((0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).ENROLMENT_DATE),
        spotlightShown: findValue((0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).SPOTLIGHT_SHOWN) === 'true',
        promoDismissed: findValue((0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).PROMO_DISMISSED)
    };
    return {
        onboardingState: {
            ...queryOnboardingState,
            ...localOnboardingStateSnapshot
        },
        loading: false,
        updateOnboardingState: updateOnboardingState
    };
}
module.exports["useConnectorOnboardingState"] = $28cbb6f1931650bc$export$f605414f82afac1e;

});

parcelRegister("gikGR", function(module, exports) {
/**
 * @generated SignedSource<<aecbb2a2fb7d4d0b370b72d42ff93673>>
 * @relayHash 7174e5f46f94e0340e2be57ace17cb1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c4fb068086036b0d8869003abab5519d1e65fc7c47b58a70ea5c07745b05c8f
const $878e3b8b3ab16eac$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": [
                                "twcg-1489:enrolmentDate",
                                "twcg-1489:spotlightShown",
                                "twcg-1489:promoDismissed"
                            ]
                        }
                    ],
                    "concreteType": "UserOnboardingState",
                    "kind": "LinkedField",
                    "name": "onboardingState",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ],
                    "storageKey": "onboardingState(key:[\"twcg-1489:enrolmentDate\",\"twcg-1489:spotlightShown\",\"twcg-1489:promoDismissed\"])"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useConnectorOnboardingStateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useConnectorOnboardingStateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7174e5f46f94e0340e2be57ace17cb1a",
            "id": "3c4fb068086036b0d8869003abab5519d1e65fc7c47b58a70ea5c07745b05c8f",
            "metadata": {},
            "name": "useConnectorOnboardingStateQuery",
            "operationKind": "query",
            "text": "query useConnectorOnboardingStateQuery{userPreferences{onboardingState(key:[\"twcg-1489:enrolmentDate\",\"twcg-1489:spotlightShown\",\"twcg-1489:promoDismissed\"]){key,value}}}"
        }
    };
}();
$878e3b8b3ab16eac$var$node.hash = "d9e97ff849d5b5284d9dd5284d3cab5d";
var $878e3b8b3ab16eac$export$2e2bcd8739ae039 = $878e3b8b3ab16eac$var$node;
module.exports["default"] = $878e3b8b3ab16eac$export$2e2bcd8739ae039;

});

parcelRegister("iQzVo", function(module, exports) {
const $ac3059bce5b9a0ea$export$7bed14e1f2921c0a = {
    ENROLMENT_DATE: 'twcg-1489:enrolmentDate',
    SPOTLIGHT_SHOWN: 'twcg-1489:spotlightShown',
    PROMO_DISMISSED: 'twcg-1489:promoDismissed'
};
const $ac3059bce5b9a0ea$export$461c2b41206d7875 = [
    ...Object.values($ac3059bce5b9a0ea$export$7bed14e1f2921c0a)
];
module.exports["TWCG_1489_CONNECTOR_ONBOARDING"] = $ac3059bce5b9a0ea$export$7bed14e1f2921c0a;
module.exports["Twcg1489ConnectorOnboardingKeys"] = $ac3059bce5b9a0ea$export$461c2b41206d7875;

});

parcelRegister("11YyD", function(module, exports) {

let $0c04dbe754a791cf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0c04dbe754a791cf$var$load("5oWNT").then(()=>parcelRequire('iXTnk'));

});

parcelRegister("eGUIL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6ab3d9f83e467c30$export$8ff51aff18368071 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $6ab3d9f83e467c30$export$18d9743f01f9c283 = ()=>{
    const context = (0, $cozmU.useContext)($6ab3d9f83e467c30$export$8ff51aff18368071);
    if (!context) throw new Error("useSideNavigation must be used within a SideNavigationContext.Provider");
    return context;
};
module.exports["SideNavigationContext"] = $6ab3d9f83e467c30$export$8ff51aff18368071;
module.exports["useSideNavigation"] = $6ab3d9f83e467c30$export$18d9743f01f9c283;

});

parcelRegister("lpfM9", function(module, exports) {

var $b8pma = parcelRequire("b8pma");


var $jmjWc = parcelRequire("jmjWc");

const $d8af34c11b1c225c$var$createLoadingComponent = ()=>{
    return (0, $b8pma.default)({
        name: 'LoadingConfluenceRightPanelBundle'
    });
};

const $d8af34c11b1c225c$export$bec010aa49373196 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mQOM4",
    name: "PanelLoader",
    loader: async ()=>(await (parcelRequire("aP0Zm"))).RightPanel,
    loading: $d8af34c11b1c225c$var$createLoadingComponent
});
module.exports["PanelLoader"] = $d8af34c11b1c225c$export$bec010aa49373196;

});

parcelRegister("aP0Zm", function(module, exports) {

let $7e0f6f280d919f65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7e0f6f280d919f65$var$load("6aezV"),
    $7e0f6f280d919f65$var$load("46GUH"),
    $7e0f6f280d919f65$var$load("cFvW1"),
    $7e0f6f280d919f65$var$load("ddvkk"),
    $7e0f6f280d919f65$var$load("3upHR"),
    $7e0f6f280d919f65$var$load("dBHUb"),
    $7e0f6f280d919f65$var$load("5Rx9J"),
    $7e0f6f280d919f65$var$load("hZ2FX"),
    $7e0f6f280d919f65$var$load("6wr18"),
    $7e0f6f280d919f65$var$load("9o0Ua"),
    $7e0f6f280d919f65$var$load("3fdX4"),
    $7e0f6f280d919f65$var$load("i3R6S"),
    $7e0f6f280d919f65$var$load("b0ARW"),
    $7e0f6f280d919f65$var$load("aMUi4"),
    $7e0f6f280d919f65$var$load("ariuh"),
    $7e0f6f280d919f65$var$load("35X59"),
    $7e0f6f280d919f65$var$load("kHXvF"),
    $7e0f6f280d919f65$var$load("7gL7H"),
    $7e0f6f280d919f65$var$load("hhss7"),
    $7e0f6f280d919f65$var$load("a8glC"),
    $7e0f6f280d919f65$var$load("ffEVr"),
    $7e0f6f280d919f65$var$load("eCXJR"),
    $7e0f6f280d919f65$var$load("1VTX2"),
    $7e0f6f280d919f65$var$load("2EIkU"),
    $7e0f6f280d919f65$var$load("Wowvf"),
    $7e0f6f280d919f65$var$load("eRhBr"),
    $7e0f6f280d919f65$var$load("7EorR"),
    $7e0f6f280d919f65$var$load("cvXSy")
]).then(()=>parcelRequire('8CeBV'));

});

parcelRegister("ek5IE", function(module, exports) {
/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $a0aabcb40e04178c$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $a0aabcb40e04178c$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $a0aabcb40e04178c$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $a0aabcb40e04178c$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $a0aabcb40e04178c$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $a0aabcb40e04178c$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';
module.exports["LEFT_PANEL_WIDTH"] = $a0aabcb40e04178c$export$f963aecf2d4465bd;
module.exports["RIGHT_PANEL_WIDTH"] = $a0aabcb40e04178c$export$750459958906793;
module.exports["LEFT_SIDEBAR_WIDTH"] = $a0aabcb40e04178c$export$f897e1ed9f8ed251;
module.exports["RIGHT_SIDEBAR_WIDTH"] = $a0aabcb40e04178c$export$b44ab66843c05a69;
module.exports["TOP_NAVIGATION_HEIGHT"] = $a0aabcb40e04178c$export$aeff86a16f13529;
module.exports["BANNER_HEIGHT"] = $a0aabcb40e04178c$export$ed7cc0d417ee89e;

});

parcelRegister("j5cB3", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $IQ4Dz = parcelRequire("IQ4Dz");


const $43c705326a57355f$export$c720381daa58fcbb = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const adsTheme = (0, $IQ4Dz.default)();
    let t0;
    if ($[0] !== adsTheme) {
        t0 = adsTheme;
        $[0] = adsTheme;
        $[1] = t0;
    } else t0 = $[1];
    const effectiveTheme = t0;
    return effectiveTheme?.colorMode === "dark";
};
module.exports["useIsDarkMode"] = $43c705326a57355f$export$c720381daa58fcbb;

});

parcelRegister("b2F0e", function(module, exports) {

let $809fafebc28e9d4c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $809fafebc28e9d4c$var$load("kNFat").then(()=>parcelRequire('iETFY'));

});

parcelRegister("emNvf", function(module, exports) {
/**
 * @generated SignedSource<<6049717399a666092bcdc2991e7b1ca4>>
 * @relayHash d82ceab955fc558f582faba05877ecf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 765401ffb83f2e2a720c85a5da2a39f56c3a779bc1c3bf8b59c8eef803276a03
const $34dcc93d00ac09e9$var$node = function() {
    var v0 = [
        {
            "concreteType": "LookAndFeelSettings",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LookAndFeel",
                    "kind": "LinkedField",
                    "name": "custom",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HeaderLookAndFeel",
                            "kind": "LinkedField",
                            "name": "horizontalHeader",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundColor"
                                },
                                {
                                    "concreteType": "NavigationLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "primaryNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "highlightColor"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ThemeQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ThemeQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d82ceab955fc558f582faba05877ecf8",
            "id": "765401ffb83f2e2a720c85a5da2a39f56c3a779bc1c3bf8b59c8eef803276a03",
            "metadata": {},
            "name": "ThemeQuery",
            "operationKind": "query",
            "text": "query ThemeQuery{lookAndFeel{custom{horizontalHeader{backgroundColor,primaryNavigation{highlightColor}}}}}"
        }
    };
}();
$34dcc93d00ac09e9$var$node.hash = "1e70f0bab96233984a0d61d455b5303b";
var $34dcc93d00ac09e9$export$2e2bcd8739ae039 = $34dcc93d00ac09e9$var$node;
module.exports["default"] = $34dcc93d00ac09e9$export$2e2bcd8739ae039;

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                if ((0, $9wGTI.fg)("forge-ui-fix-forge-confluence-mainlayout-rerender")) setSidebars($8facebd0ecb5e0ee$var$_temp);
                else setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("cLgYq", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");

const $80f6c4cf061c88c5$export$909966f260e2b2b = (articleId, setArticleId, routeName, setRouteName, routeGroup, setRouteGroup)=>({
        getArticleId: ()=>articleId,
        setArticleId: setArticleId,
        getRouteName: ()=>routeName,
        setRouteName: setRouteName,
        getRouteGroup: ()=>routeGroup,
        setRouteGroup: setRouteGroup
    });
const $80f6c4cf061c88c5$var$initialInProductHelpState = {
    articleId: '',
    routeName: '',
    routeGroup: ''
};
const $80f6c4cf061c88c5$var$inProductHelpActions = {
    setArticleId: (articleId)=>({ setState: setState })=>{
            setState({
                articleId: articleId
            });
        },
    setRouteName: (routeName)=>({ setState: setState })=>{
            setState({
                routeName: routeName
            });
        },
    setRouteGroup: (routeGroup)=>({ setState: setState })=>{
            setState({
                routeGroup: routeGroup
            });
        }
};
const $80f6c4cf061c88c5$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        ...$80f6c4cf061c88c5$var$initialInProductHelpState
    },
    actions: $80f6c4cf061c88c5$var$inProductHelpActions,
    name: 'inProductHelpContext'
});
const $80f6c4cf061c88c5$export$d9f3a3de6974e16a = (0, $kBr4q.createActionsHook)($80f6c4cf061c88c5$var$Store);
const $80f6c4cf061c88c5$export$b1fca540f7ef5476 = (0, $kBr4q.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.articleId
});
const $80f6c4cf061c88c5$export$15e1d4730ce65e9d = (0, $kBr4q.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeName
});
const $80f6c4cf061c88c5$export$1dfb78b8caec7720 = (0, $kBr4q.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeGroup
});
const $80f6c4cf061c88c5$export$a611b87b3ebe1475 = (0, $j8on0.createContainer)($80f6c4cf061c88c5$var$Store, {
    onInit: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        },
    onUpdate: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        }
});
const $80f6c4cf061c88c5$export$a61d77bd8effd79e = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($80f6c4cf061c88c5$export$a611b87b3ebe1475, null, children);
};
module.exports["useInProductHelpActions"] = $80f6c4cf061c88c5$export$d9f3a3de6974e16a;
module.exports["useInProductHelpArticleId"] = $80f6c4cf061c88c5$export$b1fca540f7ef5476;
module.exports["InProductHelpProvider"] = $80f6c4cf061c88c5$export$a61d77bd8effd79e;

});

parcelRegister("jxXkP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");


var $hPTbh = parcelRequire("hPTbh");


var $4uowN = parcelRequire("4uowN");

const $5d19246504a43db4$export$8076fd3f013c4bb9 = (origin)=>{
    const $ = (0, $bDgLe.c)(34);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== origin) {
        t0 = (data)=>{
            createAnalyticsEvent((0, $4uowN.buildSnippetUIEvent)(data, origin)).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = origin;
        $[2] = t0;
    } else t0 = $[2];
    const fireUIAnalytic = t0;
    let t1;
    if ($[3] !== createAnalyticsEvent || $[4] !== origin) {
        t1 = (data_0)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_OPERATIONAL_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    type: (0, $hPTbh.ANALYTICS_TYPE).OPERATIONAL,
                    ...data_0,
                    attributes: (0, $4uowN.mergeOriginIntoAttributes)(origin, data_0.attributes)
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = origin;
        $[5] = t1;
    } else t1 = $[5];
    const fireOperationalAnalytic = t1;
    let t2;
    if ($[6] !== createAnalyticsEvent || $[7] !== origin) {
        t2 = (data_1)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_TRACK_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    ...data_1,
                    attributes: (0, $4uowN.mergeOriginIntoAttributes)(origin, data_1.attributes)
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = origin;
        $[8] = t2;
    } else t2 = $[8];
    const fireTrackAnalytic = t2;
    let t3;
    if ($[9] !== fireUIAnalytic) {
        t3 = (actionSubjectId, attributes)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).BUTTON,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            });
        };
        $[9] = fireUIAnalytic;
        $[10] = t3;
    } else t3 = $[10];
    const fireButtonClickedAnalytic = t3;
    let t4;
    if ($[11] !== createAnalyticsEvent || $[12] !== origin) {
        t4 = (attributes_0)=>{
            createAnalyticsEvent((0, $4uowN.buildSnippetUIEvent)({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).SNIPPETS,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).VIEWED,
                actionSubjectId: (0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).SNIPPETS,
                attributes: attributes_0
            }, origin)).fire();
        };
        $[11] = createAnalyticsEvent;
        $[12] = origin;
        $[13] = t4;
    } else t4 = $[13];
    const fireScreenViewedAnalytic = t4;
    let t5;
    if ($[14] !== fireUIAnalytic) {
        t5 = (actionSubjectId_0, attributes_1)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).MODAL,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLOSED,
                actionSubjectId: actionSubjectId_0,
                attributes: attributes_1
            });
        };
        $[14] = fireUIAnalytic;
        $[15] = t5;
    } else t5 = $[15];
    const fireModalClosedAnalytic = t5;
    let t6;
    if ($[16] !== fireUIAnalytic) {
        t6 = (actionSubjectId_1, attributes_2)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).TEXT_FIELD,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).TYPED,
                actionSubjectId: actionSubjectId_1,
                attributes: attributes_2
            });
        };
        $[16] = fireUIAnalytic;
        $[17] = t6;
    } else t6 = $[17];
    const fireTextFieldTypedAnalytic = t6;
    let t7;
    if ($[18] !== fireUIAnalytic) {
        t7 = (actionSubjectId_2, attributes_3)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).DROPDOWN_ITEM,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId_2,
                attributes: attributes_3
            });
        };
        $[18] = fireUIAnalytic;
        $[19] = t7;
    } else t7 = $[19];
    const fireDropdownItemClickedAnalytic = t7;
    let t8;
    if ($[20] !== fireOperationalAnalytic) {
        t8 = (actionSubject, attributes_4)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).FAILED,
                attributes: attributes_4
            });
        };
        $[20] = fireOperationalAnalytic;
        $[21] = t8;
    } else t8 = $[21];
    const fireFailedAnalytic = t8;
    let t9;
    if ($[22] !== fireOperationalAnalytic) {
        t9 = (actionSubject_0, attributes_5)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject_0,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).SUCCEEDED,
                attributes: attributes_5
            });
        };
        $[22] = fireOperationalAnalytic;
        $[23] = t9;
    } else t9 = $[23];
    const fireSuccessAnalytic = t9;
    let t10;
    if ($[24] !== fireButtonClickedAnalytic || $[25] !== fireDropdownItemClickedAnalytic || $[26] !== fireFailedAnalytic || $[27] !== fireModalClosedAnalytic || $[28] !== fireOperationalAnalytic || $[29] !== fireScreenViewedAnalytic || $[30] !== fireSuccessAnalytic || $[31] !== fireTextFieldTypedAnalytic || $[32] !== fireTrackAnalytic) {
        t10 = {
            fireOperationalAnalytic: fireOperationalAnalytic,
            fireTrackAnalytic: fireTrackAnalytic,
            fireButtonClickedAnalytic: fireButtonClickedAnalytic,
            fireScreenViewedAnalytic: fireScreenViewedAnalytic,
            fireModalClosedAnalytic: fireModalClosedAnalytic,
            fireTextFieldTypedAnalytic: fireTextFieldTypedAnalytic,
            fireDropdownItemClickedAnalytic: fireDropdownItemClickedAnalytic,
            fireFailedAnalytic: fireFailedAnalytic,
            fireSuccessAnalytic: fireSuccessAnalytic
        };
        $[24] = fireButtonClickedAnalytic;
        $[25] = fireDropdownItemClickedAnalytic;
        $[26] = fireFailedAnalytic;
        $[27] = fireModalClosedAnalytic;
        $[28] = fireOperationalAnalytic;
        $[29] = fireScreenViewedAnalytic;
        $[30] = fireSuccessAnalytic;
        $[31] = fireTextFieldTypedAnalytic;
        $[32] = fireTrackAnalytic;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
};
module.exports["useSnippetAnalytics"] = $5d19246504a43db4$export$8076fd3f013c4bb9;

});

parcelRegister("cYuYM", function(module, exports) {

var $5vi32 = parcelRequire("5vi32");


var $9bL1w = parcelRequire("9bL1w");

const $955ee3c4efc889bc$export$349f17fbd3b37cd1 = ()=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { isTemplateBrowserEnabled: isTemplateBrowserEnabled, isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    return !!(isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled);
};
module.exports["useIsSnippetCreateEnabled"] = $955ee3c4efc889bc$export$349f17fbd3b37cd1;

});

parcelRegister("5vi32", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    return (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("9bL1w", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 * Similarly, "enable-share" is an opt-in feature and should not be enabled when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons',
        'disable-close-button',
        'enable-share'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $4PNpW.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const hideCloseButton = allowedEditPageFeatures?.includes('disable-close-button');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo') && (0, $9wGTI.fg)('jira_linked_confluence_doc_rovo_nudge_gate');
    const showShare = (0, $9wGTI.fg)('csm_ai_enable_share_feature') && allowedEditPageFeatures?.includes('enable-share');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        hideCloseButton: hideCloseButton,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled,
        showShare: showShare
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("36Uax", function(module, exports) {

var $bVevd = parcelRequire("bVevd");


var $kTPbu = parcelRequire("kTPbu");

var $dcf2160d889b63fd$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $dcf2160d889b63fd$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$var$pageAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$blogPostAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$whiteboardAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard
};
const $dcf2160d889b63fd$var$contentTypeAllowedFeatures = {
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $dcf2160d889b63fd$var$pageAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $dcf2160d889b63fd$var$blogPostAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $dcf2160d889b63fd$var$whiteboardAllowedFeatures
};
const $dcf2160d889b63fd$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$dcf2160d889b63fd$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $dcf2160d889b63fd$export$3207c60940c4a9b0;

});

parcelRegister("bVevd", function(module, exports) {
var $3914485ee940289d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $3914485ee940289d$export$816ef638e478449a;

});

parcelRegister("kTPbu", function(module, exports) {
var $eaa06f5f4964dde1$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $eaa06f5f4964dde1$export$942a5fac9b8c9dc2;

});

parcelRegister("4PNpW", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

const $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40 = (0, $36Uax.ALLOWED_FEATURES).view;
const $ff056bb0ad02bd7c$export$2c7469b01e61fde2 = (0, $36Uax.ALLOWED_FEATURES).edit;
const $ff056bb0ad02bd7c$export$72afc086e90eb0bf = (0, $36Uax.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $ff056bb0ad02bd7c$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1eD4P = parcelRequire("1eD4P");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $cozmU.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $cozmU.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("gE1ec", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c1e155a1b94f67fa$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c1e155a1b94f67fa$var$useInsertionEffect = $cozmU.useInsertionEffect ? $cozmU.useInsertionEffect : false;
var $c1e155a1b94f67fa$export$db21c7ffa21794e7 = $c1e155a1b94f67fa$var$useInsertionEffect || $c1e155a1b94f67fa$var$syncFallback;
var $c1e155a1b94f67fa$export$811a713a7276cb9d = $c1e155a1b94f67fa$var$useInsertionEffect || $cozmU.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $c1e155a1b94f67fa$export$db21c7ffa21794e7;
module.exports["useInsertionEffectWithLayoutFallback"] = $c1e155a1b94f67fa$export$811a713a7276cb9d;

});

parcelRegister("eieXD", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $02af7510cb9721a1$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("a2lmi")));

var $fbwmZ = parcelRequire("fbwmZ");


var $dcw8o = parcelRequire("dcw8o");


var $ilRwI = parcelRequire("ilRwI");


var $6NrTk = parcelRequire("6NrTk");


var $eIjjl = parcelRequire("eIjjl");


var $a2lmi = parcelRequire("a2lmi");

var $02af7510cb9721a1$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $02af7510cb9721a1$var$_window = (0, $6NrTk.getGlobalObject)();
if ($02af7510cb9721a1$var$_window.Sentry && $02af7510cb9721a1$var$_window.Sentry.Integrations) $02af7510cb9721a1$var$windowIntegrations = $02af7510cb9721a1$var$_window.Sentry.Integrations;
var $02af7510cb9721a1$export$99d02219d259eb94 = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, $02af7510cb9721a1$var$windowIntegrations), (0, $ilRwI)), $eIjjl);
$parcel$exportWildcard(module.exports, $dcw8o);

});

parcelRegister("dcw8o", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("dtZ6d")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("hkv0W")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("9HPf3")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("9HPf3")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("9HPf3")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("9HPf3")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("9HPf3")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("amM2J")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("amM2J")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("amM2J")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("amM2J")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("hkv0W")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("dQl3s")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("9HPf3")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("a953x")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("9HPf3")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("9HPf3")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("9HPf3")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("9HPf3")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("9HPf3")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("9HPf3")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("9HPf3")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("e9HlS")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("9whyS")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("l17tw")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("l17tw")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("eAdCn")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("eAdCn")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("eAdCn")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("eAdCn")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("eAdCn")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("eAdCn")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("eAdCn")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("eAdCn")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("eAdCn")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("7iBHc")).SDK_NAME);

var $dtZ6d = parcelRequire("dtZ6d");


var $9HPf3 = parcelRequire("9HPf3");

var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

var $a953x = parcelRequire("a953x");

var $dQl3s = parcelRequire("dQl3s");


var $e9HlS = parcelRequire("e9HlS");


var $9whyS = parcelRequire("9whyS");


var $l17tw = parcelRequire("l17tw");


var $eAdCn = parcelRequire("eAdCn");


var $7iBHc = parcelRequire("7iBHc");


});

parcelRegister("7iBHc", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $55077470b8523cd3$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $55077470b8523cd3$export$ca61d37259221480;

});

parcelRegister("eIjjl", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("cEELl")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("51FBI")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bNfZ4")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("6oUta")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("aMh6Y")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("lBiNe")).Dedupe);

var $cEELl = parcelRequire("cEELl");


var $51FBI = parcelRequire("51FBI");


var $bNfZ4 = parcelRequire("bNfZ4");


var $6oUta = parcelRequire("6oUta");


var $aMh6Y = parcelRequire("aMh6Y");


var $lBiNe = parcelRequire("lBiNe");


});

parcelRegister("a2lmi", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("l2hU1")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("9yqZL")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("5a5jw")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hu9Hi")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("3FUEv")).makeNewXHRTransport);

var $l2hU1 = parcelRequire("l2hU1");


var $9yqZL = parcelRequire("9yqZL");


var $5a5jw = parcelRequire("5a5jw");


var $hu9Hi = parcelRequire("hu9Hi");


var $3FUEv = parcelRequire("3FUEv");


});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $abc73c6f5c74c436$var$useRouterLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $abc73c6f5c74c436$export$2e2bcd8739ae039 = $abc73c6f5c74c436$var$useRouterLink;
module.exports["default"] = $abc73c6f5c74c436$export$2e2bcd8739ae039;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("3AVOh", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $hGc5T = parcelRequire("hGc5T");


var $hcV0q = parcelRequire("hcV0q");


var $aI4Cx = parcelRequire("aI4Cx");


var $bk5x8 = parcelRequire("bk5x8");


var $ezTcL = parcelRequire("ezTcL");


var $jPzTX = parcelRequire("jPzTX");


var $14dnq = parcelRequire("14dnq");

/** Used to compose bitmasks for cloning. */ var $29e193b87644e449$var$CLONE_DEEP_FLAG = 1, $29e193b87644e449$var$CLONE_FLAT_FLAG = 2, $29e193b87644e449$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $29e193b87644e449$var$omit = $jPzTX(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $79D42(paths, function(path) {
        path = $aI4Cx(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $bk5x8(object, $14dnq(object), result);
    if (isDeep) result = $hGc5T(result, $29e193b87644e449$var$CLONE_DEEP_FLAG | $29e193b87644e449$var$CLONE_FLAT_FLAG | $29e193b87644e449$var$CLONE_SYMBOLS_FLAG, $ezTcL);
    var length = paths.length;
    while(length--)$hcV0q(result, paths[length]);
    return result;
});
module.exports = $29e193b87644e449$var$omit;

});

parcelRegister("hGc5T", function(module, exports) {

var $1tgXD = parcelRequire("1tgXD");


var $7aPLP = parcelRequire("7aPLP");


var $aDCaS = parcelRequire("aDCaS");


var $e8WyO = parcelRequire("e8WyO");


var $lunGb = parcelRequire("lunGb");


var $19mn0 = parcelRequire("19mn0");


var $7WBxT = parcelRequire("7WBxT");


var $gwj3d = parcelRequire("gwj3d");


var $j60dZ = parcelRequire("j60dZ");


var $cTBpe = parcelRequire("cTBpe");


var $14dnq = parcelRequire("14dnq");


var $jOCrv = parcelRequire("jOCrv");


var $kGJE1 = parcelRequire("kGJE1");


var $cZmfO = parcelRequire("cZmfO");


var $jFqhM = parcelRequire("jFqhM");


var $1ScXu = parcelRequire("1ScXu");


var $6DVFM = parcelRequire("6DVFM");


var $aBDCC = parcelRequire("aBDCC");


var $izVFW = parcelRequire("izVFW");


var $1ji1e = parcelRequire("1ji1e");


var $f14Rr = parcelRequire("f14Rr");


var $dNyAN = parcelRequire("dNyAN");

/** Used to compose bitmasks for cloning. */ var $cdefbd8efe913551$var$CLONE_DEEP_FLAG = 1, $cdefbd8efe913551$var$CLONE_FLAT_FLAG = 2, $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $cdefbd8efe913551$var$argsTag = '[object Arguments]', $cdefbd8efe913551$var$arrayTag = '[object Array]', $cdefbd8efe913551$var$boolTag = '[object Boolean]', $cdefbd8efe913551$var$dateTag = '[object Date]', $cdefbd8efe913551$var$errorTag = '[object Error]', $cdefbd8efe913551$var$funcTag = '[object Function]', $cdefbd8efe913551$var$genTag = '[object GeneratorFunction]', $cdefbd8efe913551$var$mapTag = '[object Map]', $cdefbd8efe913551$var$numberTag = '[object Number]', $cdefbd8efe913551$var$objectTag = '[object Object]', $cdefbd8efe913551$var$regexpTag = '[object RegExp]', $cdefbd8efe913551$var$setTag = '[object Set]', $cdefbd8efe913551$var$stringTag = '[object String]', $cdefbd8efe913551$var$symbolTag = '[object Symbol]', $cdefbd8efe913551$var$weakMapTag = '[object WeakMap]';
var $cdefbd8efe913551$var$arrayBufferTag = '[object ArrayBuffer]', $cdefbd8efe913551$var$dataViewTag = '[object DataView]', $cdefbd8efe913551$var$float32Tag = '[object Float32Array]', $cdefbd8efe913551$var$float64Tag = '[object Float64Array]', $cdefbd8efe913551$var$int8Tag = '[object Int8Array]', $cdefbd8efe913551$var$int16Tag = '[object Int16Array]', $cdefbd8efe913551$var$int32Tag = '[object Int32Array]', $cdefbd8efe913551$var$uint8Tag = '[object Uint8Array]', $cdefbd8efe913551$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cdefbd8efe913551$var$uint16Tag = '[object Uint16Array]', $cdefbd8efe913551$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $cdefbd8efe913551$var$cloneableTags = {};
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$argsTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayBufferTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dataViewTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$boolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dateTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float64Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$mapTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$numberTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$objectTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$regexpTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$setTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$stringTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$symbolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8ClampedTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint32Tag] = true;
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$errorTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$funcTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $cdefbd8efe913551$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $cdefbd8efe913551$var$CLONE_DEEP_FLAG, isFlat = bitmask & $cdefbd8efe913551$var$CLONE_FLAT_FLAG, isFull = bitmask & $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$izVFW(value)) return value;
    var isArr = $1ScXu(value);
    if (isArr) {
        result = $kGJE1(value);
        if (!isDeep) return $7WBxT(value, result);
    } else {
        var tag = $jOCrv(value), isFunc = tag == $cdefbd8efe913551$var$funcTag || tag == $cdefbd8efe913551$var$genTag;
        if ($6DVFM(value)) return $19mn0(value, isDeep);
        if (tag == $cdefbd8efe913551$var$objectTag || tag == $cdefbd8efe913551$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $jFqhM(value);
            if (!isDeep) return isFlat ? $j60dZ(value, $lunGb(result, value)) : $gwj3d(value, $e8WyO(result, value));
        } else {
            if (!$cdefbd8efe913551$var$cloneableTags[tag]) return object ? value : {};
            result = $cZmfO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $1tgXD);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($1ji1e(value)) value.forEach(function(subValue) {
        result.add($cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($aBDCC(value)) value.forEach(function(subValue, key) {
        result.set(key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $14dnq : $cTBpe : isFlat ? $dNyAN : $f14Rr;
    var props = isArr ? undefined : keysFunc(value);
    $7aPLP(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $aDCaS(result, key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $cdefbd8efe913551$var$baseClone;

});

parcelRegister("7aPLP", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5391a0175a1872c4$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $5391a0175a1872c4$var$arrayEach;

});

parcelRegister("e8WyO", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a4bf3cec5f860948$var$baseAssign(object, source) {
    return object && $bk5x8(source, $f14Rr(source), object);
}
module.exports = $a4bf3cec5f860948$var$baseAssign;

});

parcelRegister("lunGb", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $dNyAN = parcelRequire("dNyAN");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $fa4ec48e79e3b749$var$baseAssignIn(object, source) {
    return object && $bk5x8(source, $dNyAN(source), object);
}
module.exports = $fa4ec48e79e3b749$var$baseAssignIn;

});

parcelRegister("gwj3d", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $j1qF4 = parcelRequire("j1qF4");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $c06e699caf978d13$var$copySymbols(source, object) {
    return $bk5x8(source, $j1qF4(source), object);
}
module.exports = $c06e699caf978d13$var$copySymbols;

});

parcelRegister("j60dZ", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $ahKsp = parcelRequire("ahKsp");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $de6ec073df6f66ec$var$copySymbolsIn(source, object) {
    return $bk5x8(source, $ahKsp(source), object);
}
module.exports = $de6ec073df6f66ec$var$copySymbolsIn;

});

parcelRegister("kGJE1", function(module, exports) {
/** Used for built-in method references. */ var $f0fb22f60689ed3d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0fb22f60689ed3d$var$hasOwnProperty = $f0fb22f60689ed3d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $f0fb22f60689ed3d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $f0fb22f60689ed3d$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $f0fb22f60689ed3d$var$initCloneArray;

});

parcelRegister("cZmfO", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");


var $2nf4s = parcelRequire("2nf4s");


var $aOXy4 = parcelRequire("aOXy4");


var $cPFvk = parcelRequire("cPFvk");


var $39R3S = parcelRequire("39R3S");

/** `Object#toString` result references. */ var $974c71bfd764326f$var$boolTag = '[object Boolean]', $974c71bfd764326f$var$dateTag = '[object Date]', $974c71bfd764326f$var$mapTag = '[object Map]', $974c71bfd764326f$var$numberTag = '[object Number]', $974c71bfd764326f$var$regexpTag = '[object RegExp]', $974c71bfd764326f$var$setTag = '[object Set]', $974c71bfd764326f$var$stringTag = '[object String]', $974c71bfd764326f$var$symbolTag = '[object Symbol]';
var $974c71bfd764326f$var$arrayBufferTag = '[object ArrayBuffer]', $974c71bfd764326f$var$dataViewTag = '[object DataView]', $974c71bfd764326f$var$float32Tag = '[object Float32Array]', $974c71bfd764326f$var$float64Tag = '[object Float64Array]', $974c71bfd764326f$var$int8Tag = '[object Int8Array]', $974c71bfd764326f$var$int16Tag = '[object Int16Array]', $974c71bfd764326f$var$int32Tag = '[object Int32Array]', $974c71bfd764326f$var$uint8Tag = '[object Uint8Array]', $974c71bfd764326f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $974c71bfd764326f$var$uint16Tag = '[object Uint16Array]', $974c71bfd764326f$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $974c71bfd764326f$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $974c71bfd764326f$var$arrayBufferTag:
            return $bAYSF(object);
        case $974c71bfd764326f$var$boolTag:
        case $974c71bfd764326f$var$dateTag:
            return new Ctor(+object);
        case $974c71bfd764326f$var$dataViewTag:
            return $2nf4s(object, isDeep);
        case $974c71bfd764326f$var$float32Tag:
        case $974c71bfd764326f$var$float64Tag:
        case $974c71bfd764326f$var$int8Tag:
        case $974c71bfd764326f$var$int16Tag:
        case $974c71bfd764326f$var$int32Tag:
        case $974c71bfd764326f$var$uint8Tag:
        case $974c71bfd764326f$var$uint8ClampedTag:
        case $974c71bfd764326f$var$uint16Tag:
        case $974c71bfd764326f$var$uint32Tag:
            return $39R3S(object, isDeep);
        case $974c71bfd764326f$var$mapTag:
            return new Ctor;
        case $974c71bfd764326f$var$numberTag:
        case $974c71bfd764326f$var$stringTag:
            return new Ctor(object);
        case $974c71bfd764326f$var$regexpTag:
            return $aOXy4(object);
        case $974c71bfd764326f$var$setTag:
            return new Ctor;
        case $974c71bfd764326f$var$symbolTag:
            return $cPFvk(object);
    }
}
module.exports = $974c71bfd764326f$var$initCloneByTag;

});

parcelRegister("2nf4s", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $1ba96b89566301a8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $bAYSF(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $1ba96b89566301a8$var$cloneDataView;

});

parcelRegister("aOXy4", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $7e0cc3fe33183417$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $7e0cc3fe33183417$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $7e0cc3fe33183417$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $7e0cc3fe33183417$var$cloneRegExp;

});

parcelRegister("cPFvk", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");

/** Used to convert symbols to primitives and strings. */ var $957a7155a4d05ec8$var$symbolProto = $2v1OR ? $2v1OR.prototype : undefined, $957a7155a4d05ec8$var$symbolValueOf = $957a7155a4d05ec8$var$symbolProto ? $957a7155a4d05ec8$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $957a7155a4d05ec8$var$cloneSymbol(symbol) {
    return $957a7155a4d05ec8$var$symbolValueOf ? Object($957a7155a4d05ec8$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $957a7155a4d05ec8$var$cloneSymbol;

});

parcelRegister("aBDCC", function(module, exports) {

var $aPSWx = parcelRequire("aPSWx");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $7b8c182c149a3e72$var$nodeIsMap = $izBVL && $izBVL.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $7b8c182c149a3e72$var$isMap = $7b8c182c149a3e72$var$nodeIsMap ? $gGzL7($7b8c182c149a3e72$var$nodeIsMap) : $aPSWx;
module.exports = $7b8c182c149a3e72$var$isMap;

});

parcelRegister("aPSWx", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $7e3949613e91b78e$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7e3949613e91b78e$var$baseIsMap(value) {
    return $7WFUU(value) && $jOCrv(value) == $7e3949613e91b78e$var$mapTag;
}
module.exports = $7e3949613e91b78e$var$baseIsMap;

});

parcelRegister("1ji1e", function(module, exports) {

var $l6Y5L = parcelRequire("l6Y5L");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $0f458af8916b54b7$var$nodeIsSet = $izBVL && $izBVL.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $0f458af8916b54b7$var$isSet = $0f458af8916b54b7$var$nodeIsSet ? $gGzL7($0f458af8916b54b7$var$nodeIsSet) : $l6Y5L;
module.exports = $0f458af8916b54b7$var$isSet;

});

parcelRegister("l6Y5L", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $f5e8c58b63155910$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $f5e8c58b63155910$var$baseIsSet(value) {
    return $7WFUU(value) && $jOCrv(value) == $f5e8c58b63155910$var$setTag;
}
module.exports = $f5e8c58b63155910$var$baseIsSet;

});

parcelRegister("hcV0q", function(module, exports) {

var $aI4Cx = parcelRequire("aI4Cx");


var $gO1os = parcelRequire("gO1os");


var $3ye78 = parcelRequire("3ye78");


var $4yN45 = parcelRequire("4yN45");

/** Used for built-in method references. */ var $c86fc6d9079351ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c86fc6d9079351ab$var$hasOwnProperty = $c86fc6d9079351ab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c86fc6d9079351ab$var$baseUnset(object, path) {
    path = $aI4Cx(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $4yN45(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$c86fc6d9079351ab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $3ye78(object, path);
    return obj == null || delete obj[$4yN45($gO1os(path))];
}
module.exports = $c86fc6d9079351ab$var$baseUnset;

});

parcelRegister("3ye78", function(module, exports) {

var $5g03W = parcelRequire("5g03W");


var $dAhdV = parcelRequire("dAhdV");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $295f7eda793e290e$var$parent(object, path) {
    return path.length < 2 ? object : $5g03W(object, $dAhdV(path, 0, -1));
}
module.exports = $295f7eda793e290e$var$parent;

});

parcelRegister("ezTcL", function(module, exports) {

var $etJuK = parcelRequire("etJuK");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $a9cf2821aeb590cb$var$customOmitClone(value) {
    return $etJuK(value) ? undefined : value;
}
module.exports = $a9cf2821aeb590cb$var$customOmitClone;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("lyWac", function(module, exports) {

var $3mugH = parcelRequire("3mugH");

function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') {
                const fulfilledValue = result.value;
                if (fulfilledValue instanceof Error) errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue));
                else if (Array.isArray(fulfilledValue)) {
                    const filteredErrors = fulfilledValue.filter((value)=>value instanceof Error);
                    errors.push(...filteredErrors.flatMap($6e8f7926b945fe5e$var$expandErrorToErrors));
                }
            }
        }
        if (errors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of errors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return errors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("bPDOf", function(module, exports) {
const $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575 = {
    hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
    isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
    hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
    hasSeenTrackChangesStreamingSpotlight: 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight',
    isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
    hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
    hasDismissedGettingStartedTour: 'aifc-onboarding:hasDismissedGettingStartedTour',
    hasSeenDeeplinkReturnSpotlight: 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight',
    hasSeenTwcAifcOnboarding: 'aifc-onboarding:hasSeenTwcAifcOnboarding'
};
const $4fc1e4c0ecd68c6d$export$6024bf9594f957fe = [
    ...Object.values($4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575)
];
module.exports["AIFC_ONBOARDING_STATE_KEYS"] = $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575;
module.exports["AIFCOnboardingKeys"] = $4fc1e4c0ecd68c6d$export$6024bf9594f957fe;

});

parcelRegister("hAiCi", function(module, exports) {
/**
 * @generated SignedSource<<bea9c781c186dacbb56d302fc1fdf3bc>>
 * @relayHash 03c88593e0a708b4a806a4bb00935330
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a40daa03e54d1598b3952a7a86fc5c6a154a8756d1cb79b58cc7bf3f2e125ee
const $1d80fc45612ce410$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "value"
    }, v1 = [
        {
            "concreteType": "SiteConfiguration",
            "kind": "LinkedField",
            "name": "siteConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "customSiteLogo"
                }
            ]
        },
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "siteTitle"
                },
                {
                    "kind": "ScalarField",
                    "name": "showApplicationTitle"
                }
            ]
        },
        {
            "concreteType": "SiteDescription",
            "kind": "LinkedField",
            "name": "siteDescription",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "logoUrl"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ 
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "TopNavigationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "TopNavigationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "03c88593e0a708b4a806a4bb00935330",
            "id": "2a40daa03e54d1598b3952a7a86fc5c6a154a8756d1cb79b58cc7bf3f2e125ee",
            "metadata": {},
            "name": "TopNavigationQuery",
            "operationKind": "query",
            "text": "query TopNavigationQuery{siteConfiguration{customSiteLogo},siteSettings{siteTitle,showApplicationTitle},siteDescription{logoUrl},user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary},photos{value}}}"
        }
    };
}();
$1d80fc45612ce410$var$node.hash = "58252cd5493d65d590f00c523b3d3ad8";
var $1d80fc45612ce410$export$2e2bcd8739ae039 = $1d80fc45612ce410$var$node;
module.exports["default"] = $1d80fc45612ce410$export$2e2bcd8739ae039;

});

parcelRegister("74VX5", function(module, exports) {
/**
 * @generated SignedSource<<ad4717b23996fc6dd876d64497a8db4e>>
 * @relayHash 13e9ccffd4783d3489f7fdc0bdb79076
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8
const $7964c46f2f85665b$var$node = function() {
    var v0 = [
        {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "unseenNotificationCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "NotificationsButtonQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "NotificationsButtonQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "13e9ccffd4783d3489f7fdc0bdb79076",
            "id": "9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8",
            "metadata": {},
            "name": "NotificationsButtonQuery",
            "operationKind": "query",
            "text": "query NotificationsButtonQuery{notifications{unseenNotificationCount}}"
        }
    };
}();
$7964c46f2f85665b$var$node.hash = "942a544fd139c706378825d031824679";
var $7964c46f2f85665b$export$2e2bcd8739ae039 = $7964c46f2f85665b$var$node;
module.exports["default"] = $7964c46f2f85665b$export$2e2bcd8739ae039;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("2iGHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b090c2970a43735$export$2e2bcd8739ae039);
var $3b090c2970a43735$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== requestAnimationFrame || $[9] !== setTimeout) {
        t3 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = requestAnimationFrame;
        $[9] = setTimeout;
        $[10] = t3;
    } else t3 = $[10];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[11] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[11] = setElementRef;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("5Wig1", function(module, exports) {

var $jevsd = parcelRequire("jevsd");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/workspace/manifest.ts
var $4530881607509d00$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jevsd.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $jevsd.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $4530881607509d00$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4530881607509d00$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $4530881607509d00$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4530881607509d00$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $4530881607509d00$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $4530881607509d00$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $4530881607509d00$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};
module.exports["ConfluenceWorkspaceAri"] = $4530881607509d00$export$d47d8a7e69df1865;

});

parcelRegister("jevsd", function(module, exports) {
// src/confluence/workspace/types.ts
var $e007b94796479ac0$export$19f1a63686ec0369 = "confluence", $e007b94796479ac0$export$f1c423a93fbc71 = "workspace";
module.exports["ConfluenceWorkspaceAriResourceOwner"] = $e007b94796479ac0$export$19f1a63686ec0369;
module.exports["ConfluenceWorkspaceAriResourceType"] = $e007b94796479ac0$export$f1c423a93fbc71;

});

parcelRegister("4vyfK", function(module, exports) {

var $dAxoX = parcelRequire("dAxoX");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $iEfsZ = parcelRequire("iEfsZ");


var $eSLr0 = parcelRequire("eSLr0");

const $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery = (0, $dAxoX.default);
const $2272f3d6a41ef128$var$isSystemBatchLocation = (location)=>location.length === 2 && location.includes((0, $eSLr0.SYSTEM_HEADER_LEFT)) && location.includes((0, $eSLr0.SYSTEM_USER));
// Keep this in sync with the editorToolbarLocations batched by
// load-edit-page/src/preload/preloadEditorData.ts.
const $2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS = [
    (0, $eSLr0.TOOLS_MENU_CONTAINER),
    (0, $eSLr0.SYSTEM_EDITOR_PRECURSOR_BUTTONS)
];
const $2272f3d6a41ef128$var$CONTENT_BATCH_ALLOWED_LOCATIONS = new Set([
    ...$2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS,
    (0, $eSLr0.PAGE_BUTTONS)
]);
const $2272f3d6a41ef128$var$isContentBatchLocation = (location)=>{
    const locationSet = new Set(location);
    return $2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS.every((requiredLocation)=>locationSet.has(requiredLocation)) && [
        ...locationSet
    ].every((candidateLocation)=>$2272f3d6a41ef128$var$CONTENT_BATCH_ALLOWED_LOCATIONS.has(candidateLocation));
};
const $2272f3d6a41ef128$var$filterSectionsByLocations = (webItemSections, locations)=>webItemSections.filter((section)=>locations.some((location)=>section?.id?.startsWith(`${location}/`)));
const $2272f3d6a41ef128$var$writeWebItemLocationCache = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $iEfsZ.default),
        variables: {
            location: null,
            locations: locations,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        data: {
            webItemSections: webItemSections
        },
        __callerPackage__: "@confluence/web-item-location"
    });
};
const $2272f3d6a41ef128$var$writeWebItemLocationEntries = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    locations.forEach((location)=>{
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: location,
                locations: [],
                contentId: contentId,
                spaceKey: spaceKey,
                version: version
            },
            data: {
                webItemSections: $2272f3d6a41ef128$var$filterSectionsByLocations(webItemSections, [
                    location
                ])
            },
            __callerPackage__: "@confluence/web-item-location"
        });
    });
};
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, context: context } = {}) {
    if (!contentId && spaceKey) return (0, $dYU3e.query)({
        query: $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery,
        variables: {
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            spaceKey: spaceKey,
            version: version
        },
        context: context,
        __callerPackage__: "@confluence/web-item-location"
    }).then(({ data: data })=>{
        if (data?.space?.homepageId) (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                contentId: data?.space?.homepageId,
                spaceKey: null,
                version: version
            },
            data: {
                webItemSections: data?.space?.homepageWebSections || []
            },
            __callerPackage__: "@confluence/web-item-location"
        });
    });
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    const result = (0, $dYU3e.query)({
        query: (0, $iEfsZ.default),
        variables: variables,
        context: context,
        __callerPackage__: "@confluence/web-item-location"
    });
    if (Array.isArray(location)) {
        const shouldWriteSystemBatchEntries = (0, $6mKj3.expValEquals)('web_item_query_batch_system_call', 'isEnabled', true) && $2272f3d6a41ef128$var$isSystemBatchLocation(location);
        const shouldWriteContentBatchEntries = $2272f3d6a41ef128$var$isContentBatchLocation(location) && (0, $6mKj3.expValEquals)('web_item_query_batch_content_call', 'isEnabled', true);
        if (shouldWriteSystemBatchEntries || shouldWriteContentBatchEntries) result.then(({ data: data })=>{
            if (!data?.webItemSections) return;
            $2272f3d6a41ef128$var$writeWebItemLocationCache({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
            $2272f3d6a41ef128$var$writeWebItemLocationEntries({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
            if (shouldWriteContentBatchEntries && location.includes((0, $eSLr0.PAGE_BUTTONS))) {
                const liveEllipsisLocations = [
                    (0, $eSLr0.TOOLS_MENU_CONTAINER),
                    (0, $eSLr0.PAGE_BUTTONS)
                ];
                $2272f3d6a41ef128$var$writeWebItemLocationCache({
                    locations: liveEllipsisLocations,
                    contentId: contentId,
                    spaceKey: spaceKey,
                    version: version,
                    webItemSections: $2272f3d6a41ef128$var$filterSectionsByLocations(data.webItemSections, liveEllipsisLocations)
                });
            }
        });
    }
    return result;
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("dAxoX", function(module, exports) {
/**
 * @generated SignedSource<<723e491a15ec21972dd962ca0e8f8ba8>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511
const $074c400385fc6141$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "location"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locations"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "location",
                            "variableName": "location"
                        },
                        {
                            "kind": "Variable",
                            "name": "locations",
                            "variableName": "locations"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        }
                    ],
                    "concreteType": "WebSection",
                    "kind": "LinkedField",
                    "name": "homepageWebSections",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "cacheKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "WebItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accessKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "completeKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCondition"
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "height"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "params",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "section"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "tooltip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlWithoutContextPath"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "weight"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
            "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
            "metadata": {},
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
        }
    };
}();
$074c400385fc6141$var$node.hash = "fb9ef136f5257fc82dc16b8dc37de41b";
var $074c400385fc6141$export$2e2bcd8739ae039 = $074c400385fc6141$var$node;
module.exports["default"] = $074c400385fc6141$export$2e2bcd8739ae039;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<50efd21e0db5811e6867b792d80a2f0a>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9o4Fw = parcelRequire("9o4Fw");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $9o4Fw.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/content-appearance"
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $fqVYq = parcelRequire("fqVYq");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("6YrB3", function(module, exports) {

var $fmV2n = parcelRequire("fmV2n");

const $293056f9068f55f6$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $293056f9068f55f6$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $293056f9068f55f6$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fmV2n.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $293056f9068f55f6$export$2e2bcd8739ae039;

});

parcelRegister("fmV2n", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $a61ea4cfed034b37$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $a61ea4cfed034b37$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$a61ea4cfed034b37$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $a61ea4cfed034b37$export$efebfe7859cae3c7;

});

parcelRegister("yuV6Z", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    const baseUrl = (0, $ixfCV.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $4xiow = parcelRequire("4xiow");


var $drRzc = parcelRequire("drRzc");


var $anBbz = parcelRequire("anBbz");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            if ((0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                // Skip SSR for nodes without an Id
                if (!node.attrs.id) return undefined;
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    id: node.attrs.id,
                    shortName: node.attrs.shortName,
                    fallback: node.attrs.text,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    },
                    searchable: true,
                    type: '',
                    category: ''
                };
            }
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // For STANDARD emojis, return a UnicodeRepresentation so they are rendered
            // as native text characters rather than images (twemoji removal).
            if (node.attrs.id && result && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    ...result,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    }
                };
            }
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("5CUwy", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $3PNw6 = parcelRequire("3PNw6");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $6mKj3 = parcelRequire("6mKj3");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $3uzFB = parcelRequire("3uzFB");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default),
            __callerPackage__: "@confluence/loom-utils"
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    if ((0, $6mKj3.isExperimentEnabled)('confluence_frontend_loom_agg_perm_check_exp')) return $9633e2f0bea217d1$var$getLoomUserAggPermissionStatus(cloudId, userId);
    return $9633e2f0bea217d1$export$4fb5a1b2348fe5c4(cloudId, userId, environment);
};
const $9633e2f0bea217d1$export$4fb5a1b2348fe5c4 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$getLoomUserAggPermissionStatus = async (cloudId, userId)=>{
    if (!userId) return "not-permitted";
    const variables = (0, $3uzFB.getLoomUserPermissionQueryVariables)(cloudId, userId);
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $3uzFB.LoomUserPermissionQuery),
            variables: variables,
            errorPolicy: 'all',
            interopApolloAggClient: true,
            __callerPackage__: "@confluence/loom-utils"
        });
        if (error) throw error;
        return (0, $3uzFB.hasExactLoomUserPermission)(data, variables) ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $3PNw6.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $8s9DV.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $kBr4q.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $kBr4q.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserLegacyPermissionStatus"] = $9633e2f0bea217d1$export$4fb5a1b2348fe5c4;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("3uzFB", function(module, exports) {

var $keH2u = parcelRequire("keH2u");

const $9ee481529bbe8b4d$export$a4bb6b905bc500e2 = (0, $keH2u.default);
const $9ee481529bbe8b4d$export$8d50de945dbf45ca = (cloudId, userId)=>({
        principalId: `ari:cloud:identity::user/${userId}`,
        loomResourceId: `ari:cloud:loom::site/${cloudId}`
    });
const $9ee481529bbe8b4d$export$b048e9c33b8e482 = (data, variables)=>{
    const matchingRows = data?.bulkPermitted?.filter((row)=>row?.principalId === variables.principalId && row?.resourceId === variables.loomResourceId && row?.permissionId === 'write') ?? [];
    if (matchingRows.length < 1) return false;
    return matchingRows.every((row)=>row?.permitted === true);
};
module.exports["LoomUserPermissionQuery"] = $9ee481529bbe8b4d$export$a4bb6b905bc500e2;
module.exports["getLoomUserPermissionQueryVariables"] = $9ee481529bbe8b4d$export$8d50de945dbf45ca;
module.exports["hasExactLoomUserPermission"] = $9ee481529bbe8b4d$export$b048e9c33b8e482;

});

parcelRegister("keH2u", function(module, exports) {
/**
 * @generated SignedSource<<9936c66f475f5b5cae80af06b548f8cb>>
 * @relayHash 1246767ea7fb9149278e67c3ec09752c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5
const $ebcff904befcd9cb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "loomResourceId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "permissionIds",
                    "value": [
                        "write"
                    ]
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "principalIds.0",
                            "variableName": "principalId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "principalIds"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "resourceIds.0",
                            "variableName": "loomResourceId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "resourceIds"
                }
            ],
            "concreteType": "BulkPermittedResponse",
            "kind": "LinkedField",
            "name": "bulkPermitted",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "principalId"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permissionId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permitted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "1246767ea7fb9149278e67c3ec09752c",
            "id": "b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5",
            "metadata": {},
            "name": "loomUserPermissionQuery",
            "operationKind": "query",
            "text": "query loomUserPermissionQuery($principalId:String!,$loomResourceId:String!){bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted}}"
        }
    };
}();
$ebcff904befcd9cb$var$node.hash = "714c5537c580f754bda23bcf99534b30";
var $ebcff904befcd9cb$export$2e2bcd8739ae039 = $ebcff904befcd9cb$var$node;
module.exports["default"] = $ebcff904befcd9cb$export$2e2bcd8739ae039;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<7e1563bf12c221b07284eee871d1f539>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<d3a959f3c995162dd3e589ad8c39797e>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("1k2r8", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $8Z78B = parcelRequire("8Z78B");

const $2daa64592339f2ce$export$ce5c629ae8376218 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
module.exports["preloadAllOnboardingState"] = $2daa64592339f2ce$export$ce5c629ae8376218;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<79c814000abc51a87825021048515fd1>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "031eb89bf77537fd501cf18345136db8";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("6dPGs", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $7dBf8 = parcelRequire("7dBf8");

// `localStorage` is a browser-only Web API and does not exist during server-side
// rendering (SSR). Accessing the bare `localStorage` identifier on the server
// throws a `ReferenceError`, which crashes the render.
const $96c9493b1d7fc1a3$var$isLocalStorageAvailable = ()=>{
    if (!(0, $ixfCV.fg)('fix_ssr_browser_storage_undefined')) return true;
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};
const $96c9493b1d7fc1a3$export$5aa524d86254b4f = (key, value)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $ixfCV.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).setItem(key, value);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(key, value);
};
const $96c9493b1d7fc1a3$export$93d719890ad66653 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $ixfCV.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $96c9493b1d7fc1a3$export$5df15f289f441790 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $ixfCV.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? item : null;
};
const $96c9493b1d7fc1a3$export$baf306891f1b93bd = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $ixfCV.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).removeItem(key);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $96c9493b1d7fc1a3$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $96c9493b1d7fc1a3$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $96c9493b1d7fc1a3$export$5df15f289f441790;
module.exports["removeLocalStorageItem"] = $96c9493b1d7fc1a3$export$baf306891f1b93bd;

});

parcelRegister("aqAfG", function(module, exports) {


const $04ba0efeefc046b8$export$a0110d095394669e = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    Talent: 'radar'
};
const $04ba0efeefc046b8$export$deaa7a6e1403419a = Object.values($04ba0efeefc046b8$export$a0110d095394669e);
const $04ba0efeefc046b8$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $04ba0efeefc046b8$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($04ba0efeefc046b8$export$a93cddd79e3ea530).includes(key);
};
module.exports["ProductKeys1P"] = $04ba0efeefc046b8$export$a0110d095394669e;
module.exports["ARI_EXTRACTED_1P_KEYS"] = $04ba0efeefc046b8$export$deaa7a6e1403419a;
module.exports["NounKeys"] = $04ba0efeefc046b8$export$a93cddd79e3ea530;

});

parcelRegister("iS5Ay", function(module, exports) {

var $c6StJ = parcelRequire("c6StJ");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $c6StJ.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("1RY07", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData, convertToApolloError: convertToApolloError }) {
    if (skip) return {
        data: undefined,
        error: undefined
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            error: undefined
        };
    } catch (error) {
        const apolloError = await Promise.resolve(convertToApolloError(error));
        if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
            (0, $7Sm4c.processError)(e);
        });
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            error: apolloError
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $c9IWh = parcelRequire("c9IWh");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $c9IWh.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $kBr4q.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $kBr4q.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $krgsn = parcelRequire("krgsn");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $krgsn.GraphQLError)(message, null, // nodes - no GraphQL query AST
    null, // source - no GraphQL query text
    null, // positions - no GraphQL query positions
    null, // path - not executing GraphQL schema fields
    originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("4UYoK", function(module, exports) {
/**
 * Onboarding-state keys for the spotlight that is anchored to the Universal
 * Create menu dropdown shown the first time a user in the Universal Create
 * (CwR) experiment cohort opens the create menu.
 */ const $88afb75838a9f8b5$export$134ea9981ab0c82e = {
    hasSeenUniversalCreateCwRExperimentSpotlight: 'universal-create-cwr-experiment-spotlight:hasSeenUniversalCreateCwRExperimentSpotlight'
};
const $88afb75838a9f8b5$export$5b55ba0fa31f0184 = [
    ...Object.values($88afb75838a9f8b5$export$134ea9981ab0c82e)
];
module.exports["UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS"] = $88afb75838a9f8b5$export$134ea9981ab0c82e;
module.exports["UniversalCreateCwRExperimentSpotlightOnboardingKeys"] = $88afb75838a9f8b5$export$5b55ba0fa31f0184;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<b9ad5a08ae51c98f54e2bf136fb000a5>>
 * @relayHash 3a81188260e43110e57bf35a979f5053
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c767da7861d97903ba1d85d6b0a41ab5ff13ba32a0ebf4537e812118caef418
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalsBetaFeatures"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "success"
    }, v11 = {
        "kind": "ScalarField",
        "name": "message"
    }, v12 = {
        "kind": "ScalarField",
        "name": "principalType"
    }, v13 = {
        "kind": "ScalarField",
        "name": "principalId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v16 = {
        "kind": "ScalarField",
        "name": "value"
    }, v17 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v18 = [
        v7 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v17 /*: any*/ 
            ]
        }
    ], v19 = {
        "condition": "includeApprovalsBetaFeatures",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v9 /*: any*/ 
                ],
                "concreteType": "ConfluenceContentApprovalsSiteSettings",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSiteSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "enabled"
                    }
                ]
            },
            {
                "args": [
                    v9 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "filterSelf",
                        "value": false
                    },
                    {
                        "kind": "Variable",
                        "name": "spaceKey",
                        "variableName": "spaceKey"
                    }
                ],
                "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSpaceSettingConfig",
                "plural": false,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "concreteType": "MutationError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v11 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "disallowFirstPublish"
                            },
                            {
                                "concreteType": "ConfluenceApprovalReviewerConfig",
                                "kind": "LinkedField",
                                "name": "enforcedApprovalReviewerConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isEnabled"
                                    },
                                    {
                                        "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                                        "kind": "LinkedField",
                                        "name": "reviewers",
                                        "plural": true,
                                        "selections": [
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            {
                                                "concreteType": "AtlassianUser",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": v18 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v20 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "status"
    }, v22 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v23 = {
        "args": [
            v9 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v24 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v25 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v26 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v27 = [
        v9 /*: any*/ ,
        v24 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v28 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v29 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v30 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v28 /*: any*/ ,
                    v29 /*: any*/ 
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v32 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            v31 /*: any*/ 
        ]
    }, v33 = [
        v9 /*: any*/ ,
        v24 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v34 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v35 = [
        v16 /*: any*/ 
    ], v36 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v15 /*: any*/ ,
            v34 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v18 /*: any*/ 
            }
        ]
    }, v37 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            v31 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "condition": "includeApprovalsBetaFeatures",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": v35 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            v34 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v35 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v7 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    v16 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v38 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v28 /*: any*/ ,
                    v29 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v7 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v8 /*: any*/ ,
                v19 /*: any*/ ,
                {
                    "args": v20 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v27 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v30 /*: any*/ ,
                        v32 /*: any*/ 
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v30 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v8 /*: any*/ ,
                v19 /*: any*/ ,
                {
                    "args": v20 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v27 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v38 /*: any*/ ,
                        v32 /*: any*/ 
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v38 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3a81188260e43110e57bf35a979f5053",
            "id": "9c767da7861d97903ba1d85d6b0a41ab5ff13ba32a0ebf4537e812118caef418",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}},confluence_contentApprovalsSiteSettings(cloudId:$cloudId)@include(if:$includeApprovalsBetaFeatures){enabled}\n  confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "20f79def106defb4cc34e9f770d1c8cc";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("fywGr", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $5cryL = parcelRequire("5cryL");


var $8Z78B = parcelRequire("8Z78B");


var $1k2r8 = parcelRequire("1k2r8");

const $7aae32df106d9977$export$864cb1c5b7b9b39 = ()=>{
    // When the centralized onboarding state experiment is enabled, use the centralized preloader
    // to ensure all onboarding state queries hit the cache.
    if ((0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return (0, $1k2r8.preloadAllOnboardingState)();
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS))
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
module.exports["preloadEditorOnboardingState"] = $7aae32df106d9977$export$864cb1c5b7b9b39;

});

parcelRegister("ln0hx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $3PNw6 = parcelRequire("3PNw6");


var $l6Cdg = parcelRequire("l6Cdg");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $3PNw6.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("8aF6s", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $8s9DV.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $kBr4q.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $cozmU.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $kBr4q.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $cozmU.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("8qMNj", function(module, exports) {
$parcel$export(module.exports, "default", () => $623699fd92ec4e19$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $kr6hK = parcelRequire("kr6hK");


var $3yGK6 = parcelRequire("3yGK6");


var $4m74k = parcelRequire("4m74k");

function $623699fd92ec4e19$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $3yGK6.default)(1, arguments);
    var defaultOptions = (0, $4m74k.getDefaultOptions)();
    var weekStartsOn = (0, $kr6hK.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("iGwRU", function(module, exports) {
parcelRequire("fmu9K");
var $iTJtk = parcelRequire("iTJtk");

const $3011e158d8129415$export$85183a312807388d = (0, $iTJtk.FabricChannel).aiMate;
module.exports["ANALYTICS_CHANNEL"] = $3011e158d8129415$export$85183a312807388d;

});

parcelRegister("fmu9K", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("iTJtk")).FabricChannel);

var $hpWmZ = parcelRequire("hpWmZ");


var $lMjmr = parcelRequire("lMjmr");


var $iTJtk = parcelRequire("iTJtk");


});

parcelRegister("l9F99", function(module, exports) {
const $9a048168f718fa86$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        return {
            ...acc,
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $9a048168f718fa86$export$d97c97ed77ff09e8;

});

parcelRegister("i8NpI", function(module, exports) {
const $5912f9d7fe53faa6$export$f6abe2eda5c1912f = ()=>({
        eventType: 'track',
        tags: [
            'atlaskit'
        ]
    });
module.exports["getDefaultTrackEventConfig"] = $5912f9d7fe53faa6$export$f6abe2eda5c1912f;

});

parcelRegister("gtQgC", function(module, exports) {

var $62APY = parcelRequire("62APY");

const $1665c8ad23657fd1$var$getStudioHost = (env)=>env === 'staging' ? (0, $62APY.STUDIO_STAGING_URL) : (0, $62APY.STUDIO_PROD_URL);
const $1665c8ad23657fd1$export$b4a3ce4b99911063 = (env, path, email)=>{
    const studioHost = $1665c8ad23657fd1$var$getStudioHost(env);
    const normalizedPath = path ? path.startsWith('/') ? path : `/${path}` : '';
    const destination = `${studioHost}${normalizedPath}`;
    if (!email) return destination;
    // Merge login_hint into any existing query string.
    const url = new URL(destination);
    url.searchParams.set('login_hint', email);
    return url.toString();
};
module.exports["getStudioSessionSyncUrl"] = $1665c8ad23657fd1$export$b4a3ce4b99911063;

});

parcelRegister("62APY", function(module, exports) {
const $e6043006edffc91a$export$83a42cd6c4b5f72d = 'https://studio.atlassian.com';
const $e6043006edffc91a$export$1b2ea4d616a1810d = 'https://studio.stg.atlassian.com';
module.exports["STUDIO_PROD_URL"] = $e6043006edffc91a$export$83a42cd6c4b5f72d;
module.exports["STUDIO_STAGING_URL"] = $e6043006edffc91a$export$1b2ea4d616a1810d;

});

parcelRegister("dTEBe", function(module, exports) {

var $iDZi9 = parcelRequire("iDZi9");

const $f229989060597496$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $f229989060597496$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $f229989060597496$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $f229989060597496$export$9748efee331ec573 = (param)=>`${0, $iDZi9.ROVO_PARAM_PREFIX}${$f229989060597496$export$fda91e425d265029(param)}`;
const $f229989060597496$export$f2888183a34644d4 = (param)=>{
    return $f229989060597496$export$858653b7ee3cbb17(param.replace((0, $iDZi9.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $f229989060597496$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $f229989060597496$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $iDZi9.ROVO_PARAM_PREFIX))) return;
        const paramKey = $f229989060597496$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $f229989060597496$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $f229989060597496$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $f229989060597496$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $f229989060597496$export$ef04687636c850fe(window.location.pathname, params));
};
const $f229989060597496$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $f229989060597496$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $f229989060597496$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $f229989060597496$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$f229989060597496$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$f229989060597496$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $f229989060597496$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $f229989060597496$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
  For products using react-resource-router (e.g Atlas) to
  pass as the value of `query` on the route definition. It ensures that our parameters
  are not stripped from the URL when loading the page, or through redirect hops
  Any new parameters we want to maintain should be added here as well, which means
  only a version bump is needed in those products to support the latest param list
  The !=false simply means that the parameter is supported but is optional, and should
  not contain a value of 'false'
  */ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $iDZi9.ROVO_VALID_PARAMS).map((param)=>`${$f229989060597496$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $f229989060597496$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $f229989060597496$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $f229989060597496$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $f229989060597496$export$eddc20a009406015;

});

parcelRegister("iDZi9", function(module, exports) {
const $36649e4ee5b3590e$export$5a550907ffbc9119 = 'rovoChat';
const $36649e4ee5b3590e$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt',
    'promptLibraryOpen',
    'openChatMode'
];
module.exports["ROVO_PARAM_PREFIX"] = $36649e4ee5b3590e$export$5a550907ffbc9119;
module.exports["ROVO_VALID_PARAMS"] = $36649e4ee5b3590e$export$3cd6b610e7ede579;

});

parcelRegister("fa8WQ", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $gtQgC = parcelRequire("gtQgC");


var $2J4Io = parcelRequire("2J4Io");

const $7a5b39f110eb7e66$var$STUDIO_PROD_URL = 'https://studio.atlassian.com';
const $7a5b39f110eb7e66$var$STUDIO_STAGING_URL = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';
const $7a5b39f110eb7e66$export$72eb188ed9591973 = ()=>{
    return (0, $2J4Io.isStaging)() ? $7a5b39f110eb7e66$var$STUDIO_STAGING_URL : $7a5b39f110eb7e66$var$STUDIO_PROD_URL;
};
const $7a5b39f110eb7e66$var$getStudioEnv = ()=>(0, $2J4Io.isStaging)() ? 'staging' : 'production';
const $7a5b39f110eb7e66$export$372c8de5c124bdc8 = (path, email)=>{
    if (email && (0, $ixfCV.fg)('asf-944-account-sync')) return (0, $gtQgC.getStudioSessionSyncUrl)($7a5b39f110eb7e66$var$getStudioEnv(), path, email);
    return `${$7a5b39f110eb7e66$export$72eb188ed9591973()}${path}`;
};
const $7a5b39f110eb7e66$var$buildStudioAutomationRuleEditUrl = (workspaceId, spaceId, ruleIdUuid)=>{
    const base = `/w/${workspaceId}/spaces/${spaceId}/automation#`;
    return `${base}/rule/${encodeURIComponent(ruleIdUuid)}`;
};
const $7a5b39f110eb7e66$export$bb5c2ff2ee505e4a = (siteId, navigationSource, csid, email, starterText)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', navigationSource);
    if (csid && (0, $ixfCV.fg)('rovo-agents-universal-analytics')) searchParams.set('csid', csid);
    if (starterText) searchParams.set('starterText', starterText);
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/chat${searchParams.size > 0 ? `?${searchParams}` : ''}`, email);
};
const $7a5b39f110eb7e66$export$fe475324c26e3007 = (siteId, email)=>{
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/overview`, email);
};
const $7a5b39f110eb7e66$export$ef221a159d6fa3e8 = (siteId, agentId, email)=>$7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}`, email);
const $7a5b39f110eb7e66$export$a20abb994c34f0a4 = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/:agentId/overview')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$36c11ab884b7b2cb = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/create')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $7a5b39f110eb7e66$export$c2d162390af7b91d = (siteId, agentAri, navigationSource, email)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', encodeURIComponent(navigationSource));
    const query = searchParams.size > 0 ? `?${searchParams}` : '';
    return $7a5b39f110eb7e66$export$372c8de5c124bdc8(`/s/${siteId}/agents/${encodeURIComponent(agentAri)}/permissions${query}`, email);
};
const $7a5b39f110eb7e66$export$bae72ef7f23dbede = (workspaceId, spaceId, ruleIdUuid, email)=>$7a5b39f110eb7e66$export$372c8de5c124bdc8($7a5b39f110eb7e66$var$buildStudioAutomationRuleEditUrl(workspaceId, spaceId, ruleIdUuid), email);
module.exports["getStudioPath"] = $7a5b39f110eb7e66$export$372c8de5c124bdc8;
module.exports["getAtlassianStudioNLCreateUrl"] = $7a5b39f110eb7e66$export$bb5c2ff2ee505e4a;
module.exports["getAtlassianStudioAgentEditUrl"] = $7a5b39f110eb7e66$export$a20abb994c34f0a4;
module.exports["getAtlassianStudioAgentDuplicateUrl"] = $7a5b39f110eb7e66$export$36c11ab884b7b2cb;
module.exports["getAtlassianStudioAutomationRuleEditUrl"] = $7a5b39f110eb7e66$export$bae72ef7f23dbede;

});

parcelRegister("2J4Io", function(module, exports) {
const $d610f1a90044572d$export$23da1d24a38b0bde = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
module.exports["isStaging"] = $d610f1a90044572d$export$23da1d24a38b0bde;

});

parcelRegister("aaPn1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7cQjw = parcelRequire("7cQjw");


var $iTxmV = parcelRequire("iTxmV");

const $bebfe5469a5e55d3$export$8a1abb7c176bd202 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId)=>{
    const $ = (0, $bDgLe.c)(5);
    const { data: tenantData } = (0, $iTxmV.useTenantDataController)(siteId);
    let t0;
    if ($[0] !== siteId || $[1] !== tenantData?.orgId) {
        t0 = (path)=>(0, $7cQjw.getAtlasURL)(siteId, path, tenantData?.orgId);
        $[0] = siteId;
        $[1] = tenantData?.orgId;
        $[2] = t0;
    } else t0 = $[2];
    tenantData?.orgId;
    const atlasURL = t0;
    let t1;
    if ($[3] !== atlasURL) {
        t1 = {
            atlasURL: atlasURL
        };
        $[3] = atlasURL;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (siteId)=>{
    const { data: tenantData } = (0, $iTxmV.useTenantDataController)(siteId);
    const atlasURL = (0, $cozmU.useCallback)((path)=>(0, $7cQjw.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $bebfe5469a5e55d3$export$b61b99f9ac0264be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId)=>{
    const $ = (0, $bDgLe.c)(2);
    const { atlasURL: atlasURL } = $bebfe5469a5e55d3$export$8a1abb7c176bd202(siteId);
    let t0;
    if ($[0] !== atlasURL) {
        t0 = atlasURL("/chat/agents/new");
        $[0] = atlasURL;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (siteId)=>{
    const { atlasURL: atlasURL } = $bebfe5469a5e55d3$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};
module.exports["useAtlasURL"] = $bebfe5469a5e55d3$export$8a1abb7c176bd202;

});

parcelRegister("7cQjw", function(module, exports) {

var $dTEBe = parcelRequire("dTEBe");


var $2J4Io = parcelRequire("2J4Io");

const $4c09219c949e06e3$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $4c09219c949e06e3$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $4c09219c949e06e3$export$5105758c0e772381 = ()=>{
    return (0, $2J4Io.isStaging)() ? $4c09219c949e06e3$var$ATLAS_STAGING_URL : $4c09219c949e06e3$var$ATLAS_PROD_URL;
};
const $4c09219c949e06e3$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$4c09219c949e06e3$export$5105758c0e772381()}/o/${orgId}` : $4c09219c949e06e3$export$5105758c0e772381();
    return (0, $dTEBe.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};
module.exports["getAtlasHost"] = $4c09219c949e06e3$export$5105758c0e772381;
module.exports["getAtlasURL"] = $4c09219c949e06e3$export$bfee0f88bf621ad3;

});

parcelRegister("iTxmV", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $5SS4O = parcelRequire("5SS4O");


var $fBeNh = parcelRequire("fBeNh");

const $a5b67b50b6da9994$export$b863fec6791eae25 = (siteId)=>{
    (0, $6cFsl.di)((0, $5SS4O.useQuery));
    const experience = (0, $bjY3F.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error_0 } = (0, $5SS4O.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $fBeNh.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error_0
    };
};
module.exports["useTenantDataController"] = $a5b67b50b6da9994$export$b863fec6791eae25;

});

parcelRegister("fBeNh", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $haiCi = parcelRequire("haiCi");


var $8JTh2 = parcelRequire("8JTh2");

const $c818cddb4b471711$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
    orgId
    customDomains {
      product
      hostName
    }
  }
}
`;
// Cached per `cloudId` — the raw AGG payload is product-agnostic, so we fetch
// once per tenant and let the rewrite step branch on product. The cache stores
// the in-flight Promise so concurrent product lookups dedupe to one request.
const $c818cddb4b471711$var$rawTenantCache = new Map();
const $c818cddb4b471711$var$fetchTenantContext = async (cloudId)=>{
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: $c818cddb4b471711$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};
const $c818cddb4b471711$export$d4ace54df9bd6bb1 = async (cloudId, product)=>{
    const cachingEnabled = (0, $ixfCV.fg)('aifc_create_enabled');
    let inFlight = cachingEnabled ? $c818cddb4b471711$var$rawTenantCache.get(cloudId) : undefined;
    if (!inFlight) {
        inFlight = $c818cddb4b471711$var$fetchTenantContext(cloudId);
        if (cachingEnabled) {
            $c818cddb4b471711$var$rawTenantCache.set(cloudId, inFlight);
            inFlight.then((result)=>{
                if (result === undefined) $c818cddb4b471711$var$rawTenantCache.delete(cloudId);
            }, ()=>{
                $c818cddb4b471711$var$rawTenantCache.delete(cloudId);
            });
        }
    }
    const raw = await inFlight;
    if (!raw) return undefined;
    return {
        cloudUrl: product ? (0, $8JTh2.rewriteBaseToCustomDomain)(raw.cloudUrl, product, raw.customDomains) : raw.cloudUrl,
        orgId: raw.orgId
    };
};
module.exports["getCloudUrlFromId"] = $c818cddb4b471711$export$d4ace54df9bd6bb1;

});

parcelRegister("haiCi", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");

const $a406323faf455711$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $a406323faf455711$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $a406323faf455711$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $a406323faf455711$export$ba203f24e0131ba7) throw err;
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') return {
            // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing GraphQL abort baseline: abort returns an empty typed success shape for generic callers.
            data: null,
            errors: undefined
        };
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $jTKfH.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $a406323faf455711$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $a406323faf455711$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $a406323faf455711$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $a406323faf455711$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $a406323faf455711$export$f602b5befecb0b84;
module.exports["GqlApiError"] = $a406323faf455711$export$ba203f24e0131ba7;

});

parcelRegister("8JTh2", function(module, exports) {
const $43581a61b5d6dd12$export$432453592155ebf4 = (base, product, customDomains)=>{
    const match = customDomains?.find((domain)=>domain.product === product && Boolean(domain.hostName));
    if (!match) return base;
    try {
        const url = new URL(base);
        url.hostname = match.hostName;
        // url.toString() normalises bare-root URLs to include a trailing slash
        // (e.g. 'https://wiki.starbucks.com/'). All handlers concatenate a
        // leading-slash path, so we strip the trailing slash to avoid double-slashes
        // (e.g. 'https://wiki.starbucks.com//wiki/spaces/...' → correct).
        return url.toString().replace(/\/$/, '');
    } catch  {
        return base;
    }
};
module.exports["rewriteBaseToCustomDomain"] = $43581a61b5d6dd12$export$432453592155ebf4;

});

parcelRegister("boaiH", function(module, exports) {

var $2gr4B = parcelRequire("2gr4B");

class $ffade2ccf1ecf3ef$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $2gr4B.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $ffade2ccf1ecf3ef$export$12b6b072930fd68f;

});

parcelRegister("2gr4B", function(module, exports) {

var $apqal = parcelRequire("apqal");

function $8617e1b2001e7e7c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $8617e1b2001e7e7c$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $apqal.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $8617e1b2001e7e7c$export$c90b54e658fc4d7c;

});

parcelRegister("apqal", function(module, exports) {
class $f9800b995ac71735$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $f9800b995ac71735$export$d27a2b6293f7631c;

});

parcelRegister("33DP2", function(module, exports) {
const $1034fab58a3f1117$export$73b400613798970e = 'rovo-agents-fe';
module.exports["ROVO_AGENTS_FE_TEAM_NAME"] = $1034fab58a3f1117$export$73b400613798970e;

});

parcelRegister("rECdA", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $8m50u = parcelRequire("8m50u");

const $71deccf66348f07d$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $8m50u.componentWithCondition)(()=>(0, $ixfCV.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $71deccf66348f07d$export$cf56d0f54cfcce4;

});

parcelRegister("8m50u", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

function $fb7caad66dba5065$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
        const $ = (0, $bDgLe.c)(3);
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $fb7caad66dba5065$export$6e8ea24b15199873;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_baseNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("kMzDv", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => (parcelRequire("7zxJs")).AuthError);

var $7zxJs = parcelRequire("7zxJs");


var $75u2V = parcelRequire("75u2V");

function $0ace81f38c50981c$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $75u2V.isOfTypeAuthError)(errorType)) reject(new (0, $7zxJs.AuthError)(data.message, errorType));
                    else reject(new (0, $7zxJs.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $7zxJs.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}
module.exports["auth"] = $0ace81f38c50981c$export$73693bad9f5880b0;

});

parcelRegister("7zxJs", function(module, exports) {
class $dd3fe40c981b3bd9$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}
module.exports["AuthError"] = $dd3fe40c981b3bd9$export$145273558d58e0ac;

});

parcelRegister("75u2V", function(module, exports) {
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $6f56de9d96dc4f7f$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};
module.exports["isOfTypeAuthError"] = $6f56de9d96dc4f7f$export$400e64c8451aa84f;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("f7Bnv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1ytiN = parcelRequire("1ytiN");

function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}
module.exports["withIsSiteAdmin"] = $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5;

});

parcelRegister("aOjGz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa391a3d57e28f300b24cee0bba3c43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7dedd806b3dd6402$var$_react = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7dedd806b3dd6402$var$_baseNew = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("gElAV")));
function $7dedd806b3dd6402$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for use for Jira Projects for now. This will replace the Jira rocket. 

More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7dedd806b3dd6402$var$SpacesIcon = (props)=>/*#__PURE__*/ $7dedd806b3dd6402$var$_react.default.createElement($7dedd806b3dd6402$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$7dedd806b3dd6402$var$SpacesIcon.displayName = 'SpacesIcon';
var $7dedd806b3dd6402$var$_default = module.exports.default = $7dedd806b3dd6402$var$SpacesIcon;

});

parcelRegister("1RMKR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $323d99f2c95b5263$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $323d99f2c95b5263$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $cozmU.useMemo)(()=>obj, $323d99f2c95b5263$export$cdf98ded28406f69(obj));
}
module.exports["useStableObject"] = $323d99f2c95b5263$export$ed02d4adf2068b08;

});

parcelRegister("7NHN3", function(module, exports) {

var $kEPax = parcelRequire("kEPax");

const $b15c706fb306d92c$export$39b0f5626e96f41e = (0, $kEPax.useMessageInstanceEvent);
module.exports["useMessageInstanceEvent"] = $b15c706fb306d92c$export$39b0f5626e96f41e;

});

parcelRegister("5h1mk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $6nvBr = parcelRequire("6nvBr");


var $1RMKR = parcelRequire("1RMKR");

const $a524e85936787c13$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $a524e85936787c13$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $a524e85936787c13$var$usePostOfficeRouteStore = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { subscribe: subscribe, getSnapshot: getSnapshot } = t0;
    const route = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $1RMKR.useStableObject)(route);
} : ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $1RMKR.useStableObject)(route);
};
const $a524e85936787c13$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $a524e85936787c13$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$a524e85936787c13$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $a524e85936787c13$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $cozmU.createContext)($a524e85936787c13$var$initialState);
const $a524e85936787c13$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $cozmU.useRef)();
    if (!ref.current) ref.current = $a524e85936787c13$export$98c77e1bd702ed15(props);
    const route = $a524e85936787c13$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a524e85936787c13$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $a524e85936787c13$export$79301b66f7808cd8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($a524e85936787c13$export$f7f47a74e8b47b1f);
} : ()=>(0, $cozmU.useContext)($a524e85936787c13$export$f7f47a74e8b47b1f); //Route listener
module.exports["PostOfficeRouteContext"] = $a524e85936787c13$export$f7f47a74e8b47b1f;
module.exports["PostOfficeRouteProvider"] = $a524e85936787c13$export$89eadc6b3e5f4e9e;
module.exports["usePostOfficeRoute"] = $a524e85936787c13$export$79301b66f7808cd8;

});

parcelRegister("5W8qe", function(module, exports) {
var $4528e6ffac657016$var$has = Object.prototype.hasOwnProperty;
function $4528e6ffac657016$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $4528e6ffac657016$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($4528e6ffac657016$var$has.call(foo, ctor) && ++len && !$4528e6ffac657016$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$4528e6ffac657016$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $4528e6ffac657016$export$de8294bb3be0322f;

});

parcelRegister("cUcPn", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $cfc2cb470fbdc4fd$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $cfc2cb470fbdc4fd$export$2e2bcd8739ae039 = $cfc2cb470fbdc4fd$export$852ff24d0930c62f;
module.exports["default"] = $cfc2cb470fbdc4fd$export$2e2bcd8739ae039;

});

parcelRegister("2ZJmt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("ki0qk"))).NavigationLockout
});
module.exports["NavigationLockout"] = $caa92877b3f564cd$export$e2ddff3a4a4594f0;

});

parcelRegister("ki0qk", function(module, exports) {

let $ec55d139e213cdf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec55d139e213cdf9$var$load("hwiu3").then(()=>parcelRequire('jUOfU'));

});

parcelRegister("4WmbV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $7joZr = parcelRequire("7joZr");


var $1ytiN = parcelRequire("1ytiN");


var $iJ9aA = parcelRequire("iJ9aA");


var $ki6F7 = parcelRequire("ki6F7");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");


var $lNKOh = parcelRequire("lNKOh");


var $bhvFb = parcelRequire("bhvFb");


var $5u7Ox = parcelRequire("5u7Ox");


var $a9aSv = parcelRequire("a9aSv");

var $3a454656eb0e87cd$export$d33a80488b9cab17 = /*#__PURE__*/ function(SectionMessageButtonConfig) {
    SectionMessageButtonConfig["DEFAULT"] = "default";
    SectionMessageButtonConfig["UPGRADE_ONLY"] = "upgradeOnly";
    SectionMessageButtonConfig["NONE"] = "none";
    return SectionMessageButtonConfig;
}({});
const $3a454656eb0e87cd$export$2e68cfab3dc25476 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(65);
    let footer;
    let grandfathered;
    let headerButton;
    let learnMoreLink;
    let onRequestUpgradeButtonClick;
    let onUpFlowOpen;
    let props;
    let secondaryLink;
    let source;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let targetEdition;
    if ($[0] !== t0) {
        ({ canShowUpgradeButton: t1, buttonConfig: t2, upgradeEditionActionSubjectId: t3, grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: t4, isLoadingRequestUpgradeButton: t5, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick, requestUpgradeButtonIsLoading: t6, ...props } = t0);
        $[0] = t0;
        $[1] = footer;
        $[2] = grandfathered;
        $[3] = headerButton;
        $[4] = learnMoreLink;
        $[5] = onRequestUpgradeButtonClick;
        $[6] = onUpFlowOpen;
        $[7] = props;
        $[8] = secondaryLink;
        $[9] = source;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = targetEdition;
    } else {
        footer = $[1];
        grandfathered = $[2];
        headerButton = $[3];
        learnMoreLink = $[4];
        onRequestUpgradeButtonClick = $[5];
        onUpFlowOpen = $[6];
        props = $[7];
        secondaryLink = $[8];
        source = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        t4 = $[13];
        t5 = $[14];
        t6 = $[15];
        targetEdition = $[16];
    }
    const canShowUpgradeButton = t1 === undefined ? true : t1;
    const buttonConfig = t2 === undefined ? "default" : t2;
    const upgradeEditionActionSubjectId = t3 === undefined ? "freeTryNow" : t3;
    const showRequestUpgradeButton = t4 === undefined ? false : t4;
    const isLoadingRequestUpgradeButton = t5 === undefined ? false : t5;
    const requestUpgradeButtonIsLoading = t6 === undefined ? false : t6;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const t7 = Boolean(grandfathered);
    let t8;
    if ($[17] !== isSiteAdmin || $[18] !== t7) {
        t8 = {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: t7
        };
        $[17] = isSiteAdmin;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    const CTAAnalyticsAttributes = t8;
    let t9;
    if ($[20] !== CTAAnalyticsAttributes || $[21] !== source) {
        t9 = (actionSubjectId)=>({
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: CTAAnalyticsAttributes
            });
        $[20] = CTAAnalyticsAttributes;
        $[21] = source;
        $[22] = t9;
    } else t9 = $[22];
    const generateCTAAnalyticsProps = t9;
    let t10;
    if ($[23] !== CTAAnalyticsAttributes || $[24] !== createAnalyticsEvent || $[25] !== source) {
        t10 = (clickEventActionSubjectId, linkMessage)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: clickEventActionSubjectId,
                    source: source,
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        linkMessage: linkMessage
                    }
                }
            }).fire();
        };
        $[23] = CTAAnalyticsAttributes;
        $[24] = createAnalyticsEvent;
        $[25] = source;
        $[26] = t10;
    } else t10 = $[26];
    const triggerLinkClickAnalytics = t10;
    let t11;
    if ($[27] !== secondaryLink || $[28] !== triggerLinkClickAnalytics) {
        t11 = ()=>{
            const link = secondaryLink;
            if (link) {
                triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
                if (typeof link.onClick === "function") link.onClick();
            }
        };
        $[27] = secondaryLink;
        $[28] = triggerLinkClickAnalytics;
        $[29] = t11;
    } else t11 = $[29];
    const handleSecondaryLinkClick = t11;
    let t12;
    let t13;
    if ($[30] !== CTAAnalyticsAttributes || $[31] !== createAnalyticsEvent || $[32] !== source) {
        t12 = ()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "changeEditionGatewayScreen",
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        source: source
                    }
                }
            }).fire();
        };
        t13 = [
            createAnalyticsEvent,
            CTAAnalyticsAttributes,
            source
        ];
        $[30] = CTAAnalyticsAttributes;
        $[31] = createAnalyticsEvent;
        $[32] = source;
        $[33] = t12;
        $[34] = t13;
    } else {
        t12 = $[33];
        t13 = $[34];
    }
    (0, $cozmU.useEffect)(t12, t13);
    let T0;
    let t14;
    if ($[35] !== buttonConfig || $[36] !== canShowUpgradeButton || $[37] !== generateCTAAnalyticsProps || $[38] !== handleSecondaryLinkClick || $[39] !== isLoadingRequestUpgradeButton || $[40] !== isSiteAdmin || $[41] !== learnMoreLink || $[42] !== onRequestUpgradeButtonClick || $[43] !== onUpFlowOpen || $[44] !== props || $[45] !== requestUpgradeButtonIsLoading || $[46] !== secondaryLink || $[47] !== showRequestUpgradeButton || $[48] !== source || $[49] !== targetEdition || $[50] !== upgradeEditionActionSubjectId) {
        const renderButtons = ()=>{
            if (isLoadingRequestUpgradeButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "loading-end-user-request-upgrade-button-skeleton",
                width: "200px",
                height: "32px"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
                isSiteAdmin: isSiteAdmin,
                canShowUpgradeButton: canShowUpgradeButton,
                shouldShowLearnMore: !secondaryLink,
                showRequestUpgradeButton: showRequestUpgradeButton
            }, (t15)=>{
                const { showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA } = t15;
                let primary;
                const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ki6F7.UpgradeEditionButton), {
                    analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                    onUpFlowOpen: onUpFlowOpen,
                    targetEdition: targetEdition,
                    ...props
                }) : null;
                if (upgradeEditionButton) primary = upgradeEditionButton;
                else if (showRequestUpgradeButton) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5u7Ox.EndUserRequestUpgradeButton), {
                    source: source,
                    onRequestUpgradeButtonClick: onRequestUpgradeButtonClick,
                    requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading
                });
                let secondaries;
                if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                    if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(upgradeEditionButton, {
                            appearance: "link"
                        })
                    ];
                    else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, primary, secondaries);
            });
        };
        const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
            const withIcon = Boolean(learnMoreLink?.icon);
            const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || "default" : "link";
            const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
                appearance: learnMoreAppearance
            }) : null;
            const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                key: "secondLink",
                appearance: secondaryLink.appearance || "default",
                href: secondaryLink.href ? secondaryLink.href : undefined,
                id: "secondaryLink",
                spacing: "default",
                target: secondaryLink.target || "_blank",
                onClick: handleSecondaryLinkClick,
                testId: (0, $k4Vdy.calculateTestId)({
                    source: source,
                    actionSubjectId: secondaryLink.actionSubjectId
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryLink.messageDescriptor)) : null;
            return secondaryLink?.appearance === "primary" && learnMoreAppearance !== "primary" ? [
                secondaryLinkComponent,
                learnMoreButton
            ] : [
                learnMoreButton,
                secondaryLinkComponent
            ];
        };
        const renderLearnMoreLink = (t16)=>{
            const { children: children, ...learnMoreProps } = t16;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ9aA.LearnMoreButton), {
                key: "learnMore",
                analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || "freeLearnMore"),
                appearance: learnMoreLink?.appearance || "default",
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                inProductHelpId: learnMoreLink?.inProductHelpId,
                inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
                href: learnMoreLink?.href,
                icon: learnMoreLink?.icon,
                ariaLabel: learnMoreLink?.ariaLabel,
                ...learnMoreProps,
                onClick: learnMoreLink?.onClick
            }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), learnMoreLink.messageDescriptor) : undefined);
        };
        T0 = (0, $bhvFb.EditionSectionMessage);
        t14 = buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, renderButtons()) : undefined;
        $[35] = buttonConfig;
        $[36] = canShowUpgradeButton;
        $[37] = generateCTAAnalyticsProps;
        $[38] = handleSecondaryLinkClick;
        $[39] = isLoadingRequestUpgradeButton;
        $[40] = isSiteAdmin;
        $[41] = learnMoreLink;
        $[42] = onRequestUpgradeButtonClick;
        $[43] = onUpFlowOpen;
        $[44] = props;
        $[45] = requestUpgradeButtonIsLoading;
        $[46] = secondaryLink;
        $[47] = showRequestUpgradeButton;
        $[48] = source;
        $[49] = targetEdition;
        $[50] = upgradeEditionActionSubjectId;
        $[51] = T0;
        $[52] = t14;
    } else {
        T0 = $[51];
        t14 = $[52];
    }
    let t15;
    if ($[53] !== footer || $[54] !== isSiteAdmin) {
        t15 = isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, footer) : null;
        $[53] = footer;
        $[54] = isSiteAdmin;
        $[55] = t15;
    } else t15 = $[55];
    let t16;
    if ($[56] !== headerButton) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, headerButton);
        $[56] = headerButton;
        $[57] = t16;
    } else t16 = $[57];
    let t17;
    if ($[58] !== T0 || $[59] !== props || $[60] !== t14 || $[61] !== t15 || $[62] !== t16 || $[63] !== targetEdition) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            actions: t14,
            edition: targetEdition,
            footer: t15,
            headerButton: t16,
            ...props
        });
        $[58] = T0;
        $[59] = props;
        $[60] = t14;
        $[61] = t15;
        $[62] = t16;
        $[63] = targetEdition;
        $[64] = t17;
    } else t17 = $[64];
    return t17;
} : ({ canShowUpgradeButton: canShowUpgradeButton = true, buttonConfig: buttonConfig = "default", upgradeEditionActionSubjectId: upgradeEditionActionSubjectId = 'freeTryNow', grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: showRequestUpgradeButton = false, isLoadingRequestUpgradeButton: isLoadingRequestUpgradeButton = false, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick, requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading = false, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const CTAAnalyticsAttributes = (0, $cozmU.useMemo)(()=>{
        return {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: Boolean(grandfathered)
        };
    }, [
        grandfathered,
        isSiteAdmin
    ]);
    const generateCTAAnalyticsProps = (actionSubjectId)=>({
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: CTAAnalyticsAttributes
        });
    const triggerLinkClickAnalytics = (clickEventActionSubjectId, linkMessage)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: clickEventActionSubjectId,
                source: source,
                attributes: {
                    ...CTAAnalyticsAttributes,
                    linkMessage: linkMessage
                }
            }
        }).fire();
    };
    const handleSecondaryLinkClick = ()=>{
        const link = secondaryLink;
        if (link) {
            triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
            if (typeof link.onClick === 'function') link.onClick();
        }
    };
    (0, $cozmU.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'changeEditionGatewayScreen',
                attributes: {
                    ...CTAAnalyticsAttributes,
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        CTAAnalyticsAttributes,
        source
    ]);
    const renderButtons = ()=>{
        if (isLoadingRequestUpgradeButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "loading-end-user-request-upgrade-button-skeleton",
            width: "200px",
            height: "32px"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
            isSiteAdmin: isSiteAdmin,
            canShowUpgradeButton: canShowUpgradeButton,
            shouldShowLearnMore: !secondaryLink,
            showRequestUpgradeButton: showRequestUpgradeButton
        }, ({ showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA })=>{
            //
            // primary
            //
            let primary;
            const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ki6F7.UpgradeEditionButton), {
                analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                ...props
            }) : null;
            if (upgradeEditionButton) primary = upgradeEditionButton;
            else if (showRequestUpgradeButton) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5u7Ox.EndUserRequestUpgradeButton), {
                source: source,
                onRequestUpgradeButtonClick: onRequestUpgradeButtonClick,
                requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading
            });
            //
            // secondaries
            //
            let secondaries;
            if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                // If the 'Try it free/now' button is to be shown, but it is not the
                // primary CTA, then make sure its appearance is appropriate for a
                // secondary:
                if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(upgradeEditionButton, {
                        appearance: 'link'
                    })
                ];
                else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, primary, secondaries);
        });
    };
    const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
        const withIcon = Boolean(learnMoreLink?.icon);
        const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || 'default' : 'link';
        const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
            appearance: learnMoreAppearance
        }) : null;
        const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            key: "secondLink",
            appearance: secondaryLink.appearance || 'default',
            href: secondaryLink.href ? secondaryLink.href : undefined,
            id: "secondaryLink",
            spacing: "default",
            target: secondaryLink.target || '_blank',
            onClick: handleSecondaryLinkClick,
            testId: (0, $k4Vdy.calculateTestId)({
                source: source,
                actionSubjectId: secondaryLink.actionSubjectId
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryLink.messageDescriptor)) : null;
        return secondaryLink?.appearance === 'primary' && learnMoreAppearance !== 'primary' ? [
            secondaryLinkComponent,
            learnMoreButton
        ] : [
            learnMoreButton,
            secondaryLinkComponent
        ];
    };
    const renderLearnMoreLink = ({ children: children, ...learnMoreProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ9aA.LearnMoreButton), {
            key: "learnMore",
            analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || 'freeLearnMore'),
            appearance: learnMoreLink?.appearance || 'default',
            onUpFlowOpen: onUpFlowOpen,
            targetEdition: targetEdition,
            inProductHelpId: learnMoreLink?.inProductHelpId,
            inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
            href: learnMoreLink?.href,
            icon: learnMoreLink?.icon,
            ariaLabel: learnMoreLink?.ariaLabel,
            ...learnMoreProps,
            onClick: learnMoreLink?.onClick
        }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), learnMoreLink.messageDescriptor) : undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bhvFb.EditionSectionMessage), {
        actions: buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, renderButtons()) : undefined,
        edition: targetEdition,
        footer: isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, footer) : null,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, headerButton),
        ...props
    });
};
module.exports["SectionMessageButtonConfig"] = $3a454656eb0e87cd$export$d33a80488b9cab17;
module.exports["ChangeEditionSectionMessage"] = $3a454656eb0e87cd$export$2e68cfab3dc25476;

});

parcelRegister("iJ9aA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jd2pZ = parcelRequire("jd2pZ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2KmnS = parcelRequire("2KmnS");


var $bQm3c = parcelRequire("bQm3c");


var $f7tt0 = parcelRequire("f7tt0");


var $gsZdA = parcelRequire("gsZdA");


var $f7Bnv = parcelRequire("f7Bnv");


var $iC1wS = parcelRequire("iC1wS");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $k4Vdy = parcelRequire("k4Vdy");

const $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding = (0, $buxP3.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    margin: 'auto'
});
const $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding = (0, $buxP3.xcss)({
    padding: 'space.0'
});
const $c00269aedb3a5e7e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    tryItFree: {
        id: "change-edition.section.message.try.free",
        defaultMessage: "Try it free"
    },
    learnMoreButton: {
        id: "change-edition.section.message.general.button.link",
        defaultMessage: "Learn more"
    }
});
const $c00269aedb3a5e7e$export$628b38b203828231 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    let { analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: t1, isGrandfathered: t2, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps } = t0;
    const targetEdition = t1 === undefined ? (0, $euL71.ConfluenceEdition).STANDARD : t1;
    const isGrandfathered = t2 === undefined ? false : t2;
    const intl = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    let t3;
    if ($[0] !== children) {
        t3 = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
        $[0] = children;
        $[1] = t3;
    } else t3 = $[1];
    const message = t3;
    const iconOnly = icon && !message;
    let t4;
    let t5;
    if ($[2] !== experienceTracker || $[3] !== showUpFlow) {
        t4 = ()=>()=>{
                if (!showUpFlow) experienceTracker.abort({
                    name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                    reason: "Canceled by user"
                });
            };
        t5 = [
            experienceTracker,
            showUpFlow
        ];
        $[2] = experienceTracker;
        $[3] = showUpFlow;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[6] !== actionSubjectId || $[7] !== analyticsProps || $[8] !== createAnalyticsEvent || $[9] !== edition || $[10] !== experienceTracker || $[11] !== isSiteAdmin || $[12] !== showUpFlow || $[13] !== source || $[14] !== targetEdition) {
        t6 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "freeLearnMore",
                    ...analyticsProps,
                    attributes: {
                        currentEdition: edition,
                        isSiteAdmin: isSiteAdmin,
                        linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                        targetEdition: targetEdition,
                        ...analyticsProps.attributes
                    }
                }
            }).fire();
            experienceTracker.start({
                name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: edition,
                    linkClicked: actionSubjectId || "freeLearnMore",
                    source: source,
                    targetEdition: targetEdition
                }
            });
        };
        $[6] = actionSubjectId;
        $[7] = analyticsProps;
        $[8] = createAnalyticsEvent;
        $[9] = edition;
        $[10] = experienceTracker;
        $[11] = isSiteAdmin;
        $[12] = showUpFlow;
        $[13] = source;
        $[14] = targetEdition;
        $[15] = t6;
    } else t6 = $[15];
    const fireClickAnalytics = t6;
    let t7;
    if ($[16] !== onUpFlowOpen) {
        t7 = ()=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jd2pZ)))(onUpFlowOpen)) setIsUpFlowOpen(false);
        };
        $[16] = onUpFlowOpen;
        $[17] = t7;
    } else t7 = $[17];
    const onUpFlowClose = t7;
    const renderLearnMoreButton = (t8)=>{
        const props = t8 === undefined ? {} : t8;
        if (appearance === "inline-link") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", props, message);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: appearance,
            className: appearance === "subtle-link" ? undefined : "primaryButton",
            id: "learnMoreLink",
            spacing: iconOnly ? "none" : "default",
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    let t9;
    if ($[18] !== createAnalyticsEvent || $[19] !== inProductHelpId) {
        t9 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "helpLink",
                    source: "adminKeyUpSell",
                    attributes: {
                        targetArticleId: inProductHelpId,
                        isSPA: true
                    }
                }
            }).fire();
        };
        $[18] = createAnalyticsEvent;
        $[19] = inProductHelpId;
        $[20] = t9;
    } else t9 = $[20];
    const fireAnalyticsEvent = t9;
    if (isGrandfathered && !isSiteAdmin) return null;
    if (!href) href = showUpFlow ? "#" : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith("#") ? undefined : "_blank";
    let t10;
    if ($[21] !== fireClickAnalytics || $[22] !== onClick || $[23] !== showUpFlow || $[24] !== target) {
        t10 = (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        };
        $[21] = fireClickAnalytics;
        $[22] = onClick;
        $[23] = showUpFlow;
        $[24] = target;
        $[25] = t10;
    } else t10 = $[25];
    const buttonProps = {
        target: target,
        href: href,
        onClick: t10,
        "aria-label": ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    const t11 = !showUpFlow && inProductHelpId && inProductHelpTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps);
    let t12;
    if ($[26] !== cloudId || $[27] !== edition || $[28] !== isSiteAdmin || $[29] !== isUpFlowOpen || $[30] !== onUpFlowClose || $[31] !== onUpFlowOpen || $[32] !== showUpFlow || $[33] !== source || $[34] !== targetEdition || $[35] !== userId) {
        t12 = showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            cloudId: cloudId,
            atlassianAccountId: userId || undefined,
            canChangeEdition: isSiteAdmin,
            currentEdition: edition || undefined,
            targetEdition: targetEdition,
            flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
            product: "confluence",
            touchpointId: source,
            onClose: onUpFlowClose,
            onOpen: onUpFlowOpen,
            isExperienceTrackerEnabled: true,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
        $[26] = cloudId;
        $[27] = edition;
        $[28] = isSiteAdmin;
        $[29] = isUpFlowOpen;
        $[30] = onUpFlowClose;
        $[31] = onUpFlowOpen;
        $[32] = showUpFlow;
        $[33] = source;
        $[34] = targetEdition;
        $[35] = userId;
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== t11 || $[38] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t11, t12);
        $[37] = t11;
        $[38] = t12;
        $[39] = t13;
    } else t13 = $[39];
    return t13;
} : ({ analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, isGrandfathered: isGrandfathered = false, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    const message = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
    const iconOnly = icon && !message;
    (0, $cozmU.useEffect)(()=>()=>{
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                ...analyticsProps,
                attributes: {
                    currentEdition: edition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                    targetEdition: targetEdition,
                    ...analyticsProps.attributes
                }
            }
        }).fire();
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: edition,
                linkClicked: actionSubjectId || 'freeLearnMore',
                source: source,
                targetEdition: targetEdition
            }
        });
    };
    const onUpFlowClose = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jd2pZ)))(onUpFlowOpen)) // only attempt to close if there is no onUpFlowOpen handler (as
        // UpFlowComponent will invoke it to unmount our parent already)
        setIsUpFlowOpen(false);
    };
    const renderLearnMoreButton = (props = {})=>{
        if (appearance === 'inline-link') return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", props, message));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: appearance,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: appearance === 'subtle-link' ? undefined : 'primaryButton',
            id: "learnMoreLink",
            spacing: iconOnly ? 'none' : 'default',
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    const fireAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'helpLink',
                source: 'adminKeyUpSell',
                attributes: {
                    targetArticleId: inProductHelpId,
                    isSPA: true
                }
            }
        }).fire();
    };
    if (isGrandfathered && !isSiteAdmin) return null;
    // prioritizing href if it passed by the consumer regardless of edition type
    if (!href) href = showUpFlow ? '#' : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith('#') ? undefined : '_blank';
    const buttonProps = {
        target: target,
        href: href,
        onClick: (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        },
        'aria-label': ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !showUpFlow && inProductHelpId && inProductHelpTopic ? /**
     * Special handling In Product Help Button
     * InProductHelpButton force the spacing to none, thus creating a BOX here to add back the padding and margin
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps), showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        cloudId: cloudId,
        atlassianAccountId: userId || undefined,
        canChangeEdition: isSiteAdmin,
        currentEdition: edition || undefined,
        targetEdition: targetEdition,
        flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
        product: "confluence",
        touchpointId: source,
        onClose: onUpFlowClose,
        onOpen: onUpFlowOpen,
        isExperienceTrackerEnabled: true,
        epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
    }));
};
const $c00269aedb3a5e7e$export$176492db868efc7f = (0, $f7Bnv.withIsSiteAdmin)($c00269aedb3a5e7e$export$628b38b203828231);
module.exports["i18n"] = $c00269aedb3a5e7e$export$a7357cdd1f0b0168;
module.exports["LearnMoreButtonComponent"] = $c00269aedb3a5e7e$export$628b38b203828231;
module.exports["LearnMoreButton"] = $c00269aedb3a5e7e$export$176492db868efc7f;

});

parcelRegister("2KmnS", function(module, exports) {
var $af6754ea8048b03c$export$a719c036dcaa8cea = /*#__PURE__*/ function(UpFlowComponentFlowType) {
    UpFlowComponentFlowType["LEARN_MORE"] = "learn-more";
    UpFlowComponentFlowType["UPGRADE"] = "upgrade";
    UpFlowComponentFlowType["REQUEST_UPGRADE"] = "request-upgrade";
    UpFlowComponentFlowType["REQUEST_LEARN_MORE"] = "request-learn-more";
    return UpFlowComponentFlowType;
}({});
module.exports["UpFlowComponentFlowType"] = $af6754ea8048b03c$export$a719c036dcaa8cea;

});

parcelRegister("f7tt0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0dfdd35e9850cea$export$b14685a9b52779e1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xD_n9",
    name: "InProductHelpButton",
    loader: async ()=>(await (parcelRequire("a77yF"))).InProductHelpButton
});
module.exports["InProductHelpButton"] = $d0dfdd35e9850cea$export$b14685a9b52779e1;

});

parcelRegister("a77yF", function(module, exports) {

let $75d06bbbb7d49c89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $75d06bbbb7d49c89$var$load("idSqX"),
    $75d06bbbb7d49c89$var$load("82QsP")
]).then(()=>parcelRequire('lcEzf'));

});

parcelRegister("gsZdA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $f57489e4f8cda39e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';
var $f57489e4f8cda39e$export$fd53124e1292f3e0 = /*#__PURE__*/ function(SECTION_MESSAGE_APPEARANCE_TYPES) {
    SECTION_MESSAGE_APPEARANCE_TYPES["DEFAULT"] = "default";
    SECTION_MESSAGE_APPEARANCE_TYPES["FLAT"] = "flat";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE"] = "inline";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE_MODAL"] = "inline-modal";
    return SECTION_MESSAGE_APPEARANCE_TYPES;
}({});
const $f57489e4f8cda39e$export$9d01cd0779f8a694 = 'confluence-up-flow-modal';
module.exports["LEARN_MORE_LINK"] = $f57489e4f8cda39e$export$997e23a0aec74966;
module.exports["SECTION_MESSAGE_APPEARANCE_TYPES"] = $f57489e4f8cda39e$export$fd53124e1292f3e0;
module.exports["UP_FLOW_EP_MESSAGE_ID"] = $f57489e4f8cda39e$export$9d01cd0779f8a694;

});

parcelRegister("iC1wS", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $8ea1c6a3abbe8170$var$EditionsAnalyticsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $8ea1c6a3abbe8170$export$198c73506737f848 = (payload, data)=>({
        ...payload,
        data: {
            ...payload.data,
            attributes: {
                ...payload.data.attributes,
                ...data?.customAttributes
            }
        }
    });
const $8ea1c6a3abbe8170$export$ce3e4b18be9c194b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const internalData = (0, $cozmU.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== internalData) {
        t0 = (data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData);
        $[0] = internalData;
        $[1] = t0;
    } else t0 = $[1];
    const wrapAnalyticsEventPayload = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== wrapAnalyticsEventPayload) {
        t1 = (initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload));
        $[2] = createAnalyticsEvent;
        $[3] = wrapAnalyticsEventPayload;
        $[4] = t1;
    } else t1 = $[4];
    const wrappedCreateAnalyticsEvent = t1;
    let t2;
    if ($[5] !== wrapAnalyticsEventPayload || $[6] !== wrappedCreateAnalyticsEvent) {
        t2 = {
            createAnalyticsEvent: wrappedCreateAnalyticsEvent,
            wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
        };
        $[5] = wrapAnalyticsEventPayload;
        $[6] = wrappedCreateAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const internalData = (0, $cozmU.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $cozmU.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $cozmU.useCallback)((initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload)), [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$var$emptyAttributes = {};
const $8ea1c6a3abbe8170$export$1b581a2ec13e37f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, customAttributes: t1 } = t0;
    const customAttributes = t1 === undefined ? $8ea1c6a3abbe8170$var$emptyAttributes : t1;
    let t2;
    if ($[0] !== customAttributes) {
        t2 = {
            customAttributes: customAttributes
        };
        $[0] = customAttributes;
        $[1] = t2;
    } else t2 = $[1];
    const editionsAnalyticsContextValue = t2;
    let t3;
    if ($[2] !== children || $[3] !== editionsAnalyticsContextValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
            value: editionsAnalyticsContextValue
        }, children);
        $[2] = children;
        $[3] = editionsAnalyticsContextValue;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, customAttributes: customAttributes = $8ea1c6a3abbe8170$var$emptyAttributes })=>{
    const editionsAnalyticsContextValue = (0, $cozmU.useMemo)(()=>({
            customAttributes: customAttributes
        }), [
        customAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
        value: editionsAnalyticsContextValue
    }, children);
};
const $8ea1c6a3abbe8170$export$19bbfac2f7120ab5 = (Component)=>{
    const WrappedComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        let t0;
        if ($[0] !== context || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                ...props,
                ...context
            });
            $[0] = context;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...props,
            ...context
        });
    };
    return WrappedComponent;
};
module.exports["useEditionsAnalyticsContext"] = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b;
module.exports["AnalyticsProvider"] = $8ea1c6a3abbe8170$export$1b581a2ec13e37f1;

});

parcelRegister("k4Vdy", function(module, exports) {

var $gfV78 = parcelRequire("gfV78");

const $b05bae0ef566e919$export$b1556774836001f5 = ({ actionSubjectId: actionSubjectId, source: source })=>actionSubjectId !== undefined ? `${source}${(0, (/*@__PURE__*/$parcel$interopDefault($gfV78)))(actionSubjectId)}` : undefined;
module.exports["calculateTestId"] = $b05bae0ef566e919$export$b1556774836001f5;

});

parcelRegister("lNKOh", function(module, exports) {
const $5ea77288491beecf$export$2321d4fb07b49d13 = ({ canShowUpgradeButton: canShowUpgradeButton, children: children, isSiteAdmin: isSiteAdmin, shouldShowLearnMore: shouldShowLearnMore = true, showRequestUpgradeButton: showRequestUpgradeButton })=>{
    let showUpgradeTryNowButton = false;
    let showLearnMore = true;
    let learnMoreIsPrimaryCTA = true;
    if (canShowUpgradeButton) {
        if (isSiteAdmin) showUpgradeTryNowButton = true;
        if (showUpgradeTryNowButton) {
            // NOTE: Don't show 'Learn More' CTA if it will appear in between the
            // Upgrade Edition button and a secondary feature link (like
            // "Remove this page's restrictions" button). In those cases, "Learn
            // More" CTA will be displayed at the end of the general text content,
            // outside of this component.
            showLearnMore = shouldShowLearnMore;
            learnMoreIsPrimaryCTA = false;
        }
    }
    if (showRequestUpgradeButton) // If an end user request upgrade button is present,
    // we don't show the learn more link if it's not specifically provided.
    showLearnMore = shouldShowLearnMore;
    return children({
        showUpgradeTryNowButton: showUpgradeTryNowButton,
        showLearnMore: showLearnMore,
        learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA
    });
};
module.exports["ChangeEditionSectionMessageButtonsWrapper"] = $5ea77288491beecf$export$2321d4fb07b49d13;

});

parcelRegister("5u7Ox", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $aRGok = parcelRequire("aRGok");


var $9DHhW = parcelRequire("9DHhW");


var $4PPzL = parcelRequire("4PPzL");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $TCbX7 = parcelRequire("TCbX7");


var $bZmiL = parcelRequire("bZmiL");

const $125b05aca1e71376$export$ccc7e3a47fa3a9b0 = ({ source: source, requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading = false, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const hasSentViewedEvent = (0, $cozmU.useRef)(false);
    const [showModal, setShowModal] = (0, $cozmU.useState)(false);
    const [isLoadingModal, setIsLoadingModal] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleCloseModal = ()=>{
        setShowModal(false);
    };
    const handleOpenModal = ()=>{
        if (onRequestUpgradeButtonClick) // If onRequestUpgradeButtonClick is provided, call it let it handle the modal opening
        onRequestUpgradeButtonClick();
        else {
            setIsLoadingModal(true);
            setShowModal(true);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source,
                attributes: {
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
    };
    (0, $cozmU.useEffect)(()=>{
        if (hasSentViewedEvent.current) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source,
                attributes: {
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
        hasSentViewedEvent.current = true;
    }, [
        createAnalyticsEvent,
        edition,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: edition === (0, $d9tcB.ConfluenceEdition).STANDARD ? 'growth-luna' : 'growth-transmuters'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "experiment-confluence-enable-end-user-request.request-upgrade-button",
        onClick: handleOpenModal,
        appearance: "primary",
        isLoading: isLoadingModal || requestUpgradeButtonIsLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "experiment-confluence-enable-end-user-request.request-upgrade-button.label",
        defaultMessage: "Request to try"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $TCbX7.EndUserRequestUpgradeModalEntrypoint), {
        source: source,
        handleCloseModal: handleCloseModal,
        setIsLoadingModal: setIsLoadingModal
    })));
};
module.exports["EndUserRequestUpgradeButton"] = $125b05aca1e71376$export$ccc7e3a47fa3a9b0;

});

parcelRegister("TCbX7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2d60c82434c5c2c8$export$8512e09daabbe9d7 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i-AMj",
    name: "EndUserRequestUpgradeModalEntrypoint",
    loader: async ()=>(await (parcelRequire("jiFss"))).EndUserRequestUpgradeModal
});
module.exports["EndUserRequestUpgradeModalEntrypoint"] = $2d60c82434c5c2c8$export$8512e09daabbe9d7;

});

parcelRegister("jiFss", function(module, exports) {

let $e0cfdb73cfe6ca74$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e0cfdb73cfe6ca74$var$load("dBHUb"),
    $e0cfdb73cfe6ca74$var$load("5Rx9J"),
    $e0cfdb73cfe6ca74$var$load("6wr18"),
    $e0cfdb73cfe6ca74$var$load("dxcsb"),
    $e0cfdb73cfe6ca74$var$load("99ObF"),
    $e0cfdb73cfe6ca74$var$load("Wowvf"),
    $e0cfdb73cfe6ca74$var$load("ffEVr"),
    $e0cfdb73cfe6ca74$var$load("jZMUd"),
    $e0cfdb73cfe6ca74$var$load("hhss7"),
    $e0cfdb73cfe6ca74$var$load("eRrWU")
]).then(()=>parcelRequire('4YFRT'));

});

parcelRegister("bZmiL", function(module, exports) {

var $7L1H0 = parcelRequire("7L1H0");

const $ac662e4699f149b2$export$a6ecd874f477affc = (edition)=>({
        currentProductEdition: (0, $7L1H0.mapConfluenceEditionToSupportedCurrentEdition)(edition)
    });
module.exports["editionAnalytics"] = $ac662e4699f149b2$export$a6ecd874f477affc;

});

parcelRegister("7L1H0", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $4f5583827653668a$var$supportedCurrentEditionsMap = {
    [(0, $d9tcB.ConfluenceEdition).FREE]: 'free',
    [(0, $d9tcB.ConfluenceEdition).STANDARD]: 'standard'
};
const $4f5583827653668a$var$isSupportedEdition = (edition)=>{
    return edition in $4f5583827653668a$var$supportedCurrentEditionsMap;
};
const $4f5583827653668a$export$b48897de0c2497d9 = (edition)=>{
    if (!edition || !$4f5583827653668a$var$isSupportedEdition(edition)) return undefined;
    return $4f5583827653668a$var$supportedCurrentEditionsMap[edition];
};
module.exports["mapConfluenceEditionToSupportedCurrentEdition"] = $4f5583827653668a$export$b48897de0c2497d9;

});

parcelRegister("dIDyF", function(module, exports) {

var $jO9zg = parcelRequire("jO9zg");

const $c2412d4c16af1f46$export$c43c7444da662fa1 = '1';
const $c2412d4c16af1f46$export$e99efa3985fa3c26 = 'in-product-help';
const $c2412d4c16af1f46$export$23aa6670f346c214 = 368;
const $c2412d4c16af1f46$export$dd8cabd06ab03363 = {
    summary: 'summary',
    wasThisHelpful: 'customfield_10081',
    description: 'description',
    reason: 'customfield_10082',
    title: 'customfield_10083',
    contentId: 'customfield_10084',
    contentLink: 'customfield_10088',
    feedbackContext: 'customfield_10047',
    routeGroup: 'customfield_10085',
    routeName: 'customfield_10086',
    customerName: 'customfield_10045',
    email: 'email',
    contactMe: 'customfield_10043'
};
const $c2412d4c16af1f46$export$597555bbf10f10b8 = {
    yes: {
        id: '10182',
        label: 'yes'
    },
    no: {
        id: '10183',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$cd692d959c11a1e9 = {
    noAccurate: {
        id: '10184',
        label: (0, $jO9zg.notAccurateLabel)
    },
    noClear: {
        id: '10185',
        label: (0, $jO9zg.notClearLabel)
    },
    noRelevant: {
        id: '10186',
        label: (0, $jO9zg.notRelevantLabel)
    }
};
const $c2412d4c16af1f46$export$ee3be114bf2680b4 = {
    yes: {
        id: '10109',
        label: 'yes'
    },
    no: {
        id: '10111',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$31f0ec6fc5b07a82 = 'afae180b-eb61-43c5-bc3f-5f65349a8853';
const $c2412d4c16af1f46$export$d006cfb73688051e = '279';
module.exports["HELP_PANEL_ID"] = $c2412d4c16af1f46$export$e99efa3985fa3c26;
module.exports["HELP_PANEL_WIDTH"] = $c2412d4c16af1f46$export$23aa6670f346c214;
module.exports["FEEDBACK_FIELDS_ID"] = $c2412d4c16af1f46$export$dd8cabd06ab03363;
module.exports["WAS_THIS_HELPFUL_OPTIONS"] = $c2412d4c16af1f46$export$597555bbf10f10b8;
module.exports["FEEDBACK_REASON_OPTIONS"] = $c2412d4c16af1f46$export$cd692d959c11a1e9;
module.exports["CAN_BE_CONTACTED_OPTIONS"] = $c2412d4c16af1f46$export$ee3be114bf2680b4;
module.exports["EMBEDDABLE_KEY"] = $c2412d4c16af1f46$export$31f0ec6fc5b07a82;
module.exports["REQUEST_TYPE_ID"] = $c2412d4c16af1f46$export$d006cfb73688051e;

});

parcelRegister("jO9zg", function(module, exports) {
const $136af91396913aa8$export$653b1475ad2952b = "It wasn\u2019t accurate";
const $136af91396913aa8$export$910eb5168d5e4926 = "It wasn\u2019t clear";
const $136af91396913aa8$export$7e4b37ff0a487bc2 = "It wasn\u2019t relevant";
module.exports["notAccurateLabel"] = $136af91396913aa8$export$653b1475ad2952b;
module.exports["notClearLabel"] = $136af91396913aa8$export$910eb5168d5e4926;
module.exports["notRelevantLabel"] = $136af91396913aa8$export$7e4b37ff0a487bc2;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("7tXrp", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $f4962613d517e76c$var$FREE_TOUCHPOINTS = {
    pageInsights: {
        requestedEdition: 'standard',
        requestedFeature: 'pageInsights'
    },
    archiveUpsellDialog: {
        requestedEdition: 'standard',
        requestedFeature: 'archive'
    },
    generalAccessLevelSelector: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    shareAndRestrictDialogUpsell: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    quickSummaryUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'rovo'
    },
    teamCalendarUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'calendars'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
const $f4962613d517e76c$var$STANDARD_TOUCHPOINTS = {
    viewSpacePerms: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    },
    contentManagerUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'contentManager'
    },
    adminCenter: {
        requestedEdition: 'premium',
        requestedFeature: 'adminCenter'
    },
    userAccessUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    shareAndRestrictDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    restrictionsDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    companyHubUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'companyHub'
    },
    premiumCardsInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCardsConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    whiteboardsUpsellCtaScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboardInsert'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-unsetDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-viewOnlyButton': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    createSpaceDrawer: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    }
};
const $f4962613d517e76c$export$354adb22437506d7 = (source, edition)=>{
    switch(edition){
        case (0, $d9tcB.ConfluenceEdition).FREE:
            return $f4962613d517e76c$var$FREE_TOUCHPOINTS[source];
        case (0, $d9tcB.ConfluenceEdition).STANDARD:
            return $f4962613d517e76c$var$STANDARD_TOUCHPOINTS[source];
        default:
            return undefined;
    }
};
module.exports["getEligibleTouchpointForEdition"] = $f4962613d517e76c$export$354adb22437506d7;

});

parcelRegister("cHKtk", function(module, exports) {

var $hG9ZM = parcelRequire("hG9ZM");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $7tXrp = parcelRequire("7tXrp");


var $bZmiL = parcelRequire("bZmiL");

const $0db05c5b00b76da2$export$4af81e07a25a3fcc = (source)=>{
    // TODO: During productionization replace with EligibleTouchpoints type for source
    const { cloudId: cloudId, edition: edition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const eligibleTouchpoint = (0, $7tXrp.getEligibleTouchpointForEdition)(source, edition);
    const offeringName = eligibleTouchpoint?.requestedEdition ?? 'standard';
    const isEnabledStandardEdition = edition === (0, $d9tcB.ConfluenceEdition).STANDARD;
    const { loading: loading, data: data } = (0, $jMyy4.useQueryInterop)((0, $hG9ZM.default), {
        variables: {
            cloudId: cloudId,
            offeringName: offeringName,
            shouldCheckForTrial: isEnabledStandardEdition
        },
        fetchPolicy: 'cache-first',
        skip: !isEnabledStandardEdition || isSiteAdmin || !eligibleTouchpoint,
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/experiment-confluence-enable-end-user-request"
    });
    const { isEligibleForEndUserRequestStandard: isEligibleForEndUserRequestStandard } = (0, $cozmU.useMemo)(()=>{
        const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
        const isInCollection = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION')?.entitlementId;
        const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
        const changeOfferingExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
        const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingExperienceUrl);
        const hasPaymentDetailsEntered = Boolean(entitlement?.transactionAccount?.isBillToPresent);
        const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
        const entitlementId = entitlementInfo?.entitlementId;
        const transactionAccountId = entitlement?.transactionAccount?.key;
        // Additional eligibility checks for Standard
        const trialTimeLeft = entitlement?.subscription?.trial?.timeLeft;
        const isInTrial = Boolean(trialTimeLeft && trialTimeLeft > 0);
        const invoiceableStatus = typeof entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable === 'boolean' ? entitlement.subscription.accountDetails.invoiceGroup.invoiceable ? 'INVOICEABLE' : 'NOT_INVOICEABLE' : 'UNKNOWN';
        const isInPredunning = entitlement?.preDunning?.status === 'IN_PRE_DUNNING' && invoiceableStatus === 'NOT_INVOICEABLE';
        return {
            isEligibleForEndUserRequestStandard: Boolean(!loading && !isInCollection && isEnabledStandardEdition && hasPaymentDetailsEntered && !canUpgrade && Boolean(userId) && Boolean(changeOfferingExperienceUrl) && Boolean(transactionAccountId) && Boolean(entitlementId) && !isInTrial && !isInPredunning)
        };
    }, [
        data,
        loading,
        isEnabledStandardEdition,
        userId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isEligibleForEndUserRequestStandard) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'feature',
                source: 'useEnableEndUserRequestUpgrade',
                attributes: {
                    cohort: (0, $6mKj3.expVal)('twcg-1169_ceurs2p_end_user_requests', 'cohort', 'not-enrolled'),
                    flagKey: 'twcg-1169_ceurs2p_end_user_requests',
                    touchpoint: source,
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
    }, [
        edition,
        isEligibleForEndUserRequestStandard,
        createAnalyticsEvent,
        source
    ]);
    return {
        showRequestUpgradeButton: // Standard Edition
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isEligibleForEndUserRequestStandard && (0, $6mKj3.expValEquals)('twcg-1169_ceurs2p_end_user_requests', 'cohort', 'variation'),
        loading: loading
    };
};
module.exports["useEnableEndUserRequestUpgrade"] = $0db05c5b00b76da2$export$4af81e07a25a3fcc;

});

parcelRegister("hG9ZM", function(module, exports) {
/**
 * @generated SignedSource<<7540d078609821cbd0d1d47464bf1494>>
 * @relayHash 95c17f8ab13d7575aa221eba1b6971a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e810472e5bef79ddd590fcbef7d716cc8bfbcf5a0d5843c4293d62692950c1c2
const $a3d3dc9056ba2c7e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offeringName"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldCheckForTrial"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "offeringName"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v11 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "status"
    }, v13 = {
        "kind": "ScalarField",
        "name": "timeLeft"
    }, v14 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v15 = [
        v4 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldCheckForTrial",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "trial",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v15 /*: any*/ ,
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldCheckForTrial",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "trial",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v15 /*: any*/ ,
                                                                            "type": "CcpInvoiceGroup"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v15 /*: any*/ ,
                                                            "type": "CcpSubscription"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "95c17f8ab13d7575aa221eba1b6971a5",
            "id": "e810472e5bef79ddd590fcbef7d716cc8bfbcf5a0d5843c4293d62692950c1c2",
            "metadata": {},
            "name": "useEnableEndUserRequestUpgradeQuery",
            "operationKind": "query",
            "text": "query useEnableEndUserRequestUpgradeQuery($cloudId:ID!,$offeringName:String!,$shouldCheckForTrial:Boolean!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlementId,entitlement{id,__typename,experienceCapabilities{__typename,changeOfferingV2(offeringName:$offeringName){__typename,isAvailableToUser,experienceUrl}},transactionAccount{__typename,key,isBillToPresent,...on Node{__isNode:__typename,id}},relatesFromEntitlements{__typename,entitlementId,relationshipType},preDunning@include(if:$shouldCheckForTrial){__typename,status}\n        subscription@include(if:$shouldCheckForTrial){__typename,trial{__typename,timeLeft},accountDetails{__typename,invoiceGroup{__typename,invoiceable,...on CcpInvoiceGroup{id}}},...on CcpSubscription{id}}}}}}"
        }
    };
}();
$a3d3dc9056ba2c7e$var$node.hash = "ab7d869d4ea7e269d66f1403bf66098f";
var $a3d3dc9056ba2c7e$export$2e2bcd8739ae039 = $a3d3dc9056ba2c7e$var$node;
module.exports["default"] = $a3d3dc9056ba2c7e$export$2e2bcd8739ae039;

});

parcelRegister("bNHBU", function(module, exports) {

var $lFjE5 = parcelRequire("lFjE5");


var $923lQ = parcelRequire("923lQ");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $8976196cdeddb1dc$var$baseEach = $923lQ($lFjE5);
module.exports = $8976196cdeddb1dc$var$baseEach;

});

parcelRegister("lFjE5", function(module, exports) {

var $comu1 = parcelRequire("comu1");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $fc5caa85fb423e25$var$baseForOwn(object, iteratee) {
    return object && $comu1(object, iteratee, $f14Rr);
}
module.exports = $fc5caa85fb423e25$var$baseForOwn;

});

parcelRegister("923lQ", function(module, exports) {

var $9pMwd = parcelRequire("9pMwd");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6936e67b6e4d0605$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$9pMwd(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $6936e67b6e4d0605$var$createBaseEach;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("fqCbQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $cozmU.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $cozmU.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("iXGsw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $cozmU.useRef)(null);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $cozmU.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $cozmU.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("1HeZJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fVsXG = parcelRequire("fVsXG");

const $1ac5d6c80bc49835$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $cozmU.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$1ac5d6c80bc49835$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $fVsXG.resolveService)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $1ac5d6c80bc49835$var$DIFFERENT = false;
const $1ac5d6c80bc49835$var$EQUAL = true;
const $1ac5d6c80bc49835$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $1ac5d6c80bc49835$var$EQUAL;
    if (!prevObject || !nextObject) return $1ac5d6c80bc49835$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $1ac5d6c80bc49835$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $1ac5d6c80bc49835$var$DIFFERENT;
        }
        return $1ac5d6c80bc49835$var$EQUAL;
    }
};
module.exports["useService"] = $1ac5d6c80bc49835$export$6de4685a6c88b4e9;

});

parcelRegister("fVsXG", function(module, exports) {

var $2LYjf = parcelRequire("2LYjf");

function $65b2e4c93b6838a7$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $2LYjf.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $65b2e4c93b6838a7$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $65b2e4c93b6838a7$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $65b2e4c93b6838a7$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }
module.exports["resolveService"] = $65b2e4c93b6838a7$export$388f24d19a29b0a2;

});

parcelRegister("2LYjf", function(module, exports) {
const $7ff17f6787cd1620$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $7ff17f6787cd1620$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $7ff17f6787cd1620$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};
module.exports["isServiceWithDeps"] = $7ff17f6787cd1620$export$4094c5185600bd73;
module.exports["unimplementedAbstractService"] = $7ff17f6787cd1620$export$6e9f7b680f09bab1;
module.exports["toError"] = $7ff17f6787cd1620$export$cc3b967c039ed3e7;

});

parcelRegister("kMx7n", function(module, exports) {
/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 
var $2LYjf = parcelRequire("2LYjf");

const $d1fa119fb73e6e08$export$c7904a8284e43beb = (url)=>`/gateway/api${url}`;
const $d1fa119fb73e6e08$export$ddb1688281a3443e = (0, $2LYjf.unimplementedAbstractService)('getCurrentCloudId');
const $d1fa119fb73e6e08$export$7a2d3e6a9f4c0016 = (0, $2LYjf.unimplementedAbstractService)('getCurrentOrgId');
const $d1fa119fb73e6e08$export$5ebc6cb2748e1881 = (0, $2LYjf.unimplementedAbstractService)('getCurrentUserId');
const $d1fa119fb73e6e08$export$d01408ed6f850a64 = (0, $2LYjf.unimplementedAbstractService)('getCurrentProduct');
const $d1fa119fb73e6e08$export$a48841c0475a8073 = (0, $2LYjf.unimplementedAbstractService)('createAnalyticsEvent');
const $d1fa119fb73e6e08$export$a27c21aa3ed8f0f1 = (0, $2LYjf.unimplementedAbstractService)('fireErrorAnalytics');
class $d1fa119fb73e6e08$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) {
            super(responseJson.message);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        } else {
            super(`Received error response during action ${action}: ${response.statusText}`);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        }
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
const $d1fa119fb73e6e08$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: $d1fa119fb73e6e08$var$getErrorStatus(err)
    });
const $d1fa119fb73e6e08$var$getErrorStatus = (error)=>{
    if (!error) return undefined;
    const e = error;
    return e.statusCode ?? e.status ?? e.responseCode ?? e.response?.status;
};
const $d1fa119fb73e6e08$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $d1fa119fb73e6e08$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $d1fa119fb73e6e08$export$1f2663aaa83f036d = 'Failed to fetch';
const $d1fa119fb73e6e08$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $d1fa119fb73e6e08$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $d1fa119fb73e6e08$export$6827a0909c1bf12f = [
    $d1fa119fb73e6e08$export$1f2663aaa83f036d,
    $d1fa119fb73e6e08$export$65e55894e6e38a89,
    $d1fa119fb73e6e08$export$f25400ad927aa79c
];
const $d1fa119fb73e6e08$export$e1b6bb1617649e83 = (errorMessage)=>$d1fa119fb73e6e08$export$6827a0909c1bf12f.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $d1fa119fb73e6e08$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $d1fa119fb73e6e08$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $d1fa119fb73e6e08$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $d1fa119fb73e6e08$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $d1fa119fb73e6e08$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $d1fa119fb73e6e08$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $d1fa119fb73e6e08$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $d1fa119fb73e6e08$export$e089e1d2018847da = 'Default group for the requested resource not found.';
const $d1fa119fb73e6e08$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (_ignoredError) {
        return false;
    }
};
const $d1fa119fb73e6e08$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === $d1fa119fb73e6e08$export$80a3c1a1eb6f063 || errorMessage === $d1fa119fb73e6e08$export$e089e1d2018847da;
const $d1fa119fb73e6e08$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $d1fa119fb73e6e08$export$678d91a98f79a24d(message, status) || status === 400 && ($d1fa119fb73e6e08$export$cb3290253184cb70(message, $d1fa119fb73e6e08$export$c53f16dd5442ef61) || $d1fa119fb73e6e08$export$cb3290253184cb70(message, $d1fa119fb73e6e08$export$e27975535396141b)) || status === 412 && $d1fa119fb73e6e08$export$395f41a02d6a8be0(key, message);
};
const $d1fa119fb73e6e08$export$9de493bcd9b1d977 = 'bad-request';
const $d1fa119fb73e6e08$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $d1fa119fb73e6e08$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $d1fa119fb73e6e08$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $d1fa119fb73e6e08$export$e5254cb9f7678ab9) return false;
    return true;
};
const $d1fa119fb73e6e08$export$ba588e0ff1c8ed38 = {
    CROSSJOIN_NUDGE: 'Crossjoin Nudge',
    DIRECT_ACCESS_JOIN: 'Direct Access - Join',
    DIRECT_ACCESS_AUTOJOIN: 'Direct Access - AutoJoin',
    DIRECT_ACCESS_INVITE_LINKS: 'Direct Access - Invite Links',
    REQUEST_ACCESS: 'Request Access Screen',
    ASSIGNS: 'Assigns',
    CORE_INVITES: 'Core Invites',
    MENTIONS: 'Mentions',
    NAV4_TEAMS_ADD: 'Nav4 Teams Add',
    PEOPLE_DIRECTORY: 'People Directory',
    PROMPT_INVITE_ON_LINK_INSERT: 'Prompt invite on link insert',
    SHARE_DIALOG: 'Share Dialog',
    SPACES: 'Spaces',
    TEAMS_MENU: 'Teams Menu',
    USER_INVITE_DRAWER: 'User Invite Drawer',
    UNKNOWN: 'unknown'
};
module.exports["getStargateURL"] = $d1fa119fb73e6e08$export$c7904a8284e43beb;
module.exports["getCurrentCloudId"] = $d1fa119fb73e6e08$export$ddb1688281a3443e;
module.exports["getCurrentUserId"] = $d1fa119fb73e6e08$export$5ebc6cb2748e1881;
module.exports["getCurrentProduct"] = $d1fa119fb73e6e08$export$d01408ed6f850a64;
module.exports["createAnalyticsEvent"] = $d1fa119fb73e6e08$export$a48841c0475a8073;
module.exports["getErrorDetails"] = $d1fa119fb73e6e08$export$33e83b6fee5d732d;
module.exports["isAcceptableFailure"] = $d1fa119fb73e6e08$export$678d91a98f79a24d;
module.exports["isAcceptableFailureForUserInvite"] = $d1fa119fb73e6e08$export$1c4c1f7e2d529330;
module.exports["shouldReportFailedInvite"] = $d1fa119fb73e6e08$export$90cda429f609d666;
module.exports["EnablementTouchpoint"] = $d1fa119fb73e6e08$export$ba588e0ff1c8ed38;

});

parcelRegister("6R9dB", function(module, exports) {

var $2LYjf = parcelRequire("2LYjf");

const $f6ff9e76ba25bd46$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $2LYjf.unimplementedAbstractService)('fetchJSON');
module.exports["fetchJSON"] = $f6ff9e76ba25bd46$export$81bec6e38e8b706b;

});

parcelRegister("mr7nI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0437174526e2cd74$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0437174526e2cd74$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("ghNlj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dIRsp = parcelRequire("dIRsp");

function $34284f28bf40f8ea$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $cozmU.useRef)(null);
    const eventListeners = (0, $cozmU.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $dIRsp.useEntryPointPreload)(load);
    const clickListener = (0, $cozmU.useMemo)(()=>{
        return ()=>{
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $cozmU.useMemo)(()=>{
        return ()=>{
            eagerLoad();
        };
    }, [
        eagerLoad
    ]);
    const cleanUpEventListeners = (0, $cozmU.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $cozmU.useCallback)((element, type, callback)=>{
        const unbind = (0, $cbY7C.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $cozmU.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', preloadReference);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        preloadReference,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}
module.exports["usePressablePreloadRef"] = $34284f28bf40f8ea$export$1ff47f24e06a5d2d;

});

parcelRegister("dIRsp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");

const $d4f85bcbe97d7b23$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $d4f85bcbe97d7b23$var$TIME_TO_INTENT = 200;
function $d4f85bcbe97d7b23$export$57effc2a5e3611f(load) {
    const actions = (0, $cozmU.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $ixfCV.fg)('platform_relay_preload_ensure_max_age_disposal') === false) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            if ((0, $ixfCV.fg)('platform_relay_persist_entrypoint_preloaded_data') === false) request.preload?.dispose();
        };
        const cleanupPreload = ()=>{
            request.preload?.dispose();
            // Only remove the max age timeout when the component is cleaned up.
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $ixfCV.fg)('platform_relay_preload_ensure_max_age_disposal')) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            return loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $d4f85bcbe97d7b23$var$PRELOAD_MAX_AGE);
            }, $d4f85bcbe97d7b23$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: cancelPreload,
            cleanupPreload: cleanupPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
    // Dispose preload and clear timeouts when component unmounts
    // or when `load` identity changes (new actions object created).
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if ((0, $ixfCV.fg)('platform_relay_persist_entrypoint_preloaded_data')) actions.cleanupPreload();
        };
    }, [
        actions
    ]);
    return actions;
}
module.exports["useEntryPointPreload"] = $d4f85bcbe97d7b23$export$57effc2a5e3611f;

});

parcelRegister("14v7H", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4fc294785825a382$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $cozmU.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $4fc294785825a382$export$30ab340faaed55d4 = (experience)=>{
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $4fc294785825a382$var$useConstructor(()=>experience.start());
    return null;
};
module.exports["useUFOComponentExperience"] = $4fc294785825a382$export$30ab340faaed55d4;

});

parcelRegister("gqypm", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");


var $f7MuR = parcelRequire("f7MuR");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip, fetchPolicy: fetchPolicy })=>{
    const legacyResult = (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip || (0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)
    });
    const traitsResult = (0, $f7MuR.useSiteUserTraits)({
        skip: skip || !(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false),
        fetchPolicy: fetchPolicy
    });
    if (!(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)) return {
        data: legacyResult.data,
        loading: legacyResult.loading,
        error: legacyResult.error ?? undefined
    };
    // Exp on: adapt traits result into legacy data/loading/error shape
    const adaptedData = traitsResult.data !== null ? {
        experimentalSiteUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(traitsResult.data.attributes)
        }
    } : undefined;
    return {
        data: adaptedData,
        loading: traitsResult.loading,
        error: traitsResult.error ?? undefined
    };
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("dK51B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $cozmU.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("f7MuR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $8s9DV.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $kBr4q.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $kBr4q.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $cozmU.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kLlYX = parcelRequire("kLlYX");


var $cow67 = parcelRequire("cow67");


var $3gdp3 = parcelRequire("3gdp3");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $2hJf7 = parcelRequire("2hJf7");


var $9zxkL = parcelRequire("9zxkL");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    const actualType = isLivePage && isMarkdownMode ? "markdown" : isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t3;
    if ($[4] !== Icon || $[5] !== color || $[6] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[4] = Icon;
        $[5] = color;
        $[6] = label.id;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const actualType = isLivePage && isMarkdownMode ? 'markdown' : isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    },
    markdown: {
        id: "icons.content-icon.label.markdown",
        defaultMessage: "Markdown"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gdp3))),
        label: $b2e0c504f331f5cc$var$i18n.note
    },
    markdown: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cow67))),
        label: $b2e0c504f331f5cc$var$i18n.markdown
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("cow67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac59572d5177720dc1f7db0f6832687d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90609fd80a141ebe$var$_react = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $90609fd80a141ebe$var$_baseNew = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("gElAV")));
function $90609fd80a141ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90609fd80a141ebe$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $90609fd80a141ebe$var$_react.default.createElement($90609fd80a141ebe$var$_baseNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$90609fd80a141ebe$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $90609fd80a141ebe$var$_default = module.exports.default = $90609fd80a141ebe$var$FileMarkdownIcon;

});

parcelRegister("3gdp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd434ab2c22b25$var$_react = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25fd434ab2c22b25$var$_baseNew = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("gElAV")));
function $25fd434ab2c22b25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd434ab2c22b25$var$NotepadIcon = (props)=>/*#__PURE__*/ $25fd434ab2c22b25$var$_react.default.createElement($25fd434ab2c22b25$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$25fd434ab2c22b25$var$NotepadIcon.displayName = 'NotepadIcon';
var $25fd434ab2c22b25$var$_default = module.exports.default = $25fd434ab2c22b25$var$NotepadIcon;

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_baseNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("9kQkq"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("9kQkq", function(module, exports) {

let $6cbe92ac80b5fc53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6cbe92ac80b5fc53$var$load("ddvkk"),
    $6cbe92ac80b5fc53$var$load("3upHR"),
    $6cbe92ac80b5fc53$var$load("dBHUb"),
    $6cbe92ac80b5fc53$var$load("5Rx9J"),
    $6cbe92ac80b5fc53$var$load("6HpsR"),
    $6cbe92ac80b5fc53$var$load("N3oqb"),
    $6cbe92ac80b5fc53$var$load("hZ2FX"),
    $6cbe92ac80b5fc53$var$load("6wr18"),
    $6cbe92ac80b5fc53$var$load("ffEVr"),
    $6cbe92ac80b5fc53$var$load("4Ldt2"),
    $6cbe92ac80b5fc53$var$load("kFiBp"),
    $6cbe92ac80b5fc53$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("kxhju", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iEfsZ = parcelRequire("iEfsZ");


var $cozmU = parcelRequire("cozmU");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $cozmU.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy,
            __callerPackage__: "@confluence/web-item-location"
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1wIeS", function(module, exports) {

var $1Rned = parcelRequire("1Rned");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $11cb188fd562c44b$var$uniq(array) {
    return array && array.length ? $1Rned(array) : [];
}
module.exports = $11cb188fd562c44b$var$uniq;

});

parcelRegister("1gjU5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw1qyo _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("gfIPU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("kRW4Y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $kNIYN.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("4NX9d", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $cozmU.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("9chzr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $ikWHh = parcelRequire("ikWHh");


var $eVcJM = parcelRequire("eVcJM");

const $c64a9e97047f0043$export$6a6a5d23d75b0f62 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { selectors: selectors, options: options } = t0;
    let t1;
    if ($[0] !== options || $[1] !== selectors) {
        t1 = (0, $ixfCV.fg)("platform-dst-top-layer-spotlight") ? /*#__PURE__*/ $cozmU.createElement((0, $eVcJM.UNSAFE_UpdateOnChange), {
            selectors: selectors,
            options: options
        }) : /*#__PURE__*/ $cozmU.createElement((0, $ikWHh.UNSAFE_UpdateOnChange), {
            selectors: selectors,
            options: options
        });
        $[0] = options;
        $[1] = selectors;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ selectors: selectors, options: options })=>(0, $ixfCV.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ $cozmU.createElement((0, $eVcJM.UNSAFE_UpdateOnChange), {
        selectors: selectors,
        options: options
    }) : /*#__PURE__*/ $cozmU.createElement((0, $ikWHh.UNSAFE_UpdateOnChange), {
        selectors: selectors,
        options: options
    });
module.exports["UNSAFE_UpdateOnChange"] = $c64a9e97047f0043$export$6a6a5d23d75b0f62;

});

parcelRegister("ikWHh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $haNN4 = parcelRequire("haNN4");


var $j8G8s = parcelRequire("j8G8s");

const $2507bbd5b7af8817$var$defaultOptions = {
    childList: true,
    subtree: true
};
const $2507bbd5b7af8817$export$6a6a5d23d75b0f62 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { selectors: t1, options: t2 } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? [
            "body"
        ] : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const selectors = t3;
    const options = t2 === undefined ? $2507bbd5b7af8817$var$defaultOptions : t2;
    const { popoverContent: popoverContent } = (0, $cozmU.useContext)((0, $j8G8s.SpotlightContext));
    const { update: update } = popoverContent;
    let t4;
    let t5;
    if ($[2] !== options || $[3] !== selectors || $[4] !== update) {
        t4 = ()=>{
            if (!update || selectors.length === 0) return;
            const doc = (0, $haNN4.getDocument)();
            if (!doc) return;
            const elements = new Set();
            selectors.forEach((selector)=>{
                const element = doc.querySelector(selector);
                if (!element) return;
                elements.add(element);
            });
            if (elements.size === 0) return;
            const observers = [];
            elements.forEach((element_0)=>{
                const observer = new MutationObserver((mutations)=>{
                    if (mutations.length === 0) return;
                    update();
                });
                observer.observe(element_0, options);
                observers.push(observer);
            });
            return ()=>{
                observers.forEach($2507bbd5b7af8817$var$_temp);
            };
        };
        t5 = [
            selectors,
            options,
            update
        ];
        $[2] = options;
        $[3] = selectors;
        $[4] = update;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $cozmU.useEffect)(t4, t5);
    return null;
} : ({ selectors: selectors = [
    'body'
], options: options = $2507bbd5b7af8817$var$defaultOptions })=>{
    const { popoverContent: popoverContent } = (0, $cozmU.useContext)((0, $j8G8s.SpotlightContext));
    const { update: update } = popoverContent;
    (0, $cozmU.useEffect)(()=>{
        if (!update || selectors.length === 0) return;
        const doc = (0, $haNN4.getDocument)();
        if (!doc) return;
        const elements = new Set();
        selectors.forEach((selector)=>{
            const element = doc.querySelector(selector);
            if (!element) return;
            elements.add(element);
        });
        if (elements.size === 0) return;
        const observers = [];
        elements.forEach((element_0)=>{
            const observer = new MutationObserver((mutations)=>{
                if (mutations.length === 0) return;
                update();
            });
            observer.observe(element_0, options);
            observers.push(observer);
        });
        return ()=>{
            observers.forEach((observer_0)=>observer_0.disconnect());
        };
    }, [
        selectors,
        options,
        update
    ]);
    return null;
};
function $2507bbd5b7af8817$var$_temp(observer_0) {
    return observer_0.disconnect();
}
module.exports["UNSAFE_UpdateOnChange"] = $2507bbd5b7af8817$export$6a6a5d23d75b0f62;

});

parcelRegister("eVcJM", function(module, exports) {
const $40d232a496003659$export$6a6a5d23d75b0f62 = (_props)=>null;
module.exports["UNSAFE_UpdateOnChange"] = $40d232a496003659$export$6a6a5d23d75b0f62;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId,
        __callerPackage__: "@confluence/entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<247131d79908e150d144b65bd18338c4>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<a98ec14c52d173566241d54d72eed0e4>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<8e9cb6fd76c3c39141d1214b5e844944>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<c3ea92623b4eef102f52ae11931592ca>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("1SNEF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $cozmU.useContext)((0, $c0urc.QuickReloadContext));
    (0, $cozmU.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("1vpkQ", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
const $f378941f4cbfa1d0$export$e439c3cb9ea2e5e3 = 'confluence.approvals.pane.contextKey';
const $f378941f4cbfa1d0$export$bbf9a6919720fa3a = 'CURRENT';
const $f378941f4cbfa1d0$export$74a7304e4ecb72ad = 'DRAFT';
const $f378941f4cbfa1d0$export$effd283748674146 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
/**
 * In-memory cache of the approvals pane context key.
 *
 * When the `confluence_browser_storage_controls` feature gate is enabled,
 * `sessionStorageManager.setItem` delegates to `AtlBrowserStorageSession.setItem`
 * which is **async** (it awaits IndexedDB consent checks before writing to
 * `sessionStorage`). This means a synchronous read immediately after a write
 * will return `null` — the value hasn't been persisted yet.
 *
 * The ownership helpers (`shouldRenderApprovalsPaneForContext`,
 * `syncApprovalsPaneContextOwnership`) run synchronously during React renders
 * and effects, so they need a synchronous source of truth. This in-memory
 * variable serves that purpose. Session storage is still written for
 * durability across page reloads, but in-session reads use this cache.
 */ let $f378941f4cbfa1d0$var$inMemoryContextKey = null;
const $f378941f4cbfa1d0$export$7df64ccaccec4e24 = ()=>$f378941f4cbfa1d0$var$inMemoryContextKey;
const $f378941f4cbfa1d0$export$d4f550c493c9338 = (contextKey)=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = contextKey;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3, contextKey);
};
const $f378941f4cbfa1d0$export$fbd6783260490074 = ()=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
};
const $f378941f4cbfa1d0$export$823b1a6d7b43bfe4 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $f378941f4cbfa1d0$export$41945f41a6acb22 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalsExperimentEnabled || !isSidebarApprovalsPaneOpen) return false;
    return $f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: $f378941f4cbfa1d0$export$7df64ccaccec4e24()
    });
};
const $f378941f4cbfa1d0$export$f29b4d98dbe0b579 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey, closeApprovalsPane: closeApprovalsPane })=>{
    if (!isApprovalsExperimentEnabled) return;
    if (!isSidebarApprovalsPaneOpen) {
        $f378941f4cbfa1d0$export$fbd6783260490074();
        return;
    }
    const storedContextKey = $f378941f4cbfa1d0$export$7df64ccaccec4e24();
    if ($f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalsPane();
    $f378941f4cbfa1d0$export$fbd6783260490074();
};
const $f378941f4cbfa1d0$export$c922f15693c980c9 = ({ contentId: contentId, contentStatus: contentStatus, rightSidebarContext: rightSidebarContext })=>{
    $f378941f4cbfa1d0$export$d4f550c493c9338($f378941f4cbfa1d0$export$effd283748674146({
        contentId: contentId,
        contentStatus: contentStatus
    }));
    rightSidebarContext.open($f378941f4cbfa1d0$export$64c46cf06596fc50, $f378941f4cbfa1d0$export$48f59b832d015459);
};
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_CURRENT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$bbf9a6919720fa3a;
module.exports["getApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$effd283748674146;
module.exports["getStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$7df64ccaccec4e24;
module.exports["clearStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$fbd6783260490074;
module.exports["syncApprovalsPaneContextOwnership"] = $f378941f4cbfa1d0$export$f29b4d98dbe0b579;
module.exports["openApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$c922f15693c980c9;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("LSims", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $aJUpe = parcelRequire("aJUpe");


var $4Pmcr = parcelRequire("4Pmcr");

const $450638ee7a6e2e59$export$ec80b976b56288ba = (contentId)=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $aJUpe.default), {
        variables: {
            contentId: contentId ?? '',
            isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)
        },
        fetchPolicy: 'cache-only',
        skip: !contentId || !(0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
        __callerPackage__: "@confluence/content-markdown-mode"
    });
    return (0, $4Pmcr.getIsMarkdownModeFromData)(data);
};
module.exports["useIsMarkdownMode"] = $450638ee7a6e2e59$export$ec80b976b56288ba;

});

parcelRegister("aJUpe", function(module, exports) {
/**
 * @generated SignedSource<<97f042394447b34381d2572432982113>>
 * @relayHash 8ee1f0cde2475ae17a8f029f978204ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971
const $1180c416e2ce3051$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isMarkdownModeEnabled"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isMarkdownModeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isMarkdownMode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8ee1f0cde2475ae17a8f029f978204ad",
            "id": "1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971",
            "metadata": {},
            "name": "IsMarkdownModeQuery",
            "operationKind": "query",
            "text": "query IsMarkdownModeQuery($contentId:ID!,$isMarkdownModeEnabled:Boolean=false){content(id:$contentId){nodes{id,contentProperties{latest{isMarkdownMode@include(if:$isMarkdownModeEnabled)}}}}}"
        }
    };
}();
$1180c416e2ce3051$var$node.hash = "65f92bc360aa57691987c1aba7d545ca";
var $1180c416e2ce3051$export$2e2bcd8739ae039 = $1180c416e2ce3051$var$node;
module.exports["default"] = $1180c416e2ce3051$export$2e2bcd8739ae039;

});

parcelRegister("4Pmcr", function(module, exports) {
const $70bbf1741b7230f7$export$6bc4ac71fcf3f02a = (data)=>{
    return data?.content?.nodes?.[0]?.contentProperties?.latest?.isMarkdownMode ?? false;
};
module.exports["getIsMarkdownModeFromData"] = $70bbf1741b7230f7$export$6bc4ac71fcf3f02a;

});

parcelRegister("lqy4C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $cozmU.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "@confluence/storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<dc205b784e864c4042673f60370ebfb9>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $8s9DV.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $kBr4q.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $kBr4q.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("jqe2L", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $jiJCD = parcelRequire("jiJCD");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $9wGTI = parcelRequire("9wGTI");

const $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled = ()=>{
    return (0, $9wGTI.fg)('confluence_frontend_fabric_editor_blank_page') || (0, $9wGTI.fg)('confluence_frontend_fabric_editor_all_pages');
};
const $350735cb5bb3c1ba$export$9d03777b293b05ce = ()=>{
    return $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled();
};
const $350735cb5bb3c1ba$export$c8780cd30055dcb8 = (parentPageResponse, creationSpaceKey)=>{
    // parent page is in the selected space
    const spaceKey = parentPageResponse?.content?.nodes?.[0]?.space?.key;
    if (spaceKey !== creationSpaceKey) return false;
    // ancestors must be of the same content Type
    const contentType = parentPageResponse?.content?.nodes?.[0]?.type;
    if (contentType !== 'page') return false;
    // parent page must not be archived
    const status = parentPageResponse?.content?.nodes?.[0]?.status;
    if (status === 'archived') return false;
    // must have create access under the parent page
    const operations = parentPageResponse?.content?.nodes?.[0]?.operations;
    const hasCreateOperation = operations && operations.find((op)=>op?.targetType === 'page' && op.operation === 'create');
    return !!hasCreateOperation;
};
const $350735cb5bb3c1ba$export$4c6171230e6eef02 = (overrideValue, defaultValue)=>{
    return {
        value: overrideValue || defaultValue,
        usedOverride: !!overrideValue
    };
};
const $350735cb5bb3c1ba$export$a0b32aef6b0d7373 = (urlToChange, params, updateEditorMode)=>{
    updateEditorMode?.('create-page');
    const urlComponents = (0, $jiJCD.parse)(urlToChange, true);
    return (0, $jiJCD.format)({
        ...urlComponents,
        // remove `search`, otherwise
        // `query` will be ignored
        search: undefined,
        query: {
            ...urlComponents.query,
            ...params
        }
    });
};
const $350735cb5bb3c1ba$export$f59f47d22cf7d84d = (url)=>{
    if (!url) throw new Error('No url for new content');
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $350735cb5bb3c1ba$export$cca9db3da8f2e4f8 = ({ spaceKey: spaceKey, contentId: contentId, url: url, type: type = 'page' })=>{
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(url);
    const draftShareId = legacyDraftRouteMatch?.query?.draftShareId || '';
    const editV2Url = type === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        contentType: 'blog',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    }) : (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        contentType: 'pages',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    });
    return $350735cb5bb3c1ba$export$f59f47d22cf7d84d(editV2Url);
};
const $350735cb5bb3c1ba$export$b47a1345d675bf12 = (error, messageMatches)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>messageMatches.some((messageMatch)=>message.includes(messageMatch)));
    return false;
};
module.exports["isCreateBlankFabricPageEnabled"] = $350735cb5bb3c1ba$export$9d03777b293b05ce;
module.exports["appendQueryParams"] = $350735cb5bb3c1ba$export$a0b32aef6b0d7373;
module.exports["processDraftUrl"] = $350735cb5bb3c1ba$export$f59f47d22cf7d84d;
module.exports["getEditPageUrl"] = $350735cb5bb3c1ba$export$cca9db3da8f2e4f8;
module.exports["graphqlErrorHasMessage"] = $350735cb5bb3c1ba$export$b47a1345d675bf12;

});

parcelRegister("dkIiA", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ee5b1a976329bd8a$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["ConfluencePageSubType"] = $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8;
module.exports["GraphQLContentStatus"] = $ee5b1a976329bd8a$export$b634e5de755b7d35;

});

parcelRegister("ieWRE", function(module, exports) {
/**
 * @generated SignedSource<<5557859264359e1b675fb8554d840b36>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e
const $89ec832c644948be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSmartFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "544e060744fb4498c2bc0371295ea8f5",
            "id": "eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e",
            "metadata": {},
            "name": "useIsSmartFoldersEnabledQuery",
            "operationKind": "query",
            "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
        }
    };
}();
$89ec832c644948be$var$node.hash = "03675b093cffce21dc93e86a9415a3c7";
var $89ec832c644948be$export$2e2bcd8739ae039 = $89ec832c644948be$var$node;
module.exports["default"] = $89ec832c644948be$export$2e2bcd8739ae039;

});

parcelRegister("ig7dg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");

const $116c5e27ebbb6682$var$MIN_VALUE = 0;
const $116c5e27ebbb6682$var$MAX_VALUE = 1;
const $116c5e27ebbb6682$var$increasingBarAnimation = null;
const $116c5e27ebbb6682$var$decreasingBarAnimation = null;
const $116c5e27ebbb6682$var$containerStyles = null;
const $116c5e27ebbb6682$var$containerStylesT26Shape = null;
const $116c5e27ebbb6682$var$containerAppearance = {
    default: "_bfhki8nm",
    success: "_bfhki8nm",
    inverse: "_bfhk1vck"
};
const $116c5e27ebbb6682$var$barAppearance = {
    default: "_bfhk1aqn",
    success: "_bfhkkcmj",
    inverse: "_bfhkvuon"
};
const $116c5e27ebbb6682$var$barStyles = null;
const $116c5e27ebbb6682$var$barStylesT26Shape = null;
const $116c5e27ebbb6682$var$determinateBarStyles = null;
const $116c5e27ebbb6682$var$increasingBarStyles = null;
const $116c5e27ebbb6682$var$decreasingBarStyles = null; /**
                                   * __Progress bar__
                                   *
                                   * A progress bar displays the status of a given process.
                                   *
                                   * - [Examples](https://atlassian.design/components/progress-bar/examples)
                                   * - [Code](https://atlassian.design/components/progress-bar/code)
                                   * - [Usage](https://atlassian.design/components/progress-bar/usage)
                                   */ 
const $116c5e27ebbb6682$var$ProgressBar = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: t1, ariaLabel: ariaLabel, isIndeterminate: t2, testId: t3, value: t4 } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const isIndeterminate = t2 === undefined ? false : t2;
    const testId = t3 === undefined ? "progress-bar" : t3;
    const value = t4 === undefined ? 0 : t4;
    const valueParsed = isIndeterminate ? $116c5e27ebbb6682$var$MIN_VALUE : Math.max($116c5e27ebbb6682$var$MIN_VALUE, Math.min(value, $116c5e27ebbb6682$var$MAX_VALUE));
    let t5;
    if ($[0] !== appearance) {
        t5 = (0, $hekY6.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
            (0, $ixfCV.fg)("platform-dst-shape-theme-default") && "_2rko1rr0",
            $116c5e27ebbb6682$var$containerAppearance[appearance]
        ]);
        $[0] = appearance;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== appearance || $[3] !== isIndeterminate || $[4] !== value) {
        t6 = isIndeterminate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $116c5e27ebbb6682$var$barAppearance[appearance],
                "_5sagymdr _tip812c5 _j7hq7g40",
                (0, $ixfCV.fg)("platform-dst-shape-theme-default") && "_2rko1rr0"
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $116c5e27ebbb6682$var$barAppearance[appearance],
                "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v",
                (0, $ixfCV.fg)("platform-dst-shape-theme-default") && "_2rko1rr0"
            ])
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $hekY6.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $116c5e27ebbb6682$var$barAppearance[appearance],
                "_v564calv",
                (0, $ixfCV.fg)("platform-dst-shape-theme-default") && "_2rko1rr0"
            ])
        });
        $[2] = appearance;
        $[3] = isIndeterminate;
        $[4] = value;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== ariaLabel || $[7] !== t5 || $[8] !== t6 || $[9] !== testId || $[10] !== valueParsed) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "progressbar",
            "aria-label": ariaLabel,
            "aria-valuemin": $116c5e27ebbb6682$var$MIN_VALUE,
            "aria-valuenow": valueParsed,
            "aria-valuemax": $116c5e27ebbb6682$var$MAX_VALUE,
            "data-testid": testId,
            className: t5
        }, t6);
        $[6] = ariaLabel;
        $[7] = t5;
        $[8] = t6;
        $[9] = testId;
        $[10] = valueParsed;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $116c5e27ebbb6682$var$MIN_VALUE : Math.max($116c5e27ebbb6682$var$MIN_VALUE, Math.min(value, $116c5e27ebbb6682$var$MAX_VALUE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $116c5e27ebbb6682$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $116c5e27ebbb6682$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
            (0, $ixfCV.fg)('platform-dst-shape-theme-default') && "_2rko1rr0",
            $116c5e27ebbb6682$var$containerAppearance[appearance]
        ])
    }, isIndeterminate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
            $116c5e27ebbb6682$var$barAppearance[appearance],
            "_5sagymdr _tip812c5 _j7hq7g40",
            (0, $ixfCV.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
            $116c5e27ebbb6682$var$barAppearance[appearance],
            "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v",
            (0, $ixfCV.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            width: `${Number(value) * 100}%`
        },
        className: (0, $hekY6.default)([
            "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
            $116c5e27ebbb6682$var$barAppearance[appearance],
            "_v564calv",
            (0, $ixfCV.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
        ])
    }));
};
var $116c5e27ebbb6682$export$2e2bcd8739ae039 = $116c5e27ebbb6682$var$ProgressBar;
module.exports["default"] = $116c5e27ebbb6682$export$2e2bcd8739ae039;

});

parcelRegister("kDja4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $cozmU.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return (0, $9wGTI.fg)('aifc_create_enabled');
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $ixfCV.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $3ricL = parcelRequire("3ricL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $jH9cM.isFedRamp)() && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");

var $esV19 = parcelRequire("esV19");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $6Mfv2.default)((0, $gkHoc.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $esV19.default)(cutoffDate) ? (0, $6Mfv2.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("kOUwv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $8s9DV.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $kBr4q.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $kBr4q.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("7EIq6", function(module, exports) {

var $dd33Q = parcelRequire("dd33Q");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");

const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, spaceEnabledContentTypesQueryOptions);
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = isDefaultSpaceKeyLoading || isAnyContentTypesLoading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("9ib3C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55422f7c50559ad266d0694af3ada2f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c3e5f4485c7f9fc$var$_react = $6c3e5f4485c7f9fc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $6c3e5f4485c7f9fc$var$_baseNew = $6c3e5f4485c7f9fc$var$_interopRequireDefault((parcelRequire("gElAV")));
function $6c3e5f4485c7f9fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c3e5f4485c7f9fc$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $6c3e5f4485c7f9fc$var$_react.default.createElement($6c3e5f4485c7f9fc$var$_baseNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$6c3e5f4485c7f9fc$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $6c3e5f4485c7f9fc$var$_default = module.exports.default = $6c3e5f4485c7f9fc$var$AppSwitcherIcon;

});

parcelRegister("6cyWf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $350c8455dc4e7cf5$export$d158fa15757a1890 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $350c8455dc4e7cf5$export$abfcaeeca4ae7a55 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHasCustomTheme() {
    return (0, $cozmU.useContext)($350c8455dc4e7cf5$export$d158fa15757a1890);
} : function useHasCustomTheme() {
    return (0, $cozmU.useContext)($350c8455dc4e7cf5$export$d158fa15757a1890);
};
module.exports["HasCustomThemeContext"] = $350c8455dc4e7cf5$export$d158fa15757a1890;
module.exports["useHasCustomTheme"] = $350c8455dc4e7cf5$export$abfcaeeca4ae7a55;

});

parcelRegister("aXMFs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");

function $25b427f2364d8f29$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $25b427f2364d8f29$var$IconRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { icon: Icon } = t0;
    let t1;
    if ($[0] !== Icon) {
        t1 = $25b427f2364d8f29$var$isIconRenderProp(Icon);
        $[0] = Icon;
        $[1] = t1;
    } else t1 = $[1];
    const isRenderProp = t1;
    let t2;
    if ($[2] !== Icon || $[3] !== isRenderProp) {
        const iconProps = {
            label: "",
            color: "currentColor",
            size: (0, $ixfCV.fg)("platform_dst_button_chevron_sizing") ? $25b427f2364d8f29$var$_temp : undefined
        };
        t2 = isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, iconProps);
        $[2] = Icon;
        $[3] = isRenderProp;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2);
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ icon: Icon })=>{
    const isRenderProp = $25b427f2364d8f29$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $ixfCV.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, iconProps));
};
var $25b427f2364d8f29$export$2e2bcd8739ae039 = $25b427f2364d8f29$var$IconRenderer;
function $25b427f2364d8f29$var$_temp(iconName) {
    return iconName.startsWith("Chevron") ? "small" : "medium";
}
module.exports["default"] = $25b427f2364d8f29$export$2e2bcd8739ae039;

});

parcelRegister("5dijw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $ixfCV = parcelRequire("ixfCV");


var $hBYtq = parcelRequire("hBYtq");


var $hVZgb = parcelRequire("hVZgb");

const $33036e997e9cb956$var$styles = {
    root: "_zulp12x7 _11c8fhey _2rkofajl _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    rootT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564o1g2 _1gglat8s",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $33036e997e9cb956$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $33036e997e9cb956$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $33036e997e9cb956$export$66240319f1f78d74 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedPressable(t0, ref) {
    const $ = (0, $bDgLe.c)(20);
    let T0;
    let appearance;
    let hasBorder;
    let isDisabled;
    let isSelected;
    let shape;
    let t1;
    if ($[0] !== t0) {
        const { appearance: t2, shape: t3, isSelected: t4, isDisabled: t5, ...props } = t0;
        isSelected = t4;
        isDisabled = t5;
        appearance = t2 === undefined ? "default" : t2;
        shape = t3 === undefined ? "default" : t3;
        hasBorder = appearance === "default" || isSelected;
        T0 = (0, $hBYtq.default);
        t1 = (0, $hVZgb.getPrimitiveSpreadProps)(props);
        $[0] = t0;
        $[1] = T0;
        $[2] = appearance;
        $[3] = hasBorder;
        $[4] = isDisabled;
        $[5] = isSelected;
        $[6] = shape;
        $[7] = t1;
    } else {
        T0 = $[1];
        appearance = $[2];
        hasBorder = $[3];
        isDisabled = $[4];
        isSelected = $[5];
        shape = $[6];
        t1 = $[7];
    }
    let t2;
    if ($[8] !== appearance || $[9] !== hasBorder || $[10] !== isDisabled || $[11] !== isSelected || $[12] !== shape) {
        t2 = (0, $k12R1.cx)($33036e997e9cb956$var$styles.root, (0, $ixfCV.fg)("platform-dst-shape-theme-default") && $33036e997e9cb956$var$styles.rootT26Shape, $33036e997e9cb956$var$shapeStyles[shape], hasBorder && $33036e997e9cb956$var$styles.border, $33036e997e9cb956$var$appearanceStyles[appearance], isSelected && $33036e997e9cb956$var$styles.selected, isDisabled && $33036e997e9cb956$var$styles.disabled, (0, $ixfCV.fg)("platform-dst-motion-uplift-button") && $33036e997e9cb956$var$styles.interactiveMotion);
        $[8] = appearance;
        $[9] = hasBorder;
        $[10] = isDisabled;
        $[11] = isSelected;
        $[12] = shape;
        $[13] = t2;
    } else t2 = $[13];
    let t3;
    if ($[14] !== T0 || $[15] !== isDisabled || $[16] !== ref || $[17] !== t1 || $[18] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            ref: ref,
            type: "button",
            xcss: t2,
            isDisabled: isDisabled
        });
        $[14] = T0;
        $[15] = isDisabled;
        $[16] = ref;
        $[17] = t1;
        $[18] = t2;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
} : function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        ...(0, $hVZgb.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
                                                                                 * We are using some style values that are outside of the strict
                                                                                 * `@atlaskit/css` types.
                                                                                 */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($33036e997e9cb956$var$styles.root, (0, $ixfCV.fg)('platform-dst-shape-theme-default') && $33036e997e9cb956$var$styles.rootT26Shape, $33036e997e9cb956$var$shapeStyles[shape], hasBorder && $33036e997e9cb956$var$styles.border, $33036e997e9cb956$var$appearanceStyles[appearance], isSelected && $33036e997e9cb956$var$styles.selected, isDisabled && $33036e997e9cb956$var$styles.disabled, (0, $ixfCV.fg)('platform-dst-motion-uplift-button') && $33036e997e9cb956$var$styles.interactiveMotion),
        isDisabled: isDisabled
    });
});
module.exports["ThemedPressable"] = $33036e997e9cb956$export$66240319f1f78d74;

});

parcelRegister("hVZgb", function(module, exports) {
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $c03f86859c8952b6$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
module.exports["getPrimitiveSpreadProps"] = $c03f86859c8952b6$export$e4c95325a21f9785;

});

parcelRegister("fk0Hw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $6cyWf = parcelRequire("6cyWf");


var $2SfBJ = parcelRequire("2SfBJ");

const $651274d8ee84c28a$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $2SfBJ.ThemedButton) : (0, $ad7Ou.default);
    let t0;
    if ($[0] !== Component || $[1] !== props || $[2] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ref: ref,
            ...props
        });
        $[0] = Component;
        $[1] = props;
        $[2] = ref;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props, ref)=>{
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $2SfBJ.ThemedButton) : (0, $ad7Ou.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        ref: ref,
        ...props
    });
});
module.exports["Button"] = $651274d8ee84c28a$export$353f5b6fc5456de1;

});

parcelRegister("2SfBJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $aXMFs = parcelRequire("aXMFs");


var $5dijw = parcelRequire("5dijw");

const $8c55572969b08c36$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
const $8c55572969b08c36$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedButton(t0, ref) {
    const $ = (0, $bDgLe.c)(14);
    let IconBefore;
    let children;
    let props;
    if ($[0] !== t0) {
        ({ iconBefore: IconBefore, children: children, ...props } = t0);
        $[0] = t0;
        $[1] = IconBefore;
        $[2] = children;
        $[3] = props;
    } else {
        IconBefore = $[1];
        children = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] !== IconBefore) {
        t1 = IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $8c55572969b08c36$var$textButtonStyles.iconBefore
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXMFs.default), {
            icon: IconBefore
        }));
        $[4] = IconBefore;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $8c55572969b08c36$var$textButtonStyles.text
        ]);
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t2
        }, children);
        $[7] = children;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== props || $[10] !== ref || $[11] !== t1 || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dijw.ThemedPressable), {
            ...props,
            ref: ref
        }, t1, t3);
        $[9] = props;
        $[10] = ref;
        $[11] = t1;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dijw.ThemedPressable), {
        ...props,
        ref: ref
    }, IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $8c55572969b08c36$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXMFs.default), {
        icon: IconBefore
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $8c55572969b08c36$var$textButtonStyles.text
        ])
    }, children));
});
module.exports["ThemedButton"] = $8c55572969b08c36$export$f67fb575035cc7d0;

});

parcelRegister("dDJT6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45233a62a3f56b9e4911deb2a2339447>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ee283416514adb3$var$_react = $9ee283416514adb3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9ee283416514adb3$var$_baseNew = $9ee283416514adb3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9ee283416514adb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global app navigation and within app screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ee283416514adb3$var$NotificationIcon = (props)=>/*#__PURE__*/ $9ee283416514adb3$var$_react.default.createElement($9ee283416514adb3$var$_baseNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.42 13.5a1.748 1.748 0 0 0 3.16 0zM4.5 8.636c0 .215-.06.426-.175.608L2.603 12h10.795l-1.723-2.756a1.15 1.15 0 0 1-.175-.608V5a3.5 3.5 0 0 0-7 0zm8.5-.1 1.788 2.86a1.375 1.375 0 0 1-1.166 2.104h-2.46a3.25 3.25 0 0 1-6.324 0h-2.46a1.375 1.375 0 0 1-1.166-2.104L3 8.537V5a5 5 0 0 1 10 0z"/>`
    }, props));
$9ee283416514adb3$var$NotificationIcon.displayName = 'NotificationIcon';
var $9ee283416514adb3$var$_default = module.exports.default = $9ee283416514adb3$var$NotificationIcon;

});

parcelRegister("hPGQU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af5bdeaecdb0e37d55178bb1e6c281ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfb870adeedce136$var$_react = $cfb870adeedce136$var$_interopRequireDefault((parcelRequire("cozmU")));

var $cfb870adeedce136$var$_baseNew = $cfb870adeedce136$var$_interopRequireDefault((parcelRequire("gElAV")));
function $cfb870adeedce136$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfb870adeedce136$var$LogInIcon = (props)=>/*#__PURE__*/ $cfb870adeedce136$var$_react.default.createElement($cfb870adeedce136$var$_baseNew.default, Object.assign({
        name: "LogInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$cfb870adeedce136$var$LogInIcon.displayName = 'LogInIcon';
var $cfb870adeedce136$var$_default = module.exports.default = $cfb870adeedce136$var$LogInIcon;

});

parcelRegister("lBYCH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1e166e9bfc301d21$export$695e6f0ac03b03ae = (0, $cozmU.createContext)({
    isBranchDeploy: false
});
$1e166e9bfc301d21$export$695e6f0ac03b03ae.displayName = 'AppNavigationContext';
module.exports["AppNavigationContext"] = $1e166e9bfc301d21$export$695e6f0ac03b03ae;

});

parcelRegister("jyA9t", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    isLoomRecorderOpen: false,
    attachedLoomVideo: null,
    submittedWithLoomAttachment: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    isFloating: false,
    shouldShowBackButton: undefined,
    entryPoint: 'confluenceUnknown',
    initialPrompt: undefined,
    initialOutcomeType: undefined,
    lockInitialOutcomeType: false,
    remixConversationId: null,
    onboardingData: undefined,
    onOnboardingSubmit: undefined,
    totalSteps: undefined,
    submitCallback: undefined,
    onCloseCallback: undefined,
    onOpenCallback: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: ({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, stagingAreaActive: stagingAreaActive, isFloating: isFloating, shouldShowBackButton: shouldShowBackButton, content: content, initialPrompt: initialPrompt, initialOutcomeType: initialOutcomeType, lockInitialOutcomeType: lockInitialOutcomeType, submitCallback: submitCallback, onCloseCallback: onCloseCallback, onOpenCallback: onOpenCallback, remixConversationId: remixConversationIdFromOpen, onboardingData: onboardingData, onOnboardingSubmit: onOnboardingSubmit, totalSteps: totalSteps })=>({ setState: setState })=>{
            const floating = isFloating ?? false;
            const remixConversationId = floating && remixConversationIdFromOpen !== undefined && remixConversationIdFromOpen !== null && remixConversationIdFromOpen !== '' ? remixConversationIdFromOpen : null;
            setState({
                showSmartCreationModal: true,
                // A fresh open is never behind the recorder; clearing here also
                // recovers if a prior recorder session left the flag stuck on.
                isLoomRecorderOpen: false,
                // A fresh open never carries a prior session's attachment.
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                isFloating: floating,
                shouldShowBackButton: shouldShowBackButton ?? undefined,
                initialPrompt: initialPrompt,
                initialOutcomeType: initialOutcomeType ?? undefined,
                // Lock requires an initial outcome type — guard against misuse.
                lockInitialOutcomeType: Boolean(initialOutcomeType && lockInitialOutcomeType),
                remixConversationId: remixConversationId,
                onboardingData: onboardingData ?? undefined,
                onOnboardingSubmit: onOnboardingSubmit ?? undefined,
                totalSteps: totalSteps ?? undefined,
                submitCallback: submitCallback ?? undefined,
                onCloseCallback: onCloseCallback ?? undefined,
                onOpenCallback: onOpenCallback ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                isLoomRecorderOpen: false,
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                content: undefined,
                stagingAreaActive: false,
                isFloating: false,
                shouldShowBackButton: undefined,
                entryPoint: 'confluenceUnknown',
                initialPrompt: undefined,
                initialOutcomeType: undefined,
                lockInitialOutcomeType: false,
                remixConversationId: null,
                onboardingData: undefined,
                onOnboardingSubmit: undefined,
                onCloseCallback: undefined,
                onOpenCallback: undefined
            });
        },
    setLoomRecorderOpen: (isLoomRecorderOpen)=>({ setState: setState })=>{
            setState({
                isLoomRecorderOpen: isLoomRecorderOpen
            });
        },
    setAttachedLoomVideo: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                attachedLoomVideo: attachedLoomVideo
            });
        },
    setSubmittedWithLoomAttachment: (submittedWithLoomAttachment)=>({ setState: setState })=>{
            setState({
                submittedWithLoomAttachment: submittedWithLoomAttachment
            });
        },
    // Atomically reads-and-clears the marker from live store state (not a
    // render-lagged hook value) so the create/finalize step sees the value set
    // by the submit that immediately preceded it, and never fires twice or leaks
    // onto a later create.
    consumeSubmittedWithLoomAttachment: ()=>({ getState: getState, setState: setState })=>{
            const submitted = getState().submittedWithLoomAttachment;
            if (submitted) setState({
                submittedWithLoomAttachment: false
            });
            return submitted;
        },
    // Attaches a just-recorded Loom and forces the modal open. A recording can
    // finish after the modal was closed mid-record (reopened via global create,
    // then dismissed); the orphaned SDK "Add to prompt" callback fires here, so
    // reopening lets the attachment land on a visible modal instead of nowhere.
    attachLoomVideoAndOpenModal: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                attachedLoomVideo: attachedLoomVideo
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $kBr4q.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $kBr4q.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $kBr4q.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("1KBSi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $fEhQK = parcelRequire("fEhQK");

const $15029de520f1b9e8$export$cadd7e072478f5e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const t0 = !isLicensed;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            skip: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { data: canCreateData, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $fEhQK.default), {
        ...t1,
        __callerPackage__: "@confluence/create-space"
    });
    let t2;
    if ($[2] !== canCreateData?.user?.confluence?.operations) {
        t2 = canCreateData?.user?.confluence?.operations.some($15029de520f1b9e8$var$_temp);
        $[2] = canCreateData?.user?.confluence?.operations;
        $[3] = t2;
    } else t2 = $[3];
    const canCreateSpace = Boolean(t2);
    let t3;
    if ($[4] !== canCreateSpace || $[5] !== loading) {
        t3 = {
            canCreateSpace: canCreateSpace,
            loading: loading
        };
        $[4] = canCreateSpace;
        $[5] = loading;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: canCreateData, loading: loading } = (0, $jMyy4.useQueryInterop)(// Due to circular dependency issues we are using the PreloadCreateSpaceQuery from create-space-preload package
    (0, $fEhQK.default), {
        skip: !isLicensed,
        __callerPackage__: "@confluence/create-space"
    });
    const canCreateSpace = Boolean(canCreateData?.user?.confluence?.operations.some((obj)=>obj?.operation === 'create_space'));
    return {
        canCreateSpace: canCreateSpace,
        loading: loading
    };
};
function $15029de520f1b9e8$var$_temp(obj) {
    return obj?.operation === "create_space";
}
module.exports["useCanCreateSpace"] = $15029de520f1b9e8$export$cadd7e072478f5e;

});

parcelRegister("fEhQK", function(module, exports) {
/**
 * @generated SignedSource<<d09735fc2cd7a6020b32121ef039e936>>
 * @relayHash a615654a08ce3274fc54e07efd9211ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf
const $ba87c6a44dc20089$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a615654a08ce3274fc54e07efd9211ea",
            "id": "e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf",
            "metadata": {},
            "name": "preloadCreateSpaceQuery",
            "operationKind": "query",
            "text": "query preloadCreateSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation}}}}"
        }
    };
}();
$ba87c6a44dc20089$var$node.hash = "9a716c385cdfcba90204a7cf16292b9a";
var $ba87c6a44dc20089$export$2e2bcd8739ae039 = $ba87c6a44dc20089$var$node;
module.exports["default"] = $ba87c6a44dc20089$export$2e2bcd8739ae039;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== activationId || $[3] !== cloudId) {
        t1 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[2] = activationId;
        $[3] = cloudId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t1) {
        t2 = {
            headers: {
                ...t1
            }
        };
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t4;
    if ($[7] !== t0 || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            variables: t0,
            context: t2,
            skip: t3
        };
        $[7] = t0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        ...t4,
        __callerPackage__: "@confluence/loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__),
        __callerPackage__: "@confluence/loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== environment || $[5] !== initLoomEntryPointVariant || $[6] !== loading || $[7] !== skip || $[8] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId,
            environment
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = environment;
        $[5] = initLoomEntryPointVariant;
        $[6] = loading;
        $[7] = skip;
        $[8] = userId;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3ricL = parcelRequire("3ricL");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18rx4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("hLP6B", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d27efa463aaac1e4$var$skeletonItemElemSize = 20;
const $d27efa463aaac1e4$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $d27efa463aaac1e4$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $d27efa463aaac1e4$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $d27efa463aaac1e4$var$SkeletonItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: t1, isSideNavSkeleton: t2, testId: testId, width: width, xcss: xcss } = t0;
    const isShimmering = t1 === undefined ? false : t1;
    const isSideNavSkeleton = t2 === undefined ? false : t2;
    const t3 = (hasAvatar || hasIcon) && $d27efa463aaac1e4$var$styles.beforeElement;
    const t4 = hasAvatar && $d27efa463aaac1e4$var$styles.avatar;
    const t5 = hasIcon && $d27efa463aaac1e4$var$styles.icon;
    const t6 = width ? $d27efa463aaac1e4$var$styles.customWidth : $d27efa463aaac1e4$var$styles.defaultWidth;
    const t7 = isSideNavSkeleton && $d27efa463aaac1e4$var$styles.sideNavSkeleton;
    const t8 = isShimmering && "";
    const t9 = isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff";
    let t10;
    if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5 || $[3] !== t6 || $[4] !== t7 || $[5] !== t8 || $[6] !== t9 || $[7] !== xcss) {
        t10 = (0, $hekY6.default)([
            $d27efa463aaac1e4$var$styles.root,
            t3,
            t4,
            t5,
            t6,
            t7,
            t8,
            t9,
            xcss
        ]);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
        $[6] = t9;
        $[7] = xcss;
        $[8] = t10;
    } else t10 = $[8];
    let t11;
    if ($[9] !== width) {
        t11 = {
            "--width": width
        };
        $[9] = width;
        $[10] = t11;
    } else t11 = $[10];
    const t12 = t11;
    let t13;
    if ($[11] !== t10 || $[12] !== t12 || $[13] !== testId) {
        t13 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t10,
            style: t12,
            "data-testid": testId
        });
        $[11] = t10;
        $[12] = t12;
        $[13] = testId;
        $[14] = t13;
    } else t13 = $[14];
    return t13;
} : ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $d27efa463aaac1e4$var$styles.root,
            (hasAvatar || hasIcon) && $d27efa463aaac1e4$var$styles.beforeElement,
            hasAvatar && $d27efa463aaac1e4$var$styles.avatar,
            hasIcon && $d27efa463aaac1e4$var$styles.icon,
            width ? $d27efa463aaac1e4$var$styles.customWidth : $d27efa463aaac1e4$var$styles.defaultWidth,
            isSideNavSkeleton && $d27efa463aaac1e4$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $d27efa463aaac1e4$export$2e2bcd8739ae039 = $d27efa463aaac1e4$var$SkeletonItem;
module.exports["default"] = $d27efa463aaac1e4$export$2e2bcd8739ae039;

});

parcelRegister("9ivsj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dX6FL = parcelRequire("dX6FL");


var $jlWUB = parcelRequire("jlWUB");

const $68c74ae30c005fed$export$c537e63161742ce3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $68c74ae30c005fed$export$c537e63161742ce3;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $e5ba90f4b97bd7c1$var$i18n = (0, $kSwu1.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("gd8AW", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $8s9DV.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $kBr4q.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $kBr4q.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("bK5Dy", function(module, exports) {
const $bedb38fd6d7a6e5d$var$LOOM_URL_REGEX = // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
function $bedb38fd6d7a6e5d$var$extractLoomVideoId(url) {
    const match = url.match($bedb38fd6d7a6e5d$var$LOOM_URL_REGEX);
    return match?.groups?.videoId;
}
async function $bedb38fd6d7a6e5d$var$digestMessage(message) {
    // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
    if (window?.crypto?.subtle?.digest) {
        const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
        const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
        return hashHex;
    }
    return '';
}
async function $bedb38fd6d7a6e5d$export$495fb2ecc80ca6c0(url) {
    try {
        const videoId = $bedb38fd6d7a6e5d$var$extractLoomVideoId(url);
        if (videoId) {
            const data = atob('c2U1UTwgekZlVEYkP1MzRno1QmV5WXBoSE13SHg8RWpjM10saHJQZmhPMVVHKHM=') + videoId;
            const digestHex = await $bedb38fd6d7a6e5d$var$digestMessage(data);
            return digestHex ? `vidhash-${digestHex}` : '';
        }
        return '';
    } catch (_) {
        return '';
    }
}
module.exports["getHashedLoomVideoIdFromUrl"] = $bedb38fd6d7a6e5d$export$495fb2ecc80ca6c0;

});

parcelRegister("ifF9E", function(module, exports) {

var $e8eWN = parcelRequire("e8eWN");

// eslint-disable-next-line no-undef
var $d4998d3150d9a680$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $d4998d3150d9a680$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $e8eWN.default)(function(prop) {
    return $d4998d3150d9a680$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $d4998d3150d9a680$export$2e2bcd8739ae039;

});

parcelRegister("9V507", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $738d50ffcc582510$var$_react = $738d50ffcc582510$var$_interopRequireDefault((parcelRequire("cozmU")));

var $738d50ffcc582510$var$_baseNew = $738d50ffcc582510$var$_interopRequireDefault((parcelRequire("gElAV")));
function $738d50ffcc582510$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $738d50ffcc582510$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $738d50ffcc582510$var$_react.default.createElement($738d50ffcc582510$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$738d50ffcc582510$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $738d50ffcc582510$var$_default = module.exports.default = $738d50ffcc582510$var$AiGenerativeTextIcon;

});

parcelRegister("iCisl", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $lpNn5 = parcelRequire("lpNn5");

var $1B9Aq = parcelRequire("1B9Aq");


var $khtFq = parcelRequire("khtFq");

const $0d6a7abd934ab2be$var$i18n = (0, $kSwu1.defineMessages)({
    tooltip: {
        id: "ai-common.ai-labs-lozenge.tooltip",
        defaultMessage: "Beta: This feature is still in development."
    }
});
const $0d6a7abd934ab2be$var$lozengeStyles = {
    lozenge: "_2rko12b0 _18zr1b66 _1e0c1txw _4cvr1h6o _1bah1h6o",
    tooltip: "_2rko12b0 _11c8wadc _vchhusvi _p12f7l9q _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna"
};
const $0d6a7abd934ab2be$var$gradientWaveKeyframes = null;
const $0d6a7abd934ab2be$var$sampResetStyles = null;
const $0d6a7abd934ab2be$var$lozengeAnimatedBorder = null; // Using a custom tooltip is a workaround to avoid odd spacing due to default styles,
// primarily for the English locale
const $0d6a7abd934ab2be$var$CustomTooltip = /*#__PURE__*/ (0, $cozmU.forwardRef)(function CustomTooltip({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
        ...props,
        ref: ref,
        className: (0, $hekY6.default)([
            $0d6a7abd934ab2be$var$lozengeStyles.tooltip
        ])
    }, children);
});
const $0d6a7abd934ab2be$export$48aba4499a97f6bf = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)(); // We don't want to i18n the term 'AI Labs' because it is the branding name
    // and should be the same across all languages
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        component: $0d6a7abd934ab2be$var$CustomTooltip,
        content: formatMessage($0d6a7abd934ab2be$var$i18n.tooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "ai-labs-lozenge",
        className: (0, $hekY6.default)([
            $0d6a7abd934ab2be$var$lozengeStyles.lozenge,
            "_2rko12b0 _18zr1b66 _kqswh2mm _bfhksm61 _1e0c1txw _4cvr1h6o _1bah1h6o _1pbyidpf _1tesidpf _rfx312b0 _1414t94y _p7f0t94y _7gpxt94y _syayt94y _1s6kyrfl _16qq1ajn _1kt9b3bt _1cs8stnw _1ankm4tz _12a1epuu _x5brkvto _13sb1p67 _dsq4glyw _1g0v1mrw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        grow: "hug",
        space: "space.025",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $khtFq.LabsIcon), {
        darkMode: colorMode === 'dark'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "small",
        weight: "semibold",
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("samp", {
        className: (0, $hekY6.default)([
            "_11c81kw7"
        ])
    }, "LABS"))))));
};
module.exports["AILabsLozenge"] = $0d6a7abd934ab2be$export$48aba4499a97f6bf;

});

parcelRegister("khtFq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $64351f65bd133f46$export$36be37b392de5213 = ({ darkMode: darkMode = false })=>{
    return darkMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon-dark"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_1466_13761)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_1466_13761"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "8.25276",
        height: "7.89",
        fill: "white",
        transform: "translate(0.9375 0.0625)"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_1352_45568)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
        fill: "#1E1F21"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_1352_45568"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "8.25276",
        height: "7.89",
        fill: "white",
        transform: "translate(0.9375 0.0625)"
    }))));
};
module.exports["LabsIcon"] = $64351f65bd133f46$export$36be37b392de5213;

});

parcelRegister("evORK", function(module, exports) {

var $mr7nI = parcelRequire("mr7nI");


var $9wGTI = parcelRequire("9wGTI");


var $kAcNG = parcelRequire("kAcNG");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $eeeb74b654b378be$export$c71507e40f69e111 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: siteUserPersonalizationData, loading: siteUserPersonalizationLoading, error: siteUserPersonalizationError } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const siteUserPersonalizationAttributes = siteUserPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    const confluenceFirstActive = siteUserPersonalizationAttributes?.find(({ name: name })=>name === $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const { attributes: sitePersonalizationAttributes, loading: sitePersonalizationLoading, error: sitePersonalizationError } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const AIFCBetaEnrolledDateTime = sitePersonalizationAttributes?.find(({ name: name })=>name === 'confluence_aifc_enabled_datetime')?.value;
    const isExistingUserBeforeAIFCBetaEnrolled = !!confluenceFirstActive && !!AIFCBetaEnrolledDateTime && (0, $mr7nI.default)(new Date(confluenceFirstActive), new Date(AIFCBetaEnrolledDateTime));
    if (sitePersonalizationError || sitePersonalizationLoading || siteUserPersonalizationError || siteUserPersonalizationLoading || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')) return {
        isAIFCOnbardingEligible: false,
        error: sitePersonalizationError || siteUserPersonalizationError,
        loading: sitePersonalizationLoading || siteUserPersonalizationLoading
    };
    return {
        isAIFCOnbardingEligible: isExistingUserBeforeAIFCBetaEnrolled,
        loading: false
    };
};
module.exports["useIsAIFCOnbardingEligible"] = $eeeb74b654b378be$export$c71507e40f69e111;

});

parcelRegister("kAcNG", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");


var $kOUwv = parcelRequire("kOUwv");


var $hcDKy = parcelRequire("hcDKy");

let $a3e54b7319a42934$export$98a405b08ebbac37 = false;
const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ cloudId: cloudId, skip: skip, fetchPolicy: fetchPolicy })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || $a3e54b7319a42934$export$98a405b08ebbac37 || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const legacyQuery = (0, $hcDKy.useExperimentalSitePersonalizationQuery)({
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy || 'cache-first',
        skip: skipOptions || (0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false),
        onError (apolloError) {
            $a3e54b7319a42934$export$98a405b08ebbac37 = apolloError?.graphQLErrors?.some((graphQLError)=>(0, $aMcHK.isStatusCodeError)(graphQLError, '401') || (0, $1uFM6.isUnauthorizedError)(graphQLError));
        }
    });
    const siteTraits = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: skipOptions || !(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)
    });
    if (skipOptions) return {
        loading: false,
        error: undefined,
        attributes: []
    };
    // The experiment path reads snapshot-backed site traits and does not guarantee
    // same-session freshness. Keep the legacy query path available while the
    // migration rolls out for callers that still need dynamic TAP behavior.
    const attributes = ((0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false) ? siteTraits.data?.attributes : legacyQuery.data?.experimentalSitePersonalization?.attributes) || [];
    return {
        loading: (0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false) ? siteTraits.loading : legacyQuery.loading,
        error: (0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false) ? siteTraits.error ?? undefined : legacyQuery.error,
        attributes: attributes
    };
};
module.exports["useSitePersonalizationQuery"] = $a3e54b7319a42934$export$3cfde1d6c626a865;

});

parcelRegister("hcDKy", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $c7a26f042941282d$export$f9ec68434a742b9f = ({ skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy })=>{
    return (0, $dK51B.useExperimentalQuery)({
        // eslint-disable-next-line confluence-targeting-usage/no-legacy-tap-personalization-api -- To be migrated to useSiteTraits. See ACTIVATION-2527
        url: ({ cloudId: cloudId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
        method: 'GET',
        parseResult: (json)=>({
                experimentalSitePersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalSitePersonalizationQuery"] = $c7a26f042941282d$export$f9ec68434a742b9f;

});

parcelRegister("88DFk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ge84 = parcelRequire("3ge84");

var $9DHhW = parcelRequire("9DHhW");


var $iGwRU = parcelRequire("iGwRU");


var $kXiqf = parcelRequire("kXiqf");


var $l9F99 = parcelRequire("l9F99");


var $i8NpI = parcelRequire("i8NpI");

const $9d01a40d5c3361ba$var$DefaultActionSubject = 'rovoAgent';
const $9d01a40d5c3361ba$var$globalEventConfig = (0, $i8NpI.getDefaultTrackEventConfig)();
const $9d01a40d5c3361ba$export$b9dc0ab1bce924aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (commonAttributes)=>{
    const $ = (0, $bDgLe.c)(21);
    const [t0, t1] = (0, $kXiqf.useRovoAgentCSID)();
    const { csid: csid, globalCSID: globalCSID } = t0;
    const { refresh: refreshCSID } = t1;
    const analyticsContext = (0, $cozmU.useContext)((0, $3ge84.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    let t2;
    if ($[0] !== analyticsContext || $[1] !== createAnalyticsEvent) {
        t2 = (event)=>{
            const referrer = typeof window !== "undefined" ? window.document.referrer : "unknown";
            const attributes = {
                ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
                ...commonAttributesRef.current,
                ...event.attributes,
                actionGroup: "createFlow",
                referrer: referrer
            };
            createAnalyticsEvent({
                ...$9d01a40d5c3361ba$var$globalEventConfig,
                ...event,
                attributes: attributes
            }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
        };
        $[0] = analyticsContext;
        $[1] = createAnalyticsEvent;
        $[2] = t2;
    } else t2 = $[2];
    const fireAnalyticsEvent = t2;
    let t3;
    if ($[3] !== fireAnalyticsEvent || $[4] !== globalCSID) {
        t3 = (action, attributes_0)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: action,
                attributes: {
                    csid: globalCSID,
                    ...attributes_0
                }
            });
        };
        $[3] = fireAnalyticsEvent;
        $[4] = globalCSID;
        $[5] = t3;
    } else t3 = $[5];
    const trackCreateSession = t3;
    let t4;
    if ($[6] !== csid || $[7] !== fireAnalyticsEvent || $[8] !== refreshCSID) {
        t4 = (attributes_1)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: "createFlowStart",
                attributes: {
                    csid: csid,
                    ...attributes_1
                }
            });
            refreshCSID();
        };
        $[6] = csid;
        $[7] = fireAnalyticsEvent;
        $[8] = refreshCSID;
        $[9] = t4;
    } else t4 = $[9];
    const trackCreateSessionStart = t4;
    let t5;
    if ($[10] !== fireAnalyticsEvent || $[11] !== globalCSID) {
        t5 = (error, attributes_2)=>{
            fireAnalyticsEvent({
                actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
                action: "createFlowError",
                attributes: {
                    error: {
                        message: error.message
                    },
                    csid: globalCSID,
                    ...attributes_2
                }
            });
        };
        $[10] = fireAnalyticsEvent;
        $[11] = globalCSID;
        $[12] = t5;
    } else t5 = $[12];
    const trackCreateSessionError = t5;
    let t6;
    if ($[13] !== refreshCSID || $[14] !== trackCreateSession || $[15] !== trackCreateSessionError || $[16] !== trackCreateSessionStart) {
        t6 = {
            trackCreateSession: trackCreateSession,
            trackCreateSessionStart: trackCreateSessionStart,
            trackCreateSessionError: trackCreateSessionError,
            refreshCSID: refreshCSID
        };
        $[13] = refreshCSID;
        $[14] = trackCreateSession;
        $[15] = trackCreateSessionError;
        $[16] = trackCreateSessionStart;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== csid || $[19] !== t6) {
        t7 = [
            csid,
            t6
        ];
        $[18] = csid;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : (commonAttributes)=>{
    const [{ csid: csid, globalCSID: globalCSID }, { refresh: refreshCSID }] = (0, $kXiqf.useRovoAgentCSID)();
    const analyticsContext = (0, $cozmU.useContext)((0, $3ge84.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const commonAttributesRef = (0, $cozmU.useRef)(commonAttributes);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        const referrer = typeof window !== 'undefined' ? window.document.referrer : 'unknown';
        const attributes = {
            ...(0, $l9F99.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
            ...commonAttributesRef.current,
            ...event.attributes,
            actionGroup: 'createFlow',
            referrer: referrer
        };
        createAnalyticsEvent({
            ...$9d01a40d5c3361ba$var$globalEventConfig,
            ...event,
            attributes: attributes
        }).fire((0, $iGwRU.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsContext
    ] // keep number of dependencies minimal to prevent re-rendering
    );
    /**
   * Fires an analytics event for a step in the create agent flow funnel.
   * Uses the CSID from the URL query parameter.
   */ const trackCreateSession = (0, $cozmU.useCallback)((action, attributes_0)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: action,
            attributes: {
                csid: globalCSID,
                ...attributes_0
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    /**
   * Fires `createFlowStart` with the current CSID (matching the href),
   * then refreshes the CSID for the next session.
   * The component re-renders with the new CSID, updating any href attributes.
   */ const trackCreateSessionStart = (0, $cozmU.useCallback)((attributes_1)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: 'createFlowStart',
            attributes: {
                csid: csid,
                ...attributes_1
            }
        });
        refreshCSID();
    }, [
        fireAnalyticsEvent,
        refreshCSID,
        csid
    ]);
    const trackCreateSessionError = (0, $cozmU.useCallback)((error, attributes_2)=>{
        fireAnalyticsEvent({
            actionSubject: $9d01a40d5c3361ba$var$DefaultActionSubject,
            action: 'createFlowError',
            attributes: {
                error: {
                    message: error.message
                },
                csid: globalCSID,
                ...attributes_2
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    return [
        csid,
        {
            trackCreateSession: trackCreateSession,
            trackCreateSessionStart: trackCreateSessionStart,
            trackCreateSessionError: trackCreateSessionError,
            refreshCSID: refreshCSID
        }
    ];
};
module.exports["useRovoAgentCreateAnalytics"] = $9d01a40d5c3361ba$export$b9dc0ab1bce924aa;

});

parcelRegister("kXiqf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $debAY = parcelRequire("debAY");

let $3de3d827eb32710a$var$CACHED_CSID = null;
const $3de3d827eb32710a$var$generateCSID = ()=>{
    return crypto.randomUUID();
};
const $3de3d827eb32710a$export$2e155615ea28a17b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $3de3d827eb32710a$var$CACHED_CSID || $3de3d827eb32710a$var$generateCSID();
        $[0] = t0;
    } else t0 = $[0];
    const [csid, setCSID] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        const queryParams = new URLSearchParams(window.location.search);
        t1 = queryParams.get((0, $debAY.CSID_QUERY_PARAM));
        $[1] = t1;
    } else t1 = $[1];
    const globalCSID = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            refresh: ()=>{
                const newCSID = $3de3d827eb32710a$var$generateCSID();
                setCSID(newCSID);
                $3de3d827eb32710a$var$CACHED_CSID = newCSID;
                return newCSID;
            }
        };
        $[2] = t2;
    } else t2 = $[2];
    const actions = t2;
    let t3;
    if ($[3] !== csid) {
        t3 = [
            {
                csid: csid,
                globalCSID: globalCSID
            },
            actions
        ];
        $[3] = csid;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ()=>{
    const [csid, setCSID] = (0, $cozmU.useState)($3de3d827eb32710a$var$CACHED_CSID || $3de3d827eb32710a$var$generateCSID());
    const globalCSID = (0, $cozmU.useMemo)(()=>{
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get((0, $debAY.CSID_QUERY_PARAM));
    }, []);
    const actions = (0, $cozmU.useMemo)(()=>{
        return {
            refresh: ()=>{
                const newCSID = $3de3d827eb32710a$var$generateCSID();
                setCSID(newCSID);
                $3de3d827eb32710a$var$CACHED_CSID = newCSID;
                return newCSID;
            }
        };
    }, []);
    return [
        {
            csid: csid,
            globalCSID: // generated CSID to be used in href and createFlowStart events
            globalCSID // CSID from the URL query parameter
        },
        actions
    ];
};
module.exports["useRovoAgentCSID"] = $3de3d827eb32710a$export$2e155615ea28a17b;

});

parcelRegister("debAY", function(module, exports) {
const $881ebb84c71795d2$export$61b85fb5d2d632d0 = 'csid';
module.exports["CSID_QUERY_PARAM"] = $881ebb84c71795d2$export$61b85fb5d2d632d0;

});

parcelRegister("cbBHq", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ 
var $cozmU = parcelRequire("cozmU");


var $lvOsp = parcelRequire("lvOsp");


var $2PxwR = parcelRequire("2PxwR");


var $6gwjd = parcelRequire("6gwjd");

const $0b3da77a55c8d66c$export$47d6a944ca09299 = ()=>{
    const [preloadSmartCreationModalQuery] = (0, $lvOsp.useLazyQueryInterop)((0, $6gwjd.default), {
        __callerPackage__: "@confluence/smart-create"
    });
    return (0, $cozmU.useCallback)(()=>{
        preloadSmartCreationModalQuery();
        (0, $2PxwR.LazyConfluenceSmartCreationModal).preload();
    }, [
        preloadSmartCreationModalQuery
    ]);
};
module.exports["usePreloadSmartCreationModal"] = $0b3da77a55c8d66c$export$47d6a944ca09299;

});

parcelRegister("2PxwR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c156286aa1d634b0$export$116ded32e65c3603 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4mwBk",
    name: "LazyConfluenceSmartCreationModal",
    loader: async ()=>(await (parcelRequire("gPeQ7"))).ConfluenceSmartCreationModal
});
module.exports["LazyConfluenceSmartCreationModal"] = $c156286aa1d634b0$export$116ded32e65c3603;

});

parcelRegister("gPeQ7", function(module, exports) {

let $c3fceba0c1a38f96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c3fceba0c1a38f96$var$load("6yMT4"),
    $c3fceba0c1a38f96$var$load("4ZKBo"),
    $c3fceba0c1a38f96$var$load("jZMUd"),
    $c3fceba0c1a38f96$var$load("7TnhR"),
    $c3fceba0c1a38f96$var$load("hUbK8"),
    $c3fceba0c1a38f96$var$load("68hpv"),
    $c3fceba0c1a38f96$var$load("1r4R9"),
    $c3fceba0c1a38f96$var$load("bx5S2"),
    $c3fceba0c1a38f96$var$load("7fsAO"),
    $c3fceba0c1a38f96$var$load("knuqf"),
    $c3fceba0c1a38f96$var$load("ipIDQ"),
    $c3fceba0c1a38f96$var$load("agv3Q"),
    $c3fceba0c1a38f96$var$load("garBx"),
    $c3fceba0c1a38f96$var$load("eyY0h"),
    $c3fceba0c1a38f96$var$load("5HweM"),
    $c3fceba0c1a38f96$var$load("3bz2q"),
    $c3fceba0c1a38f96$var$load("eRcQY"),
    $c3fceba0c1a38f96$var$load("by6h6"),
    $c3fceba0c1a38f96$var$load("j3345"),
    $c3fceba0c1a38f96$var$load("2J2X1"),
    $c3fceba0c1a38f96$var$load("7xLM7"),
    $c3fceba0c1a38f96$var$load("Mjfig"),
    $c3fceba0c1a38f96$var$load("e7Dyr"),
    $c3fceba0c1a38f96$var$load("cPAXo"),
    $c3fceba0c1a38f96$var$load("44j0l"),
    $c3fceba0c1a38f96$var$load("6aezV"),
    $c3fceba0c1a38f96$var$load("huHiR"),
    $c3fceba0c1a38f96$var$load("46GUH"),
    $c3fceba0c1a38f96$var$load("dxcsb"),
    $c3fceba0c1a38f96$var$load("gbejv"),
    $c3fceba0c1a38f96$var$load("GD9EA"),
    $c3fceba0c1a38f96$var$load("2hLAI"),
    $c3fceba0c1a38f96$var$load("dCilB"),
    $c3fceba0c1a38f96$var$load("1T8H1"),
    $c3fceba0c1a38f96$var$load("fyKFO"),
    $c3fceba0c1a38f96$var$load("d9sg7"),
    $c3fceba0c1a38f96$var$load("l0N35"),
    $c3fceba0c1a38f96$var$load("iNoxQ"),
    $c3fceba0c1a38f96$var$load("lOm4J"),
    $c3fceba0c1a38f96$var$load("9LVeR"),
    $c3fceba0c1a38f96$var$load("8exG0"),
    $c3fceba0c1a38f96$var$load("gnocL"),
    $c3fceba0c1a38f96$var$load("kT6dz"),
    $c3fceba0c1a38f96$var$load("dBHUb"),
    $c3fceba0c1a38f96$var$load("5Rx9J"),
    $c3fceba0c1a38f96$var$load("6wr18"),
    $c3fceba0c1a38f96$var$load("av7K3"),
    $c3fceba0c1a38f96$var$load("hZVEi"),
    $c3fceba0c1a38f96$var$load("fcsnw"),
    $c3fceba0c1a38f96$var$load("ffEVr"),
    $c3fceba0c1a38f96$var$load("eCXJR"),
    $c3fceba0c1a38f96$var$load("1VTX2"),
    $c3fceba0c1a38f96$var$load("ddvkk"),
    $c3fceba0c1a38f96$var$load("3upHR"),
    $c3fceba0c1a38f96$var$load("hhss7"),
    $c3fceba0c1a38f96$var$load("Wowvf"),
    $c3fceba0c1a38f96$var$load("eRhBr"),
    $c3fceba0c1a38f96$var$load("hZ2FX"),
    $c3fceba0c1a38f96$var$load("cKDij"),
    $c3fceba0c1a38f96$var$load("7EorR"),
    $c3fceba0c1a38f96$var$load("ce05o"),
    $c3fceba0c1a38f96$var$load("fQKYr")
]).then(()=>parcelRequire('6CLTo'));

});

parcelRegister("6gwjd", function(module, exports) {
/**
 * @generated SignedSource<<aed928c86f10a4e4f6955f6a921227cd>>
 * @relayHash e04a1fbd9772100897718d8eb52d327f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641
const $7b2c6142b984d24d$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e04a1fbd9772100897718d8eb52d327f",
            "id": "29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641",
            "metadata": {},
            "name": "ConfluenceSmartCreationModalQuery",
            "operationKind": "query",
            "text": "query ConfluenceSmartCreationModalQuery{user:confluence_atlassianUser(current:true){id,title}}"
        }
    };
}();
$7b2c6142b984d24d$var$node.hash = "b82822dc05785ac3b5e50c2feec2f4f2";
var $7b2c6142b984d24d$export$2e2bcd8739ae039 = $7b2c6142b984d24d$var$node;
module.exports["default"] = $7b2c6142b984d24d$export$2e2bcd8739ae039;

});

parcelRegister("kb3cs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $588defb4b914bf6a$export$bc9ec39841ba8fd3 = {
    CHAT: 'chat',
    SEARCH_QF_PILL: 'search-qf-connect-apps-pill',
    SEARCH_FPS_CONNECT_APPS_BUTTON: 'search-fps-connect-apps-button'
};
const $588defb4b914bf6a$export$ec3ac09cbc485f99 = (surface)=>surface?.startsWith('search-') === true;
const $588defb4b914bf6a$var$initialState = {
    product: '',
    siteId: '',
    experienceId: 'ai-mate',
    assistanceServiceConfig: undefined,
    surface: undefined
};
const $588defb4b914bf6a$var$rovoSettingsConfig = /*#__PURE__*/ (0, $cozmU.createContext)($588defb4b914bf6a$var$initialState);
const $588defb4b914bf6a$var$rovoSettingsModalMountedContext = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $588defb4b914bf6a$export$e6e0575f100c37ab = $588defb4b914bf6a$var$rovoSettingsConfig.Provider;
const $588defb4b914bf6a$export$c32765f1b1c62608 = $588defb4b914bf6a$var$rovoSettingsModalMountedContext.Provider;
const $588defb4b914bf6a$export$db68c798d50f727e = ()=>(0, $cozmU.useContext)($588defb4b914bf6a$var$rovoSettingsConfig);
const $588defb4b914bf6a$export$ddb548fa2ffa23a3 = ()=>(0, $cozmU.useContext)($588defb4b914bf6a$var$rovoSettingsModalMountedContext);
module.exports["RovoSettingsModalSurface"] = $588defb4b914bf6a$export$bc9ec39841ba8fd3;
module.exports["isSearchSurface"] = $588defb4b914bf6a$export$ec3ac09cbc485f99;
module.exports["RovoSettingsConfigProvider"] = $588defb4b914bf6a$export$e6e0575f100c37ab;
module.exports["RovoSettingsModalMountedProvider"] = $588defb4b914bf6a$export$c32765f1b1c62608;
module.exports["useRovoSettingsConfig"] = $588defb4b914bf6a$export$db68c798d50f727e;
module.exports["useIsRovoSettingsModalProviderMounted"] = $588defb4b914bf6a$export$ddb548fa2ffa23a3;

});

parcelRegister("eytcg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2c6792bc438bfd46$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final",
        defaultMessage: "Sources & apps"
    },
    searchPlaceholder: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final",
        defaultMessage: "Search settings"
    },
    defaultTriggerLabel: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final",
        defaultMessage: "Explore all apps"
    }
});
module.exports["messages"] = $2c6792bc438bfd46$export$defe85febe8b728c;

});

parcelRegister("hGRCq", function(module, exports) {

var $aqAfG = parcelRequire("aqAfG");


var $fR63l = parcelRequire("fR63l");

const $fc005fb0f05fc434$export$73be91b73ebbdb05 = [
    ...Object.values((0, $aqAfG.ProductKeys1P)),
    ...Object.values((0, $fR63l.ProductKeys3P))
];
module.exports["allProductKeys"] = $fc005fb0f05fc434$export$73be91b73ebbdb05;

});

parcelRegister("5Sv3D", function(module, exports) {
$parcel$export(module.exports, "default", () => $447a164f7d0faf6b$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $447a164f7d0faf6b$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $cozmU.useRef)(null);
    var maxWaitArgs = (0, $cozmU.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $cozmU.useRef)(false);
    var functionTimeoutHandler = (0, $cozmU.useRef)(null);
    var isComponentUnmounted = (0, $cozmU.useRef)(false);
    var debouncedFunction = (0, $cozmU.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $cozmU.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $cozmU.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $cozmU.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $cozmU.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("iN08H", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("cIWiw")).disableNativeDragPreview);

var $cIWiw = parcelRequire("cIWiw");


});

parcelRegister("cIWiw", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $8d2daf016c36a388$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $8d2daf016c36a388$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $8d2daf016c36a388$var$tinyTransparentImage) nativeSetDragImage($8d2daf016c36a388$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $8d2daf016c36a388$export$c588cb30ff3b876e;

});

parcelRegister("aLPNu", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("fGXGw")).preventUnhandled);

var $fGXGw = parcelRequire("fGXGw");


});

parcelRegister("fGXGw", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $bl5yp = parcelRequire("bl5yp");

function $3ba3c538e2294e67$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $3ba3c538e2294e67$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $3ba3c538e2294e67$var$start() {
    $3ba3c538e2294e67$var$cleanup();
    $3ba3c538e2294e67$var$unbindEvents = (0, $cbY7C.bindAll)(window, [
        {
            type: 'dragover',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $3ba3c538e2294e67$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $3ba3c538e2294e67$var$cleanup
        },
        ...(0, $bl5yp.getBindingsForBrokenDrags)({
            onDragEnd: $3ba3c538e2294e67$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $3ba3c538e2294e67$var$cleanup() {
    $3ba3c538e2294e67$var$unbindEvents?.();
    $3ba3c538e2294e67$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $3ba3c538e2294e67$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $3ba3c538e2294e67$var$cleanup();
}
const $3ba3c538e2294e67$export$453c0582481cc59d = {
    start: $3ba3c538e2294e67$var$start,
    stop: $3ba3c538e2294e67$var$stop
};
module.exports["preventUnhandled"] = $3ba3c538e2294e67$export$453c0582481cc59d;

});

parcelRegister("c8XQL", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lOiVq = parcelRequire("lOiVq");


var $fp2Bc = parcelRequire("fp2Bc");


var $gE1ec = parcelRequire("gE1ec");


var $lxV8r = parcelRequire("lxV8r");


var $cozmU = parcelRequire("cozmU");


var $ifF9E = parcelRequire("ifF9E");

var $8d74a858e0464007$var$isDevelopment = false;
var $8d74a858e0464007$var$testOmitPropsOnStringTag = (0, $ifF9E.default);
var $8d74a858e0464007$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $8d74a858e0464007$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $8d74a858e0464007$var$testOmitPropsOnStringTag : $8d74a858e0464007$var$testOmitPropsOnComponent;
};
var $8d74a858e0464007$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $8d74a858e0464007$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lxV8r.registerStyles)(cache, serialized, isStringTag);
    (0, $gE1ec.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lxV8r.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $8d74a858e0464007$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $8d74a858e0464007$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $8d74a858e0464007$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $lOiVq.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $cozmU.useContext((0, $lOiVq.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $lxV8r.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $fp2Bc.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $8d74a858e0464007$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement($8d74a858e0464007$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $cozmU.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $8d74a858e0464007$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $eb3ax.default)({}, options, nextOptions, {
                shouldForwardProp: $8d74a858e0464007$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $8d74a858e0464007$export$2e2bcd8739ae039;

});

parcelRegister("gAlT6", function(module, exports) {

var $bsTU9 = parcelRequire("bsTU9");


var $aYr7p = parcelRequire("aYr7p");

/** Used for built-in method references. */ var $c130fc97ec35be58$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c130fc97ec35be58$var$hasOwnProperty = $c130fc97ec35be58$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $c130fc97ec35be58$var$groupBy = $aYr7p(function(result, value, key) {
    if ($c130fc97ec35be58$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $bsTU9(result, key, [
        value
    ]);
});
module.exports = $c130fc97ec35be58$var$groupBy;

});

parcelRegister("aYr7p", function(module, exports) {

var $aQVxe = parcelRequire("aQVxe");


var $gvTsE = parcelRequire("gvTsE");


var $j6gAQ = parcelRequire("j6gAQ");


var $1ScXu = parcelRequire("1ScXu");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $7fd48b25632d9305$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $1ScXu(collection) ? $aQVxe : $gvTsE, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $j6gAQ(iteratee, 2), accumulator);
    };
}
module.exports = $7fd48b25632d9305$var$createAggregator;

});

parcelRegister("aQVxe", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $7e6b63f27d697568$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $7e6b63f27d697568$var$arrayAggregator;

});

parcelRegister("gvTsE", function(module, exports) {

var $bNHBU = parcelRequire("bNHBU");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c05a9000df9c8764$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $bNHBU(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $c05a9000df9c8764$var$baseAggregator;

});

parcelRegister("hHL57", function(module, exports) {

var $dojlP = parcelRequire("dojlP");


var $anHcQ = parcelRequire("anHcQ");

/** Used to match HTML entities and HTML characters. */ var $ce3af93da41c9a81$var$reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, $ce3af93da41c9a81$var$reHasEscapedHtml = RegExp($ce3af93da41c9a81$var$reEscapedHtml.source);
/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */ function $ce3af93da41c9a81$var$unescape(string) {
    string = $dojlP(string);
    return string && $ce3af93da41c9a81$var$reHasEscapedHtml.test(string) ? string.replace($ce3af93da41c9a81$var$reEscapedHtml, $anHcQ) : string;
}
module.exports = $ce3af93da41c9a81$var$unescape;

});

parcelRegister("anHcQ", function(module, exports) {

var $aJnR3 = parcelRequire("aJnR3");

/** Used to map HTML entities to characters. */ var $78ed913858b2bf85$var$htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */ var $78ed913858b2bf85$var$unescapeHtmlChar = $aJnR3($78ed913858b2bf85$var$htmlUnescapes);
module.exports = $78ed913858b2bf85$var$unescapeHtmlChar;

});

parcelRegister("12QCz", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-deprecated-imports, @typescript-eslint/ban-types -- Preserve existing mention implementation while focus-ring usage is reviewed separately. */ 
var $cozmU = parcelRequire("cozmU");


var $b1FLc = parcelRequire("b1FLc");


var $21cx5 = parcelRequire("21cx5");


var $cK6Td = parcelRequire("cK6Td");


var $iD1Wv = parcelRequire("iD1Wv");


var $gcaru = parcelRequire("gcaru");


var $caelp = parcelRequire("caelp");


var $b3nqj = parcelRequire("b3nqj");


var $lzgC6 = parcelRequire("lzgC6");


var $j7Sza = parcelRequire("j7Sza");


var $j1Rvl = parcelRequire("j1Rvl");


var $27ALb = parcelRequire("27ALb");

const $1b57c88557e5831b$export$7452d7062a4d0634 = 1000;
const $1b57c88557e5831b$export$af8124aa496797f2 = '_|unknown|_';
class $1b57c88557e5831b$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        (0, $27ALb.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $27ALb.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $j7Sza.UFOExperienceState)['STARTED'],
            (0, $j7Sza.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j1Rvl.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            }
        }, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, `@${message}`));
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId, disabledTooltip: disabledTooltip } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$1b57c88557e5831b$export$af8124aa496797f2}`;
        const showRestrictedTooltip = mentionType === (0, $caelp.MentionType).RESTRICTED;
        const showDisabledTooltip = mentionType === (0, $caelp.MentionType).DISABLED && !!disabledTooltip;
        // A11y: when the chip is in the disabled visual state, expose
        // `aria-disabled` so assistive tech announces it as such. The
        // disabled-tooltip text is mirrored into `aria-label` so the
        // announcement carries the reason even without portal-id wiring for
        // `aria-describedby`.
        const isDisabledChip = mentionType === (0, $caelp.MentionType).DISABLED;
        const disabledA11yProps = isDisabledChip ? {
            'aria-disabled': true,
            ...disabledTooltip ? {
                'aria-label': `${text || '@...'} \u{2014} ${disabledTooltip}`
            } : {}
        } : {};
        const mentionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1FLc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK6Td.default), {
            mentionType: mentionType,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            spellCheck: false,
            "data-testid": `mention-${id}`,
            "data-mention-type": mentionType,
            "data-mention-tooltip": showRestrictedTooltip || showDisabledTooltip,
            ...disabledA11yProps
        }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
        const ssrPlaceholderProp = props.ssrPlaceholderId ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        const wrappedMention = (()=>{
            if (showRestrictedTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: mentionComponent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iD1Wv.default), {
                name: text
            }, mentionComponent));
            if (showDisabledTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: mentionComponent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gcaru.default), {
                tooltip: disabledTooltip
            }, mentionComponent));
            return mentionComponent;
        })();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $27ALb.UfoErrorBoundary), {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            id: localId,
            "data-mention-id": id,
            "data-local-id": localId,
            "data-access-level": accessLevel,
            spellCheck: false,
            ...ssrPlaceholderProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21cx5.default), null, wrappedMention)));
    }
    constructor(props){
        super(props);
        this.hoverTimeout = void 0;
        this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick, isDisabled: isDisabled } = this.props;
            if (isDisabled) // Disabled chips do not invoke their click handler.
            return;
            if (onClick) onClick(id, text, e);
        };
        this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $1b57c88557e5831b$export$7452d7062a4d0634);
        };
        this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        };
        this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted, isDisabled: isDisabled } = this.props;
            if (isDisabled) return (0, $caelp.MentionType).DISABLED;
            if (isHighlighted) return (0, $caelp.MentionType).SELF;
            if ((0, $caelp.isRestricted)(accessLevel)) return (0, $caelp.MentionType).RESTRICTED;
            return (0, $caelp.MentionType).DEFAULT;
        };
        (0, $27ALb.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
}
const $1b57c88557e5831b$var$MentionWithAnalytics = (0, $lzgC6.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $b3nqj.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $b3nqj.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($1b57c88557e5831b$export$92ab8442e7a15cef);
const $1b57c88557e5831b$var$Mention = $1b57c88557e5831b$var$MentionWithAnalytics;
var $1b57c88557e5831b$export$2e2bcd8739ae039 = $1b57c88557e5831b$var$Mention;
module.exports["UNKNOWN_USER_ID"] = $1b57c88557e5831b$export$af8124aa496797f2;
module.exports["default"] = $1b57c88557e5831b$export$2e2bcd8739ae039;

});

parcelRegister("cK6Td", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $caelp = parcelRequire("caelp");


var $cozmU = parcelRequire("cozmU");

const $ef75f214d8da3bca$var$mentionStyle = {
    [(0, $caelp.MentionType).SELF]: {
        background: "var(--ds-background-brand-bold, #1868DB)",
        borderColor: 'transparent',
        text: "var(--ds-text-inverse, #FFFFFF)",
        hoveredBackground: "var(--ds-background-brand-bold-hovered, #1558BC)",
        pressedBackground: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    [(0, $caelp.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: "var(--ds-border-bold, #7D818A)",
        text: "var(--ds-text, #292A2E)",
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $caelp.MentionType).DEFAULT]: {
        background: "var(--ds-background-neutral, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-subtle, #505258)",
        hoveredBackground: "var(--ds-background-neutral-hovered, #0B120E24)",
        pressedBackground: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    [(0, $caelp.MentionType).DISABLED]: {
        background: "var(--ds-background-disabled, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-disabled, #080F214A)",
        // Disabled chips do not change on hover / press.
        hoveredBackground: "var(--ds-background-disabled, #0515240F)",
        pressedBackground: "var(--ds-background-disabled, #0515240F)"
    }
};
const $ef75f214d8da3bca$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $ef75f214d8da3bca$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $ef75f214d8da3bca$var$PrimitiveMention = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $lOiVq.css)("display:inline;border:var(--ds-border-width, 1px) solid ", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $ef75f214d8da3bca$export$2e2bcd8739ae039 = $ef75f214d8da3bca$var$PrimitiveMention;
module.exports["default"] = $ef75f214d8da3bca$export$2e2bcd8739ae039;

});

parcelRegister("gcaru", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $139bcf7839d1a883$var$AsyncDisabledMentionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("2GsKr")).then((module)=>{
        return {
            default: module.DisabledMentionTooltip
        };
    }));
var $139bcf7839d1a883$export$2e2bcd8739ae039 = $139bcf7839d1a883$var$AsyncDisabledMentionTooltip;
module.exports["default"] = $139bcf7839d1a883$export$2e2bcd8739ae039;

});

parcelRegister("2GsKr", function(module, exports) {

let $1f45cdcc4b463c3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f45cdcc4b463c3d$var$load("5bU1Y").then(()=>parcelRequire('eZafG'));

});

parcelRegister("27ALb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fh15z = parcelRequire("fh15z");

var $4MiWC = parcelRequire("4MiWC");

const $0f53e930d80d4c74$export$1d011e4240507c78 = new (0, $fh15z.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
});
class $0f53e930d80d4c74$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch() {
        $0f53e930d80d4c74$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["mentionRenderedUfoExperience"] = $0f53e930d80d4c74$export$1d011e4240507c78;
module.exports["UfoErrorBoundary"] = $0f53e930d80d4c74$export$5ef1c2550074a375;

});

parcelRegister("8lt5O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $464fa95e1d18f18e$var$rovoEntitlementStore = (0, $8s9DV.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $464fa95e1d18f18e$var$useStateHook = (0, $kBr4q.createStateHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$66d5dd4be64dea43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const result = $464fa95e1d18f18e$var$useStateHook();
    let t0;
    if ($[0] !== result) {
        t0 = {
            ...result,
            isRovoEnabled: result.isRovoEnabled
        };
        $[0] = result;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const result = $464fa95e1d18f18e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $464fa95e1d18f18e$export$8004893135276275 = (0, $kBr4q.createActionsHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$d03a05ad8547472c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { isRovoEnabled: isRovoEnabled } = t0;
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    setIsRovoEnabled(isRovoEnabled);
    return null;
} : ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    (0, $cozmU.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $464fa95e1d18f18e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $464fa95e1d18f18e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $464fa95e1d18f18e$export$d03a05ad8547472c;

});

parcelRegister("ji12t", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");

const $ee0754b6a3322402$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $ee0754b6a3322402$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $ee0754b6a3322402$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE' || agent.creator_type === 'REMOTE_A2A' && (0, $ixfCV.fg)('rovo_agent_support_a2a_avatar');
const $ee0754b6a3322402$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $ee0754b6a3322402$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $ee0754b6a3322402$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    VERIFIED_AGENTS: 'verified-agents',
    /** Jira browse tab: agents available for Jira (UI label localized in product). */ AVAILABLE_FOR_JIRA: 'available-for-jira',
    /** Jira browse tab: 3P marketplace coding agents (UI label localized in product). */ CODING_AGENTS: 'coding-agents'
};
module.exports["isSystemAgent"] = $ee0754b6a3322402$export$7c120b233d4844c6;
module.exports["isCustomerAgent"] = $ee0754b6a3322402$export$f817e52cf2c5cc8c;
module.exports["isForgeAgent"] = $ee0754b6a3322402$export$2149adda3d8a5807;
module.exports["isOOTBAgent"] = $ee0754b6a3322402$export$7091e3bee2adaacb;
module.exports["BrowseCategories"] = $ee0754b6a3322402$export$916e4870f74f205b;

});

parcelRegister("63sT2", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("8NccQ")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("8NccQ")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("8NccQ")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("dYn3u")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("dYn3u")).Reasons);

var $8NccQ = parcelRequire("8NccQ");


var $dYn3u = parcelRequire("dYn3u");


});

parcelRegister("8NccQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $h9Y0D = parcelRequire("h9Y0D");


var $6j5v3 = parcelRequire("6j5v3");


var $dYn3u = parcelRequire("dYn3u");

const $95842fb34f191a76$var$LATEST_VERSION = (0, $6j5v3.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $95842fb34f191a76$var$CrossFlowContext = /*#__PURE__*/ (0, $cozmU.createContext)(()=>({
        isEnabled: false,
        reason: (0, $dYn3u.Reasons).NO_PROVIDER
    }));
const $95842fb34f191a76$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $6j5v3.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $h9Y0D.createAPIv0)(onOpen),
                    apiV1: (0, $6j5v3.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $dYn3u.Reasons).NO_API_SUPPORT
                };
        }
    };
const $95842fb34f191a76$export$c0ddec072762f62a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onOpen: onOpen, children: children } = t0;
    let t1;
    if ($[0] !== onOpen) {
        t1 = $95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen);
        $[0] = onOpen;
        $[1] = t1;
    } else t1 = $[1];
    const negotiateApi = t1;
    let t2;
    if ($[2] !== children || $[3] !== negotiateApi) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
            value: negotiateApi
        }, children);
        $[2] = children;
        $[3] = negotiateApi;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $cozmU.useMemo)(()=>$95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $95842fb34f191a76$export$6e7a10fe635a0dfc = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    let t0;
    if ($[0] !== negotiateApi) {
        t0 = negotiateApi($95842fb34f191a76$var$LATEST_VERSION);
        $[0] = negotiateApi;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    return (0, $cozmU.useMemo)(()=>negotiateApi($95842fb34f191a76$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $95842fb34f191a76$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        let t0;
        if ($[0] !== crossFlow || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...props,
                crossFlow: crossFlow
            });
            $[0] = crossFlow;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $95842fb34f191a76$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $95842fb34f191a76$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $95842fb34f191a76$export$655b6c19a0daddb8;

});

parcelRegister("h9Y0D", function(module, exports) {
const $dac2ee632762edd0$export$a4ad2735b021c132 = 0;
const $dac2ee632762edd0$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $dac2ee632762edd0$export$9ff7368ac93fcf2d;

});

parcelRegister("6j5v3", function(module, exports) {
const $146c188c19063c17$export$a4ad2735b021c132 = 1;
const $146c188c19063c17$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $146c188c19063c17$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $146c188c19063c17$export$8fd5792fc468459f;

});

parcelRegister("dYn3u", function(module, exports) {
const $f5b6049530406f9f$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $f5b6049530406f9f$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $f5b6049530406f9f$export$3411873bfd520bb6;
module.exports["Reasons"] = $f5b6049530406f9f$export$da2d4f2f250d6f84;

});

parcelRegister("7L44N", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $eq1BO = parcelRequire("eq1BO");


var $iQwJa = parcelRequire("iQwJa");

var $bGVJw = parcelRequire("bGVJw");

var $5h1mk = parcelRequire("5h1mk");

var $1RMKR = parcelRequire("1RMKR");


var $4OYR1 = parcelRequire("4OYR1");


var $gswTK = parcelRequire("gswTK");


var $cozmU = parcelRequire("cozmU");


var $a33Aa = parcelRequire("a33Aa");


var $9aSEF = parcelRequire("9aSEF");


var $4PX6o = parcelRequire("4PX6o");


var $3raeL = parcelRequire("3raeL");


var $4QMIF = parcelRequire("4QMIF");


var $8BQV6 = parcelRequire("8BQV6");


var $ixfCV = parcelRequire("ixfCV");

const $17d7b5e1361d82f3$var$useInitialDataIfEnabled = (0, $gtMdU.isReactCompilerActivePlatform)() ? (placementId, context, baseUrl, path, disableInitialData)=>{
    const $ = (0, $bDgLe.c)(10);
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    let t0;
    if ($[0] !== context) {
        t0 = (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context);
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const arePlacementsGloballyDisabled = t0;
    let t1;
    if ($[2] !== arePlacementsGloballyDisabled || $[3] !== baseUrl || $[4] !== context || $[5] !== disableInitialData || $[6] !== fetcher.fetch || $[7] !== path || $[8] !== placementId) {
        t1 = arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $4PX6o.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        });
        $[2] = arePlacementsGloballyDisabled;
        $[3] = baseUrl;
        $[4] = context;
        $[5] = disableInitialData;
        $[6] = fetcher.fetch;
        $[7] = path;
        $[8] = placementId;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    const arePlacementsGloballyDisabled = (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context);
    return (0, $cozmU.useMemo)(()=>arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $4PX6o.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        arePlacementsGloballyDisabled,
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $17d7b5e1361d82f3$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $17d7b5e1361d82f3$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $17d7b5e1361d82f3$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $a33Aa.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $a33Aa.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $17d7b5e1361d82f3$var$Placement = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: t1, children: children } = t0;
    const disableInitialData = t1 === undefined ? false : t1;
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $3raeL.useBuildBasePath)();
    let t2;
    if ($[0] !== context || $[1] !== postOfficeRoute) {
        t2 = {
            ...context,
            postOfficeRoute: postOfficeRoute
        };
        $[0] = context;
        $[1] = postOfficeRoute;
        $[2] = t2;
    } else t2 = $[2];
    const stableContextWithRoute = (0, $1RMKR.useStableObject)(t2);
    let t3;
    if ($[3] !== consumptionType || $[4] !== placementId) {
        t3 = new (0, $4OYR1.UFOv1).PlacementPerformanceTracker(placementId, consumptionType);
        $[3] = consumptionType;
        $[4] = placementId;
        $[5] = t3;
    } else t3 = $[5];
    const ufoV1PlacementTracker = t3;
    const ufoV2InteractionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const ufoV2InteractionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const t4 = ufoV2InteractionContext?.labelStack;
    let t5;
    if ($[6] !== t4 || $[7] !== ufoV2InteractionId.current) {
        t5 = {
            interactionId: ufoV2InteractionId.current,
            labelStack: t4
        };
        $[6] = t4;
        $[7] = ufoV2InteractionId.current;
        $[8] = t5;
    } else t5 = $[8];
    const stableUfoV2Interaction = (0, $1RMKR.useStableObject)(t5);
    let t6;
    if ($[9] !== consumptionType || $[10] !== placementId || $[11] !== placementOnEvent || $[12] !== stableUfoV2Interaction || $[13] !== ufoV1PlacementTracker) {
        t6 = (t7)=>{
            const { type: type, error: error } = t7;
            if (consumptionType === "local") {
                switch(type){
                    case "fetch-error":
                    case "component-error":
                    case "render-error":
                        if ((0, $ixfCV.fg)("post-office_enable_ufo-v2-add-error")) $17d7b5e1361d82f3$var$handleUfoV2Error({
                            ufoV2Interaction: stableUfoV2Interaction,
                            placementId: placementId,
                            error: error,
                            errorEventType: type
                        });
                }
                return;
            }
            if (consumptionType === "remote") {
                placementOnEvent?.({
                    type: type,
                    error: error
                });
                bb31: switch(type){
                    case "fetch-complete":
                        ufoV1PlacementTracker?.markFetchComplete();
                        break bb31;
                    case "fetch-error":
                        ufoV1PlacementTracker?.markFetchFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb31;
                    case "render-complete":
                        ufoV1PlacementTracker?.markRenderComplete();
                        break bb31;
                    case "render-error":
                        ufoV1PlacementTracker?.markRenderFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb31;
                    case "initial-data-complete":
                        ufoV1PlacementTracker?.markInitialDataComplete();
                        break bb31;
                    case "initial-data-error":
                        ufoV1PlacementTracker?.markInitialDataFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb31;
                    case "component-error":
                        ufoV1PlacementTracker?.markComponentFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb31;
                    case "component-ready":
                        ufoV1PlacementTracker?.markComponentReady();
                        break bb31;
                    case "unmount":
                        ufoV1PlacementTracker?.markComponentAborted();
                }
            }
        };
        $[9] = consumptionType;
        $[10] = placementId;
        $[11] = placementOnEvent;
        $[12] = stableUfoV2Interaction;
        $[13] = ufoV1PlacementTracker;
        $[14] = t6;
    } else t6 = $[14];
    const componentOnEvent = t6;
    const initialData = $17d7b5e1361d82f3$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    let t7;
    if ($[15] !== placementId) {
        t7 = {
            source: (0, $9aSEF.ANALYTICS_SOURCE),
            componentName: "Placement",
            attributes: {
                placementId: placementId,
                channel: "in-app"
            }
        };
        $[15] = placementId;
        $[16] = t7;
    } else t7 = $[16];
    const placementAnalyticsContext = t7;
    let t8;
    if ($[17] !== children || $[18] !== componentOnEvent || $[19] !== initialData || $[20] !== stableContextWithRoute) {
        t8 = children({
            initialData: initialData,
            context: stableContextWithRoute,
            onEvent: componentOnEvent
        });
        $[17] = children;
        $[18] = componentOnEvent;
        $[19] = initialData;
        $[20] = stableContextWithRoute;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== placementAnalyticsContext || $[23] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext
        }, t8);
        $[22] = placementAnalyticsContext;
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $3raeL.useBuildBasePath)();
    const stableContextWithRoute = (0, $1RMKR.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $cozmU.useMemo)(()=>isUFOEnabled ? new (0, $4OYR1.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const ufoV2InteractionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const stableUfoV2Interaction = (0, $1RMKR.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $cozmU.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    if ((0, $ixfCV.fg)('post-office_enable_ufo-v2-add-error')) $17d7b5e1361d82f3$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $17d7b5e1361d82f3$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $cozmU.useMemo)(()=>({
            source: (0, $9aSEF.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext
    }, children({
        initialData: initialData,
        context: stableContextWithRoute,
        onEvent: componentOnEvent
    }));
};
var $17d7b5e1361d82f3$export$2e2bcd8739ae039 = $17d7b5e1361d82f3$var$Placement;
module.exports["default"] = $17d7b5e1361d82f3$export$2e2bcd8739ae039;

});

parcelRegister("4OYR1", function(module, exports) {

var $jAbAo = parcelRequire("jAbAo");


var $8fXDz = parcelRequire("8fXDz");

const $baf07cb19e3d1dfe$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jAbAo.MessagePerformanceTracker,
    PlacementPerformanceTracker: $8fXDz.PlacementPerformanceTracker
};
module.exports["UFOv1"] = $baf07cb19e3d1dfe$export$96236906ebaa7f87;

});

parcelRegister("jAbAo", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");


var $8UDja = parcelRequire("8UDja");

class $01005f2678a8118a$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $34VCg.UFOExperience)((0, $8UDja.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $gZFfs.ExperienceTypes).Load,
            platform: {
                component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $34VCg.UFOExperience)(`${(0, $8UDja.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $gZFfs.ExperienceTypes).Load,
            platform: {
                component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}
module.exports["MessagePerformanceTracker"] = $01005f2678a8118a$export$ae5c73c7c4f454e6;

});

parcelRegister("8UDja", function(module, exports) {
const $21c39d458f004fb5$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $21c39d458f004fb5$export$6d482cfa20c9d220 = 'post-office';
module.exports["UFOExperienceNames"] = $21c39d458f004fb5$export$cc7ddf8ca628f6f1;
module.exports["POST_OFFICE_PLATFORM_NAME"] = $21c39d458f004fb5$export$6d482cfa20c9d220;

});

parcelRegister("8fXDz", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");


var $8UDja = parcelRequire("8UDja");

const $e2ea1aa57de97a70$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $gZFfs.ExperienceTypes).Load,
    platform: {
        component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $e2ea1aa57de97a70$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $34VCg.UFOExperience)((0, $8UDja.UFOExperienceNames).PLACEMENT, $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $34VCg.UFOExperience)(`${(0, $8UDja.UFOExperienceNames).PLACEMENT}.${placementId}`, $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}
module.exports["PlacementPerformanceTracker"] = $e2ea1aa57de97a70$export$8b48c2105ba0b35a;

});

parcelRegister("9aSEF", function(module, exports) {
const $94018a62770928ba$export$85183a312807388d = 'postOffice';
const $94018a62770928ba$export$f7109619a5e9e0d6 = 'post-office-frontend';
module.exports["ANALYTICS_SOURCE"] = $94018a62770928ba$export$f7109619a5e9e0d6;

});

parcelRegister("3raeL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $apw3A = parcelRequire("apw3A");

var $jdpvF = parcelRequire("jdpvF");


var $cozmU = parcelRequire("cozmU");

const $04b3f6e864eb8426$export$83d6c58b7ab7ae67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const postOfficeEnvironment = (0, $jdpvF.usePostOfficeEnvironment)();
    let t0;
    if ($[0] !== postOfficeEnvironment.currentEnv || $[1] !== postOfficeEnvironment.envConfigs) {
        t0 = (0, $apw3A.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs);
        $[0] = postOfficeEnvironment.currentEnv;
        $[1] = postOfficeEnvironment.envConfigs;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const postOfficeEnvironment = (0, $jdpvF.usePostOfficeEnvironment)();
    return (0, $cozmU.useMemo)(()=>(0, $apw3A.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};
module.exports["useBuildBasePath"] = $04b3f6e864eb8426$export$83d6c58b7ab7ae67;

});

parcelRegister("gzlgs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7c03d2728886be26240ae9af453c127>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c10068ea3730be40$var$_react = $c10068ea3730be40$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c10068ea3730be40$var$_baseNew = $c10068ea3730be40$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c10068ea3730be40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c10068ea3730be40$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $c10068ea3730be40$var$_react.default.createElement($c10068ea3730be40$var$_baseNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$c10068ea3730be40$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $c10068ea3730be40$var$_default = module.exports.default = $c10068ea3730be40$var$SidebarCollapseIcon;

});

parcelRegister("1pYOd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::87b126ba38d591666b6bb1a2ae894895>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10874b9e5ca41beb$var$_react = $10874b9e5ca41beb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $10874b9e5ca41beb$var$_baseNew = $10874b9e5ca41beb$var$_interopRequireDefault((parcelRequire("gElAV")));
function $10874b9e5ca41beb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10874b9e5ca41beb$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $10874b9e5ca41beb$var$_react.default.createElement($10874b9e5ca41beb$var$_baseNew.default, Object.assign({
        name: "SidebarExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$10874b9e5ca41beb$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $10874b9e5ca41beb$var$_default = module.exports.default = $10874b9e5ca41beb$var$SidebarExpandIcon;

});

parcelRegister("cQUD5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $34VCg = parcelRequire("34VCg");

var $14v7H = parcelRequire("14v7H");


var $fAint = parcelRequire("fAint");

function $2f8cb6b1da1c2a48$var$useUFOExperience(id, config, instanceId) {
    return (0, $cozmU.useMemo)(()=>new (0, $34VCg.UFOExperience)(id, config, instanceId), [
        id,
        config,
        instanceId
    ]);
}
function $2f8cb6b1da1c2a48$export$cdefb2a8b53f879f(key) {
    const experienceObj = (0, $fAint.NavigationExperienceId)[key];
    const experience = $2f8cb6b1da1c2a48$var$useUFOExperience(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
    (0, $14v7H.useUFOComponentExperience)(experience); // this hook starts the experience and aborts it when the component is unmounted
    return experience;
}
function $2f8cb6b1da1c2a48$export$15f9dc99109fec75(key) {
    const experienceObj = (0, $fAint.NavigationExperienceId)[key];
    return new (0, $34VCg.UFOExperience)(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
}
module.exports["useExperienceTracker"] = $2f8cb6b1da1c2a48$export$cdefb2a8b53f879f;
module.exports["createExperienceTracker"] = $2f8cb6b1da1c2a48$export$15f9dc99109fec75;

});

parcelRegister("ivert", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdccba3d7742a12d1dd259bf333308d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d78653211ce9e783$var$_react = $d78653211ce9e783$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d78653211ce9e783$var$_baseNew = $d78653211ce9e783$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d78653211ce9e783$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d78653211ce9e783$var$TemplateIcon = (props)=>/*#__PURE__*/ $d78653211ce9e783$var$_react.default.createElement($d78653211ce9e783$var$_baseNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$d78653211ce9e783$var$TemplateIcon.displayName = 'TemplateIcon';
var $d78653211ce9e783$var$_default = module.exports.default = $d78653211ce9e783$var$TemplateIcon;

});

parcelRegister("kqIWy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    let t3;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t3 = {
            variables: {
                spaceKey: spaceKey,
                includeSpaceTypeSettings: includeSpaceTypeSettings
            }
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    const options = t3;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), options);
    let t4;
    if ($[5] !== data || $[6] !== includeSpaceTypeSettings) {
        t4 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[5] = data;
        $[6] = includeSpaceTypeSettings;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== error || $[9] !== loading || $[10] !== t4) {
        t5 = {
            loading: loading,
            data: t4,
            error: error
        };
        $[8] = error;
        $[9] = loading;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("epLE5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $cozmU.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("vkiEA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::282b63b14f5d8b9b1a4035ff1652d30e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05e2a47ee66e67f2$var$_react = $05e2a47ee66e67f2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $05e2a47ee66e67f2$var$_baseNew = $05e2a47ee66e67f2$var$_interopRequireDefault((parcelRequire("gElAV")));
function $05e2a47ee66e67f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05e2a47ee66e67f2$var$LogOutIcon = (props)=>/*#__PURE__*/ $05e2a47ee66e67f2$var$_react.default.createElement($05e2a47ee66e67f2$var$_baseNew.default, Object.assign({
        name: "LogOutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$05e2a47ee66e67f2$var$LogOutIcon.displayName = 'LogOutIcon';
var $05e2a47ee66e67f2$var$_default = module.exports.default = $05e2a47ee66e67f2$var$LogOutIcon;

});

parcelRegister("4ri4I", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $kBr4q.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $kBr4q.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("cxu5H", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $4PNpW.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("6AG3B", function(module, exports) {
const $ad71aceb64f29d5c$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $ad71aceb64f29d5c$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $ad71aceb64f29d5c$export$6c053e1694ef181c = {
    prod: $ad71aceb64f29d5c$export$31048cb2a0753b12,
    staging: $ad71aceb64f29d5c$export$9d8f18312db80469
};
const $ad71aceb64f29d5c$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $ad71aceb64f29d5c$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $ad71aceb64f29d5c$export$54e3fc09a2a3347a;

});

parcelRegister("b5YqG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6AG3B = parcelRequire("6AG3B");


var $hnuQ8 = parcelRequire("hnuQ8");

function $a68332960b9f5309$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $cozmU.useRef)();
    const firedViewedUIEventId = (0, $cozmU.useRef)();
    const mapToCcpProductKeys = (0, $cozmU.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $6AG3B.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $6AG3B.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $cozmU.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $cozmU.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $cozmU.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $a68332960b9f5309$export$c2095165ae2bdcda;

});

parcelRegister("hnuQ8", function(module, exports) {
const $a675bd78c3704abb$export$c536a7e29a0739b8 = 'crossFlow';
var $a675bd78c3704abb$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $a675bd78c3704abb$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $a675bd78c3704abb$export$285f3d0989f9023f;

});

parcelRegister("9Z1sw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eq95w = parcelRequire("eq95w");


var $cozmU = parcelRequire("cozmU");


var $ah4BL = parcelRequire("ah4BL");


var $bavCP = parcelRequire("bavCP");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $bDgLe.c)(3);
    const batchContext = (0, $cozmU.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    if (!panelHasContent) return children;
    const t1 = `web-panel-${locationName}`;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: t1
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "@confluence/web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $cozmU.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $cozmU.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, loading: loading, error: error })=>{
        // For transitions, loading and data is true
        if (loading && data) return null;
        if (!renderWhenLoading) {
            if (loading || error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "@confluence/web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("iqPSe", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $6UM2Q = parcelRequire("6UM2Q");


var $gIaMn = parcelRequire("gIaMn");


var $gEtAQ = parcelRequire("gEtAQ");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { html: html, panelId: panelId } = t0;
    const containerRef = (0, $cozmU.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $cozmU.useState)(true);
    let t1;
    if ($[0] !== html) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /"moduleLocation"\s*:\s*"atl\.general"/;
            $[2] = t2;
        } else t2 = $[2];
        t1 = html.match(t2);
        $[0] = html;
        $[1] = t1;
    } else t1 = $[1];
    const moduleLocationMatch = t1;
    let t2;
    if ($[3] !== moduleLocationMatch) {
        t2 = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
        $[3] = moduleLocationMatch;
        $[4] = t2;
    } else t2 = $[4];
    const isMatchForActivatable = t2;
    let t3;
    if ($[5] !== isMatchForActivatable || $[6] !== ssrSuccess) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            if (isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false)) {
                if (window?.__HYDRATABLE__) {
                    const scriptElement = container.querySelector("script.ap-iframe-body-script");
                    if (scriptElement) {
                        const scriptContent = scriptElement.textContent || "";
                        const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                        if (match) {
                            const uniqueKey = match[1];
                            const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                            if (iframe) return;
                        }
                    }
                }
                if (ssrSuccess) setSsrSuccess(false);
            }
            (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false));
        };
        $[5] = isMatchForActivatable;
        $[6] = ssrSuccess;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== html || $[9] !== isMatchForActivatable || $[10] !== panelId || $[11] !== ssrSuccess) {
        t4 = [
            html,
            panelId,
            ssrSuccess,
            isMatchForActivatable
        ];
        $[8] = html;
        $[9] = isMatchForActivatable;
        $[10] = panelId;
        $[11] = ssrSuccess;
        $[12] = t4;
    } else t4 = $[12];
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[13] !== html || $[14] !== isMatchForActivatable || $[15] !== panelId || $[16] !== ssrSuccess) {
        t5 = isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6UM2Q.ActivatableComponent), {
            id: panelId ?? "WebPanel",
            triggers: [
                {
                    type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
                }
            ],
            ssrSuccess: ssrSuccess,
            analyticsName: "WebPanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: containerRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
        $[13] = html;
        $[14] = isMatchForActivatable;
        $[15] = panelId;
        $[16] = ssrSuccess;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("6UM2Q", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9s45p = parcelRequire("9s45p");


var $75bK2 = parcelRequire("75bK2");


var $hRdzX = parcelRequire("hRdzX");

const $68e0b10beef6f399$export$1db2f2faaee8467f = (0, $3u0dr.isReactCompilerActiveV2)() ? function ActivatableComponent(t0) {
    const $ = (0, $bDgLe.c)(26);
    const { children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9s45p.makeGate)();
        $[0] = t1;
    } else t1 = $[0];
    const gate = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[1] !== children) {
        t2 = ()=>children;
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    const renderChildren = t2;
    let t3;
    if ($[3] !== analyticsName || $[4] !== createAnalyticsEvent || $[5] !== id || $[6] !== onActivate || $[7] !== triggers) {
        t3 = (reason)=>{
            if (gate?.getStatus() === "suspended") {
                onActivate?.(reason);
                if (analyticsName) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        source: "activatableComponent",
                        action: "activated",
                        actionSubject: "activatableComponent",
                        attributes: {
                            analyticsName: analyticsName,
                            triggers: triggers,
                            boundaryId: id,
                            activationReason: reason
                        }
                    }
                }).fire();
                gate.resolve();
            }
        };
        $[3] = analyticsName;
        $[4] = createAnalyticsEvent;
        $[5] = id;
        $[6] = onActivate;
        $[7] = triggers;
        $[8] = t3;
    } else t3 = $[8];
    const activateComponent = t3;
    let t4;
    if ($[9] !== activateComponent || $[10] !== analyticsName || $[11] !== id || $[12] !== triggers) {
        t4 = {
            triggers: triggers,
            gate: gate,
            activateComponent: activateComponent,
            boundaryId: id,
            analyticsName: analyticsName
        };
        $[9] = activateComponent;
        $[10] = analyticsName;
        $[11] = id;
        $[12] = triggers;
        $[13] = t4;
    } else t4 = $[13];
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)(t4);
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = gate?.getStatus?.();
        $[14] = t5;
    } else t5 = $[14];
    const t6 = analyticsName || id;
    let t7;
    if ($[15] !== activateComponent || $[16] !== id || $[17] !== renderChildren || $[18] !== ssrSuccess || $[19] !== t6 || $[20] !== triggers) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75bK2.Boundary), {
            gate: gate,
            id: id,
            render: renderChildren,
            ssrSuccess: ssrSuccess,
            activateComponent: activateComponent,
            resolved: t5 === "resolved",
            boundaryName: t6,
            triggers: triggers
        });
        $[15] = activateComponent;
        $[16] = id;
        $[17] = renderChildren;
        $[18] = ssrSuccess;
        $[19] = t6;
        $[20] = triggers;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== hostRefWithActivation || $[23] !== id || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: hostRefWithActivation,
            "data-hydration-shield": id
        }, t7);
        $[22] = hostRefWithActivation;
        $[23] = id;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function ActivatableComponent({ children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess }) {
    const gate = (0, $cozmU.useMemo)(()=>(0, $9s45p.makeGate)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const renderChildren = (0, $cozmU.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    const activateComponent = (0, $cozmU.useCallback)((reason)=>{
        if (gate?.getStatus() === 'suspended') {
            onActivate?.(reason);
            if (analyticsName) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'activatableComponent',
                    action: 'activated',
                    actionSubject: 'activatableComponent',
                    attributes: {
                        analyticsName: analyticsName,
                        triggers: triggers,
                        boundaryId: id,
                        activationReason: reason
                    }
                }
            }).fire();
            gate.resolve();
        }
    }, [
        gate,
        id,
        onActivate,
        createAnalyticsEvent,
        analyticsName,
        triggers
    ]);
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)({
        triggers: triggers,
        gate: gate,
        activateComponent: activateComponent,
        boundaryId: id,
        analyticsName: analyticsName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: hostRefWithActivation,
        "data-hydration-shield": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75bK2.Boundary), {
        gate: gate,
        id: id,
        render: renderChildren,
        ssrSuccess: ssrSuccess,
        activateComponent: activateComponent,
        resolved: gate?.getStatus?.() === 'resolved',
        boundaryName: analyticsName || id,
        triggers: triggers
    }));
};
module.exports["ActivatableComponent"] = $68e0b10beef6f399$export$1db2f2faaee8467f;

});

parcelRegister("6JxPX", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $c6e5a8cbbcd4e4d4$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$c6e5a8cbbcd4e4d4$var$AkGrid(multiplier * num),
        half: ()=>$c6e5a8cbbcd4e4d4$var$AkGrid(0.5 * num),
        twice: ()=>$c6e5a8cbbcd4e4d4$var$AkGrid(2 * num)
    });
const $c6e5a8cbbcd4e4d4$export$85fc379452d91af0 = $c6e5a8cbbcd4e4d4$var$AkGrid(1);
const $c6e5a8cbbcd4e4d4$export$b9930dabfa4a3a3 = '56px';
const $c6e5a8cbbcd4e4d4$export$f6af7620e8789c39 = '200px';
const $c6e5a8cbbcd4e4d4$export$64d8573e83b64ff8 = '150px';
const $c6e5a8cbbcd4e4d4$export$a3da89b899389ed8 = '780px';
const $c6e5a8cbbcd4e4d4$export$ce4512df260a325a = 780;
const $c6e5a8cbbcd4e4d4$export$a406031ed42c8e02 = '1130px';
const $c6e5a8cbbcd4e4d4$export$e00021bea368c518 = $c6e5a8cbbcd4e4d4$export$85fc379452d91af0.multiple(4);
const $c6e5a8cbbcd4e4d4$export$30310ee354b45eb0 = $c6e5a8cbbcd4e4d4$export$85fc379452d91af0.multiple(6);
module.exports["grid"] = $c6e5a8cbbcd4e4d4$export$85fc379452d91af0;
module.exports["atlassianNavigationHeight"] = $c6e5a8cbbcd4e4d4$export$b9930dabfa4a3a3;
module.exports["collapsedSearchInputWidth"] = $c6e5a8cbbcd4e4d4$export$f6af7620e8789c39;
module.exports["dialogWidth"] = $c6e5a8cbbcd4e4d4$export$a3da89b899389ed8;
module.exports["dialogPageTakeoverWidth"] = $c6e5a8cbbcd4e4d4$export$ce4512df260a325a;
module.exports["dialogPageCentreWidth"] = $c6e5a8cbbcd4e4d4$export$a406031ed42c8e02;
module.exports["inputFieldHeight"] = $c6e5a8cbbcd4e4d4$export$e00021bea368c518;
module.exports["enlargedInputFieldHeight"] = $c6e5a8cbbcd4e4d4$export$30310ee354b45eb0;

});

parcelRegister("aHr8q", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ca2f7f1db0386fa$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $7c1cJ = parcelRequire("7c1cJ");


var $4eov6 = parcelRequire("4eov6");


var $3yGK6 = parcelRequire("3yGK6");

var $7ca2f7f1db0386fa$var$MILLISECONDS_IN_WEEK = 604800000;
function $7ca2f7f1db0386fa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var diff = (0, $7c1cJ.default)(date).getTime() - (0, $4eov6.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $7ca2f7f1db0386fa$var$MILLISECONDS_IN_WEEK) + 1;
}

});

parcelRegister("7c1cJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $53ca968e5cafd3ce$export$2e2bcd8739ae039);

var $8qMNj = parcelRequire("8qMNj");


var $3yGK6 = parcelRequire("3yGK6");

function $53ca968e5cafd3ce$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    return (0, $8qMNj.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});

parcelRegister("4eov6", function(module, exports) {
$parcel$export(module.exports, "default", () => $314b7991eb76028c$export$2e2bcd8739ae039);

var $7LSTy = parcelRequire("7LSTy");


var $7c1cJ = parcelRequire("7c1cJ");


var $3yGK6 = parcelRequire("3yGK6");

function $314b7991eb76028c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var year = (0, $7LSTy.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $7c1cJ.default)(fourthOfJanuary);
    return date;
}

});

parcelRegister("7LSTy", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a87812fe954b524$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $7c1cJ = parcelRequire("7c1cJ");


var $3yGK6 = parcelRequire("3yGK6");

function $5a87812fe954b524$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $7c1cJ.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $7c1cJ.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});

parcelRegister("bMPhU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $bDgLe.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t2,
        __callerPackage__: "@confluence/space-utils"
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<9c89aa0352f7d1dca5a5a1271100cc40>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("lEBcH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1d2d6708d394f801c1e7c6452a7750c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc3a315370b5b847$var$_react = $fc3a315370b5b847$var$_interopRequireDefault((parcelRequire("cozmU")));

var $fc3a315370b5b847$var$_baseNew = $fc3a315370b5b847$var$_interopRequireDefault((parcelRequire("gElAV")));
function $fc3a315370b5b847$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Theme".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing themes and theme switching.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc3a315370b5b847$var$ThemeIcon = (props)=>/*#__PURE__*/ $fc3a315370b5b847$var$_react.default.createElement($fc3a315370b5b847$var$_baseNew.default, Object.assign({
        name: "ThemeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25-5H8a5 5 0 0 1 0 10h-.75z" clip-rule="evenodd"/>`
    }, props));
$fc3a315370b5b847$var$ThemeIcon.displayName = 'ThemeIcon';
var $fc3a315370b5b847$var$_default = module.exports.default = $fc3a315370b5b847$var$ThemeIcon;

});

parcelRegister("jEeDd", function(module, exports) {

var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    return identity;
}
module.exports["getLoginLink"] = $2dd269c5e0cf48e9$export$264b5fa7ee2d3260;

});

parcelRegister("3yh4a", function(module, exports) {

var $8YePs = parcelRequire("8YePs");


var $9wGTI = parcelRequire("9wGTI");

const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $d415184962066c9b$export$cf56d0f54cfcce4;

});

parcelRegister("6ld6a", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $jtuBN = parcelRequire("jtuBN");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery, skipFetchIfCached: skipFetchIfCached } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipFetchIfCached || $[9] !== skipQuery || $[10] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery,
            skipFetchIfCached: skipFetchIfCached
        };
        $[8] = skipFetchIfCached;
        $[9] = skipQuery;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), baseQueryOptions);
    if (!data) {
        let t8;
        let t9;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[12] = t8;
            $[13] = t9;
        } else {
            t8 = $[12];
            t9 = $[13];
        }
        let t10;
        if ($[14] !== error || $[15] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[14] = error;
            $[15] = loading;
            $[16] = t10;
        } else t10 = $[16];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[17] !== allowedWebItems || $[18] !== data || $[19] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        $[17] = allowedWebItems;
        $[18] = data;
        $[19] = notAllowedWebItems;
        $[20] = webItems;
        $[21] = webSections;
    } else {
        webItems = $[20];
        webSections = $[21];
    }
    let t8;
    if ($[22] !== error || $[23] !== webItems || $[24] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[22] = error;
        $[23] = webItems;
        $[24] = webSections;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("kawxu", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $buxP3 = parcelRequire("buxP3");


var $gP9iN = parcelRequire("gP9iN");


var $hgbrK = parcelRequire("hgbrK");

function $9278a0867c7923b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9278a0867c7923b7$var$showAboveQueries = (0, $gP9iN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $9278a0867c7923b7$var$showBelowQueries = (0, $hgbrK.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $9278a0867c7923b7$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $9278a0867c7923b7$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $buxP3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $9278a0867c7923b7$var$defaultHiddenStyles,
            above && $9278a0867c7923b7$var$showAboveQueries[above],
            below && $9278a0867c7923b7$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Show"] = $9278a0867c7923b7$export$f6a3d19be20f5819;

});

parcelRegister("gP9iN", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $lOiVq = parcelRequire("lOiVq");


var $9vEMa = parcelRequire("9vEMa");


var $gnKXs = parcelRequire("gnKXs");

const $43486d63aa94dbc3$export$918f8818cfbbeb2c = (input)=>{
    return (0, $9vEMa.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $gnKXs.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
module.exports["UNSAFE_buildAboveMediaQueryCSS"] = $43486d63aa94dbc3$export$918f8818cfbbeb2c;

});

parcelRegister("9vEMa", function(module, exports) {
const $5e5a55fac3e6fd2a$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $5e5a55fac3e6fd2a$export$2d293d9871c38e91 = Object.keys($5e5a55fac3e6fd2a$export$e5ee4fe8b989fd09);
const $5e5a55fac3e6fd2a$export$b7ed752a57b4177b = $5e5a55fac3e6fd2a$export$2d293d9871c38e91[0];
module.exports["UNSAFE_BREAKPOINTS_ORDERED_LIST"] = $5e5a55fac3e6fd2a$export$2d293d9871c38e91;

});

parcelRegister("hgbrK", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $lOiVq = parcelRequire("lOiVq");


var $9vEMa = parcelRequire("9vEMa");


var $45mGg = parcelRequire("45mGg");

const $b7e4de65fa0c7921$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $9vEMa.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $45mGg.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};
module.exports["UNSAFE_buildBelowMediaQueryCSS"] = $b7e4de65fa0c7921$export$b2a4e2b0c6417297;

});

parcelRegister("2aija", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $buxP3 = parcelRequire("buxP3");


var $gP9iN = parcelRequire("gP9iN");


var $hgbrK = parcelRequire("hgbrK");

const $97165e869498f5e6$var$hideAboveQueries = (0, $gP9iN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $97165e869498f5e6$var$hideBelowQueries = (0, $hgbrK.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $97165e869498f5e6$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $buxP3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $97165e869498f5e6$var$hideAboveQueries[above],
            below && $97165e869498f5e6$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Hide"] = $97165e869498f5e6$export$bed28288a051538;

});

parcelRegister("awSMG", function(module, exports) {
const $4ce470d2dd3584e9$export$6ff460ddb5710005 = 'editor:offline-steps-';
const $4ce470d2dd3584e9$export$7023de141f2ab721 = 'meta';
const $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7 = 'steps';
const $4ce470d2dd3584e9$export$9fd1ded1027f9ea2 = 2;
module.exports["OFFLINE_STEPS_DATABASE_NAME_PREFIX"] = $4ce470d2dd3584e9$export$6ff460ddb5710005;
module.exports["OFFLINE_META_STORE_NAME"] = $4ce470d2dd3584e9$export$7023de141f2ab721;
module.exports["OFFLINE_STEPS_STORE_NAME"] = $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7;
module.exports["OFFLINE_STEPS_DATABASE_VERSION"] = $4ce470d2dd3584e9$export$9fd1ded1027f9ea2;

});

parcelRegister("6wrL8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c2828397bc04eb44$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ltMJ3",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("lPg5a"))).DevToolsDialog
});

const $c2828397bc04eb44$export$edf3a07292eacd91 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "f62AJ",
    name: "LazyDevToolsDialog",
    loader: async ()=>(await (parcelRequire("lPg5a"))).DevToolsDialog
});

const $c2828397bc04eb44$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "xzcSO",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("gsBOn"))).DevToolsBanner
});
module.exports["DevToolsDialog"] = $c2828397bc04eb44$export$23eed8de2215911d;
module.exports["LazyDevToolsDialog"] = $c2828397bc04eb44$export$edf3a07292eacd91;
module.exports["DevToolsBanner"] = $c2828397bc04eb44$export$a08fb8aab8d5eb82;

});

parcelRegister("lPg5a", function(module, exports) {

let $fe3ad608f3597c89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fe3ad608f3597c89$var$load("jzUgs"),
    $fe3ad608f3597c89$var$load("8zMmc"),
    $fe3ad608f3597c89$var$load("6wr18"),
    $fe3ad608f3597c89$var$load("ilUG7"),
    $fe3ad608f3597c89$var$load("efUj2"),
    $fe3ad608f3597c89$var$load("iWnyc"),
    $fe3ad608f3597c89$var$load("ffEVr"),
    $fe3ad608f3597c89$var$load("hhss7"),
    $fe3ad608f3597c89$var$load("Wowvf"),
    $fe3ad608f3597c89$var$load("eRhBr"),
    $fe3ad608f3597c89$var$load("7EorR"),
    $fe3ad608f3597c89$var$load("fYNhh")
]).then(()=>parcelRequire('bFmys'));

});

parcelRegister("gsBOn", function(module, exports) {

let $bfbc976fa724bf2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bfbc976fa724bf2c$var$load("C72jX").then(()=>parcelRequire('5uV65'));

});

parcelRegister("8gF2o", function(module, exports) {
/**
 * Utilities for talking to the Atlassian outbound-auth gateway, which is the
 * canonical source of truth for whether a user has a working OAuth connection
 * to a given Smart Link connector.
 *
 * Why this exists
 * ---------------
 * Previously we relied on the CDS endpoint
 *   GET /gateway/api/third-party-configuration/connected-data-sources/{cloudId}
 * (via `get3pSearchConfig`) to determine both the OAuth start URL and whether
 * the user was already connected. That endpoint has four well-known problems
 * for the Confluence onboarding "Connect your 3P tools" experience:
 *
 *   1. Edition-gated: CDS only works on Standard+ tenants with Rovo
 *      provisioned. Free tier tenants return 403.
 *   2. Lazy-init: the registry behind CDS (ERS) does not have a
 *      `smartlinks-connector-{provider}` row until a Smart Link resolve event
 *      for that provider has fired on the tenant. Brand-new tenants are
 *      effectively empty.
 *   3. Not a definitive provider universe: CDS only enumerates what's already
 *      been touched on this tenant, not what's available to connect.
 *   4. No back-population: even after a user connects via a fallback path,
 *      CDS does not see it (until/unless ERS gets the event), so downstream
 *      surfaces like the post-office banner keep re-prompting.
 *
 * The outbound-auth gateway endpoint
 *   GET /gateway/api/outbound-auth/aaId/{aaId}
 * powers id.atlassian.com/manage-profile/apps. It is cookie-authed (no ASAP
 * needed), works cross-origin from *.atlassian.net, and returns the user's
 * full OAuth-grant list with a per-account `status` field. This is the same
 * data the Atlassian ID Manage Profile UI uses.
 *
 * Canonical container UUIDs come from
 *   ai-3p-connector/connector-service/implementation/src/main/resources/application-prod.yml
 *   ai-3p-connector/connector-service/implementation/src/main/resources/application.yml      (staging)
 * under `linking-platform.providers[]`. The `containerId` + `serviceKey`
 * tuples in the outbound-auth response match those values exactly.
 *
 * Backwards-compat / defensive design
 * -----------------------------------
 *  - All network/parse failures return `null` and let callers fall back to
 *    whatever they were doing before. This module never throws.
 *  - The container maps are `Partial<Record<...>>` and helpers return `null`
 *    when a product has no mapping. Callers are expected to filter such
 *    providers out rather than render broken Connect buttons.
 */ 
var $fR63l = parcelRequire("fR63l");


var $bNe5y = parcelRequire("bNe5y");

// Verified identical in prod and staging gdrive CDS URLs.
const $ee8d2d572fb3c0d4$var$SMARTLINK_GDRIVE_SCOPES = [
    'https://www.googleapis.com/auth/drive.readonly',
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/userinfo.email'
];
const $ee8d2d572fb3c0d4$export$860f54a43e361c13 = {
    [(0, $fR63l.ProductKeys3P).GoogleDrive]: {
        containerId: 'ff32b4a9-0056-4c40-bb6e-eebf3b1d82f7_c50f3d56-68fc-4c3c-8191-6717f173dc54',
        serviceKey: 'gdrive',
        defaultScopes: $ee8d2d572fb3c0d4$var$SMARTLINK_GDRIVE_SCOPES
    },
    [(0, $fR63l.ProductKeys3P).Slack]: {
        containerId: '25ab8ceb-e2e9-4b3a-b4ef-902049561d3a_74232f16-3f89-4bc8-9dcb-b5481bca783e',
        serviceKey: 'slack'
    },
    [(0, $fR63l.ProductKeys3P).OneDrive]: {
        containerId: '00f40f12-faac-4ac8-8d6d-310f96ac97f5_f039c3c2-7e00-41c4-b1cf-70743efbf91a',
        serviceKey: 'onedrive'
    },
    [(0, $fR63l.ProductKeys3P).Sharepoint]: {
        containerId: '7289b5af-9aa4-4977-bb8b-6876502a6466_e7e24a0a-0b03-4ef8-9a83-642e6ef97dbc',
        serviceKey: 'sharepoint'
    },
    [(0, $fR63l.ProductKeys3P).Github]: {
        containerId: 'c364f950-69f5-4812-9716-ed71a8d3d408_a57ca83d-597f-4de9-8dca-f9d3cd18d3a7',
        serviceKey: 'github'
    },
    [(0, $fR63l.ProductKeys3P).Figma]: {
        containerId: '7f89dc0c-5c1e-4b71-997f-220bf92361aa_73fbf758-c657-4f06-8edd-f721911f7f53',
        serviceKey: 'figma'
    },
    [(0, $fR63l.ProductKeys3P).Teams]: {
        containerId: 'fe8ece6c-97b6-45ac-959d-865da9a33409_61030824-303b-4751-bca5-1def33b6b0d0',
        serviceKey: 'ms-teams'
    },
    [(0, $fR63l.ProductKeys3P).Dropbox]: {
        containerId: 'd4d6a241-1008-42cf-b2d6-d0b380c096d6_b6796989-c34a-4e19-a4e1-ccc7655f8fd6',
        serviceKey: 'dropbox'
    },
    [(0, $fR63l.ProductKeys3P).Airtable]: {
        containerId: 'c5805f5a-3e9a-48a5-a8f5-7b04aac4ad16_572b2748-e9b1-4161-b36d-19f962646d1a',
        serviceKey: 'airtable'
    },
    [(0, $fR63l.ProductKeys3P).LaunchDarkly]: {
        containerId: '30ba2eba-6d3f-4124-8060-0ea9a9c9e990_d28912a6-171c-41a2-9adb-1426eccbc767',
        serviceKey: 'launchdarkly'
    },
    [(0, $fR63l.ProductKeys3P).ClickUp]: {
        containerId: '12967bc2-803e-4f8d-9e66-1aa48773a5a4_13a589a5-f514-4b63-a104-7d454b8dc676',
        serviceKey: 'clickup'
    },
    [(0, $fR63l.ProductKeys3P).Pipedrive]: {
        containerId: '1edf2d8e-c159-4ffe-8be0-165821a0ecf1_743950e9-2685-4558-a5b0-ae5d3b47853c',
        serviceKey: 'pipedrive'
    },
    [(0, $fR63l.ProductKeys3P).Gitlab]: {
        containerId: '790bd6ce-7ef8-404a-a9dc-798feb10b12b_049b63cb-90b1-4bfa-aa02-f3fdd9298b03',
        serviceKey: 'gitlab'
    },
    [(0, $fR63l.ProductKeys3P).Docusign]: {
        containerId: '35cd5415-c24c-457e-af7c-ac84df8c8628_0a7329e4-b658-41a1-89c2-419514a5ca08',
        serviceKey: 'docusign'
    },
    [(0, $fR63l.ProductKeys3P).Dovetail]: {
        containerId: 'b51f1664-8705-4938-a9a5-02a7eb3395cb_cba4f674-8eea-43aa-874f-8f16af6b75cb',
        serviceKey: 'dovetail'
    },
    [(0, $fR63l.ProductKeys3P).Box]: {
        containerId: '3a79e004-2e3e-45fe-8a21-84f53568a8ee_35421d47-ad3e-44f5-9cde-60bfa869e0b0',
        serviceKey: 'box'
    },
    [(0, $fR63l.ProductKeys3P).AdobeXD]: {
        containerId: '80c22a47-9ca7-4690-88db-65b375f402a7_ad251cf5-828d-494d-b555-4294d9654173',
        serviceKey: 'adobexd'
    },
    [(0, $fR63l.ProductKeys3P).Asana]: {
        containerId: '2487d697-ed1e-4cf5-9655-f1fb1355c341_a927cae4-3500-4386-9ac3-28e87671c2c8',
        serviceKey: 'asana'
    },
    [(0, $fR63l.ProductKeys3P).Smartsheet]: {
        containerId: '101a27da-d409-4f8c-9c75-326eec4fd5d4_fe89f892-8c94-4574-88f7-5898c05be186',
        serviceKey: 'smartsheet'
    },
    [(0, $fR63l.ProductKeys3P).Mural]: {
        containerId: 'cc21faf3-19fc-4522-af92-295866ef82e7_373f2501-6f74-4c0f-9bfa-c54cdea00066',
        serviceKey: 'mural'
    },
    [(0, $fR63l.ProductKeys3P).PowerBI]: {
        containerId: '9c59191f-63ab-44b2-a2cb-2f20adc75365_556e62ba-588b-494d-8c6c-b672e50537f6',
        serviceKey: 'power-bi'
    },
    [(0, $fR63l.ProductKeys3P).Miro]: {
        containerId: 'd01d8332-4637-4ea4-8b14-17a9d1a61504_a894175f-cb17-4e45-88fa-c348967f379c',
        serviceKey: 'miro'
    },
    [(0, $fR63l.ProductKeys3P).Hubspot]: {
        containerId: 'da0f0482-f78f-4eec-b7e6-0bc98ca5a54c_707406e8-d607-427a-b32e-e1d4710c0f2d',
        serviceKey: 'hubspot'
    },
    [(0, $fR63l.ProductKeys3P).Notion]: {
        containerId: '2bc172f6-c553-4fe1-85d4-3e2e087f84f6_be0969ca-ea7e-4685-abaa-7de142c01b36',
        serviceKey: 'notion'
    },
    [(0, $fR63l.ProductKeys3P).Sentry]: {
        containerId: '977cb3af-b6e9-4450-9ce5-bf40f9c73dff_3a8bcf5e-44ab-4f5b-b18d-340027b6a97e',
        serviceKey: 'sentry'
    },
    [(0, $fR63l.ProductKeys3P).PagerDuty]: {
        containerId: '49cdc160-0ad5-4dbf-adad-6a57fb082774_5cef1b1a-44aa-409e-97b3-b90065cbb39e',
        serviceKey: 'pagerduty'
    },
    [(0, $fR63l.ProductKeys3P).Salesforce]: {
        containerId: '2b45cadc-67a2-4902-8148-03e4de5ba747_db858b85-c098-45e7-96c8-9ccc9caf72da',
        serviceKey: 'salesforce'
    },
    [(0, $fR63l.ProductKeys3P).Amplitude]: {
        containerId: '1e30cfdf-cceb-43f4-b34a-dde94e1f9b21_939acc6f-274a-42da-acdc-8af5a14fe698',
        serviceKey: 'amplitude'
    },
    [(0, $fR63l.ProductKeys3P).Lucid]: {
        containerId: '9262005e-5c1a-49af-9ec0-4a354f581c73_80f25935-3f1f-40e1-9b2a-35db54297ebf',
        serviceKey: 'lucid'
    },
    [(0, $fR63l.ProductKeys3P).Zeplin]: {
        containerId: 'a401d4f0-b3d1-4b64-a85d-3952bd42d9a7_3da3c5e7-89db-4330-878f-dff1fe878556',
        serviceKey: 'zeplin'
    },
    [(0, $fR63l.ProductKeys3P).Todoist]: {
        containerId: '0202ace9-65df-40e3-b539-d831b446dad9_c7809c53-31e9-4fc0-8df9-8b8dcb418bb8',
        serviceKey: 'todoist'
    },
    [(0, $fR63l.ProductKeys3P).Stripe]: {
        containerId: 'bb81e8b8-7d0d-4a24-bb5b-acf31ab97bbc_f38b2a60-30a9-4abd-9086-efb78f6986ce',
        serviceKey: 'stripe'
    },
    [(0, $fR63l.ProductKeys3P).AzureDevops]: {
        // Sourced from ai-3p-connector application-prod.yml
        // (permission.linking-platform-info[container=6b34a992…]).
        containerId: '6b34a992-af2a-4a16-8a4d-89038c48a355_719d2d91-a89a-46f5-bacc-e3baf87d21c8',
        serviceKey: 'azuredevops'
    },
    [(0, $fR63l.ProductKeys3P).Webex]: {
        // Sourced from ai-3p-connector application-prod.yml
        // (permission.linking-platform-info[container=18025f11…]).
        containerId: '18025f11-aafe-49ca-ad45-d48f7005e459_19846c70-0c88-44f6-a7c1-d5bdd77c606c',
        serviceKey: 'webex'
    }
};
const $ee8d2d572fb3c0d4$export$e25d6f2386134a66 = {
    [(0, $fR63l.ProductKeys3P).GoogleDrive]: {
        containerId: '2357cbb7-bf5c-4fe4-a9c6-c8e172ccb5b1_3b53863d-a6bb-4818-91da-4de04f975f48',
        serviceKey: 'gdrive',
        defaultScopes: $ee8d2d572fb3c0d4$var$SMARTLINK_GDRIVE_SCOPES
    },
    [(0, $fR63l.ProductKeys3P).Slack]: {
        containerId: '32a368b4-220e-45a9-b65f-df104dc2e559_7ab21f60-b89a-44c1-bed3-00282c3e7b9e',
        serviceKey: 'slack'
    },
    [(0, $fR63l.ProductKeys3P).OneDrive]: {
        containerId: '6b74c0f8-ce5e-43b0-a68e-eba0fed27cea_4254f605-625b-4026-904a-bdf8ee6de413',
        serviceKey: 'onedrive'
    },
    [(0, $fR63l.ProductKeys3P).Sharepoint]: {
        containerId: '03d0881e-f10f-4751-ab11-27592812060e_b269c883-58b9-463a-9b77-50b6cd8da5fc',
        serviceKey: 'sharepoint'
    },
    [(0, $fR63l.ProductKeys3P).Github]: {
        containerId: '9bb160f8-1abb-4dc8-9780-ca5327e7ccc8_91300e36-3710-4f7b-aba2-95f43be1ac6f',
        serviceKey: 'github'
    },
    [(0, $fR63l.ProductKeys3P).Figma]: {
        containerId: '652e701c-09ac-4e05-bd96-4c95b5c8cac5_ccaebdc1-68e5-406a-b1f4-efcc5962aa40',
        serviceKey: 'figma'
    },
    [(0, $fR63l.ProductKeys3P).Teams]: {
        containerId: 'd27ee9f8-f60b-4076-910b-f16da23b7df4_b3763282-4b2e-4b4b-b924-3c8ba8f6e218',
        serviceKey: 'ms-teams'
    },
    [(0, $fR63l.ProductKeys3P).Dropbox]: {
        containerId: 'd7a3169c-13c8-4b76-96b6-e8f9f849313d_d73e8370-9035-494d-ae16-20854375cb6f',
        serviceKey: 'dropbox'
    },
    [(0, $fR63l.ProductKeys3P).Airtable]: {
        containerId: '070278f6-260c-420f-be4f-a7942a712c23_c2fe283b-51d2-4a0a-8e7f-4ce1199e0a10',
        serviceKey: 'airtable'
    },
    [(0, $fR63l.ProductKeys3P).LaunchDarkly]: {
        containerId: 'd63e3423-0a85-461f-9650-7f26342c62bf_49e197a6-c428-442e-a5ca-f9d4889c82d8',
        serviceKey: 'launchdarkly'
    },
    [(0, $fR63l.ProductKeys3P).ClickUp]: {
        containerId: 'fe20ccd3-b054-4139-aacb-8d98e086c16d_0b40b3c7-4c18-40e3-a030-101c94347723',
        serviceKey: 'clickup'
    },
    [(0, $fR63l.ProductKeys3P).Pipedrive]: {
        containerId: '6012b82a-da48-44ff-af6e-da1c73b279f6_e6a2cefa-c9fe-4d50-b8ea-36391a2d41e6',
        serviceKey: 'pipedrive'
    },
    [(0, $fR63l.ProductKeys3P).Gitlab]: {
        containerId: 'a7b83eeb-482d-402d-b87d-21ede67e73ed_3082dfec-249f-45d9-b84d-b49d256874e9',
        serviceKey: 'gitlab'
    },
    [(0, $fR63l.ProductKeys3P).Docusign]: {
        containerId: 'ec9d65b4-72ee-4030-8dd1-e393026cf335_f4f50986-99a8-4f96-8b52-917d4c6bbbb7',
        serviceKey: 'docusign'
    },
    [(0, $fR63l.ProductKeys3P).Dovetail]: {
        containerId: 'f9a3bf31-88d5-4b5a-80c2-cc32670259a2_c0c8e23b-ec93-45bb-928c-91b9671f0041',
        serviceKey: 'dovetail'
    },
    [(0, $fR63l.ProductKeys3P).Box]: {
        containerId: '43cd20d8-11a7-4910-8789-06523fb2e6db_957783c9-4448-4d91-93dc-0ad7b24a327a',
        serviceKey: 'box'
    },
    [(0, $fR63l.ProductKeys3P).AdobeXD]: {
        containerId: 'c1225a08-acd6-4908-84a7-d5b573f14cc1_e701a1e0-b819-4077-99ac-0b3525510c66',
        serviceKey: 'adobexd'
    },
    [(0, $fR63l.ProductKeys3P).Asana]: {
        containerId: '35462eee-abe5-4873-ba7a-610d4c85f640_cb8525b3-26b3-467d-b42c-cb944e912311',
        serviceKey: 'asana'
    },
    [(0, $fR63l.ProductKeys3P).Smartsheet]: {
        containerId: '48cb55a0-db03-4ce4-8f76-1f986f734652_e6b58d0f-fa9f-4543-9b67-5957b73dee6f',
        serviceKey: 'smartsheet'
    },
    [(0, $fR63l.ProductKeys3P).Mural]: {
        containerId: '95d1bad0-96d7-40a8-996f-b8226dfd8fa1_d6095215-c4a5-4be1-bdd9-7065ed65ae37',
        serviceKey: 'mural'
    },
    [(0, $fR63l.ProductKeys3P).PowerBI]: {
        containerId: 'ea3c5a46-228c-47ea-8c4b-f18e0f17fe8c_abc5ee35-a08c-4481-aa26-0439ce58b4c4',
        serviceKey: 'power-bi'
    },
    [(0, $fR63l.ProductKeys3P).Miro]: {
        containerId: 'e37bcd89-df89-4e65-90f9-98a92fa2dbd0_7c1ec941-d9e7-40be-96fb-69fae6b6bfd2',
        serviceKey: 'miro'
    },
    [(0, $fR63l.ProductKeys3P).Hubspot]: {
        containerId: 'aca58c62-2fb0-4abc-93f0-08bc704ab82a_c39eff84-66f8-4fa9-bb75-768ac83b5f6d',
        serviceKey: 'hubspot'
    },
    [(0, $fR63l.ProductKeys3P).Notion]: {
        containerId: '60913f14-f7e5-465a-9df7-a5f7974caad6_80617f98-fa46-4b5e-9c8e-a54bc42b7c3e',
        serviceKey: 'notion'
    },
    [(0, $fR63l.ProductKeys3P).Sentry]: {
        containerId: '59ec4558-3649-433e-a6b9-7964ae040b78_39660d3a-f2c9-446a-9a53-db433bbc7c2d',
        serviceKey: 'sentry'
    },
    [(0, $fR63l.ProductKeys3P).PagerDuty]: {
        containerId: '2db77a65-0037-45ea-9f57-642051d86ff5_dd18e9a6-e52a-4b80-9a2f-1aa487c9f747',
        serviceKey: 'pagerduty'
    },
    [(0, $fR63l.ProductKeys3P).Salesforce]: {
        containerId: 'd62184e4-87e4-41b2-9321-8b3c1dede9d7_433a0c54-84d5-41ee-9c21-684887b34330',
        serviceKey: 'salesforce'
    },
    [(0, $fR63l.ProductKeys3P).Amplitude]: {
        containerId: '953d4aed-a528-4a5e-9f84-fe42741063f5_eed898af-fb54-4a76-ba73-8d6261639a1a',
        serviceKey: 'amplitude'
    },
    [(0, $fR63l.ProductKeys3P).Lucid]: {
        containerId: 'd188e82f-311c-429d-a17f-bde97037890e_937a3756-c797-4f04-bde1-3eba582b91cf',
        serviceKey: 'lucid'
    },
    [(0, $fR63l.ProductKeys3P).Zeplin]: {
        containerId: '2e14b294-385f-4d3c-a0a0-3e29e1f3a30b_f156da1b-5880-4fc1-ae67-2581ab8fda87',
        serviceKey: 'zeplin'
    },
    [(0, $fR63l.ProductKeys3P).Todoist]: {
        containerId: '6ff1e497-21ac-4f8e-ac74-b869e2c3f274_0f5c1a58-fdae-41ae-841d-2bc5a2875c38',
        serviceKey: 'todoist'
    },
    [(0, $fR63l.ProductKeys3P).Stripe]: {
        containerId: '48824814-f7d3-465a-9535-f589940c8e5a_8a330cd4-3af2-4c32-8c8e-8e751a3fad8a',
        serviceKey: 'stripe'
    },
    [(0, $fR63l.ProductKeys3P).AzureDevops]: {
        // containerId sourced from the canonical Confluence page
        // (page id 6649924469). serviceKey assumed identical to prod —
        // ai-3p-connector's application-staging.yml does NOT declare a
        // per-provider serviceKey for Azure DevOps, but every other
        // provider in this file uses the same serviceKey across both
        // environments, so the prod value is the safe assumption.
        containerId: '784f3542-1a1d-4f49-8769-f3c2cb1e83b3_b91efd28-4d10-43d4-bcae-a5b0fef72bb1',
        serviceKey: 'azuredevops'
    },
    [(0, $fR63l.ProductKeys3P).Webex]: {
        // containerId sourced from the canonical Confluence page
        // (page id 6649924469). serviceKey assumed identical to prod
        // (see note on AzureDevops above).
        containerId: 'ead13644-c3c5-4f8d-8d31-58be86dc7c8e_cedff546-1b81-4f3c-b65d-30c4cb2d8c61',
        serviceKey: 'webex'
    }
};
const $ee8d2d572fb3c0d4$var$ATLASSIAN_ID_BASE_URLS = {
    prod: 'https://id.atlassian.com',
    staging: 'https://id.stg.internal.atlassian.com'
};
const $ee8d2d572fb3c0d4$var$CONTAINER_MAPS = {
    prod: $ee8d2d572fb3c0d4$export$860f54a43e361c13,
    staging: $ee8d2d572fb3c0d4$export$e25d6f2386134a66
};
const $ee8d2d572fb3c0d4$var$isProdHostname = ()=>{
    if (typeof window === 'undefined' || !window.location) return true;
    return window.location.hostname.endsWith('.atlassian.net');
};
const $ee8d2d572fb3c0d4$var$getEnvFromHostname = ()=>$ee8d2d572fb3c0d4$var$isProdHostname() ? 'prod' : 'staging';
const $ee8d2d572fb3c0d4$export$d73c6d475285293 = (payload)=>{
    if (!payload || !Array.isArray(payload.containers) || payload.containers.length === 0) return null;
    const prodUuids = new Set(Object.values($ee8d2d572fb3c0d4$export$860f54a43e361c13).map((m)=>m?.containerId));
    const stagingUuids = new Set(Object.values($ee8d2d572fb3c0d4$export$e25d6f2386134a66).map((m)=>m?.containerId));
    let prodHits = 0;
    let stagingHits = 0;
    for (const c of payload.containers){
        const id = c.container?.containerId;
        if (!id) continue;
        if (prodUuids.has(id)) prodHits++;
        if (stagingUuids.has(id)) stagingHits++;
    }
    if (prodHits === 0 && stagingHits === 0) return null;
    return prodHits >= stagingHits ? 'prod' : 'staging';
};
const $ee8d2d572fb3c0d4$var$getAtlassianIdBaseUrl = (env)=>$ee8d2d572fb3c0d4$var$ATLASSIAN_ID_BASE_URLS[env];
const $ee8d2d572fb3c0d4$var$getContainerMap = (env)=>$ee8d2d572fb3c0d4$var$CONTAINER_MAPS[env];
const $ee8d2d572fb3c0d4$export$50ff30f26c11fe5f = async (aaId, { forceRefresh: forceRefresh = false } = {})=>{
    if (!aaId) return null;
    try {
        const response = await (0, $bNe5y.fetchAccountsByAaId)({
            aaid: aaId,
            // When `forceRefresh` is true, bypass the cache (always hit the
            // gateway). Otherwise, prefer cached values over the network when
            // they are still warm — the post-office banner re-mounts on most
            // navigation events and we don't want to thrash the gateway.
            onlyRefreshIfExpired: !forceRefresh,
            returnExpired: true
        });
        if (!response || !Array.isArray(response.containers)) return null;
        return response;
    } catch  {
        return null;
    }
};
const $ee8d2d572fb3c0d4$export$6d3a2e8837b79055 = (payload, productKey, env)=>{
    if (!payload || !Array.isArray(payload.containers) || payload.containers.length === 0) return false;
    // Prefer the env we detect from the payload itself (deterministic — the
    // gateway can only return UUIDs from one env at a time). Fall back to
    // hostname-based detection only if the payload contains no recognised
    // UUIDs in either map (defensive — should be unreachable since the
    // gateway always returns at least the user's atlassian-token-service-key
    // container, plus any Smart Link grants).
    const resolvedEnv = env ?? $ee8d2d572fb3c0d4$export$d73c6d475285293(payload) ?? $ee8d2d572fb3c0d4$var$getEnvFromHostname();
    const mapping = $ee8d2d572fb3c0d4$var$getContainerMap(resolvedEnv)[productKey];
    if (!mapping) return false;
    const matchingContainer = payload.containers.find((c)=>c.container?.containerId === mapping.containerId);
    if (!matchingContainer) return false;
    const services = Array.isArray(matchingContainer.services) ? matchingContainer.services : [];
    // Filter services by the expected serviceKey. For unique-container
    // providers this is a no-op (one service per container). For shared
    // containers it ensures we only look at accounts owned by the right
    // service.
    const matchingServices = services.filter((s)=>s.service?.serviceKey === mapping.serviceKey);
    return matchingServices.some((s)=>(Array.isArray(s.accounts) ? s.accounts : []).some((account)=>account.status === 'available'));
};
const $ee8d2d572fb3c0d4$export$8acaf25597d6f4b9 = (productKey, env)=>{
    const resolvedEnv = env ?? $ee8d2d572fb3c0d4$var$getEnvFromHostname();
    const mapping = $ee8d2d572fb3c0d4$var$getContainerMap(resolvedEnv)[productKey];
    if (!mapping) return null;
    const baseUrl = $ee8d2d572fb3c0d4$var$getAtlassianIdBaseUrl(resolvedEnv);
    const params = new URLSearchParams({
        serviceKey: mapping.serviceKey,
        containerId: mapping.containerId
    });
    if (mapping.defaultScopes?.length) params.set('scopes', mapping.defaultScopes.join(' '));
    // URLSearchParams encodes spaces as '+'; gateway expects RFC 3986 '%20'.
    return `${baseUrl}/outboundAuth/start?${params.toString().replace(/\+/g, '%20')}`;
};
const $ee8d2d572fb3c0d4$export$27e6019a895f8241 = (productKey, env)=>{
    const resolvedEnv = env ?? $ee8d2d572fb3c0d4$var$getEnvFromHostname();
    return Boolean($ee8d2d572fb3c0d4$var$getContainerMap(resolvedEnv)[productKey]);
};
module.exports["detectEnvFromPayload"] = $ee8d2d572fb3c0d4$export$d73c6d475285293;
module.exports["fetchOutboundAuthAccounts"] = $ee8d2d572fb3c0d4$export$50ff30f26c11fe5f;
module.exports["isAuthenticatedForProduct"] = $ee8d2d572fb3c0d4$export$6d3a2e8837b79055;
module.exports["buildSmartLinkAuthUrl"] = $ee8d2d572fb3c0d4$export$8acaf25597d6f4b9;
module.exports["hasSmartLinkContainerMapping"] = $ee8d2d572fb3c0d4$export$27e6019a895f8241;

});

parcelRegister("bNe5y", function(module, exports) {

var $fyjce = parcelRequire("fyjce");


var $9C63M = parcelRequire("9C63M");


var $feBoR = parcelRequire("feBoR");

const $4fb07153bd78bc9f$var$accountsByAaIdCache = (0, $fyjce.promiseCache)({
    name: 'accounts-by-aaid-cache',
    expiration: 1800000 // 30 minutes
});
const $4fb07153bd78bc9f$export$75264ee4f9af0fe1 = async ({ aaid: aaid, onlyRefreshIfExpired: onlyRefreshIfExpired = true, expiration: expiration, degradationCallback: degradationCallback = ()=>{}, cacheAnalyticsCallback: cacheAnalyticsCallback, returnExpired: returnExpired = false })=>{
    const supplier = ()=>{
        const accountsPromise = (0, $feBoR.fetchAccountsByAaIdInternal)(aaid);
        const degrader = new (0, $9C63M.DegradablePromise)(accountsPromise, degradationCallback);
        return degrader.promise();
    };
    const cacheKey = aaid;
    return $4fb07153bd78bc9f$var$accountsByAaIdCache.refreshOnAccessDecorator({
        key: cacheKey,
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback
    });
};
module.exports["fetchAccountsByAaId"] = $4fb07153bd78bc9f$export$75264ee4f9af0fe1;

});

parcelRegister("feBoR", function(module, exports) {

var $kKR0X = parcelRequire("kKR0X");

const $bc7e7cf1bc3ed88d$export$8fc8913ba4f36c51 = async (aaid)=>{
    const url = `/gateway/api/outbound-auth/aaId/${aaid}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new (0, $kKR0X.OutboundAuthApiError)('Failed to fetch accounts by aaId');
    return await response.json();
};
module.exports["fetchAccountsByAaIdInternal"] = $bc7e7cf1bc3ed88d$export$8fc8913ba4f36c51;

});

parcelRegister("kKR0X", function(module, exports) {
/**
 * Type definitions for Outbound Auth service responses
 *
 * These types mirror the response models from the outbound-auth service.
 * Source of truth: https://bitbucket.org/atlassian/outbound-auth/
 * Reference implementation: /src/service/accountManagement.ts
 * API Spec: /docs/content/platform/outbound-auth/swagger.yaml
 */ /**
 * Include fields for controlling what data is returned in account responses
 * Mirrors AtlassianAuthAccount.IncludeFields from outbound-auth service
 */ var $e9dc573f98a366a7$export$9e1d8c9863da0d81 = /*#__PURE__*/ function(IncludeFields) {
    IncludeFields["AccessToken"] = "accessToken";
    IncludeFields["DisplayName"] = "displayName";
    IncludeFields["AaId"] = "aaId";
    IncludeFields["AvatarUrl"] = "avatarUrl";
    IncludeFields["ExternalAccountId"] = "externalAccountId";
    IncludeFields["Expiry"] = "expiry";
    return IncludeFields;
}({});
class $e9dc573f98a366a7$export$7f02dcf7cf9277d8 extends Error {
    constructor(message){
        super(message);
        this.name = 'OutboundAuthApiError';
    }
}
module.exports["OutboundAuthApiError"] = $e9dc573f98a366a7$export$7f02dcf7cf9277d8;

});

parcelRegister("6MlZq", function(module, exports) {
const $2b534f0161088f49$export$f5501c77c624c70 = ()=>{
    /**
	 * DO NOT MODIFY THIS METHOD.
	 * This method has been refactored to return true as part of an effort to remove LaunchDarkly feature flags.
	 * Returning true avoids regressions.
	 * This method will be removed when ALL dependent feature flags have been removed.
	 * This work is being tracked in https://hello.jira.atlassian.cloud/browse/CTIA-2808
	 */ return true;
};
module.exports["useIsCreationDropdownEnabled"] = $2b534f0161088f49$export$f5501c77c624c70;

});

parcelRegister("7yn0t", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4ri4I = parcelRequire("4ri4I");


var $58PBI = parcelRequire("58PBI");

const $41894bf31b7b5c77$export$c6419170331da813 = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { children: children, editSource: t1 } = t0;
    const editSource = t1 === undefined ? "" : t1;
    const preloader = (0, $cozmU.useContext)((0, $58PBI.EditContentButtonPreloaderContext));
    const [doPreload, setDoPreload] = (0, $cozmU.useState)(false);
    const [t2, t3] = (0, $4ri4I.useEditSource)();
    const { editSource: contextEditSource } = t2;
    const { setEditSource: setEditSource } = t3;
    let t4;
    if ($[0] !== editSource || $[1] !== setEditSource) {
        t4 = ()=>{
            setEditSource(editSource);
            setDoPreload(true);
        };
        $[0] = editSource;
        $[1] = setEditSource;
        $[2] = t4;
    } else t4 = $[2];
    const onHover = t4;
    let t5;
    if ($[3] !== children || $[4] !== onHover) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onMouseEnter: onHover,
            onFocus: onHover
        }, children);
        $[3] = children;
        $[4] = onHover;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== contextEditSource || $[7] !== doPreload || $[8] !== editSource || $[9] !== preloader) {
        t6 = editSource === contextEditSource && doPreload && preloader ? preloader({}) : null;
        $[6] = contextEditSource;
        $[7] = doPreload;
        $[8] = editSource;
        $[9] = preloader;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t5 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t5, t6);
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
};
module.exports["CreateContentButtonPreloader"] = $41894bf31b7b5c77$export$c6419170331da813;

});

parcelRegister("3vzuQ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $w6R6I = parcelRequire("w6R6I");


var $3Lgno = parcelRequire("3Lgno");


var $eh6Ml = parcelRequire("eh6Ml");


var $aCJyI = parcelRequire("aCJyI");


var $kMzDv = parcelRequire("kMzDv");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");


var $l6ne5 = parcelRequire("l6ne5");

const $fc14e136f8b50026$var$messages = (0, $kSwu1.defineMessages)({
    connect: {
        id: "confluence-account-setup.third-party-connection-item.connect",
        defaultMessage: "Connect"
    },
    tryAgain: {
        id: "confluence-account-setup.third-party-connection-item.try-again",
        defaultMessage: "Try again"
    },
    failedToConnect: {
        id: "confluence-account-setup.third-party-connection-item.failed-to-connect",
        defaultMessage: "Failed to connect"
    },
    connected: {
        id: "confluence-account-setup.third-party-connection-item.connected",
        defaultMessage: "Connected"
    }
});
const $fc14e136f8b50026$var$styles = {
    errorRow: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    iconTile: "_2rko1qi0 _4cvr1h6o _bfhki8nm _1e0c1txw _1o9zidpf _4t3i1ylp _1bah1h6o _1bsb1ylp",
    marginAuto: "_18u01wug"
};
const $fc14e136f8b50026$export$e4993e229030740d = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { connectorInfo: connectorInfo, isPrimaryButton: isPrimaryButton = false, onConnect: onConnect, onConnected: onConnected, screenName: screenName = 'thirdPartyConnector', showIconTile: showIconTile = false, touchpoint: touchpoint } = props;
    const { fireUIAnalyticEvent: fireUIAnalyticEvent, fireTrackAnalyticEvent: fireTrackAnalyticEvent } = (0, $l6ne5.useFireAnalyticsEvent)(screenName); // Initialise from ground-truth `isAuthenticated` so providers the user is
    // already connected to render the "Connected" lozenge on first paint,
    // instead of a misleading "Connect" CTA. The full fix (hiding already-
    // connected providers from the list entirely) is tracked in CCCEMAU-2984.
    const [status, setStatus] = (0, $cozmU.useState)(connectorInfo.isAuthenticated ? 'success' : 'idle');
    const iconElement = connectorInfo.icon?.({
        label: connectorInfo.displayName,
        size: 'medium'
    });
    const displayName = connectorInfo.displayName;
    const toolType = connectorInfo.productKey;
    const connectButtonStyle = (0, $cozmU.useMemo)(()=>status === 'error' || isPrimaryButton ? undefined : {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
            '--ds-background-brand-bold': "var(--ds-background-success-bold, #5B7F24)",
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
            '--ds-background-brand-bold-hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
            '--ds-background-brand-bold-pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
            backgroundColor: "var(--ds-background-success-bold, #5B7F24)",
            color: "var(--ds-text-inverse, #FFFFFF)"
        }, [
        isPrimaryButton,
        status
    ]);
    const handleConnect = async ()=>{
        const ctaType = status === 'error' ? 'tryAgain' : 'connect';
        fireUIAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartlinkConnect',
            attributes: {
                ctaType: ctaType,
                touchpoint: touchpoint,
                toolType: toolType
            }
        });
        setStatus('loading');
        try {
            if (onConnect) await onConnect();
            else {
                const authUrl = connectorInfo.authUrl;
                if (!authUrl) throw new Error('No authUrl');
                const width = 600;
                const height = 800;
                const left = window.screenX + (window.outerWidth - width) / 2;
                const top = window.screenY + (window.outerHeight - height) / 2;
                const features = `width=${width},height=${height},left=${left},top=${top},status=no,resizable=yes,scrollbars=yes`;
                await (0, $kMzDv.auth)(authUrl, features);
            }
            setStatus('success');
            fireTrackAnalyticEvent({
                action: 'connected',
                actionSubject: 'smartLinkConnectButton',
                attributes: {
                    touchpoint: touchpoint,
                    toolType: toolType
                }
            });
            onConnected?.();
        } catch (error) {
            setStatus('error');
            fireTrackAnalyticEvent({
                action: 'failed',
                actionSubject: 'smartLinkConnectButton',
                attributes: {
                    touchpoint: touchpoint,
                    toolType: toolType
                }
            });
        }
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
        alignItems: "center",
        gap: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
        alignItems: "center",
        gap: "space.150"
    }, showIconTile && iconElement ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $fc14e136f8b50026$var$styles.iconTile
    }, iconElement) : iconElement, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        weight: "medium"
    }, displayName)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($fc14e136f8b50026$var$styles.marginAuto)
    }, status === 'success' ? /*#__PURE__*/ $cozmU.createElement((0, $aCJyI.default), {
        appearance: "success",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml)))
    }, formatMessage($fc14e136f8b50026$var$messages.connected)) : /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
        alignItems: "center",
        gap: "space.100"
    }, status === 'error' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($fc14e136f8b50026$var$styles.errorRow)
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Lgno))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        size: "small",
        color: "color.text.danger"
    }, formatMessage($fc14e136f8b50026$var$messages.failedToConnect))), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: isPrimaryButton ? 'primary' : 'default',
        isLoading: status === 'loading',
        onClick: handleConnect,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        UNSAFE_style: connectButtonStyle
    }, status === 'error' ? formatMessage($fc14e136f8b50026$var$messages.tryAgain) : formatMessage($fc14e136f8b50026$var$messages.connect)))));
};
module.exports["ThirdPartyConnector"] = $fc14e136f8b50026$export$e4993e229030740d;

});

parcelRegister("3Lgno", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7adb5fd03a25925a35432d6cd30431e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2bd276e390ee881b$var$_react = $2bd276e390ee881b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2bd276e390ee881b$var$_baseNew = $2bd276e390ee881b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $2bd276e390ee881b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowDanger".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing statuses that signal critical issues that demand attention
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2bd276e390ee881b$var$StatusWorkflowDangerIcon = (props)=>/*#__PURE__*/ $2bd276e390ee881b$var$_react.default.createElement($2bd276e390ee881b$var$_baseNew.default, Object.assign({
        name: "StatusWorkflowDangerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-7V9h1.5V3.5z" clip-rule="evenodd"/>`
    }, props));
$2bd276e390ee881b$var$StatusWorkflowDangerIcon.displayName = 'StatusWorkflowDangerIcon';
var $2bd276e390ee881b$var$_default = module.exports.default = $2bd276e390ee881b$var$StatusWorkflowDangerIcon;

});

parcelRegister("l6ne5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");


var $a2puN = parcelRequire("a2puN");


var $dEZ8Q = parcelRequire("dEZ8Q");

const $6088849a8d369ddc$export$eed8c476984ddfad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (source)=>{
    const $ = (0, $bDgLe.c)(5);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t0 = (eventType)=>(payload)=>{
                const analyticsEvent = createAnalyticsEvent({
                    ...payload,
                    eventType: eventType,
                    source: source
                });
                analyticsEvent.fire((0, $dEZ8Q.ANALYTICS_CHANNEL));
            };
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t0;
    } else t0 = $[2];
    const fireAnalyticEvent = t0;
    let t1;
    if ($[3] !== fireAnalyticEvent) {
        t1 = {
            fireUIAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).UI),
            fireTrackAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).TRACK),
            fireOperationalAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).OPERATIONAL),
            fireScreenAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).SCREEN)
        };
        $[3] = fireAnalyticEvent;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (source)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticEvent = (eventType)=>(payload)=>{
            const analyticsEvent = createAnalyticsEvent({
                ...payload,
                eventType: eventType,
                source: source
            });
            analyticsEvent.fire((0, $dEZ8Q.ANALYTICS_CHANNEL));
        };
    return {
        fireUIAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).UI),
        fireTrackAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).TRACK),
        fireOperationalAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).OPERATIONAL),
        fireScreenAnalyticEvent: fireAnalyticEvent((0, $a2puN.EVENT_TYPE).SCREEN)
    };
};
module.exports["useFireAnalyticsEvent"] = $6088849a8d369ddc$export$eed8c476984ddfad;

});

parcelRegister("a2puN", function(module, exports) {
var $ec7536ddbfdf8034$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
module.exports["EVENT_TYPE"] = $ec7536ddbfdf8034$export$76a2e4c433c23bb9;

});

parcelRegister("dEZ8Q", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $NF6kd = parcelRequire("NF6kd");

var $l7jo6 = parcelRequire("l7jo6");


var $3d3WW = parcelRequire("3d3WW");

const $1ae0090018311f9c$export$85183a312807388d = 'accountSetup';
const $1ae0090018311f9c$var$isSSR = ()=>typeof window === 'undefined' || typeof document === 'undefined';
const $1ae0090018311f9c$export$1b581a2ec13e37f1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { children: children, analyticsData: analyticsData, analyticsClient: t1 } = t0;
    const providedAnalyticsClient = t1 === undefined ? null : t1;
    const { product: product, cloudId: cloudId, userId: userId, additionalAttributes: additionalAttributes } = analyticsData;
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)(null);
    let t2;
    if ($[0] !== additionalAttributes || $[1] !== analyticsClient || $[2] !== product) {
        t2 = (t3)=>{
            const { payload: payload } = t3;
            analyticsClient?.onEvent?.($1ae0090018311f9c$export$85183a312807388d, {
                ...payload,
                attributes: {
                    ...additionalAttributes,
                    ...payload?.attributes,
                    product: product
                }
            });
        };
        $[0] = additionalAttributes;
        $[1] = analyticsClient;
        $[2] = product;
        $[3] = t2;
    } else t2 = $[3];
    const defaultOnEvent = t2;
    let t3;
    if ($[4] !== additionalAttributes || $[5] !== product) {
        t3 = (event)=>{
            event.update((payload_0)=>({
                    ...payload_0,
                    attributes: {
                        ...additionalAttributes,
                        ...payload_0?.attributes,
                        product: product
                    }
                }));
        };
        $[4] = additionalAttributes;
        $[5] = product;
        $[6] = t3;
    } else t3 = $[6];
    const wacUpdateEvent = t3;
    const onEvent = product === "marketing" ? wacUpdateEvent : defaultOnEvent;
    let t4;
    let t5;
    if ($[7] !== cloudId || $[8] !== product || $[9] !== providedAnalyticsClient || $[10] !== userId) {
        t4 = ()=>{
            if (!$1ae0090018311f9c$var$isSSR()) setAnalyticsClient($1ae0090018311f9c$export$e9ba7ef9458d1a4a({
                product: product,
                cloudId: cloudId,
                userId: userId,
                analyticsClient: providedAnalyticsClient
            }));
        };
        t5 = [
            product,
            cloudId,
            userId,
            setAnalyticsClient,
            providedAnalyticsClient
        ];
        $[7] = cloudId;
        $[8] = product;
        $[9] = providedAnalyticsClient;
        $[10] = userId;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $cozmU.useEffect)(t4, t5);
    if ($1ae0090018311f9c$var$isSSR() || !analyticsClient) {
        let t6;
        if ($[13] !== children) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[13] = children;
            $[14] = t6;
        } else t6 = $[14];
        return t6;
    }
    let t6;
    if ($[15] !== children || $[16] !== onEvent) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            channel: $1ae0090018311f9c$export$85183a312807388d,
            onEvent: onEvent
        }, children);
        $[15] = children;
        $[16] = onEvent;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ children: children, analyticsData: analyticsData, analyticsClient: providedAnalyticsClient = null })=>{
    const { product: product, cloudId: cloudId, userId: userId, additionalAttributes: additionalAttributes } = analyticsData;
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)(null);
    const defaultOnEvent = (0, $cozmU.useCallback)(({ payload: payload })=>{
        analyticsClient?.onEvent?.($1ae0090018311f9c$export$85183a312807388d, {
            ...payload,
            attributes: {
                ...additionalAttributes,
                ...payload?.attributes,
                product: product
            }
        });
    }, [
        analyticsClient,
        additionalAttributes,
        product
    ]);
    const wacUpdateEvent = (0, $cozmU.useCallback)((event)=>{
        event.update((payload_0)=>({
                ...payload_0,
                attributes: {
                    ...additionalAttributes,
                    ...payload_0?.attributes,
                    product: product
                }
            }));
    }, [
        product,
        additionalAttributes
    ]);
    //When calling this from WAC, we see the event is fired twice.
    //Therefore, we are checking if the product is marketing to call the updateEvent,
    //which does not seem to be working in AFM when used.
    const onEvent = product === 'marketing' ? wacUpdateEvent : defaultOnEvent;
    (0, $cozmU.useEffect)(()=>{
        //  Only setup analytics client for SPA rendering since analytics requires window to be defined
        if (!$1ae0090018311f9c$var$isSSR()) setAnalyticsClient($1ae0090018311f9c$export$e9ba7ef9458d1a4a({
            product: product,
            cloudId: cloudId,
            userId: userId,
            analyticsClient: providedAnalyticsClient
        }));
    }, [
        product,
        cloudId,
        userId,
        setAnalyticsClient,
        providedAnalyticsClient
    ]);
    if ($1ae0090018311f9c$var$isSSR() || !analyticsClient) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: $1ae0090018311f9c$export$85183a312807388d,
        onEvent: onEvent
    }, children);
};
// Define default analytic-web-client environment config for now
const $1ae0090018311f9c$var$getAnalyticsEnv = (hostname)=>{
    if (hostname.includes('localhost')) return (0, $l7jo6.envType).LOCAL;
    //  Confluence staging has jira-dev, WAC staging has stg
    if (hostname.includes('jira-dev') || hostname.includes('stg')) return (0, $l7jo6.envType).STAGING;
    return (0, $l7jo6.envType).PROD;
};
const $1ae0090018311f9c$export$e9ba7ef9458d1a4a = ({ product: product, cloudId: cloudId, userId: userId, analyticsClient: analyticsClient })=>{
    const client = analyticsClient ?? new (0, $NF6kd.default)({
        product: product,
        env: $1ae0090018311f9c$var$getAnalyticsEnv(window.location.hostname),
        origin: (0, $l7jo6.originType).WEB
    });
    if (cloudId) client.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, cloudId);
    if (userId) client.setUserInfo((0, $l7jo6.userType).ATLASSIAN_ACCOUNT, userId);
    return client;
};
module.exports["ANALYTICS_CHANNEL"] = $1ae0090018311f9c$export$85183a312807388d;
module.exports["AnalyticsProvider"] = $1ae0090018311f9c$export$1b581a2ec13e37f1;

});

parcelRegister("ez9xU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $jmUhx = parcelRequire("jmUhx");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");


var $eytcg = parcelRequire("eytcg");

const $c25508467e1a19ee$var$triggerStyles = {
    button: "_1dqoglyw _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi _bfhk1j28 _80omtlke _1bsb1osq _irr31dpa",
    text: "_11c8wadc _syaz1rpy"
};
const $c25508467e1a19ee$var$DefaultTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        xcss: $c25508467e1a19ee$var$triggerStyles.button,
        onClick: ()=>open()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        alignItems: "center",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $c25508467e1a19ee$var$triggerStyles.text
    }, formatMessage((0, $eytcg.messages).defaultTriggerLabel))));
};

const $c25508467e1a19ee$var$LazyRovoSettingsModalProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("c0OlF")).then((mod)=>({
            default: mod.RovoSettingsModalLazy
        }))); /**
       * Self-contained entrypoint for the Rovo Settings modal.
       *
       * The trigger renders eagerly. The provider tree and modal
       * are lazy-loaded only when the user first clicks the trigger.
       * Subsequent opens reuse the mounted provider — no re-mount or re-fetch.
       */ 
const $c25508467e1a19ee$export$f2c3f3e62df426ba = ({ children: renderTrigger, ...providerProps })=>{
    const [isActivated, setIsActivated] = (0, $cozmU.useState)(false);
    const pendingOpenOptions = (0, $cozmU.useRef)(undefined);
    const openModalRef = (0, $cozmU.useRef)(null);
    const open = (0, $cozmU.useCallback)((options)=>{
        if (openModalRef.current) // Provider already mounted — open directly
        openModalRef.current(options);
        else {
            // First click — store options and mount the provider
            pendingOpenOptions.current = options;
            setIsActivated(true);
        }
    }, []); // Calling the render function directly (rather than mounting it as a
    // component) makes React diff the returned JSX in-place against the previous
    // render, so the trigger element survives parent re-renders even if the
    // render function's identity changes (e.g. inline arrows).
    const triggerNode = renderTrigger ? renderTrigger({
        open: open
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$DefaultTrigger, {
        open: open
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>null
    }, triggerNode, isActivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$LazyRovoSettingsModalProvider, {
        ...providerProps,
        pendingOpenOptions: pendingOpenOptions,
        openModalRef: openModalRef
    })));
};
module.exports["RovoSettingsModal"] = $c25508467e1a19ee$export$f2c3f3e62df426ba;

});

parcelRegister("c0OlF", function(module, exports) {

let $8bec8a4ae556ba60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8bec8a4ae556ba60$var$load("kT6dz"),
    $8bec8a4ae556ba60$var$load("dBHUb"),
    $8bec8a4ae556ba60$var$load("5Rx9J"),
    $8bec8a4ae556ba60$var$load("6wr18"),
    $8bec8a4ae556ba60$var$load("av7K3"),
    $8bec8a4ae556ba60$var$load("hZVEi"),
    $8bec8a4ae556ba60$var$load("7EorR"),
    $8bec8a4ae556ba60$var$load("fcsnw"),
    $8bec8a4ae556ba60$var$load("ffEVr"),
    $8bec8a4ae556ba60$var$load("eCXJR"),
    $8bec8a4ae556ba60$var$load("1VTX2"),
    $8bec8a4ae556ba60$var$load("ddvkk"),
    $8bec8a4ae556ba60$var$load("3upHR"),
    $8bec8a4ae556ba60$var$load("hhss7"),
    $8bec8a4ae556ba60$var$load("Wowvf"),
    $8bec8a4ae556ba60$var$load("eRhBr"),
    $8bec8a4ae556ba60$var$load("hZ2FX"),
    $8bec8a4ae556ba60$var$load("cKDij")
]).then(()=>parcelRequire('7bLo5'));

});

parcelRegister("7DERG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0c65948d0a153f5$export$92e41deae5b713d0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "c07Cp",
    name: 'ConfluenceSmartCreationModalLoader',
    loader: async ()=>(await (parcelRequire("bsP7V"))).ConfluenceSmartCreationModalManager
});
module.exports["ConfluenceSmartCreationModalLoader"] = $b0c65948d0a153f5$export$92e41deae5b713d0;

});

parcelRegister("bsP7V", function(module, exports) {

let $8589f7f052a20e7d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8589f7f052a20e7d$var$load("gs8si").then(()=>parcelRequire('iaA9H'));

});

parcelRegister("BHGIm", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2d7c1ebdd99982dc$var$initialState = {
    isOpen: false
};
const $2d7c1ebdd99982dc$var$actions = {
    showModal: ({ touchpointId: touchpointId })=>({ setState: setState })=>{
            setState({
                isOpen: true,
                touchpointId: touchpointId
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        }
};
const $2d7c1ebdd99982dc$var$store = (0, $8s9DV.createStore)({
    initialState: $2d7c1ebdd99982dc$var$initialState,
    actions: $2d7c1ebdd99982dc$var$actions,
    name: 'trialPlanComparisonModalStore'
});
const $2d7c1ebdd99982dc$export$9babf328a7e7b769 = (0, $kBr4q.createActionsHook)($2d7c1ebdd99982dc$var$store);
const $2d7c1ebdd99982dc$export$d2b5dd4cfe103c4e = (0, $kBr4q.createHook)($2d7c1ebdd99982dc$var$store);
module.exports["useTrialPlanComparisonModalActions"] = $2d7c1ebdd99982dc$export$9babf328a7e7b769;
module.exports["useTrialPlanComparisonModal"] = $2d7c1ebdd99982dc$export$d2b5dd4cfe103c4e;

});

parcelRegister("3fBqY", function(module, exports) {
const $13dafddd01cc0e12$export$c447f2d04f7089f6 = (data)=>{
    return data?.user?.emails?.some((email)=>email?.value && (email.value.endsWith('@atlassian.com') || email.value.endsWith('@atlassian.com.invalid') || email.value.endsWith('@usersinbuckets.com'))) || false;
};
module.exports["isAtlassianStaff"] = $13dafddd01cc0e12$export$c447f2d04f7089f6;

});

parcelRegister("3oFAV", function(module, exports) {

var $46Ns8 = parcelRequire("46Ns8");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/long-running-task/manifest.ts
var $2793e0ccdc0bc8af$var$confluenceLongRunningTaskAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $46Ns8.ConfluenceLongRunningTaskAriResourceOwner),
    resourceType: (0, $46Ns8.ConfluenceLongRunningTaskAriResourceType),
    resourceIdSlug: "activation/{activationId}/{taskId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        taskId: /[0-9]+/
    }
};
// src/confluence/long-running-task/index.ts
var $2793e0ccdc0bc8af$export$ebd9af01759f4a9a = class _ConfluenceLongRunningTaskAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get taskId() {
        return this._taskId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2793e0ccdc0bc8af$var$confluenceLongRunningTaskAriStaticOpts.qualifier,
            platformQualifier: $2793e0ccdc0bc8af$var$confluenceLongRunningTaskAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2793e0ccdc0bc8af$var$confluenceLongRunningTaskAriStaticOpts.resourceOwner,
            resourceType: $2793e0ccdc0bc8af$var$confluenceLongRunningTaskAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.taskId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                taskId: opts.taskId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $2793e0ccdc0bc8af$var$confluenceLongRunningTaskAriStaticOpts);
        return new _ConfluenceLongRunningTaskAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $2793e0ccdc0bc8af$var$confluenceLongRunningTaskAriStaticOpts);
        return new _ConfluenceLongRunningTaskAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            taskId: this.taskId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._taskId = opts.resourceIdSegmentValues.taskId;
    }
};
module.exports["ConfluenceLongRunningTaskAri"] = $2793e0ccdc0bc8af$export$ebd9af01759f4a9a;

});

parcelRegister("46Ns8", function(module, exports) {
// src/confluence/long-running-task/types.ts
var $2fde1544dc20178b$export$c3f2be88215e7f96 = "confluence", $2fde1544dc20178b$export$d803f499be36f7e2 = "long-running-task";
module.exports["ConfluenceLongRunningTaskAriResourceOwner"] = $2fde1544dc20178b$export$c3f2be88215e7f96;
module.exports["ConfluenceLongRunningTaskAriResourceType"] = $2fde1544dc20178b$export$d803f499be36f7e2;

});

parcelRegister("bnxm6", function(module, exports) {
/**
 * @generated SignedSource<<815a7eec5b335100e928f1957d431d68>>
 * @relayHash 50ebcdd0474c653398920de0204e0d3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b43ca842fc02bd31386938e87cdca2d5726a7e55f51bece2c77eb96a4972c339
const $0598d1e099a39fc5$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "HelpPanelQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "HelpPanelQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "50ebcdd0474c653398920de0204e0d3d",
            "id": "b43ca842fc02bd31386938e87cdca2d5726a7e55f51bece2c77eb96a4972c339",
            "metadata": {},
            "name": "HelpPanelQuery",
            "operationKind": "query",
            "text": "query HelpPanelQuery{user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary}}}"
        }
    };
}();
$0598d1e099a39fc5$var$node.hash = "0ed6e0fbff1bd8304e19c670d1c755dc";
var $0598d1e099a39fc5$export$2e2bcd8739ae039 = $0598d1e099a39fc5$var$node;
module.exports["default"] = $0598d1e099a39fc5$export$2e2bcd8739ae039;

});

parcelRegister("14QAi", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");

const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $jH9cM.isFedRamp)();
    if (isFedrampEnvironment) {
        // Transform help-aggregator paths for FedRAMP environment
        // /gateway/api/help-content/v2/* -> /gateway/api/ha/v2/*
        // Stargate handles routing, so return relative path without domain
        if (url.startsWith('/gateway/api/help-content/v2/')) {
            const pathAfterV2 = url.replace('/gateway/api/help-content/v2', '');
            return `/gateway/api/ha/v2${pathAfterV2}`;
        }
        // For non-help-aggregator paths in FedRAMP, return as-is (relative)
        return url;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

parcelRegister("bQIml", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


const $3dacbbeae0d408d7$export$dc5d1c021e0a8741 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "oTpkC",
    name: "KeyboardShortcutsDialog",
    loader: async ()=>{
        return (await (parcelRequire("boyQO"))).KeyboardShortcutsDialog;
    }
});
module.exports["KeyboardShortcutsDialog"] = $3dacbbeae0d408d7$export$dc5d1c021e0a8741;

});

parcelRegister("boyQO", function(module, exports) {

let $84bcf841c1c24ece$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $84bcf841c1c24ece$var$load("7EorR"),
    $84bcf841c1c24ece$var$load("kHXvF"),
    $84bcf841c1c24ece$var$load("3WCRn")
]).then(()=>parcelRequire('cIjy3'));

});

parcelRegister("gLUd5", function(module, exports) {
$parcel$export(module.exports, "exitBranchFn", () => (parcelRequire("5Z4kM")).exitBranchFn);
$parcel$export(module.exports, "isBranchDeployFn", () => (parcelRequire("5Z4kM")).isBranchDeployFn);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $5Z4kM = parcelRequire("5Z4kM");


//Plain div to display while chunk loads, avoids help menu resizing after loading
// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
const $9708b4b4a3dbcb64$var$loadingDiv = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            width: '100%',
            height: 29
        }
    });

const $9708b4b4a3dbcb64$export$b39479f42d974760 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RVoYJ",
    name: "FeedbackCollectorButton",
    loader: async ()=>(await (parcelRequire("6zA3g"))).FeedbackCollectorButton,
    loading: $9708b4b4a3dbcb64$var$loadingDiv
});

});

parcelRegister("6zA3g", function(module, exports) {

let $4c91fa11207fa1d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4c91fa11207fa1d0$var$load("6wr18"),
    $4c91fa11207fa1d0$var$load("ffEVr"),
    $4c91fa11207fa1d0$var$load("3aT4s")
]).then(()=>parcelRequire('3ZEEP'));

});

parcelRegister("5Z4kM", function(module, exports) {
/* eslint no-restricted-syntax: 0 */ 
var $jiJCD = parcelRequire("jiJCD");


var $68uaC = parcelRequire("68uaC");

const $45b602e848c81a5d$export$28445d8a8237c240 = 'useFrontendBranch';
const $45b602e848c81a5d$export$2db401a6b81eceee = 'useFrontendBuildVersion';
const $45b602e848c81a5d$var$BIFROST_OVERRIDE = 'bifrost-override';
const $45b602e848c81a5d$export$399982ccb22744fa = ()=>{
    const urlComponents = (0, $jiJCD.parse)(window.location.href, true);
    (0, $68uaC.Cookies).remove($45b602e848c81a5d$var$BIFROST_OVERRIDE);
    (0, $68uaC.Cookies).remove($45b602e848c81a5d$export$28445d8a8237c240);
    (0, $68uaC.Cookies).remove($45b602e848c81a5d$export$2db401a6b81eceee);
    window.location.assign((0, $jiJCD.format)({
        path: urlComponents.path,
        query: {
            ...urlComponents.query,
            [$45b602e848c81a5d$export$28445d8a8237c240]: 'off',
            [$45b602e848c81a5d$export$2db401a6b81eceee]: 'off'
        },
        hash: urlComponents.hash
    }));
};
const $45b602e848c81a5d$export$6b1dc8f4a2350eb5 = ()=>{
    let cookieBasedBranchVersion;
    const isBifrost = window.__IS_BIFROST__;
    let bifrostOverrideVersion;
    try {
        cookieBasedBranchVersion = (0, $68uaC.Cookies).get($45b602e848c81a5d$export$28445d8a8237c240);
        if (isBifrost) bifrostOverrideVersion = (0, $68uaC.Cookies).get('bifrost-override');
    } catch (err) {
        // Likely a firefox edge-case: "Error: can't access dead object"
        // Occasionally, document.cookie is cleaned up despite living
        // references -- including js-cookie's
        cookieBasedBranchVersion = 'off';
        if (isBifrost) bifrostOverrideVersion = 'off';
    }
    if (isBifrost) return !!(bifrostOverrideVersion && !bifrostOverrideVersion.includes('CLASSIC-off-off'));
    return !!(cookieBasedBranchVersion && cookieBasedBranchVersion !== 'off');
};
module.exports["exitBranchFn"] = $45b602e848c81a5d$export$399982ccb22744fa;
module.exports["isBranchDeployFn"] = $45b602e848c81a5d$export$6b1dc8f4a2350eb5;

});

parcelRegister("hjhCz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4367945ac32e8223$export$b878bc0015f3472e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LVIQc",
    name: "LazyAddPersonalSpaceDialog",
    loader: async ()=>(await (parcelRequire("7CjuA"))).AddPersonalSpaceDialog
});
module.exports["LazyAddPersonalSpaceDialog"] = $4367945ac32e8223$export$b878bc0015f3472e;

});

parcelRegister("7CjuA", function(module, exports) {

let $58bb33c273777d8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $58bb33c273777d8d$var$load("Wowvf"),
    $58bb33c273777d8d$var$load("iWnyc"),
    $58bb33c273777d8d$var$load("hhss7"),
    $58bb33c273777d8d$var$load("4AAsh")
]).then(()=>parcelRequire('YvPDh'));

});

parcelRegister("6U5eU", function(module, exports) {

var $7rM80 = parcelRequire("7rM80");

const $9db2e529afbaed9d$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $7rM80.createPlacementComponent)(placementId, Component, placementConfigurationOptions);
module.exports["createPlacementComponent"] = $9db2e529afbaed9d$export$8a57effc6307f916;

});

parcelRegister("7rM80", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $eW0ei = parcelRequire("eW0ei");


var $iQwJa = parcelRequire("iQwJa");

var $1RMKR = parcelRequire("1RMKR");


var $gswTK = parcelRequire("gswTK");


var $1NJu1 = parcelRequire("1NJu1");


var $1722n = parcelRequire("1722n");


var $ll379 = parcelRequire("ll379");

var $qzjr4 = parcelRequire("qzjr4");


var $8BCsI = parcelRequire("8BCsI");

const $63c899b662d40d3e$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $8BCsI.withErrorBoundary)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $eW0ei.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, fetch: fetch, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        if ((0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const stableContext = (0, $1RMKR.useStableObject)(context);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gswTK.MaybePlacementFetchingProvider), {
                fetch: fetch?.fetch,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $qzjr4.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: placementConfigurationOptions?.choreographer,
                    subscription: placementConfigurationOptions?.subscription,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    });
const $63c899b662d40d3e$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $63c899b662d40d3e$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $1722n.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $1NJu1.ERROR_BOUNDARY_LOCATION),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};
module.exports["createPlacementComponent"] = $63c899b662d40d3e$export$8a57effc6307f916;

});

parcelRegister("1722n", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c99625c3d1d9a9b2$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $cozmU.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};
module.exports["useComponentErrorHandling"] = $c99625c3d1d9a9b2$export$3d127465d22fe4e5;

});

parcelRegister("5KMtM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aeEJA = parcelRequire("aeEJA");

const $1ae28466f611f1b1$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $cozmU.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $aeEJA.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};
module.exports["useInitialData"] = $1ae28466f611f1b1$export$5523c5f3222291d0;

});

parcelRegister("2tp0D", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $4OYR1 = parcelRequire("4OYR1");

var $jTNdj = parcelRequire("jTNdj");


var $2QUz2 = parcelRequire("2QUz2");


var $k4HA2 = parcelRequire("k4HA2");


var $bBtWi = parcelRequire("bBtWi");


var $b4B1V = parcelRequire("b4B1V");


var $d4rpM = parcelRequire("d4rpM");


var $gKIF0 = parcelRequire("gKIF0");


var $bP5wt = parcelRequire("bP5wt");


var $44R0O = parcelRequire("44R0O");


var $jS1GQ = parcelRequire("jS1GQ");


var $1NVwf = parcelRequire("1NVwf");


var $8BCsI = parcelRequire("8BCsI");


var $82Ab4 = parcelRequire("82Ab4");


var $cozmU = parcelRequire("cozmU");


var $g7aP0 = parcelRequire("g7aP0");


var $1dHYE = parcelRequire("1dHYE");

const $210c900388def499$var$STABLE_EMPTY_OBJECT = {};
const $210c900388def499$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        ...props,
        children: children
    });
};
const $210c900388def499$export$7b7e5a348ef9a7c1 = (messageComponents, placementId, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $cozmU.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, SuspenseBoundary: SuspenseBoundary = (0, $cozmU.Suspense), ...data })=>{
            const isUFOEnabled = (0, $cXtTj.default).checkGate('enable_ufo_tracking_in_post_office');
            /// https://switcheroo.atlassian.com/ui/gates/e8049c84-32d5-4452-a52f-5b92940a1b55/key/post-office_enable-i18n-migration-pull
            const isI18nMigrationInAppEnabled = (0, $cXtTj.default).checkGate('post-office_enable-i18n-migration-pull');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $cozmU.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $4OYR1.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const isChunkLoadError = (error)=>{
                    return error?.name === 'ChunkLoadError';
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        if (!isChunkLoadError(error)) messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $cozmU.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $2QUz2.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $2QUz2.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $cozmU.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
                        name: (0, $jTNdj.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // Client-triggered messages: hydrate must return triggerType at top level
                // (e.g. triggerType: messageContext.triggerType). Single source of truth.
                const triggerType = componentProps.triggerType;
                const hasTrigger = (0, $jS1GQ.isClientTriggeredMessage)(triggerType);
                // Create waitForTrigger for triggered messages
                const { waitForTrigger: waitForTrigger } = (0, $bP5wt.useWaitForTrigger)({
                    hasTrigger: hasTrigger,
                    messageSuccessComponent: messageSuccessComponent,
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory
                });
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                const messageContextValue = (0, $cozmU.useMemo)(()=>({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        triggerId: triggerId,
                        messageCreationType: messageCreationType,
                        transactionAccountId: componentProps.transactionAccountId,
                        analyticsDetails: postOffice?.analyticsDetails,
                        journeyId: journeyId,
                        journeyTriggerId: journeyTriggerId,
                        configSetId: configSetId
                    }), [
                    componentProps.transactionAccountId
                ]);
                // MaybeChoreographerWrapper sits at the top so it can claim its slot while the
                // lazy chunk is loading; it no-ops for client-triggered messages, which handle
                // their own choreography via MaybeTriggeredMessageValidator below.
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1dHYE.MaybeChoreographerWrapper), {
                    ChoreographerWrapper: (0, $g7aP0.ChoreographerWrapper),
                    enabled: !waitForTrigger,
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d4rpM.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $k4HA2.MessageContextProvider), {
                            value: messageContextValue,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $82Ab4.RecommendationProvider), {
                                value: recommendationSession ?? $210c900388def499$var$STABLE_EMPTY_OBJECT,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gKIF0.MaybeTriggeredMessageValidator), {
                                        waitForTrigger: waitForTrigger,
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b4B1V.MessageAnalyticsContextProvider), {
                                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bBtWi.MaybeI18nProvider), {
                                                messageTemplateId: messageTemplateId,
                                                placementId: placementId,
                                                isI18nMigrationInAppEnabled: isI18nMigrationInAppEnabled,
                                                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $44R0O.MaybeManualMessageViewedEvent), {
                                                    isManual: !!waitForTrigger,
                                                    children: [
                                                        !waitForTrigger && messageSuccessComponent,
                                                        /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                                                            onError: onError,
                                                            messageInstanceId: messageInstanceId,
                                                            ...componentProps,
                                                            waitForTrigger: waitForTrigger
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $8BCsI.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                messageTemplateId: messageTemplateId,
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
module.exports["MaybeSuspenseBoundary"] = $210c900388def499$export$9750eb54d7c7e789;
module.exports["asMessageRenderer"] = $210c900388def499$export$7b7e5a348ef9a7c1;

});

parcelRegister("g7aP0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $9TNXZ = parcelRequire("9TNXZ");


var $6NRmI = parcelRequire("6NRmI");


var $cozmU = parcelRequire("cozmU");

const $2adf26225a469e82$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $2adf26225a469e82$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($2adf26225a469e82$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $2adf26225a469e82$export$8db7ba034addcd65;

});

parcelRegister("9l5Wa", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $l90AK = parcelRequire("l90AK");


var $cUcPn = parcelRequire("cUcPn");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $01d7a40871389f25$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $01d7a40871389f25$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("inpAr")));
        case 'da':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("iQO7s")));
        case 'de':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("g0dVc")));
        case 'en-GB':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("ccezZ")));
        case 'en-US':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("ce5RR")));
        case 'en-XA':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("cXWhm")));
        case 'en-XB':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("dv1kb")));
        case 'en-ZZ':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("aLGDo")));
        case 'en':
            return $01d7a40871389f25$var$importHelper(await Promise.resolve((parcelRequire("l90AK"))));
        case 'es':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("c9DYg")));
        case 'et':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("bu1Cy")));
        case 'fi':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("ePVqt")));
        case 'fr':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("eR3K4")));
        case 'hr':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("1LBLE")));
        case 'hu':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("5CyUy")));
        case 'it':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("2mnQ3")));
        case 'ja':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("kpJeT")));
        case 'ko':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("9tLbf")));
        case 'nb':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("bLvFC")));
        case 'nl':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("j9H37")));
        case 'pl':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("fsOUB")));
        case 'pt-BR':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("6f9cc")));
        case 'ro':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("fv67o")));
        case 'ru':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("1Ie67")));
        case 'sl':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("5UNom")));
        case 'sr-RS':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("i31ga")));
        case 'sr-YR':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("aOG9L")));
        case 'sr':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("1zB24")));
        case 'sv':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("6QXgD")));
        case 'th':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("gb2Ls")));
        case 'tr':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("ikpIt")));
        case 'uk':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("6kU66")));
        case 'vi':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("ewUZP")));
        case 'zh-CN':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("4JKuu")));
        case 'zh-TW':
            return $01d7a40871389f25$var$importHelper(await (parcelRequire("9UA9C")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($l90AK));
    }
};
module.exports["messagesLoader"] = $01d7a40871389f25$export$720676d8cac8fbb;

});

parcelRegister("inpAr", function(module, exports) {

let $d60e38fede361f69$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d60e38fede361f69$var$load("gAG2n").then(()=>parcelRequire('cqJsC'));

});

parcelRegister("iQO7s", function(module, exports) {

let $db93f5fd30d00d2b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db93f5fd30d00d2b$var$load("cYGDU").then(()=>parcelRequire('73aeZ'));

});

parcelRegister("g0dVc", function(module, exports) {

let $ba6771fc27168e9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba6771fc27168e9f$var$load("dgXJL").then(()=>parcelRequire('kZGNB'));

});

parcelRegister("ccezZ", function(module, exports) {

let $8e11ea399a9ca9b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e11ea399a9ca9b0$var$load("htu5t").then(()=>parcelRequire('5M0kU'));

});

parcelRegister("ce5RR", function(module, exports) {

let $8e6b580cdaabcac0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e6b580cdaabcac0$var$load("jM7Rj").then(()=>parcelRequire('8npx4'));

});

parcelRegister("cXWhm", function(module, exports) {

let $970833b561b8d5eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $970833b561b8d5eb$var$load("7ybmB").then(()=>parcelRequire('9buhh'));

});

parcelRegister("dv1kb", function(module, exports) {

let $9d3f32a62540d755$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d3f32a62540d755$var$load("fwyLq").then(()=>parcelRequire('biUuj'));

});

parcelRegister("aLGDo", function(module, exports) {

let $7d6f5d714e8908e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d6f5d714e8908e8$var$load("lTboH").then(()=>parcelRequire('cedQ0'));

});

parcelRegister("c9DYg", function(module, exports) {

let $8d9554b3ce493fc6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d9554b3ce493fc6$var$load("iE05k").then(()=>parcelRequire('bamUS'));

});

parcelRegister("bu1Cy", function(module, exports) {

let $85c3c0eae57eb6c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $85c3c0eae57eb6c9$var$load("lJyww").then(()=>parcelRequire('emKLr'));

});

parcelRegister("ePVqt", function(module, exports) {

let $acd25fb386b6a153$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $acd25fb386b6a153$var$load("5GSny").then(()=>parcelRequire('h5z1s'));

});

parcelRegister("eR3K4", function(module, exports) {

let $ad08eb07e8515369$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad08eb07e8515369$var$load("j2X7f").then(()=>parcelRequire('7p8q7'));

});

parcelRegister("1LBLE", function(module, exports) {

let $14977a176b437f36$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14977a176b437f36$var$load("8BwSm").then(()=>parcelRequire('4vnvJ'));

});

parcelRegister("5CyUy", function(module, exports) {

let $417b9501fdbf29b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $417b9501fdbf29b7$var$load("e40mE").then(()=>parcelRequire('hNjwP'));

});

parcelRegister("2mnQ3", function(module, exports) {

let $1b8020ae41996b4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b8020ae41996b4a$var$load("lMhbw").then(()=>parcelRequire('gabko'));

});

parcelRegister("kpJeT", function(module, exports) {

let $edc93c05e58de82c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $edc93c05e58de82c$var$load("8CX31").then(()=>parcelRequire('lRgyf'));

});

parcelRegister("9tLbf", function(module, exports) {

let $6e6b6b900467ec5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e6b6b900467ec5f$var$load("23VWs").then(()=>parcelRequire('9qJkw'));

});

parcelRegister("bLvFC", function(module, exports) {

let $890ca690463af9bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $890ca690463af9bf$var$load("aiYuN").then(()=>parcelRequire('aW8HG'));

});

parcelRegister("j9H37", function(module, exports) {

let $df204041be3d70c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df204041be3d70c4$var$load("gDEvm").then(()=>parcelRequire('aIPP6'));

});

parcelRegister("fsOUB", function(module, exports) {

let $b420f694d5a9ec21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b420f694d5a9ec21$var$load("64nco").then(()=>parcelRequire('8UfjH'));

});

parcelRegister("6f9cc", function(module, exports) {

let $48bb46dbf8b55969$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $48bb46dbf8b55969$var$load("jLbRX").then(()=>parcelRequire('dl49w'));

});

parcelRegister("fv67o", function(module, exports) {

let $b48e7f3dc8f4274d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b48e7f3dc8f4274d$var$load("kuolm").then(()=>parcelRequire('QvS9w'));

});

parcelRegister("1Ie67", function(module, exports) {

let $13f4d604fc830909$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13f4d604fc830909$var$load("6ncWv").then(()=>parcelRequire('aTKYK'));

});

parcelRegister("5UNom", function(module, exports) {

let $44e87ee667863458$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44e87ee667863458$var$load("fJ7ju").then(()=>parcelRequire('5tk2D'));

});

parcelRegister("i31ga", function(module, exports) {

let $d2397bf59c525f90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d2397bf59c525f90$var$load("g3Tkl").then(()=>parcelRequire('4H4Fu'));

});

parcelRegister("aOG9L", function(module, exports) {

let $7dff464781b25c1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7dff464781b25c1e$var$load("8N1b9").then(()=>parcelRequire('3fvX8'));

});

parcelRegister("1zB24", function(module, exports) {

let $1255c933c9fe7f4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1255c933c9fe7f4d$var$load("7JPAU").then(()=>parcelRequire('a0Hkw'));

});

parcelRegister("6QXgD", function(module, exports) {

let $4fd592a1ed831fa9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4fd592a1ed831fa9$var$load("bvBAp").then(()=>parcelRequire('27XGi'));

});

parcelRegister("gb2Ls", function(module, exports) {

let $bc6fd1657bfb7cfd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc6fd1657bfb7cfd$var$load("5wryr").then(()=>parcelRequire('6C7jr'));

});

parcelRegister("ikpIt", function(module, exports) {

let $d57e0afef8b88a47$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d57e0afef8b88a47$var$load("9tUAi").then(()=>parcelRequire('kkNVF'));

});

parcelRegister("6kU66", function(module, exports) {

let $49d0201a376563c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49d0201a376563c1$var$load("5gUdt").then(()=>parcelRequire('jv1A4'));

});

parcelRegister("ewUZP", function(module, exports) {

let $a940441a622ff1c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a940441a622ff1c1$var$load("eftfS").then(()=>parcelRequire('aitGC'));

});

parcelRegister("4JKuu", function(module, exports) {

let $372f6d83736140cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $372f6d83736140cb$var$load("2IMxh").then(()=>parcelRequire('7Xknh'));

});

parcelRegister("9UA9C", function(module, exports) {

let $7375637a400a0dce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7375637a400a0dce$var$load("QI1kr").then(()=>parcelRequire('gqPm8'));

});

parcelRegister("eaqtE", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $9UEKm = parcelRequire("9UEKm");


var $cUcPn = parcelRequire("cUcPn");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3338d8d57db1759a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $3338d8d57db1759a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("T0DBV")));
        case 'da':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("4rnG6")));
        case 'de':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("hcc5H")));
        case 'en-GB':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("7P5xH")));
        case 'en-US':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("gLMuS")));
        case 'en-XA':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("tsPTc")));
        case 'en-XB':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("kpuRB")));
        case 'en-ZZ':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("gvMdu")));
        case 'en':
            return $3338d8d57db1759a$var$importHelper(await Promise.resolve((parcelRequire("9UEKm"))));
        case 'es':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("epPtr")));
        case 'et':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("9kKq1")));
        case 'fi':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("cNuY3")));
        case 'fr':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("8ZR5H")));
        case 'hr':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("kUHWb")));
        case 'hu':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("6Naho")));
        case 'it':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("774Ai")));
        case 'ja':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("9AHDY")));
        case 'ko':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("d7WH4")));
        case 'nb':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("ji2tA")));
        case 'nl':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("i9m1s")));
        case 'pl':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("iAthU")));
        case 'pt-BR':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("luIhB")));
        case 'ro':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("5Xidp")));
        case 'ru':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("eUrQo")));
        case 'sl':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("jr7Ti")));
        case 'sr-RS':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("hvBrV")));
        case 'sr-YR':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("fBcWz")));
        case 'sr':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("aZKQY")));
        case 'sv':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("7uH4q")));
        case 'th':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("auyEA")));
        case 'tr':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("auLEI")));
        case 'uk':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("9zsK0")));
        case 'vi':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("8Ocbg")));
        case 'zh-CN':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("jZfyc")));
        case 'zh-TW':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("7lBAh")));
        case 'zh':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("jZfyc")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9UEKm));
    }
};
module.exports["messagesLoader"] = $3338d8d57db1759a$export$720676d8cac8fbb;

});

parcelRegister("T0DBV", function(module, exports) {

let $0a55a1d6cd9a1cff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a55a1d6cd9a1cff$var$load("3feYV").then(()=>parcelRequire('ezhgc'));

});

parcelRegister("4rnG6", function(module, exports) {

let $33bc0d025e59d4b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $33bc0d025e59d4b6$var$load("7Q1SM").then(()=>parcelRequire('1FQHT'));

});

parcelRegister("hcc5H", function(module, exports) {

let $c84cefad34d7b450$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c84cefad34d7b450$var$load("7JdzX").then(()=>parcelRequire('cDV05'));

});

parcelRegister("7P5xH", function(module, exports) {

let $5b219878d382c28a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b219878d382c28a$var$load("24LNf").then(()=>parcelRequire('iG1MR'));

});

parcelRegister("gLMuS", function(module, exports) {

let $c356a7a11c0c8ad6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c356a7a11c0c8ad6$var$load("70Taf").then(()=>parcelRequire('c2UOk'));

});

parcelRegister("tsPTc", function(module, exports) {

let $058913c324fe5fef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $058913c324fe5fef$var$load("1H1DU").then(()=>parcelRequire('c15fn'));

});

parcelRegister("kpuRB", function(module, exports) {

let $edbe154adf9db8f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $edbe154adf9db8f4$var$load("5GytV").then(()=>parcelRequire('ajyyK'));

});

parcelRegister("gvMdu", function(module, exports) {

let $c054f15ff46b748a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c054f15ff46b748a$var$load("cnlNg").then(()=>parcelRequire('fu2us'));

});

parcelRegister("epPtr", function(module, exports) {

let $a7eb5420b4c8578c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a7eb5420b4c8578c$var$load("9Uf61").then(()=>parcelRequire('6U3Wd'));

});

parcelRegister("9kKq1", function(module, exports) {

let $6cb9fd1e8965e155$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6cb9fd1e8965e155$var$load("2hqQb").then(()=>parcelRequire('hkhaC'));

});

parcelRegister("cNuY3", function(module, exports) {

let $95121529bf623937$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $95121529bf623937$var$load("fJSEb").then(()=>parcelRequire('aZo8e'));

});

parcelRegister("8ZR5H", function(module, exports) {

let $68cd33f78ee60d1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68cd33f78ee60d1b$var$load("9TeWr").then(()=>parcelRequire('jHH9j'));

});

parcelRegister("kUHWb", function(module, exports) {

let $f39b1eb0c87177aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f39b1eb0c87177aa$var$load("bvfHG").then(()=>parcelRequire('bIdTA'));

});

parcelRegister("6Naho", function(module, exports) {

let $4f1f4afa7eea8a6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f1f4afa7eea8a6b$var$load("fOGnR").then(()=>parcelRequire('ah3ql'));

});

parcelRegister("774Ai", function(module, exports) {

let $52dcbe3de93451ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52dcbe3de93451ff$var$load("8nEeY").then(()=>parcelRequire('I0LpX'));

});

parcelRegister("9AHDY", function(module, exports) {

let $6fb95491fd5cc916$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fb95491fd5cc916$var$load("fzzMQ").then(()=>parcelRequire('alNF5'));

});

parcelRegister("d7WH4", function(module, exports) {

let $98e9752399922d0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98e9752399922d0c$var$load("3gNEO").then(()=>parcelRequire('lnT2Y'));

});

parcelRegister("ji2tA", function(module, exports) {

let $e0b19e7b5d846f33$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e0b19e7b5d846f33$var$load("gvylW").then(()=>parcelRequire('hNq4L'));

});

parcelRegister("i9m1s", function(module, exports) {

let $d36a2677ebe9c200$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d36a2677ebe9c200$var$load("80OLx").then(()=>parcelRequire('69yxd'));

});

parcelRegister("iAthU", function(module, exports) {

let $d8824ec094ee6292$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8824ec094ee6292$var$load("e4s0V").then(()=>parcelRequire('elqYD'));

});

parcelRegister("luIhB", function(module, exports) {

let $fa5ebffa2d6e4cfd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa5ebffa2d6e4cfd$var$load("4dPO1").then(()=>parcelRequire('aMGQ1'));

});

parcelRegister("5Xidp", function(module, exports) {

let $456097994c616e4c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $456097994c616e4c$var$load("apVmx").then(()=>parcelRequire('1GQ8t'));

});

parcelRegister("eUrQo", function(module, exports) {

let $adabe4e7bccea7f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $adabe4e7bccea7f8$var$load("ltrgi").then(()=>parcelRequire('aNogn'));

});

parcelRegister("jr7Ti", function(module, exports) {

let $e266a8ecb0f1f068$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e266a8ecb0f1f068$var$load("96T5a").then(()=>parcelRequire('d7uW9'));

});

parcelRegister("hvBrV", function(module, exports) {

let $cbf26198e6e92382$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cbf26198e6e92382$var$load("2taES").then(()=>parcelRequire('8i5Vp'));

});

parcelRegister("fBcWz", function(module, exports) {

let $b5b45a100bd39c38$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b5b45a100bd39c38$var$load("eraiV").then(()=>parcelRequire('32lJS'));

});

parcelRegister("aZKQY", function(module, exports) {

let $8013f1fdbb49cbff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8013f1fdbb49cbff$var$load("bSohw").then(()=>parcelRequire('i0sQU'));

});

parcelRegister("7uH4q", function(module, exports) {

let $574cbe9d110bdc8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $574cbe9d110bdc8a$var$load("69YlM").then(()=>parcelRequire('hjc11'));

});

parcelRegister("auyEA", function(module, exports) {

let $7a379634f532b5c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a379634f532b5c3$var$load("5OFyu").then(()=>parcelRequire('goI9c'));

});

parcelRegister("auLEI", function(module, exports) {

let $7a41ac2793f1cd63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a41ac2793f1cd63$var$load("kgHzZ").then(()=>parcelRequire('dK9PC'));

});

parcelRegister("9zsK0", function(module, exports) {

let $6f7dad521bb75086$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6f7dad521bb75086$var$load("8ZNKO").then(()=>parcelRequire('ciScA'));

});

parcelRegister("8Ocbg", function(module, exports) {

let $669c7116274db364$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $669c7116274db364$var$load("lzRfF").then(()=>parcelRequire('3Hu90'));

});

parcelRegister("jZfyc", function(module, exports) {

let $e8cfc6db2147d651$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8cfc6db2147d651$var$load("j03Pa").then(()=>parcelRequire('hQIr5'));

});

parcelRegister("7lBAh", function(module, exports) {

let $5597a6053ed2d5bb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5597a6053ed2d5bb$var$load("brdRT").then(()=>parcelRequire('hrRS6'));

});

parcelRegister("jUaOQ", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $azX2I = parcelRequire("azX2I");


var $cUcPn = parcelRequire("cUcPn");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8d43e7fbe5e2c2cc$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8d43e7fbe5e2c2cc$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("4bW9B")));
        case 'da':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("cXVWo")));
        case 'de':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("1aiti")));
        case 'en-GB':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("iTha3")));
        case 'en-US':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("2cYpF")));
        case 'en-XA':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("93PQ2")));
        case 'en-XB':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("2FoMj")));
        case 'en-ZZ':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("dbjzf")));
        case 'en':
            return $8d43e7fbe5e2c2cc$var$importHelper(await Promise.resolve((parcelRequire("azX2I"))));
        case 'es':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("kBq4a")));
        case 'et':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("faWsm")));
        case 'fi':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("kqvYb")));
        case 'fr':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("5IwVB")));
        case 'hr':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("iTRgW")));
        case 'hu':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("6iTbP")));
        case 'it':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("9H6PZ")));
        case 'ja':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("9Wj8w")));
        case 'ko':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("Pc4ZY")));
        case 'nb':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("aJsa3")));
        case 'nl':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("3EiVK")));
        case 'pl':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("9XjFf")));
        case 'pt-BR':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("hEDzi")));
        case 'ro':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("f8JeE")));
        case 'ru':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("iJnb6")));
        case 'sl':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("jMeFB")));
        case 'sr-RS':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("e12yS")));
        case 'sr-YR':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("6NyE0")));
        case 'sr':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("eBoYX")));
        case 'sv':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("k1Szt")));
        case 'th':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("iZRBv")));
        case 'tr':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("b2o2S")));
        case 'uk':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("ir8Lk")));
        case 'vi':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("9MEX2")));
        case 'zh-CN':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("iTFEE")));
        case 'zh-TW':
            return $8d43e7fbe5e2c2cc$var$importHelper(await (parcelRequire("c44m2")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($azX2I));
    }
};
module.exports["messagesLoader"] = $8d43e7fbe5e2c2cc$export$720676d8cac8fbb;

});

parcelRegister("4bW9B", function(module, exports) {

let $30d54ca3a7086e90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $30d54ca3a7086e90$var$load("cip6w").then(()=>parcelRequire('lxEes'));

});

parcelRegister("cXVWo", function(module, exports) {

let $9707f0952ac15fc6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9707f0952ac15fc6$var$load("3qBwQ").then(()=>parcelRequire('aCGRW'));

});

parcelRegister("1aiti", function(module, exports) {

let $0d950da9e3a927ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d950da9e3a927ef$var$load("8rREG").then(()=>parcelRequire('JUFmp'));

});

parcelRegister("iTha3", function(module, exports) {

let $dc0aace8308201c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc0aace8308201c1$var$load("93ASN").then(()=>parcelRequire('7HMEY'));

});

parcelRegister("2cYpF", function(module, exports) {

let $19bb908b2aab3394$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $19bb908b2aab3394$var$load("7ABrW").then(()=>parcelRequire('cVFS0'));

});

parcelRegister("93PQ2", function(module, exports) {

let $698c9addb3df473d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $698c9addb3df473d$var$load("2pMmv").then(()=>parcelRequire('bpROE'));

});

parcelRegister("2FoMj", function(module, exports) {

let $1f12a186b07269bb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f12a186b07269bb$var$load("k2yB3").then(()=>parcelRequire('7UADl'));

});

parcelRegister("dbjzf", function(module, exports) {

let $0279fddb69a88d13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0279fddb69a88d13$var$load("9fQoJ").then(()=>parcelRequire('5iIV3'));

});

parcelRegister("kBq4a", function(module, exports) {

let $effb7b8930f47050$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $effb7b8930f47050$var$load("8SZbD").then(()=>parcelRequire('iv5dT'));

});

parcelRegister("faWsm", function(module, exports) {

let $b0c5226f19caa7f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0c5226f19caa7f9$var$load("5ZQnr").then(()=>parcelRequire('cKrnl'));

});

parcelRegister("kqvYb", function(module, exports) {

let $edef08dc8ea3b682$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $edef08dc8ea3b682$var$load("5pOQA").then(()=>parcelRequire('4vDnW'));

});

parcelRegister("5IwVB", function(module, exports) {

let $429a9aa889934f56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $429a9aa889934f56$var$load("gbksI").then(()=>parcelRequire('aSozu'));

});

parcelRegister("iTRgW", function(module, exports) {

let $dc26afd553d289de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc26afd553d289de$var$load("cl9Gh").then(()=>parcelRequire('c3Y0M'));

});

parcelRegister("6iTbP", function(module, exports) {

let $496f3c0b8a7e47e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $496f3c0b8a7e47e1$var$load("a98cw").then(()=>parcelRequire('2B85q'));

});

parcelRegister("9H6PZ", function(module, exports) {

let $70ed6eff50ca0acb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70ed6eff50ca0acb$var$load("4PDaO").then(()=>parcelRequire('cTnS9'));

});

parcelRegister("9Wj8w", function(module, exports) {

let $73c85ff10bbe8992$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73c85ff10bbe8992$var$load("ervs7").then(()=>parcelRequire('4cEGy'));

});

parcelRegister("Pc4ZY", function(module, exports) {

let $099e224bf001f193$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $099e224bf001f193$var$load("iMMtn").then(()=>parcelRequire('eDwPt'));

});

parcelRegister("aJsa3", function(module, exports) {

let $7d03f390fb07cf34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d03f390fb07cf34$var$load("eX5n7").then(()=>parcelRequire('jStu0'));

});

parcelRegister("3EiVK", function(module, exports) {

let $2a83cab88aeb8ef5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a83cab88aeb8ef5$var$load("3nHdy").then(()=>parcelRequire('2Img8'));

});

parcelRegister("9XjFf", function(module, exports) {

let $73f8e0a54d182cbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73f8e0a54d182cbb$var$load("ilL9c").then(()=>parcelRequire('6ZV8o'));

});

parcelRegister("hEDzi", function(module, exports) {

let $cda4dd8958c42859$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cda4dd8958c42859$var$load("bfOZL").then(()=>parcelRequire('1R0Ja'));

});

parcelRegister("f8JeE", function(module, exports) {

let $b05ab12382f65f0a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b05ab12382f65f0a$var$load("fsCDU").then(()=>parcelRequire('3yza0'));

});

parcelRegister("iJnb6", function(module, exports) {

let $da2e68a900d3895b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da2e68a900d3895b$var$load("jYdbS").then(()=>parcelRequire('7XEhN'));

});

parcelRegister("jMeFB", function(module, exports) {

let $e65de12b3d521ed5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e65de12b3d521ed5$var$load("alPCG").then(()=>parcelRequire('7JZyE'));

});

parcelRegister("e12yS", function(module, exports) {

let $a343255d4e1c3706$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a343255d4e1c3706$var$load("fFPJ9").then(()=>parcelRequire('bywuE'));

});

parcelRegister("6NyE0", function(module, exports) {

let $4f32314bc9f13c85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f32314bc9f13c85$var$load("3tgft").then(()=>parcelRequire('bdEVs'));

});

parcelRegister("eBoYX", function(module, exports) {

let $aa17e659ae83c419$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa17e659ae83c419$var$load("jZaZC").then(()=>parcelRequire('jNi53'));

});

parcelRegister("k1Szt", function(module, exports) {

let $e94e3b5a68cc9f23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e94e3b5a68cc9f23$var$load("f0i3H").then(()=>parcelRequire('1DvBo'));

});

parcelRegister("iZRBv", function(module, exports) {

let $dd47811ec0d9b470$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd47811ec0d9b470$var$load("lExpV").then(()=>parcelRequire('9lwbD'));

});

parcelRegister("b2o2S", function(module, exports) {

let $8092888afff646ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8092888afff646ac$var$load("kWOpS").then(()=>parcelRequire('f6sjl'));

});

parcelRegister("ir8Lk", function(module, exports) {

let $d6c18ba64450ae55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6c18ba64450ae55$var$load("b9XqI").then(()=>parcelRequire('hDKzS'));

});

parcelRegister("9MEX2", function(module, exports) {

let $71f85cd1ba19c368$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71f85cd1ba19c368$var$load("AXmEU").then(()=>parcelRequire('kaqk5'));

});

parcelRegister("iTFEE", function(module, exports) {

let $dc1daccebf884906$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc1daccebf884906$var$load("kVqUf").then(()=>parcelRequire('1wuYB'));

});

parcelRegister("c44m2", function(module, exports) {

let $8c893c73effbb15a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c893c73effbb15a$var$load("f7hfJ").then(()=>parcelRequire('bM3ZL'));

});

parcelRegister("5kbLE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $1RMKR = parcelRequire("1RMKR");


var $7L44N = parcelRequire("7L44N");


var $6U5eU = parcelRequire("6U5eU");


var $ll379 = parcelRequire("ll379");


var $cozmU = parcelRequire("cozmU");


var $fcLDg = parcelRequire("fcLDg");


var $jBS9T = parcelRequire("jBS9T");

const $a0d19ad2319e4e34$var$STABLE_OBJECT = {};
const $a0d19ad2319e4e34$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $cozmU.useMemo)(()=>(0, $6U5eU.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $1RMKR.useStableObject)(placementProps ?? $a0d19ad2319e4e34$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7L44N.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fcLDg.default), {
                    analyticsChannel: (0, $jBS9T.ANALYTICS_CHANNEL),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
const $a0d19ad2319e4e34$var$PlacementMemoized = /*#__PURE__*/ (0, $cozmU.memo)($a0d19ad2319e4e34$var$Placement);
var $a0d19ad2319e4e34$export$2e2bcd8739ae039 = $a0d19ad2319e4e34$var$PlacementMemoized;
module.exports["default"] = $a0d19ad2319e4e34$export$2e2bcd8739ae039;

});

parcelRegister("fcLDg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $lzgC6 = parcelRequire("lzgC6");


var $cozmU = parcelRequire("cozmU");

class $45465d036124c3a6$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $45465d036124c3a6$var$ErrorBoundaryWithAnalytics = (0, $lzgC6.default)()($45465d036124c3a6$var$ErrorBoundary);
var $45465d036124c3a6$export$2e2bcd8739ae039 = $45465d036124c3a6$var$ErrorBoundaryWithAnalytics;
module.exports["default"] = $45465d036124c3a6$export$2e2bcd8739ae039;

});

parcelRegister("jBS9T", function(module, exports) {
const $27b0c301be1a67fd$export$85183a312807388d = 'postOffice';
module.exports["ANALYTICS_CHANNEL"] = $27b0c301be1a67fd$export$85183a312807388d;

});

parcelRegister("eTXLl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $acQiA = parcelRequire("acQiA");


var $9d7Pd = parcelRequire("9d7Pd");


var $9GVkD = parcelRequire("9GVkD");


var $gjkrp = parcelRequire("gjkrp");


var $1HMFz = parcelRequire("1HMFz");


var $imIsb = parcelRequire("imIsb");


var $1P2f3 = parcelRequire("1P2f3");

/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $9484f74b5616b2c8$var$DropdownItemRadio = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(45);
    let children;
    let defaultSelected;
    let description;
    let id;
    let interactionName;
    let isDisabled;
    let isSelected;
    let rest;
    let t1;
    let t2;
    let t3;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: t1, shouldDescriptionWrap: t2, shouldTitleWrap: t3, interactionName: interactionName, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = defaultSelected;
        $[3] = description;
        $[4] = id;
        $[5] = interactionName;
        $[6] = isDisabled;
        $[7] = isSelected;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = testId;
        $[13] = title;
    } else {
        children = $[1];
        defaultSelected = $[2];
        description = $[3];
        id = $[4];
        interactionName = $[5];
        isDisabled = $[6];
        isSelected = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        testId = $[12];
        title = $[13];
    }
    const providedOnClick = t1 === undefined ? (0, $dpsRj.default) : t1;
    const shouldDescriptionWrap = t2 === undefined ? true : t2;
    const shouldTitleWrap = t3 === undefined ? true : t3;
    typeof $1P2f3;
    let t4;
    if ($[14] !== defaultSelected || $[15] !== id || $[16] !== isSelected) {
        t4 = {
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        };
        $[14] = defaultSelected;
        $[15] = id;
        $[16] = isSelected;
        $[17] = t4;
    } else t4 = $[17];
    const [selected, setSelected] = (0, $1HMFz.default)(t4);
    let t5;
    if ($[18] !== providedOnClick || $[19] !== setSelected) {
        t5 = (event)=>{
            setSelected($9484f74b5616b2c8$var$_temp);
            providedOnClick(event);
        };
        $[18] = providedOnClick;
        $[19] = setSelected;
        $[20] = t5;
    } else t5 = $[20];
    const onClickHandler = t5;
    const itemRef = (0, $imIsb.default)();
    const t6 = `${id}-radio`;
    let t7;
    if ($[21] !== selected) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gjkrp.default), {
            checked: selected
        });
        $[21] = selected;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== children || $[24] !== description || $[25] !== id || $[26] !== interactionName || $[27] !== isDisabled || $[28] !== itemRef || $[29] !== onClickHandler || $[30] !== rest || $[31] !== selected || $[32] !== shouldDescriptionWrap || $[33] !== shouldTitleWrap || $[34] !== t6 || $[35] !== t7 || $[36] !== testId || $[37] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            "aria-checked": selected,
            "aria-describedby": t6,
            description: description,
            iconBefore: t7,
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemradio",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            title: title,
            interactionName: interactionName,
            ...rest,
            "aria-current": undefined
        }, children);
        $[23] = children;
        $[24] = description;
        $[25] = id;
        $[26] = interactionName;
        $[27] = isDisabled;
        $[28] = itemRef;
        $[29] = onClickHandler;
        $[30] = rest;
        $[31] = selected;
        $[32] = shouldDescriptionWrap;
        $[33] = shouldTitleWrap;
        $[34] = t6;
        $[35] = t7;
        $[36] = testId;
        $[37] = title;
        $[38] = t8;
    } else t8 = $[38];
    const t9 = `${id}-radio`;
    let t10;
    if ($[39] !== selected || $[40] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
            id: t9
        }, "radio button ", selected);
        $[39] = selected;
        $[40] = t9;
        $[41] = t10;
    } else t10 = $[41];
    let t11;
    if ($[42] !== t10 || $[43] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none"
        }, t8, t10);
        $[42] = t10;
        $[43] = t8;
        $[44] = t11;
    } else t11 = $[44];
    return t11;
} : ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $dpsRj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $1P2f3;
    const [selected, setSelected] = (0, $1HMFz.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $cozmU.useCallback)((event)=>{
        setSelected((selected_0)=>!selected_0);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $imIsb.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        "aria-checked": selected,
        "aria-describedby": `${id}-radio`,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gjkrp.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemradio",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, this attribute are passed to ButtonItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        title: title,
        interactionName: interactionName,
        ...rest,
        // Override ButtonItem's default aria-current, as aria-checked is the correct attribute for menuitemradio (A11Y-37930)
        "aria-current": undefined
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        id: `${id}-radio`
    }, "radio button ", selected));
};
var $9484f74b5616b2c8$export$2e2bcd8739ae039 = $9484f74b5616b2c8$var$DropdownItemRadio;
function $9484f74b5616b2c8$var$_temp(selected_0) {
    return !selected_0;
}
module.exports["default"] = $9484f74b5616b2c8$export$2e2bcd8739ae039;

});

parcelRegister("gjkrp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $94a317b8d74997c1$var$svgStyles = null; /**
                         * __Radio icon__
                         *
                         * Used to visually represent the selected state in DropdownItemRadio
                         *
                         * @internal
                         */ 
const $94a317b8d74997c1$var$RadioIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { checked: checked } = t0;
    const t1 = checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)";
    const t2 = checked ? "var(--ds-icon-inverse, #FFFFFF)" : "transparent";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            color: t1,
            fill: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]);
        $[3] = t4;
    } else t4 = $[3];
    const t5 = checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)";
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
            cx: "12",
            cy: "12",
            r: "7.5",
            fill: "currentColor",
            stroke: t5,
            strokeWidth: "1"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
            cx: "12",
            cy: "12",
            r: "3",
            fill: "inherit"
        });
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            fillRule: "evenodd"
        }, t6, t7);
        $[7] = t6;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t3 || $[10] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            style: t3,
            role: "presentation",
            className: t4
        }, t8);
        $[9] = t3;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
} : ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "7.5",
        fill: "currentColor",
        stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
        strokeWidth: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3",
        fill: "inherit"
    })));
};
var $94a317b8d74997c1$export$2e2bcd8739ae039 = $94a317b8d74997c1$var$RadioIcon;
module.exports["default"] = $94a317b8d74997c1$export$2e2bcd8739ae039;

});

parcelRegister("1HMFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3SaOM = parcelRequire("3SaOM");


var $lOWpM = parcelRequire("lOWpM");

const $a4a8ae7debae1d05$var$useRadioState = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRadioState(t0) {
    const $ = (0, $bDgLe.c)(21);
    const { id: id, isSelected: isSelected, defaultSelected: defaultSelected } = t0;
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $cozmU.useContext)((0, $3SaOM.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    let t1;
    if ($[0] !== defaultSelected || $[1] !== persistedIsSelected) {
        t1 = ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
        $[0] = defaultSelected;
        $[1] = persistedIsSelected;
        $[2] = t1;
    } else t1 = $[2];
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[3] !== id || $[4] !== persistedIsSelected || $[5] !== selectRadioItem) {
        t2 = (newValue)=>{
            if (!persistedIsSelected) {
                const nextValue = newValue(persistedIsSelected);
                selectRadioItem(id, nextValue);
                setLocalIsSelected(nextValue);
            }
        };
        $[3] = id;
        $[4] = persistedIsSelected;
        $[5] = selectRadioItem;
        $[6] = t2;
    } else t2 = $[6];
    const setLocalState = t2;
    let t3;
    if ($[7] !== defaultSelected || $[8] !== id || $[9] !== radioGroupState) {
        t3 = ()=>{
            setLocalIsSelected(()=>{
                const existing = radioGroupState[id];
                return existing !== undefined ? existing : defaultSelected || false;
            });
        };
        $[7] = defaultSelected;
        $[8] = id;
        $[9] = radioGroupState;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== defaultSelected || $[12] !== group || $[13] !== id || $[14] !== radioGroupState) {
        t4 = [
            radioGroupState,
            group,
            id,
            defaultSelected
        ];
        $[11] = defaultSelected;
        $[12] = group;
        $[13] = id;
        $[14] = radioGroupState;
        $[15] = t4;
    } else t4 = $[15];
    (0, $cozmU.useEffect)(t3, t4);
    if (typeof isSelected === "boolean") {
        let t5;
        if ($[16] !== isSelected) {
            t5 = [
                isSelected,
                $a4a8ae7debae1d05$var$_temp
            ];
            $[16] = isSelected;
            $[17] = t5;
        } else t5 = $[17];
        return t5;
    }
    if (persistedIsSelected === undefined) {
        const existing_0 = getGroupState(group);
        const newGroupState = {
            ...existing_0,
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    let t5;
    if ($[18] !== localIsSelected || $[19] !== setLocalState) {
        t5 = [
            localIsSelected,
            setLocalState
        ];
        $[18] = localIsSelected;
        $[19] = setLocalState;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : function useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $cozmU.useContext)((0, $3SaOM.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $cozmU.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $cozmU.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    /**
   * Set the initial state of the context provider's store,
   * if it doesn't already have a persisted value for this id.
   */ if (persistedIsSelected === undefined) {
        const existing_0 = getGroupState(group);
        const newGroupState = {
            ...existing_0,
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    return [
        localIsSelected,
        setLocalState
    ];
};
function $a4a8ae7debae1d05$var$_temp() {
    return false;
}
var $a4a8ae7debae1d05$export$2e2bcd8739ae039 = $a4a8ae7debae1d05$var$useRadioState;
module.exports["default"] = $a4a8ae7debae1d05$export$2e2bcd8739ae039;

});

parcelRegister("3SaOM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $e4fc7f756cc729c9$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $cozmU.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $dpsRj.default)
});
module.exports["RadioGroupContext"] = $e4fc7f756cc729c9$export$a79eda4ff50e30b6;

});

parcelRegister("blg7q", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $af81f9ffe316c2e0$export$69cf3fc83b854da4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4AEfs",
    name: "ConversationAssistantNavBarButton",
    loader: async ()=>(await (parcelRequire("6lMoN"))).ConversationAssistantNavBarButton
});
module.exports["ConversationAssistantNavBarButton"] = $af81f9ffe316c2e0$export$69cf3fc83b854da4;

});

parcelRegister("6lMoN", function(module, exports) {

let $49fa3f49ed01f59f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $49fa3f49ed01f59f$var$load("ddvkk"),
    $49fa3f49ed01f59f$var$load("3upHR"),
    $49fa3f49ed01f59f$var$load("dBHUb"),
    $49fa3f49ed01f59f$var$load("5Rx9J"),
    $49fa3f49ed01f59f$var$load("6s3kH"),
    $49fa3f49ed01f59f$var$load("6ngS6"),
    $49fa3f49ed01f59f$var$load("k1meQ"),
    $49fa3f49ed01f59f$var$load("idSqX"),
    $49fa3f49ed01f59f$var$load("cmmpX"),
    $49fa3f49ed01f59f$var$load("fcsnw"),
    $49fa3f49ed01f59f$var$load("72fV2"),
    $49fa3f49ed01f59f$var$load("3kVph"),
    $49fa3f49ed01f59f$var$load("gM13h")
]).then(()=>parcelRequire('1RPPn'));

});

parcelRegister("i834V", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

var $8aG6j = parcelRequire("8aG6j");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $hekY6 = parcelRequire("hekY6");


var $3YwIp = parcelRequire("3YwIp");


var $jID7G = parcelRequire("jID7G");

const $7ed80bade4846150$export$cf9a3fbf9c3c14ce = (headers)=>(config)=>async (opts)=>{
            const isPostOfficeSynthetic = opts.request.orchestrationContext.recipient?.userId && opts.request.statsig.checkGate({
                identifiers: {
                    atlassianAccountId: opts.request.orchestrationContext.recipient.userId
                }
            }, 'post-office-is-post-office-synthetic');
            if (!isPostOfficeSynthetic) opts.koa.ctx.set(headers);
            return (0, $jID7G.defaultPlacementMiddleware)(config)(opts);
        };
const $7ed80bade4846150$export$80d235e32c5248a6 = 'private, max-age=300, stale-while-revalidate=600, stale-if-error=900';
const $7ed80bade4846150$export$dc0291b7f6e541b = 'private, max-age=120, stale-while-revalidate=300, stale-if-error=900';
const $7ed80bade4846150$export$c81528d4fcbfbe9f = 'private, max-age=600, stale-while-revalidate=900, stale-if-error=900';
const $7ed80bade4846150$export$49b0f46a7b9264ff = $7ed80bade4846150$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $7ed80bade4846150$export$80d235e32c5248a6
});
const $7ed80bade4846150$export$f90e17deb35ce39f = $7ed80bade4846150$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $7ed80bade4846150$export$80d235e32c5248a6
});
const $7ed80bade4846150$export$86309966c8dcb8f0 = $7ed80bade4846150$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $7ed80bade4846150$export$80d235e32c5248a6
});
const $7ed80bade4846150$export$d70cd3c2d3a8b23f = $7ed80bade4846150$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $7ed80bade4846150$export$dc0291b7f6e541b
});
const $7ed80bade4846150$export$5379d5ee2ecb6877 = $7ed80bade4846150$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $7ed80bade4846150$export$dc0291b7f6e541b
});
const $7ed80bade4846150$export$c499d39834887909 = $7ed80bade4846150$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $7ed80bade4846150$export$c81528d4fcbfbe9f
});



var $enlIM = parcelRequire("enlIM");


var $iDE8i = parcelRequire("iDE8i");


var $cXtTj = parcelRequire("cXtTj");

const $153b59b704637a30$export$8ea6555e3e46f620 = 'not-enrolled';
const $153b59b704637a30$var$NON_VARIANT_COHORTS = new Set([
    'control',
    $153b59b704637a30$export$8ea6555e3e46f620
]);
const $153b59b704637a30$export$963cdca6c7580c53 = [
    {
        // https://switcheroo.atlassian.com/ui/gates/4bb14a49-572d-4f41-99b8-3d8ca5260adc/key/rovo-ext_left_nav_rovo_extension_cta
        messageTemplateId: 'rovo-extension-install-cta-left-nav',
        statsigExperiment: 'rovo-ext_left_nav_rovo_extension_cta',
        statsigParameterName: 'cohort',
        statsigTestCohortPredicate: (experimentValue)=>!$153b59b704637a30$var$NON_VARIANT_COHORTS.has(experimentValue),
        shouldProceedToStatsigEvaluation: ()=>{
            if (typeof navigator === 'undefined') return false;
            const userAgent = navigator.userAgent || '';
            return userAgent.indexOf('Chrome') >= 0;
        }
    },
    {
        // https://switcheroo.atlassian.com/ui/gates/1e0b68aa-bbf1-4e84-94fd-1bb0ca0b37e9/key/rovo_chat_non_mau_jira_confluence_cta
        messageTemplateId: 'rovo-non-mau-chat-cta-jira-confluence-left-nav',
        statsigExperiment: 'rovo_chat_non_mau_jira_confluence_cta',
        statsigParameterName: 'rovo_chat_non_mau_jira_confluence_cta_treatment',
        statsigTestCohortPredicate: (experimentValue)=>!$153b59b704637a30$var$NON_VARIANT_COHORTS.has(experimentValue)
    }
];


const { createFrontend: $1828eaa171622856$var$createFrontend, createBackend: $1828eaa171622856$var$createBackend } = (0, $3YwIp.createPlacement)({
    placementId: 'confluence-side-nav',
    options: {
        choreographer: {
            isDefaultEnabled: false
        }
    }
});
const $1828eaa171622856$export$d90b37843c84d1c3 = $1828eaa171622856$var$createBackend({
    customMiddleware: (0, $7ed80bade4846150$export$5379d5ee2ecb6877)
}); // Props passed from Product to Placement
const $1828eaa171622856$var$confluenceSideNavStyles = null;
const $1828eaa171622856$var$SORTED_NBA = [
    'CONNECT_3P_TOOLS_NUDGE',
    'CREATE_WITH_ROVO_NUDGE',
    'CREATE_SPACE',
    'CREATE_PAGE',
    'CREATE_WHITEBOARD',
    '1_ON_1_LOOM_NUDGE',
    'LOOM_AI_MEETING_NOTES',
    'RESURRECTED_USER_NUDGE',
    'ROVO_EXTENSION_CTA'
]; // todo: Resolve backend ordering incorrectly
const $1828eaa171622856$var$sortMessages = (messages = [])=>{
    return messages.sort((a, b)=>{
        return(// @ts-expect-error Property 'nextBestActionType' does not exist on type 'BackendMessageBody<SerializableRecord>'
        $1828eaa171622856$var$SORTED_NBA.indexOf(a?.nextBestActionType) - // @ts-expect-error Property 'nextBestActionType' does not exist on type 'BackendMessageBody<SerializableRecord>'
        $1828eaa171622856$var$SORTED_NBA.indexOf(b?.nextBestActionType));
    });
};
const $1828eaa171622856$export$55486c2b6964dcf2 = $1828eaa171622856$var$createFrontend((Messages)=>({ preloadedInitialData: preloadedInitialData, onDismiss: onDismiss, onSideNavClick: onSideNavClick, onCallback: onCallback, currentRoute: currentRoute })=>{
        const [{ messages: messages, status: status }, setMessageState] = (0, $cozmU.useState)(()=>{
            if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? {
                status: 'done',
                messages: $1828eaa171622856$var$sortMessages(preloadedInitialData?.messages)
            } : {
                messages: undefined,
                status: 'done'
            };
            return {
                messages: undefined,
                status: 'loading'
            };
        });
        const context = (0, $iDE8i.usePostOfficeSideNavMessages)();
        const isDone = status === 'done';
        const { data: data, error: error, isLoading: isLoading } = (0, $enlIM.usePlacementApi)('/', {
            autoRefetch: {
                isEnabled: !isDone,
                updateKey: 'confluence-side-nav'
            }
        });
        const handleOnDismissed = (0, $cozmU.useCallback)(()=>{
            // no more messages until the next fetch
            onDismiss({
                messages: []
            });
            setMessageState({
                messages: undefined,
                status: 'done'
            });
        }, [
            onDismiss
        ]);
        const handleOnSideNavClick = (0, $cozmU.useCallback)((nextBestActionType)=>{
            // display the next message
            setMessageState((prevState)=>{
                if (prevState.messages) {
                    const newMessages = prevState.messages.slice(1);
                    onSideNavClick(nextBestActionType, {
                        messages: newMessages
                    });
                    return {
                        messages: newMessages,
                        status: 'done'
                    };
                }
                onSideNavClick(nextBestActionType, {
                    messages: []
                });
                return prevState;
            });
        }, [
            onSideNavClick
        ]);
        (0, $cozmU.useEffect)(()=>{
            if (!isLoading && !isDone) setMessageState({
                messages: $1828eaa171622856$var$sortMessages(data?.messages),
                status: 'done'
            });
        }, [
            isLoading,
            isDone,
            data
        ]);
        const displayedMessage = (0, $cozmU.useMemo)(()=>{
            if (!messages?.length) return;
            const filteredMessages = messages.filter((message)=>{
                // @ts-expect-error Property 'explicitEnableRequired' does not exist on type 'BackendMessageBody<SerializableRecord>'
                if (message.explicitEnableRequired) // @ts-expect-error Property 'nextBestActionType' does not exist on type 'BackendMessageBody<SerializableRecord>'
                return context?.enabledMessages.includes(message.nextBestActionType);
                if (message.messageTemplateId === 'rovo-extension-install-cta-left-nav') {
                    // Don't show on FPS to avoid collision with existing install CTA (built outside of PO)
                    if (currentRoute?.includes('/search')) return false;
                }
                return true;
            });
            if (!filteredMessages.length) return;
             // https://switcheroo.atlassian.com/ui/gates/f775d661-abc2-488d-b58c-c28fab9bd58f/key/po_enable_confluence-side-nav-exp-messages
            if ((0, $cXtTj.default).checkGate('po_enable_confluence-side-nav-exp-messages')) {
                for (const message of filteredMessages){
                    const experimentalMessage = (0, $153b59b704637a30$export$963cdca6c7580c53).find((msg)=>msg.messageTemplateId === message.messageTemplateId); // Non-experimental messages are always eligible and should not be overridden by
                    // later experimental messages in the order they are defined.
                    if (!experimentalMessage) return {
                        message: message
                    };
                    if (experimentalMessage.shouldProceedToStatsigEvaluation && !experimentalMessage.shouldProceedToStatsigEvaluation()) continue;
                    const experimentCohort = (0, $cXtTj.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, (0, $153b59b704637a30$export$8ea6555e3e46f620));
                    if (experimentalMessage.statsigTestCohortPredicate(experimentCohort)) return {
                        message: message,
                        experimentCohort: experimentCohort
                    };
                }
                return undefined;
            } else if (filteredMessages[0]?.messageTemplateId === 'rovo-non-mau-chat-cta-jira-confluence-left-nav') {
                const experimentalMessage = (0, $153b59b704637a30$export$963cdca6c7580c53).find((m)=>m.messageTemplateId === filteredMessages[0]?.messageTemplateId);
                if (experimentalMessage) {
                    const experimentCohort = (0, $cXtTj.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, (0, $153b59b704637a30$export$8ea6555e3e46f620));
                    if (experimentalMessage.statsigTestCohortPredicate(experimentCohort)) return {
                        message: filteredMessages[0],
                        experimentCohort: experimentCohort
                    };
                }
                filteredMessages.shift();
            }
            return filteredMessages[0] ? {
                message: filteredMessages[0]
            } : undefined;
        }, [
            messages,
            context,
            currentRoute
        ]);
        if (error) return null;
        if (status === 'loading') return null;
        if (!displayedMessage) return null;
        const { message: message, experimentCohort: experimentCohort } = displayedMessage;
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                !(0, $cXtTj.default).checkGate('navx-global-side-nav-confluence') && "_18s8utpp _1e0c1txw"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Messages.render, {
                ...message,
                experimentCohort: experimentCohort,
                onSideNavClick: handleOnSideNavClick,
                handleOnDismissed: handleOnDismissed,
                onCallback: onCallback
            })
        });
    });





/* message.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $hBYtq = parcelRequire("hBYtq");


var $k4HA2 = parcelRequire("k4HA2");


var $kSwu1 = parcelRequire("kSwu1");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("cozmU");





var $c25Cq = parcelRequire("c25Cq");

const $b919a6e6196403e9$var$actionsStyles = null;
const $b919a6e6196403e9$export$b52183d5cfb26dc9 = ({ whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, handleOnDismissed: handleOnDismissed })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_1yt4mkb0 _kqswstnw _1e0c1txw _154iidpf _1xi2idpf"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c25Cq.AdControls), {
            iconSize: "small",
            showWhyAmISeeingThis: true,
            whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
            onDismissed: handleOnDismissed
        })
    });
};






var $buxP3 = parcelRequire("buxP3");








var $kh0hi = parcelRequire("kh0hi");

const $7b2adafb4071338a$export$183b689fd14b3c3e = ({ ctaText: ctaText, onCTAClick: onCTAClick, pressableStyle: pressableStyle })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kh0hi.default), {
        onClick: onCTAClick,
        xcss: pressableStyle,
        children: ctaText
    });
};



var $5jiof = parcelRequire("5jiof");


var $baFbJ = parcelRequire("baFbJ");




const $e8b786ab8bea2d09$export$a5eee42871f883eb = (onMessageClick, clickedElement)=>{
    const { messageClicked: messageClicked, messageDismissed: messageDismissed } = (0, $baFbJ.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $5jiof.useMessageInstanceEvent)();
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        messageClicked().catch(()=>{});
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        }).catch(()=>{});
        onMessageClick(e);
        // Dismiss Create Whiteboard and Create Page message instances after the user clicks on the action
        // This is so that if the user reloads the page, the message is not shown again.
        // Otherwise, there is a delay of 5 mins due to us using cached tap-sidecar with a 5-min TTL so the latest TAP trait info won't be retrieved till then
        if (clickedElement.clickIdentifier.includes('CREATE_WHITEBOARD') || clickedElement.clickIdentifier.includes('CREATE_PAGE')) messageDismissed().catch(()=>{});
    }, [
        clickedElement,
        messageClicked,
        messageInstanceClicked,
        onMessageClick
    ]);
    return {
        handleClick: handleClick
    };
};


const $00b325209d323de2$var$nextBestActionButtonStyles = (0, $buxP3.xcss)({
    display: 'flex',
    width: '120px',
    paddingLeft: '0',
    paddingRight: '0',
    whiteSpace: 'nowrap',
    color: 'color.link',
    backgroundColor: 'color.background.accent.blue.subtlest',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $00b325209d323de2$export$2f350203e9a62d5 = ({ ctaMessage: ctaMessage, onCTAClick: onCTAClick, nextBestActionType: nextBestActionType })=>{
    const clickedElement = (0, $cozmU.useMemo)(()=>{
        return {
            clickIdentifier: `next-best-action-message-${nextBestActionType}`,
            clickedElement: 'link'
        };
    }, [
        nextBestActionType
    ]);
    const { handleClick: handleClick } = (0, $e8b786ab8bea2d09$export$a5eee42871f883eb)(onCTAClick, clickedElement);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7b2adafb4071338a$export$183b689fd14b3c3e), {
        ctaText: ctaMessage,
        onCTAClick: handleClick,
        pressableStyle: $00b325209d323de2$var$nextBestActionButtonStyles
    });
};



/*--Banner Content--*/ const $b29ff61904246e1a$var$confluenceNbaMessageStylesCss = null;
const $b29ff61904246e1a$var$styles = {
    confluenceNbaMessage: "_2rko1mok _1e0c1txw _kqswh2mm _4cvr1h6o _bfhk1s93 _1bsb1osq _ca0qutpp _u5f3utpp _19bvutpp _n3td12x7 _1ubta3nm _d0altlke"
};
const $b29ff61904246e1a$var$iconContainerStyles = null;
const $b29ff61904246e1a$var$bodyContentStyles = null;
const $b29ff61904246e1a$var$headerStyles = null;
const $b29ff61904246e1a$var$BodyContent = ({ header: header, ctaMessage: ctaMessage, onMessageClick: onMessageClick, nextBestActionType: nextBestActionType })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _18u01ylp _19bvu2gc _2hwxzwfg _1bsb1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                role: "presentation",
                className: (0, $hekY6.default)([
                    "_11c81qyo _1bsb1osq _n3tdu2gc"
                ]),
                children: header
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $00b325209d323de2$export$2f350203e9a62d5), {
                ctaMessage: ctaMessage,
                onCTAClick: onMessageClick,
                nextBestActionType: nextBestActionType
            })
        ]
    });
};
const $b29ff61904246e1a$var$whyAmISeeingThisModalContent = {
    title: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
        id: "post-office.ad-controls.next-best-action-title.why-am-i-seeing-this",
        defaultMessage: "Why am I seeing this?"
    }),
    message: /*#__PURE__*/ (0, $8aG6j.jsx)("p", {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.next-best-action-message.recommendation-basis",
            defaultMessage: "This recommendation is based on:"
        })
    }),
    reasons: [
        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.next-best-action-reason.actions-done-so-far",
            defaultMessage: "What you\u2019ve done so far in the product"
        }),
        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.ad-controls.next-best-action-reason.suggestions",
            defaultMessage: "What we suggest to help you get the most value from Atlassian"
        })
    ]
};
const $b29ff61904246e1a$export$7e6be280c02f2a40 = ({ icon: icon, header: header, ctaMessage: ctaMessage, onMessageClick: onMessageClick, handleOnDismissed: handleOnDismissed, nextBestActionType: nextBestActionType })=>{
    const { messageInstanceId: messageInstanceId } = (0, $k4HA2.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const clickedElement = (0, $cozmU.useMemo)(()=>{
        return {
            clickIdentifier: `next-best-action-message-${nextBestActionType}`,
            clickedElement: 'link'
        };
    }, [
        nextBestActionType
    ]);
    const { handleClick: handleClick } = (0, $e8b786ab8bea2d09$export$a5eee42871f883eb)(onMessageClick, clickedElement);
    const handleMessageClick = (e)=>{
        const currentTarget = e.currentTarget;
        let target = e.target;
        while(target.parentNode){
            if (target.tagName.toLowerCase() === 'button' || target.tagName.toLowerCase() === 'a' || target.tagName.toLowerCase() === 'html' // this is for the modal & its transparent background
            ) // Don't open action since these child elements should've already handled the click
            return;
             // Open action if the click is on the banner message itself
            if (target === currentTarget) {
                handleClick(e);
                return;
            } // Keep traversing up the DOM tree
            target = target.parentNode;
        }
    };
    return (0, $cXtTj.default).checkGate('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.default), {
        testId: "confluence-next-best-action-message",
        xcss: $b29ff61904246e1a$var$styles.confluenceNbaMessage,
        onClick: handleMessageClick,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_1e0c1txw _kqswstnw _154i1crf _1bsb1ylp _4t3i1ylp"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($b29ff61904246e1a$var$BodyContent, {
                header: header,
                ctaMessage: ctaMessage,
                onMessageClick: onMessageClick,
                nextBestActionType: nextBestActionType
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b919a6e6196403e9$export$b52183d5cfb26dc9), {
                whyAmISeeingThisModalContent: $b29ff61904246e1a$var$whyAmISeeingThisModalContent,
                handleOnDismissed: handleOnDismissed
            })
        ]
    }) : /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        "data-testid": "confluence-next-best-action-message",
        onClick: handleMessageClick,
        className: (0, $hekY6.default)([
            "_2rko1mok _1yt41jtk _1e0c1txw _kqswh2mm _4cvr1h6o _bfhk1s93 _1bsb1osq _1ubta3nm _d0altlke"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_1e0c1txw _kqswstnw _154i1crf _1bsb1ylp _4t3i1ylp"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($b29ff61904246e1a$var$BodyContent, {
                header: header,
                ctaMessage: ctaMessage,
                onMessageClick: onMessageClick,
                nextBestActionType: nextBestActionType
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b919a6e6196403e9$export$b52183d5cfb26dc9), {
                whyAmISeeingThisModalContent: $b29ff61904246e1a$var$whyAmISeeingThisModalContent,
                handleOnDismissed: handleOnDismissed
            })
        ]
    });
};








const $916273093dd8a91c$var$NBAIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M33.2748 18.1208H12.979V28.0375H33.2748V18.1208Z",
                    fill: "#BF63F3"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M26.9667 11.9624H6.6709V21.8791H26.9667V11.9624Z",
                    fill: "#FCA700"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M26.9665 18.1208H12.979V21.8792H26.9665V18.1208Z",
                    fill: "#AE2A19"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M32.0125 21.7042L27.6416 26.075L25.3833 23.7542L26.3583 22.8084L27.6583 24.1417L31.0541 20.7458L32.0166 21.7083L32.0125 21.7042Z",
                    fill: "white"
                })
            ]
        })
    });
const $916273093dd8a91c$export$e080ae79c37ff1d1 = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    const headerText = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.craete-space-header",
        defaultMessage: "Centralize your team's projects, and docs."
    });
    const ctaMessage = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.create-space-cta-message",
        defaultMessage: "Create space"
    });
    const onMessageClick = (0, $cozmU.useCallback)(()=>{
        onSideNavClick('CREATE_SPACE');
    }, [
        onSideNavClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b29ff61904246e1a$export$7e6be280c02f2a40), {
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)($916273093dd8a91c$var$NBAIcon, {}),
        header: headerText,
        ctaMessage: ctaMessage,
        onMessageClick: onMessageClick,
        handleOnDismissed: handleOnDismissed,
        nextBestActionType: "CREATE_SPACE"
    });
};












const $f16397e57b9b7738$var$NBAIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M27.0876 12.9458H10.0293V30H27.0835V12.9458H27.0876ZM13.6876 18.4291H23.4335V16.6H13.6876V18.4291ZM13.6876 22.3875H23.4335V20.5583H13.6876V22.3875ZM19.7793 26.3458H13.6876V24.5166H19.7793V26.3458Z",
                    fill: "#BF63F3"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M23.7292 18.954L20 19.9999L21.0458 16.2707L30.3458 6.9707L33.0292 9.65404L23.7292 18.954Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.3708 12.9458L21.0458 16.2708L20.9542 16.6H23.4333V18.4291H20.4417L20 20L23.7292 18.9541L27.0875 15.5958V12.9458H24.3708Z",
                    fill: "#09326C"
                })
            ]
        })
    });
const $f16397e57b9b7738$export$5688887910bb9e45 = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    const headerText = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.create-page-header",
        defaultMessage: "Plan projects, take notes, and track tasks."
    });
    const ctaMessage = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.create-page-cta-message",
        defaultMessage: "Create page"
    });
    const onMessageClick = (0, $cozmU.useCallback)(()=>{
        onSideNavClick('CREATE_PAGE');
    }, [
        onSideNavClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b29ff61904246e1a$export$7e6be280c02f2a40), {
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)($f16397e57b9b7738$var$NBAIcon, {}),
        header: headerText,
        ctaMessage: ctaMessage,
        onMessageClick: onMessageClick,
        handleOnDismissed: handleOnDismissed,
        nextBestActionType: "CREATE_PAGE"
    });
};












const $76ebdd35611572a2$var$NBAIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M25.4297 21.0963C25.4963 20.7255 25.5297 20.3255 25.5297 19.9088C25.5297 19.4922 25.4963 19.0838 25.4255 18.7047C25.0213 16.4588 23.463 15.0755 21.2713 14.7172C20.8963 14.6547 20.5047 14.6255 20.1005 14.6255C19.6963 14.6255 19.2672 14.6588 18.8797 14.7255C16.6922 15.0922 15.1338 16.4713 14.7297 18.7047C14.663 19.0838 14.6255 19.4838 14.6255 19.9088C14.6255 20.3338 14.6588 20.7255 14.7255 21.0963C15.1255 23.3255 16.6838 24.7088 18.8797 25.0755C19.2672 25.1422 19.6755 25.1755 20.1005 25.1755C20.5255 25.1755 20.9005 25.1463 21.2713 25.0838C23.463 24.7255 25.0255 23.3422 25.4255 21.0963H25.4297Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M7.37109 19.317L13.8711 8.17529L20.3711 19.317H7.37109Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M17.846 14.9922C16.2043 15.5672 15.0627 16.838 14.7293 18.7047C14.6918 18.9047 14.6668 19.1047 14.646 19.3172H20.3668L17.846 14.9922Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M29.917 20.8838H20.7837V30.0171H29.917V20.8838Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M20.7837 20.8877V25.146C20.9504 25.1294 21.1129 25.1085 21.2754 25.0835C23.467 24.7294 25.0254 23.3419 25.4295 21.096C25.442 21.0294 25.4545 20.9585 25.4629 20.8877H20.7837Z",
                fill: "#AE2A19"
            })
        ]
    });
const $76ebdd35611572a2$export$aafbf2fddacf0f4f = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    const headerText = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.create-whiteboard-header",
        defaultMessage: "Dream up new ideas, and visualize your work."
    });
    const ctaMessage = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message",
        defaultMessage: "Create whiteboard"
    });
    const onMessageClick = (0, $cozmU.useCallback)(()=>{
        onSideNavClick('CREATE_WHITEBOARD');
    }, [
        onSideNavClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b29ff61904246e1a$export$7e6be280c02f2a40), {
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)($76ebdd35611572a2$var$NBAIcon, {}),
        header: headerText,
        ctaMessage: ctaMessage,
        onMessageClick: onMessageClick,
        handleOnDismissed: handleOnDismissed,
        nextBestActionType: "CREATE_WHITEBOARD"
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var $c2h0x = parcelRequire("c2h0x");

function $ecc8494300e37b8a$export$a7a9523472993e97(value) {
    const result = $ecc8494300e37b8a$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $ecc8494300e37b8a$export$226b3eccf92c9ed9(value) {
    const result = $ecc8494300e37b8a$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $ecc8494300e37b8a$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else if (!('nextBestActionType' in value)) errors.push({
        path: 'value["nextBestActionType"]',
        expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
        value: undefined
    });
    else {
        let value__nextBestActionType___valid = false;
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_0 = [];
            if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_SPACE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_1 = [];
            if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_PAGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_2 = [];
            if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WHITEBOARD",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_3 = [];
            if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                path: 'value["nextBestActionType"]',
                expected: "1_ON_1_LOOM_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_4 = [];
            if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                path: 'value["nextBestActionType"]',
                expected: "LOOM_AI_MEETING_NOTES",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_5 = [];
            if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                path: 'value["nextBestActionType"]',
                expected: "RESURRECTED_USER_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_6 = [];
            if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WITH_ROVO_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_7 = [];
            if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_7.push({
                path: 'value["nextBestActionType"]',
                expected: "ROVO_EXTENSION_CTA",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_8 = [];
            if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_8.push({
                path: 'value["nextBestActionType"]',
                expected: "CONNECT_3P_TOOLS_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $93005c5f407ff82c$export$e7843a8f64a8d87c = (0, $1828eaa171622856$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $ecc8494300e37b8a$export$a7a9523472993e97),
            stage: ({ message: message })=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    },
                    nextBestAction: message.context.nextBestActionType
                })
        }
    }));
const $93005c5f407ff82c$export$fa9bb46961aca2cc = (0, $1828eaa171622856$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $ecc8494300e37b8a$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
            switch(nextBestActionType){
                case 'CREATE_SPACE':
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $916273093dd8a91c$export$e080ae79c37ff1d1), {
                        onSideNavClick: onSideNavClick,
                        handleOnDismissed: handleOnDismissed
                    });
                case 'CREATE_PAGE':
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f16397e57b9b7738$export$5688887910bb9e45), {
                        onSideNavClick: onSideNavClick,
                        handleOnDismissed: handleOnDismissed
                    });
                case 'CREATE_WHITEBOARD':
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $76ebdd35611572a2$export$aafbf2fddacf0f4f), {
                        onSideNavClick: onSideNavClick,
                        handleOnDismissed: handleOnDismissed
                    });
                default:
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {});
            }
        }
    }
});






var $8ajDi = parcelRequire("8ajDi");


/* message.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gBjHb = parcelRequire("gBjHb");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $l3wuH = parcelRequire("l3wuH");


var $cJ0FD = parcelRequire("cJ0FD");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");



var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");








var $9TNXZ = parcelRequire("9TNXZ");

var $b2da822dc3b76acc$exports = {};
$b2da822dc3b76acc$exports = new URL("heart.91f6fb22.svg", import.meta.url).toString();


const $b02a2119d3dbd5d7$var$styles = {
    container: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _1rjcutpp _kqswh2mm _16jlkb7n _bfhk1s93 _y4tiutpp _bozg12x7",
    link: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz12zz _k48p1wq8 _80omtlke _bfhk1j28 _9oik1r31 _1bnx8stv _jf4cnqa1 _9h8h12zz",
    headerRow: "_1bah1yb4 _4cvr1y6m _1bsb1osq",
    inlineStack: "_1bsb1osq"
};
const $b02a2119d3dbd5d7$var$i18n = (0, $kSwu1.defineMessages)({
    headerText: {
        id: "post-office.confluence-resurrected-user-welcome-back.next-best-action.header",
        defaultMessage: "Welcome back"
    },
    bodyText: {
        id: "post-office.confluence-resurrected-user-welcome-back.body",
        defaultMessage: "Catch up on the top discussions and highlights from your team."
    },
    ctaMessage: {
        id: "post-office.confluence-resurrected-user-welcome-back.cta",
        defaultMessage: "See what's popular"
    },
    closeLabel: {
        id: "post-office.confluence-resurrected-user-welcome-back.close",
        defaultMessage: "Close"
    },
    imageAltText: {
        id: "post-office.confluence-resurrected-user-welcome-back.image-alt",
        defaultMessage: "Two hearts overlapped with each other"
    }
});
const $b02a2119d3dbd5d7$export$1a9faf036da14396 = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed, nextBestActionType: nextBestActionType })=>{
    const intl = (0, $kSwu1.useIntl)();
    const imageAltText = intl.formatMessage($b02a2119d3dbd5d7$var$i18n.imageAltText); // For PO events
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $5jiof.useMessageInstanceEvent)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'confluenceResurrectedUserWelcomeSidebarNudge'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDismissClicked = ()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'resurrected-user-welcome-back-dismiss',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'resurrectedUserWelcomeBackDismiss'
        }); // moves to the next message in queue
        handleOnDismissed();
    };
    const handleCtaClicked = ()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'resurrected-user-welcome-back-cta',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'resurrectedUserWelcomeBackCta'
        }); // moves to the next message in queue and also calls necessary action in confluence
        onSideNavClick(nextBestActionType);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
        data: {
            source: 'confluence-resurrected-user-welcome-back-message'
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.default), {
            xcss: $b02a2119d3dbd5d7$var$styles.container,
            testId: "confluence-resurrected-user-welcome-back-message",
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.default), {
                xcss: $b02a2119d3dbd5d7$var$styles.inlineStack,
                shouldWrap: false,
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b2da822dc3b76acc$exports))),
                        alt: imageAltText
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.default), {
                        alignInline: "start",
                        grow: "fill",
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.default), {
                                xcss: $b02a2119d3dbd5d7$var$styles.headerRow,
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.default), {
                                        shouldWrap: false,
                                        alignBlock: "center",
                                        grow: "fill",
                                        spread: "space-between",
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                            size: "xsmall",
                                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                                ...$b02a2119d3dbd5d7$var$i18n.headerText
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                                        appearance: "subtle",
                                        label: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...$b02a2119d3dbd5d7$var$i18n.closeLabel
                                        }),
                                        isTooltipDisabled: false,
                                        onClick: handleDismissClicked,
                                        spacing: "compact"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...$b02a2119d3dbd5d7$var$i18n.bodyText
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.default), {
                                xcss: $b02a2119d3dbd5d7$var$styles.link,
                                testId: "cta-link",
                                onClick: handleCtaClicked,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...$b02a2119d3dbd5d7$var$i18n.ctaMessage
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $37bcbd7ddbacb321$export$a7a9523472993e97(value) {
    const result = $37bcbd7ddbacb321$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $37bcbd7ddbacb321$export$226b3eccf92c9ed9(value) {
    const result = $37bcbd7ddbacb321$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $37bcbd7ddbacb321$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"RESURRECTED_USER_NUDGE"',
            value: undefined
        });
        else if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") errors.push({
            path: 'value["nextBestActionType"]',
            expected: "RESURRECTED_USER_NUDGE",
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $f19d0509615c2efa$export$e7843a8f64a8d87c = (0, $1828eaa171622856$export$d90b37843c84d1c3).createMessageBackend((0, $8ajDi.defaultMessageBackend));
const $f19d0509615c2efa$export$fa9bb46961aca2cc = (0, $1828eaa171622856$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $37bcbd7ddbacb321$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b02a2119d3dbd5d7$export$1a9faf036da14396), {
                onSideNavClick: onSideNavClick,
                handleOnDismissed: handleOnDismissed,
                nextBestActionType: nextBestActionType
            });
        }
    }
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("cozmU");










var $eKMV3 = parcelRequire("eKMV3");





























var $988b74aed6ddd4d7$exports = {};
$988b74aed6ddd4d7$exports = new URL("notes.c9738615.png", import.meta.url).toString();


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $f8d93034920562b0$export$a7a9523472993e97(value) {
    const result = $f8d93034920562b0$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $f8d93034920562b0$export$226b3eccf92c9ed9(value) {
    const result = $f8d93034920562b0$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $f8d93034920562b0$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"1_ON_1_LOOM_NUDGE"',
            value: undefined
        });
        else if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") errors.push({
            path: 'value["nextBestActionType"]',
            expected: "1_ON_1_LOOM_NUDGE",
            value: value["nextBestActionType"]
        });
        if (!('explicitEnableRequired' in value)) errors.push({
            path: 'value["explicitEnableRequired"]',
            expected: 'true',
            value: undefined
        });
        else if (value["explicitEnableRequired"] !== true) errors.push({
            path: 'value["explicitEnableRequired"]',
            expected: true,
            value: value["explicitEnableRequired"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $ced9d9073f1b94b1$export$e7843a8f64a8d87c = (0, $1828eaa171622856$export$d90b37843c84d1c3).createMessageBackend((0, $8ajDi.defaultMessageBackend));
const $ced9d9073f1b94b1$var$whyAmISeeingThisModalContent = {
    title: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
        id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.why-am-i-seeing-this",
        defaultMessage: "Why am I seeing this?"
    }),
    message: /*#__PURE__*/ (0, $8aG6j.jsx)("p", {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.recommendation-basis",
            defaultMessage: "This recommendation is based on:"
        })
    }),
    reasons: [
        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.actions-done-so-far",
            defaultMessage: "What you\u2019ve done so far in the product"
        }),
        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.suggestions",
            defaultMessage: "What we suggest to help you get the most value from Atlassian"
        })
    ]
};
const $ced9d9073f1b94b1$var$styles = {
    container: "_2rko1mok _1yt4utpp _bfhkhfxm _1bsb1osq",
    body: "_19pku2gc",
    ctaWrapper: "_19pkutpp"
};
const $ced9d9073f1b94b1$export$fa9bb46961aca2cc = (0, $1828eaa171622856$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $f8d93034920562b0$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
            const { messageInstanceClicked: messageInstanceClicked } = (0, $5jiof.useMessageInstanceEvent)();
            const { messageDismissed: messageDismissed } = (0, $baFbJ.useMessageEvent)();
            const intl = (0, $kSwu1.useIntl)();
            const headerText = intl.formatMessage({
                id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.header",
                defaultMessage: "Automate meeting notes"
            });
            const bodyText = intl.formatMessage({
                id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.body",
                defaultMessage: "Instead of manually typing meeting notes, why not try Loom to record meetings?"
            });
            const ctaText = intl.formatMessage({
                id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.cta",
                defaultMessage: "Try now"
            });
            const closeLabel = intl.formatMessage({
                id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.close",
                defaultMessage: "Close"
            });
            const imageAltText = intl.formatMessage({
                id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.image-alt",
                defaultMessage: "Notepad with sparkling background"
            });
            const handleDismiss = ()=>{
                messageInstanceClicked({
                    messageEventType: 'clicked',
                    clickedElement: {
                        clickIdentifier: 'dismiss',
                        clickedElement: 'button',
                        buttonType: 'secondary'
                    },
                    action: {
                        actionType: 'dismiss'
                    },
                    additionalMetadataFromFrontend: {}
                });
                messageDismissed();
                handleOnDismissed();
            };
            const handleCloseClicked = ()=>{
                messageInstanceClicked({
                    messageEventType: 'clicked',
                    clickedElement: {
                        clickIdentifier: '1on1-loom-close',
                        clickedElement: 'button',
                        buttonType: 'secondary'
                    },
                    action: {
                        actionType: 'dismiss'
                    },
                    additionalMetadataFromFrontend: {}
                });
                messageDismissed();
                onSideNavClick(nextBestActionType);
            };
            const handleCtaClicked = ()=>{
                messageInstanceClicked({
                    messageEventType: 'clicked',
                    clickedElement: {
                        clickIdentifier: '1on1-loom-cta',
                        clickedElement: 'button',
                        buttonType: 'primary'
                    },
                    action: {
                        actionType: 'open'
                    },
                    additionalMetadataFromFrontend: {}
                });
                messageDismissed();
                onSideNavClick(nextBestActionType);
            };
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
                data: {
                    source: 'confluence-side-nav-1-on-1-loom-nudge-message'
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                    className: (0, $hekY6.default)([
                        $ced9d9073f1b94b1$var$styles.container
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.default), {
                            spread: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($988b74aed6ddd4d7$exports))),
                                    alt: imageAltText,
                                    height: "56",
                                    width: "56"
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c25Cq.AdControls), {
                                            iconSize: "small",
                                            showWhyAmISeeingThis: true,
                                            whyAmISeeingThisModalContent: $ced9d9073f1b94b1$var$whyAmISeeingThisModalContent,
                                            onDismissed: handleDismiss
                                        }),
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                            onClick: handleCloseClicked,
                                            appearance: "subtle",
                                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                                            label: closeLabel
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                            size: "small",
                            children: headerText
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            className: (0, $hekY6.default)([
                                $ced9d9073f1b94b1$var$styles.body
                            ]),
                            children: bodyText
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            className: (0, $hekY6.default)([
                                $ced9d9073f1b94b1$var$styles.ctaWrapper
                            ]),
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                                onClick: handleCtaClicked,
                                href: "https://www.loom.com/welcome",
                                spacing: "compact",
                                target: "_blank",
                                children: ctaText
                            })
                        })
                    ]
                })
            });
        }
    }
});












// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $82fe2b6b8bae43de$export$a7a9523472993e97(value) {
    const result = $82fe2b6b8bae43de$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $82fe2b6b8bae43de$export$226b3eccf92c9ed9(value) {
    const result = $82fe2b6b8bae43de$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $82fe2b6b8bae43de$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('testProp' in value)) errors.push({
            path: 'value["testProp"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["testProp"] !== 'string') errors.push({
            path: 'value["testProp"]',
            expected: 'string',
            value: value["testProp"]
        });
        if (!('testObjProp' in value)) errors.push({
            path: 'value["testObjProp"]',
            expected: 'object',
            value: undefined
        });
        else if (typeof value["testObjProp"] !== 'object' || value["testObjProp"] === null || Array.isArray(value["testObjProp"])) errors.push({
            path: 'value["testObjProp"]',
            expected: 'object',
            value: value["testObjProp"]
        });
        else {
            if (!('testObjPropKey' in value["testObjProp"])) errors.push({
                path: 'value["testObjProp"]["testObjPropKey"]',
                expected: 'string',
                value: undefined
            });
            else if (typeof value["testObjProp"]["testObjPropKey"] !== 'string') errors.push({
                path: 'value["testObjProp"]["testObjPropKey"]',
                expected: 'string',
                value: value["testObjProp"]["testObjPropKey"]
            });
        }
        if (!('testArrayProp' in value)) errors.push({
            path: 'value["testArrayProp"]',
            expected: 'number[]',
            value: undefined
        });
        else {
            if (!Array.isArray(value["testArrayProp"])) errors.push({
                path: 'value["testArrayProp"]',
                expected: 'array',
                value: value["testArrayProp"]
            });
            if (Array.isArray(value["testArrayProp"])) value["testArrayProp"].forEach((element, index)=>{
                if (typeof element !== 'number') errors.push({
                    path: 'element',
                    expected: 'number',
                    value: element
                });
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $3da87d263c14bca7$export$e7843a8f64a8d87c = (0, $1828eaa171622856$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $82fe2b6b8bae43de$export$a7a9523472993e97),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    }
                })
        },
        hydrate: {
            validate: (0, $82fe2b6b8bae43de$export$a7a9523472993e97),
            stage: ({ message: message })=>{
                message.context.testProp = `Hello ${message.context.testProp} !`;
                return Promise.resolve(message.context);
            }
        }
    }));
const $3da87d263c14bca7$export$fa9bb46961aca2cc = (0, $1828eaa171622856$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $82fe2b6b8bae43de$export$a7a9523472993e97),
        Component: ({ handleOnDismissed: handleOnDismissed })=>{
            const { messageInstanceClicked: messageInstanceClicked } = (0, $5jiof.useMessageInstanceEvent)();
            const { messageDismissed: messageDismissed } = (0, $baFbJ.useMessageEvent)();
            const onDismissed = ()=>{
                messageInstanceClicked({
                    messageEventType: 'clicked',
                    clickedElement: {
                        clickIdentifier: 'confluence-side-nav-create-a-space-dismiss',
                        clickedElement: 'button',
                        buttonType: 'secondary'
                    },
                    action: {
                        actionType: 'dismiss'
                    },
                    additionalMetadataFromFrontend: {}
                });
                messageDismissed();
                handleOnDismissed();
            };
            return /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                onClick: onDismissed,
                children: "Dismiss"
            });
        }
    }
});









/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $iMnC5 = parcelRequire("iMnC5");



















const $a077dd458a3b5801$export$75019b1a004a783d = ()=>// eslint-disable-next-line @atlassian/a11y/role-img-alt
    /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        role: "img",
        width: "80",
        height: "92",
        viewBox: "0 0 80 92",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                "clip-path": "url(#clip0_2327_84459)",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M3.01494 50.2585C1.34983 44.4516 4.70743 38.3943 10.5143 36.7292L31.543 30.6993C37.3499 29.0342 43.4072 32.3918 45.0723 38.1987L51.1021 59.2274C52.7672 65.0343 49.4096 71.0916 43.6027 72.7567L22.5741 78.7865C16.7672 80.4516 10.7099 77.094 9.04481 71.2871L3.01494 50.2585Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
                        "clip-path": "url(#clip1_2327_84459)",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
                            "clip-path": "url(#clip2_2327_84459)",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                                d: "M37.6067 56.0157C30.2172 54.7386 28.1868 54.8133 25.4524 55.5974C22.244 56.5174 19.8923 58.636 18.5252 63.0876L18.2999 63.8158C18.1166 64.4149 18.0954 64.6161 18.1575 64.8325C18.2195 65.0489 18.3806 65.1979 18.854 65.3354L23.7082 66.7149C23.9684 66.7965 24.1713 66.8163 24.3536 66.7641C24.5724 66.7013 24.6872 66.5513 24.8129 66.164L25.1795 64.9659C25.7556 63.1222 26.5223 62.3559 27.689 62.0213C28.7099 61.7286 29.9957 61.6722 31.6974 61.9649L36.5788 62.7511C37.0783 62.8421 37.5213 62.598 37.5952 62.0303L38.3544 56.9723C38.4284 56.4046 38.1895 56.1218 37.6067 56.0157ZM16.4195 53.5425C23.8089 54.8196 25.8393 54.7449 28.5737 53.9608C31.7821 53.0408 34.1338 50.9222 35.5009 46.4706L35.7262 45.7424C35.9095 45.1433 35.9307 44.9421 35.8686 44.7257C35.8066 44.5093 35.6455 44.3603 35.1721 44.2228L30.3179 42.8433C30.0577 42.7617 29.8548 42.7419 29.6725 42.7941C29.4537 42.8569 29.3389 43.0069 29.2132 43.3942L28.8466 44.5923C28.2705 46.436 27.5038 47.2023 26.3371 47.5369C25.3162 47.8296 24.0304 47.886 22.3287 47.5933L17.4474 46.8071C16.9478 46.7161 16.5049 46.9602 16.4309 47.5279L15.6717 52.5859C15.5977 53.1536 15.8366 53.4364 16.4195 53.5425Z",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("mask", {
                id: "mask0_2327_84459",
                style: {
                    maskType: 'alpha'
                },
                maskUnits: "userSpaceOnUse",
                x: "42",
                y: "34",
                width: "47",
                height: "46",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M84.5407 70.1354C85.399 68.8074 86.1676 67.3446 86.8433 65.7294C87.5189 64.1142 88.0399 62.4937 88.382 60.9391C90.4423 51.6574 86.6686 43.8231 78.8282 38.9377C77.4887 38.1071 76.0405 37.3553 74.4713 36.6989C72.9021 36.0425 71.2192 35.49 69.6242 35.1148C60.6205 32.9978 52.4142 35.7994 47.265 43.7403C46.3964 45.0801 45.6116 46.5686 44.9302 48.1976C44.2488 49.8267 43.7528 51.3873 43.4099 52.9308C41.3701 62.1507 45.1318 69.9746 52.9733 74.9092C54.3603 75.7813 55.8756 76.5666 57.5047 77.248C59.1337 77.9294 60.6241 78.4122 62.158 78.7781C71.1529 80.9293 79.3919 78.1143 84.5361 70.1334L84.5407 70.1354Z",
                    fill: "#E2E3E4"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                mask: "url(#mask0_2327_84459)",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M65.4465 54.2364C48.7381 38.7562 43.5093 13.5402 54.257 -7.8265C56.8701 -13.0214 60.2302 -17.5913 64.1386 -21.4774L21.9822 -42.6824L-33.085 66.7933L44.6016 105.87C46.0277 93.9323 49.5157 82.0341 55.2309 70.6721C58.1886 64.7921 61.6171 59.3074 65.448 54.2371L65.4465 54.2364Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M65.4458 54.2338C82.2906 31.934 106.91 17.6731 133.454 13.3867L64.1379 -21.48C60.2294 -17.5938 56.8694 -13.024 54.2563 -7.82904C43.5086 13.5377 48.7381 38.7558 65.4458 54.2338Z",
                        fill: "#AF59E0"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M191.971 42.8203L153.078 23.2568C152.288 28.7116 150.622 34.1336 148.009 39.3286C134.987 65.2179 103.443 75.6484 77.5534 62.6258C73.0307 60.3509 68.9819 57.5093 65.4457 54.2328C61.6162 59.3039 58.1856 64.7893 55.2286 70.6678C49.5142 82.0285 46.0276 93.9273 44.5993 105.866L136.904 152.296L191.971 42.8203Z",
                        fill: "#6A9A23"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M65.4459 54.2343C68.9821 57.5108 73.0309 60.3524 77.5536 62.6273C103.443 75.6499 134.987 65.2194 148.009 39.3301C150.623 34.1351 152.288 28.7131 153.079 23.2584L133.454 13.3872C106.91 17.6737 82.2906 31.9345 65.4459 54.2343Z",
                        fill: "#1868DB"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M50.8357 59.1709C52.0329 63.3459 50.6336 67.65 47.5945 70.3584C43.5378 65.6894 41.9154 59.6856 43.4099 52.9307C43.7528 51.3873 44.2491 49.8271 44.9304 48.1982C45.4556 46.9426 46.0423 45.7704 46.6814 44.6855L50.8357 59.1709Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M77.573 60.512L56.5132 56.8549L57.1141 53.3945L78.1739 57.0517L77.573 60.512Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M63.7844 67.1848L67.4416 46.125L70.9019 46.7259L67.2448 67.7857L63.7844 67.1848Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                        id: "clip0_2327_84459",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            d: "M3.01494 50.2585C1.34983 44.4516 4.70743 38.3943 10.5143 36.7292L31.543 30.6993C37.3499 29.0342 43.4072 32.3918 45.0723 38.1987L51.1021 59.2274C52.7672 65.0343 49.4096 71.0916 43.6027 72.7567L22.5741 78.7865C16.7672 80.4516 10.7099 77.094 9.04481 71.2871L3.01494 50.2585Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                        id: "clip1_2327_84459",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                            width: "32.8142",
                            height: "32.8142",
                            fill: "white",
                            transform: "translate(6.54558 43.5566) rotate(-16)"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                        id: "clip2_2327_84459",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                            width: "22.5673",
                            height: "21.5753",
                            fill: "white",
                            transform: "translate(13.193 47.5195) rotate(-16)"
                        })
                    })
                ]
            })
        ]
    });


const $4372a63b22da5e93$var$i18n = (0, $kSwu1.defineMessages)({
    headingLabel: {
        id: "post-office.confluence-create-with-rovo-side-nav-nudge.heading",
        defaultMessage: "You describe, Rovo creates"
    },
    bodyLabel: {
        id: "post-office.confluence-create-with-rovo-side-nav-nudge.body",
        defaultMessage: "With a simple prompt, Rovo can draft a page or whiteboard."
    },
    callToActionLabel: {
        id: "post-office.confluence-create-with-rovo-side-nav-nudge.call.to.action",
        defaultMessage: "Show me how"
    },
    dismissLabel: {
        id: "post-office.confluence-create-with-rovo-side-nav-nudge.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $4372a63b22da5e93$var$styles = {
    root: "_2rko1mok _kqswh2mm _16jlkb7n _bfhk1s93",
    primaryContentContainer: "_1yt4pxbi _16jlkb7n",
    callToActionContainer: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _bfhk1j28 _9oik1r31 _1bnx8stv _jf4cnqa1 _9h8h12zz",
    imageContainer: "_16jlidpf _1o9zidpf _i0dl1wug",
    closeButtonContainer: "_kqswstnw _154iu2gc _1xi2u2gc"
};
const $4372a63b22da5e93$export$73f0a7caafa5e72e = ({ action: action, onPrimaryActionClick: onPrimaryActionClick, onDismissClick: onDismissClick })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $5jiof.useMessageInstanceEvent)();
    (0, $cozmU.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'ConfluenceCreateWithRovoSideNavNudge'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireMessageInstanceClicked = ({ actionType: actionType, clickedElement: clickedElement })=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: actionType
            },
            additionalMetadataFromFrontend: {}
        });
    };
    const handleOnPrimaryActionClick = ()=>{
        fireMessageInstanceClicked({
            actionType: 'open',
            clickedElement: {
                clickIdentifier: 'showMeHow',
                clickedElement: 'button',
                buttonType: 'primary'
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWithRovoSideNavNudgeCta'
        });
        onPrimaryActionClick?.(action);
    };
    const handleOnDismissClick = ()=>{
        fireMessageInstanceClicked({
            actionType: 'dismiss',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'cross-icon'
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWithRovoSideNavNudgeDismiss'
        });
        onDismissClick?.();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
        data: {
            source: 'confluence-create-with-rovo-side-nav-nudge'
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.default), {
            xcss: $4372a63b22da5e93$var$styles.root,
            testId: "confluence-create-with-rovo-side-nav-nudge",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.default), {
                    xcss: $4372a63b22da5e93$var$styles.primaryContentContainer,
                    gap: "space.100",
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...$4372a63b22da5e93$var$i18n.headingLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.default), {
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...$4372a63b22da5e93$var$i18n.bodyLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.default), {
                                xcss: $4372a63b22da5e93$var$styles.callToActionContainer,
                                onClick: handleOnPrimaryActionClick,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.default), {
                                    color: "color.link",
                                    size: "medium",
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                        ...$4372a63b22da5e93$var$i18n.callToActionLabel
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.default), {
                    xcss: $4372a63b22da5e93$var$styles.imageContainer,
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a077dd458a3b5801$export$75019b1a004a783d), {})
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                    xcss: $4372a63b22da5e93$var$styles.closeButtonContainer,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        icon: (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                                ...props,
                                size: "small"
                            }),
                        label: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...$4372a63b22da5e93$var$i18n.dismissLabel
                        }),
                        isTooltipDisabled: false,
                        onClick: handleOnDismissClick
                    })
                })
            ]
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $e785ea2c6ab864ab$export$a7a9523472993e97(value) {
    const result = $e785ea2c6ab864ab$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $e785ea2c6ab864ab$export$226b3eccf92c9ed9(value) {
    const result = $e785ea2c6ab864ab$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $e785ea2c6ab864ab$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else if (!('nextBestActionType' in value)) errors.push({
        path: 'value["nextBestActionType"]',
        expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
        value: undefined
    });
    else {
        let value__nextBestActionType___valid = false;
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_0 = [];
            if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_SPACE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_1 = [];
            if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_PAGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_2 = [];
            if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WHITEBOARD",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_3 = [];
            if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                path: 'value["nextBestActionType"]',
                expected: "1_ON_1_LOOM_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_4 = [];
            if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                path: 'value["nextBestActionType"]',
                expected: "LOOM_AI_MEETING_NOTES",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_5 = [];
            if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                path: 'value["nextBestActionType"]',
                expected: "RESURRECTED_USER_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_6 = [];
            if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WITH_ROVO_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_7 = [];
            if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_7.push({
                path: 'value["nextBestActionType"]',
                expected: "ROVO_EXTENSION_CTA",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_8 = [];
            if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_8.push({
                path: 'value["nextBestActionType"]',
                expected: "CONNECT_3P_TOOLS_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $a45ff7782c210ce6$export$e7843a8f64a8d87c = (0, $1828eaa171622856$export$d90b37843c84d1c3).createMessageBackend((0, $8ajDi.defaultMessageBackend));
const $a45ff7782c210ce6$export$fa9bb46961aca2cc = (0, $1828eaa171622856$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $e785ea2c6ab864ab$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4372a63b22da5e93$export$73f0a7caafa5e72e), {
                action: nextBestActionType,
                onPrimaryActionClick: onSideNavClick,
                onDismissClick: handleOnDismissed
            });
        }
    }
});


// integrated-teams/{your-team}/message-templates/{message-template}/src/placements/in-app-v2/{placement-id}/index.tsx




var $jKE9w = parcelRequire("jKE9w");


// See the current list of valid CCP product IDS here:
// This is a constant used to standardized the value of the "any" field in the message metadata
const $6ecfff7fdeb1e5f7$var$AnyValue = 'any';
const $6ecfff7fdeb1e5f7$export$d7170743086edf62 = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
const $6ecfff7fdeb1e5f7$export$749a64c68d670e1c = 'de63a248-1f93-46ed-b6ea-ab8e38af1c88';
const $6ecfff7fdeb1e5f7$export$7452609cc2879709 = '46ccaa9e-cdb0-4995-8886-5827a5ff162b';
const $6ecfff7fdeb1e5f7$export$d3304f5525ccba77 = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
const $6ecfff7fdeb1e5f7$export$c44082beda68c821 = '6aab3f4e-cc71-474d-8d28-abef8b057808';
const $6ecfff7fdeb1e5f7$export$3ffd6e56cffd07e5 = '0b8ea1e2-52df-11ea-8d77-2e728ce88125';
const $6ecfff7fdeb1e5f7$export$e91f394c1f32343a = '7c917705-866d-4b6b-b266-0fc7633e8342';
const $6ecfff7fdeb1e5f7$export$9135e98f8bbab458 = '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2';
const $6ecfff7fdeb1e5f7$export$a5e8ad58f7670c77 = 'f44da23e-5907-4d81-8a78-33bedee10969';
const $6ecfff7fdeb1e5f7$export$8ce8b463868cb16e = 'b6c5632b-6018-4656-b2ac-3e32e7cef0d3';
const $6ecfff7fdeb1e5f7$export$174b0d3ebcf732d2 = 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551';
const $6ecfff7fdeb1e5f7$export$fe6a238b700ff48b = '91ae3e3f-138e-43be-98cc-48df03d13c32';
const $6ecfff7fdeb1e5f7$export$23a18b32c52da583 = '56cce7cb-8c54-4103-8736-e64d1ab00128';
const $6ecfff7fdeb1e5f7$export$a9a5d8e6a4b07b3 = '7683a73e-423d-41a1-b43f-d497656f8b5d';
const $6ecfff7fdeb1e5f7$export$b729c699fa9f25a6 = 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905';
const $6ecfff7fdeb1e5f7$export$64ae0929ad3ee453 = 'dbe4d391-d570-4313-ab0f-3a02dbab4720';
const $6ecfff7fdeb1e5f7$export$2ee82f14fe1b2d80 = $6ecfff7fdeb1e5f7$var$AnyValue;
const $6ecfff7fdeb1e5f7$export$a0b0b6a3fe1e8702 = 'fake-id';
const $6ecfff7fdeb1e5f7$export$ba7683be5feaa33e = {
    JiraSoftwareCcpId: $6ecfff7fdeb1e5f7$export$d7170743086edf62,
    JiraServiceManagementCcpId: $6ecfff7fdeb1e5f7$export$749a64c68d670e1c,
    JiraWorkManagementCloudCcpId: $6ecfff7fdeb1e5f7$export$7452609cc2879709,
    JiraProductDiscoveryCcpId: $6ecfff7fdeb1e5f7$export$d3304f5525ccba77,
    ConfluenceCloudCcpId: $6ecfff7fdeb1e5f7$export$c44082beda68c821,
    StatuspageCcpId: $6ecfff7fdeb1e5f7$export$3ffd6e56cffd07e5,
    AtlasCcpId: $6ecfff7fdeb1e5f7$export$e91f394c1f32343a,
    CompassCcpId: $6ecfff7fdeb1e5f7$export$9135e98f8bbab458,
    AtlassianAnalyticsCcpId: $6ecfff7fdeb1e5f7$export$a5e8ad58f7670c77,
    AtlassianWhiteboardCcpId: $6ecfff7fdeb1e5f7$export$8ce8b463868cb16e,
    OpsgenieCcpId: $6ecfff7fdeb1e5f7$export$174b0d3ebcf732d2,
    RovoCcpId: $6ecfff7fdeb1e5f7$export$fe6a238b700ff48b,
    RovoDevCcpId: $6ecfff7fdeb1e5f7$export$23a18b32c52da583,
    LoomCcpId: $6ecfff7fdeb1e5f7$export$a9a5d8e6a4b07b3,
    FocusCcpId: $6ecfff7fdeb1e5f7$export$b729c699fa9f25a6,
    StudioCcpId: $6ecfff7fdeb1e5f7$export$64ae0929ad3ee453,
    AnyProductCcpId: $6ecfff7fdeb1e5f7$export$2ee82f14fe1b2d80,
    TestProductCcpId: $6ecfff7fdeb1e5f7$export$a0b0b6a3fe1e8702
};
const $6ecfff7fdeb1e5f7$export$ed719b477b100ccf = 'free';
const $6ecfff7fdeb1e5f7$export$9c0d875ac3fc7486 = 'standard';
const $6ecfff7fdeb1e5f7$export$ef90b2d2063bbde5 = 'premium';
const $6ecfff7fdeb1e5f7$export$de3613be25133e67 = $6ecfff7fdeb1e5f7$var$AnyValue;
const $6ecfff7fdeb1e5f7$export$3089d1941106d80a = {
    FreeEdition: $6ecfff7fdeb1e5f7$export$ed719b477b100ccf,
    StandardEdition: $6ecfff7fdeb1e5f7$export$9c0d875ac3fc7486,
    PremiumEdiiton: $6ecfff7fdeb1e5f7$export$ef90b2d2063bbde5,
    AnyEdition: $6ecfff7fdeb1e5f7$export$de3613be25133e67
};
const $6ecfff7fdeb1e5f7$export$935920ee20f5fbfd = 'signup';
const $6ecfff7fdeb1e5f7$export$af08535a504b4ba1 = 'd1to6ai';
const $6ecfff7fdeb1e5f7$export$2e8b1b8d42494923 = 'ffp';
const $6ecfff7fdeb1e5f7$export$2887820b2787a3b = 'fo';
const $6ecfff7fdeb1e5f7$export$17c81379c0af852c = 'mcu';
const $6ecfff7fdeb1e5f7$export$7af8db49468f6ca0 = 'mau';
const $6ecfff7fdeb1e5f7$export$4a4a9bf2ef44c9d3 = 'macm'; // Month Active Community Member
const $6ecfff7fdeb1e5f7$export$1d22059176a01613 = 'purchase';
const $6ecfff7fdeb1e5f7$export$62e129faf973b35b = 'm2_ati';
const $6ecfff7fdeb1e5f7$export$b2e16dc790f0af57 = 'peu';
const $6ecfff7fdeb1e5f7$export$b02d9c969aca0c41 = 'event_registration';
const $6ecfff7fdeb1e5f7$export$6086e660e37fefd1 = 'tech_alert';
const $6ecfff7fdeb1e5f7$export$74d3ca88165fd9c7 = 'commerce_notification';
const $6ecfff7fdeb1e5f7$export$95514713d19a18ca = 'webinar_invites';
const $6ecfff7fdeb1e5f7$export$91eb8e25419b040e = 'demo';
const $6ecfff7fdeb1e5f7$export$2d677556a829b674 = 'survey_research';
const $6ecfff7fdeb1e5f7$export$c1b571ea4fc68de = 'clickthrough';
const $6ecfff7fdeb1e5f7$export$abb11c2932ba2d5f = {
    SignupGoal: $6ecfff7fdeb1e5f7$export$935920ee20f5fbfd,
    D1to6aiGoal: $6ecfff7fdeb1e5f7$export$af08535a504b4ba1,
    FfpGoal: $6ecfff7fdeb1e5f7$export$2e8b1b8d42494923,
    FoGoal: $6ecfff7fdeb1e5f7$export$2887820b2787a3b,
    McuGoal: $6ecfff7fdeb1e5f7$export$17c81379c0af852c,
    MauGoal: $6ecfff7fdeb1e5f7$export$7af8db49468f6ca0,
    MacmGoal: $6ecfff7fdeb1e5f7$export$4a4a9bf2ef44c9d3,
    PurchaseGoal: $6ecfff7fdeb1e5f7$export$1d22059176a01613,
    M2AtiGoal: $6ecfff7fdeb1e5f7$export$62e129faf973b35b,
    PeuGoal: $6ecfff7fdeb1e5f7$export$b2e16dc790f0af57,
    EventRegistrationGoal: $6ecfff7fdeb1e5f7$export$b02d9c969aca0c41,
    TechAlertGoal: $6ecfff7fdeb1e5f7$export$6086e660e37fefd1,
    CommerceNotificationGoal: $6ecfff7fdeb1e5f7$export$74d3ca88165fd9c7,
    WebinarInvitesGoal: $6ecfff7fdeb1e5f7$export$95514713d19a18ca,
    DemoGoal: $6ecfff7fdeb1e5f7$export$91eb8e25419b040e,
    SurveryResearchGoal: $6ecfff7fdeb1e5f7$export$2d677556a829b674,
    ClickthroughGoal: $6ecfff7fdeb1e5f7$export$c1b571ea4fc68de
};
const $6ecfff7fdeb1e5f7$export$428528e1e61b68ff = 'ui';
const $6ecfff7fdeb1e5f7$export$d4c7c79f2dff5f1f = 'track';
const $6ecfff7fdeb1e5f7$export$287340d0a2f482b0 = 'screen';
const $6ecfff7fdeb1e5f7$var$ValidGASv3EventTypes = {
    UIEventTypeGASv3: $6ecfff7fdeb1e5f7$export$428528e1e61b68ff,
    TrackEventTypeGASv3: $6ecfff7fdeb1e5f7$export$d4c7c79f2dff5f1f,
    ScreenEventTypeGASv3: $6ecfff7fdeb1e5f7$export$287340d0a2f482b0
};
const $6ecfff7fdeb1e5f7$export$42867c57e2cf7ae6 = {
    SignupGoal: $6ecfff7fdeb1e5f7$export$935920ee20f5fbfd,
    D1to6aiGoal: $6ecfff7fdeb1e5f7$export$af08535a504b4ba1,
    FfpGoal: $6ecfff7fdeb1e5f7$export$2e8b1b8d42494923,
    FoGoal: $6ecfff7fdeb1e5f7$export$2887820b2787a3b,
    McuGoal: $6ecfff7fdeb1e5f7$export$17c81379c0af852c,
    MauGoal: $6ecfff7fdeb1e5f7$export$7af8db49468f6ca0,
    PurchaseGoal: $6ecfff7fdeb1e5f7$export$1d22059176a01613,
    M2AtiGoal: $6ecfff7fdeb1e5f7$export$62e129faf973b35b,
    PeuGoal: $6ecfff7fdeb1e5f7$export$b2e16dc790f0af57
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $05777983b44ef4a2$export$a7a9523472993e97(value) {
    const result = $05777983b44ef4a2$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $05777983b44ef4a2$export$226b3eccf92c9ed9(value) {
    const result = $05777983b44ef4a2$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $05777983b44ef4a2$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"ROVO_EXTENSION_CTA"',
            value: undefined
        });
        else if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") errors.push({
            path: 'value["nextBestActionType"]',
            expected: "ROVO_EXTENSION_CTA",
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


/* LeftNavCtaMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("cozmU");





var $w6R6I = parcelRequire("w6R6I");











var $i1t43 = parcelRequire("i1t43");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $2wCqQ = parcelRequire("2wCqQ");

var $6Pqow = parcelRequire("6Pqow");







var $c0edc3795d3ac122$exports = {};
$c0edc3795d3ac122$exports = new URL("chrome-icon.40414d4b.svg", import.meta.url).toString();


var $b3436f676e5afb95$exports = {};
$b3436f676e5afb95$exports = new URL("rovo-icon.a638efdd.svg", import.meta.url).toString();








const $dccf3ed4fa134e1f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    linkText: {
        id: "rovo-extension-install-cta-left-nav.link",
        defaultMessage: "Get the browser extension"
    },
    jiraLinkText: {
        id: "rovo-extension-install-cta-left-nav.jira-link",
        defaultMessage: "Get the browser extension"
    },
    jiraRovoLinkText: {
        id: "rovo-extension-install-cta-left-nav.jira-rovo-link",
        defaultMessage: "Get the Rovo extension"
    },
    rovoIconAlt: {
        id: "rovo-extension-install-cta-left-nav.rovo-icon-alt",
        defaultMessage: "Rovo Icon"
    },
    chromeIconAlt: {
        id: "rovo-extension-install-cta-left-nav.chrome-icon-alt",
        defaultMessage: "Google Chrome Icon"
    },
    jiraIconAlt: {
        id: "rovo-extension-install-cta-left-nav.jira-icon-alt",
        defaultMessage: "Jira Icon"
    },
    dismissLabel: {
        id: "rovo-extension-install-cta-left-nav.dismiss-label",
        defaultMessage: "Dismiss message"
    }
});
const $dccf3ed4fa134e1f$export$1d02164cdbd97674 = {
    'copy-version-b': (0, $kSwu1.defineMessages)({
        heading: {
            id: "rovo-extension-install-cta-left-nav.heading.copy-version-b",
            defaultMessage: "Get answers for work, anywhere"
        },
        description: {
            id: "rovo-extension-install-cta-left-nav.description.copy-version-b",
            defaultMessage: "Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab."
        }
    }),
    'copy-version-c': (0, $kSwu1.defineMessages)({
        heading: {
            id: "rovo-extension-install-cta-left-nav.heading.copy-version-c",
            defaultMessage: "Unlock Rovo in every tab"
        },
        description: {
            id: "rovo-extension-install-cta-left-nav.description.copy-version-c",
            defaultMessage: "50K+ workers use it to chat with AI that understands their company."
        }
    }),
    'jira-take-anywhere': (0, $kSwu1.defineMessages)({
        heading: {
            id: "rovo-extension-install-cta-left-nav.heading.jira-take-anywhere",
            defaultMessage: "Jira. Anywhere."
        },
        description: {
            id: "rovo-extension-install-cta-left-nav.description.jira-take-anywhere",
            defaultMessage: "Manage work items, get instant insights, and act on Jira from any tab in your browser."
        }
    }),
    'jira-rovo': (0, $kSwu1.defineMessages)({
        heading: {
            id: "rovo-extension-install-cta-left-nav.heading.jira-rovo",
            defaultMessage: "Jira. Anywhere."
        },
        description: {
            id: "rovo-extension-install-cta-left-nav.description.jira-rovo",
            defaultMessage: "Manage work items, get instant insights, and act on Jira from any tab in your browser."
        }
    })
};


const $dbbe9ed9d8ce5ba8$var$styles = {
    boxContainer: "_1yt4utpp _zulpu2gc _2rko12b0 _ae4v1h6o _1bah1h6o _1e0c1txw _1bsb1osq _4cvr1y6m _bfhk1s93",
    contentStack: "_zulpu2gc _1bsb1osq",
    headerRow: "_1bah1yb4 _4cvr1y6m _1bsb1osq",
    iconAndTitle: "_zulpu2gc",
    iconContainer: "_1e0c1txw _4cvr1h6o"
};
const $dbbe9ed9d8ce5ba8$var$getLinkUrl = (cohort)=>{
    const UTM_CONTENT = `side_nav_install_cta_${cohort}`;
    return `https://chromewebstore.google.com/detail/rovo-search-chat-and-more/npbjhobkibekbklkghlhfhieggcggpdb?utm_source=confluence-side-nav&utm_medium=banner&utm_campaign=rovo_extension_side_nav_install_cta&utm_content=${UTM_CONTENT}`;
};
const $dbbe9ed9d8ce5ba8$var$selectCopyForCohort = (cohort)=>{
    return (0, $dccf3ed4fa134e1f$export$1d02164cdbd97674)[cohort] || (0, $dccf3ed4fa134e1f$export$1d02164cdbd97674)['copy-version-b'];
};
const $dbbe9ed9d8ce5ba8$export$217ec4c85bc42809 = ({ context: context, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
    const { experimentCohort: experimentCohort } = context;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { heading: heading, description: description } = $dbbe9ed9d8ce5ba8$var$selectCopyForCohort(experimentCohort);
    const { messageClicked: messageClicked } = (0, $baFbJ.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $5jiof.useMessageInstanceEvent)();
    const headingText = formatMessage(heading);
    const descriptionText = formatMessage(description);
    const linkText = formatMessage((0, $dccf3ed4fa134e1f$export$defe85febe8b728c).linkText);
    const rovoIconAlt = formatMessage((0, $dccf3ed4fa134e1f$export$defe85febe8b728c).rovoIconAlt);
    const chromeIconAlt = formatMessage((0, $dccf3ed4fa134e1f$export$defe85febe8b728c).chromeIconAlt);
    const dismissLabel = formatMessage((0, $dccf3ed4fa134e1f$export$defe85febe8b728c).dismissLabel);
    const linkUrl = $dbbe9ed9d8ce5ba8$var$getLinkUrl(experimentCohort);
    const handleDismiss = ()=>{
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: 'confluence-side-nav'
            }
        });
        handleOnDismissed();
    };
    const handleLinkClick = ()=>{
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'installLink',
                clickedElement: 'link'
            },
            action: {
                actionType: 'open',
                destinationUrl: linkUrl
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: 'confluence-side-nav'
            }
        });
        onSideNavClick('ROVO_EXTENSION_CTA');
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.default), {
        xcss: (0, $w6R6I.cx)($dbbe9ed9d8ce5ba8$var$styles.boxContainer),
        style: {
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2wCqQ.default), {
            xcss: (0, $w6R6I.cx)($dbbe9ed9d8ce5ba8$var$styles.contentStack),
            testId: "rovo-left-nav-content",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kz1Yj.default), {
                    xcss: (0, $w6R6I.cx)($dbbe9ed9d8ce5ba8$var$styles.headerRow),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kz1Yj.default), {
                            xcss: (0, $w6R6I.cx)($dbbe9ed9d8ce5ba8$var$styles.iconAndTitle),
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3izAL.default), {
                                    xcss: (0, $w6R6I.cx)($dbbe9ed9d8ce5ba8$var$styles.iconContainer),
                                    children: [
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b3436f676e5afb95$exports))),
                                            alt: rovoIconAlt,
                                            width: 24,
                                            height: 24,
                                            style: {
                                                flexShrink: 0,
                                                zIndex: 2
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($c0edc3795d3ac122$exports))),
                                            alt: chromeIconAlt,
                                            width: 24,
                                            height: 24,
                                            style: {
                                                marginLeft: '-8px',
                                                flexShrink: 0,
                                                zIndex: 1
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                    size: "xsmall",
                                    children: headingText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                            label: dismissLabel,
                            appearance: "subtle",
                            spacing: "compact",
                            onClick: handleDismiss
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6Pqow.default), {
                    size: "small",
                    children: descriptionText
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
                    href: linkUrl,
                    target: "blank",
                    onClick: handleLinkClick,
                    children: linkText
                })
            ]
        })
    });
};


const $5e23b76fbc0262f2$export$e7843a8f64a8d87c = (0, $1828eaa171622856$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $05777983b44ef4a2$export$a7a9523472993e97),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: (0, $6ecfff7fdeb1e5f7$export$7af8db49468f6ca0),
                            targetProduct: [
                                (0, $6ecfff7fdeb1e5f7$export$fe6a238b700ff48b)
                            ],
                            edition: [
                                (0, $6ecfff7fdeb1e5f7$export$de3613be25133e67)
                            ]
                        }
                    }
                })
        }
    }));
const $5e23b76fbc0262f2$export$fa9bb46961aca2cc = (0, $1828eaa171622856$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $jKE9w.noValidation)(),
        Component: (props)=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dbbe9ed9d8ce5ba8$export$217ec4c85bc42809), {
                ...props,
                context: {
                    experimentCohort: props.experimentCohort,
                    source: 'confluence-side-nav'
                }
            });
        }
    }
});















const $ac74b4b866724298$export$f83734c268a0a1ff = ({ onDismissed: onDismissed, clickIdentifier: clickIdentifier })=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $5jiof.useMessageInstanceEvent)();
    const { messageDismissed: messageDismissed } = (0, $baFbJ.useMessageEvent)();
    const handleDismiss = ()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: clickIdentifier,
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        messageDismissed();
        onDismissed();
    };
    return {
        handleDismiss: handleDismiss
    };
};


/* generic-banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $9DHhW = parcelRequire("9DHhW");






















var $f58e5f62d40b2187$exports = {};
$f58e5f62d40b2187$exports = new URL("twc-app-tiles.b4f04c82.svg", import.meta.url).toString();


const $f70a6a26cf486338$var$styles = {
    root: "_2rko1mok _195gidpf _1mou1b66 _1bsb1osq _bfhk1s93 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    appTilesWrapper: "_19pkutpp",
    headerRow: "_zulputpp _1e0c1txw _4cvr1y6m _1bah1yb4"
};
const $f70a6a26cf486338$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        id: "twc.sidenav.banner.generic.heading",
        defaultMessage: "Explore Teamwork Collection"
    },
    subheadingJira: {
        id: "twc.sidenav.banner.generic.subheading.jira",
        defaultMessage: "Discover how the other apps can accelerate your workflows in Jira."
    },
    subheadingConfluence: {
        id: "twc.sidenav.banner.generic.subheading.confluence",
        defaultMessage: "Discover how the other apps can accelerate your workflows in Confluence."
    },
    appTilesAlt: {
        id: "twc.sidenav.banner.generic.app.tiles.alt",
        defaultMessage: "App tiles illustration"
    },
    ctaButton: {
        id: "twc.sidenav.banner.generic.cta",
        defaultMessage: "Try now"
    },
    closeLabel: {
        id: "twc.sidenav.banner.generic.close",
        defaultMessage: "Close"
    }
});
const $f70a6a26cf486338$export$a350437cbfeb32d4 = ({ href: href, locale: locale, product: product, messageInstanceId: messageInstanceId, onClose: onClose, onCtaClick: onCtaClick, surfaceProduct: surfaceProduct })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcGenericBanner',
            attributes: {
                product: product,
                surfaceProduct: surfaceProduct,
                messageInstanceId: messageInstanceId,
                locale: locale,
                arm: 'generic'
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        product,
        surfaceProduct,
        messageInstanceId,
        locale
    ]);
    const handleClose = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcGenericBannerClose',
            attributes: {
                product: product,
                surfaceProduct: surfaceProduct,
                messageInstanceId: messageInstanceId,
                locale: locale,
                arm: 'generic'
            }
        }).fire('growth');
        onClose?.();
    };
    const handleCtaClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcGenericBannerCta',
            attributes: {
                product: product,
                surfaceProduct: surfaceProduct,
                messageInstanceId: messageInstanceId,
                locale: locale,
                arm: 'generic'
            }
        }).fire('growth');
        onCtaClick?.();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
        xcss: $f70a6a26cf486338$var$styles.root,
        testId: "twc-generic-banner",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.default), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.default), {
                    xcss: $f70a6a26cf486338$var$styles.headerRow,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                            xcss: $f70a6a26cf486338$var$styles.appTilesWrapper,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f58e5f62d40b2187$exports))),
                                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($f58e5f62d40b2187$exports))),
                                alt: formatMessage($f70a6a26cf486338$var$messages.appTilesAlt),
                                testId: "twc-generic-banner-app-tiles",
                                width: 91
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            onClick: handleClose,
                            label: formatMessage($f70a6a26cf486338$var$messages.closeLabel),
                            testId: "twc-generic-banner-close",
                            appearance: "subtle"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                            as: "h3",
                            size: "xsmall",
                            testId: "twc-generic-banner-heading",
                            children: formatMessage($f70a6a26cf486338$var$messages.heading)
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.default), {
                            as: "p",
                            size: "small",
                            color: "color.text.subtle",
                            maxLines: 2,
                            testId: "twc-generic-banner-subheading",
                            children: product === 'jira' ? formatMessage($f70a6a26cf486338$var$messages.subheadingJira) : formatMessage($f70a6a26cf486338$var$messages.subheadingConfluence)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                    shouldFitContainer: true,
                    href: href,
                    testId: "twc-generic-banner-cta",
                    onClick: handleCtaClick,
                    target: "_blank",
                    children: formatMessage($f70a6a26cf486338$var$messages.ctaButton)
                })
            ]
        })
    });
};


/* personalized-banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 

































const $f255002101c7218b$var$styles = {
    root: "_2rko1mok _195gidpf _1mou1b66 _1bsb1osq _bfhk1s93 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    headerRow: "_zulputpp _1e0c1txw _4cvr1y6m _1bah1yb4",
    logoWrapper: "_19pkutpp"
};
const $f255002101c7218b$var$messages = (0, $kSwu1.defineMessages)({
    subheadingConfluence: {
        id: "twc.sidenav.banner.personalized.subheading.confluence",
        defaultMessage: "Create with Rovo in Confluence"
    },
    subheadingJira: {
        id: "twc.sidenav.banner.personalized.subheading.jira",
        defaultMessage: "Plan your next team project in Jira"
    },
    subheadingLoom: {
        id: "twc.sidenav.banner.personalized.subheading.loom",
        defaultMessage: "Setup video meetings with Loom AI"
    },
    appTilesAlt: {
        id: "twc.sidenav.banner.personalized.app.tiles.alt",
        defaultMessage: "App tiles illustration"
    },
    heading: {
        id: "twc.sidenav.banner.personalized.heading",
        defaultMessage: "Explore Teamwork Collection"
    },
    ctaButton: {
        id: "twc.sidenav.banner.personalized.cta",
        defaultMessage: "Get started"
    },
    closeLabel: {
        id: "twc.sidenav.banner.personalized.close",
        defaultMessage: "Close"
    }
});
const $f255002101c7218b$var$subheadingByApp = {
    confluence: $f255002101c7218b$var$messages.subheadingConfluence,
    jira: $f255002101c7218b$var$messages.subheadingJira,
    loom: $f255002101c7218b$var$messages.subheadingLoom
};
const $f255002101c7218b$var$destinationTypeByApp = {
    confluence: 'create_with_rovo',
    jira: 'jira_onboarding',
    loom: 'loom_meetings'
};
const $f255002101c7218b$export$44c5a4ad6d35d2bf = ({ href: href, locale: locale, recommendedApp: recommendedApp, messageInstanceId: messageInstanceId, onClose: onClose, onCtaClick: onCtaClick, experimentKey: experimentKey, actionTier: actionTier, targetTenantId: targetTenantId, collectionEntitlementId: collectionEntitlementId, surfaceProduct: surfaceProduct })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
            recommendedApp: recommendedApp,
            messageInstanceId: messageInstanceId,
            locale: locale,
            experimentKey: experimentKey,
            actionTier: actionTier,
            targetTenantId: targetTenantId,
            collectionEntitlementId: collectionEntitlementId,
            surfaceProduct: surfaceProduct,
            destinationType: $f255002101c7218b$var$destinationTypeByApp[recommendedApp],
            arm: 'personalized'
        }), [
        recommendedApp,
        messageInstanceId,
        locale,
        experimentKey,
        actionTier,
        targetTenantId,
        collectionEntitlementId,
        surfaceProduct
    ]);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcPersonalizedBanner',
            attributes: analyticsAttributes
        }).fire('growth');
    }, [
        analyticsAttributes,
        createAnalyticsEvent
    ]);
    const handleClose = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcPersonalizedBannerClose',
            attributes: analyticsAttributes
        }).fire('growth');
        onClose?.();
    };
    const handleCtaClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcPersonalizedBannerCta',
            attributes: analyticsAttributes
        }).fire('growth');
        onCtaClick?.();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
        xcss: $f255002101c7218b$var$styles.root,
        testId: "twc-personalized-banner",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.default), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.default), {
                    xcss: $f255002101c7218b$var$styles.headerRow,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                            xcss: $f255002101c7218b$var$styles.logoWrapper,
                            testId: "twc-personalized-banner-logo",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f58e5f62d40b2187$exports))),
                                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($f58e5f62d40b2187$exports))),
                                alt: formatMessage($f255002101c7218b$var$messages.appTilesAlt),
                                testId: "twc-personalized-banner-app-tiles",
                                width: 91
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            onClick: handleClose,
                            label: formatMessage($f255002101c7218b$var$messages.closeLabel),
                            testId: "twc-personalized-banner-close",
                            appearance: "subtle"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                            as: "h3",
                            size: "xsmall",
                            testId: "twc-personalized-banner-heading",
                            children: formatMessage($f255002101c7218b$var$messages.heading)
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.default), {
                            as: "p",
                            size: "small",
                            color: "color.text.subtle",
                            maxLines: 2,
                            testId: "twc-personalized-banner-subheading",
                            children: formatMessage($f255002101c7218b$var$subheadingByApp[recommendedApp])
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                    shouldFitContainer: true,
                    href: href,
                    testId: "twc-personalized-banner-cta",
                    onClick: handleCtaClick,
                    target: "_blank",
                    children: formatMessage($f255002101c7218b$var$messages.ctaButton)
                })
            ]
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $2812db53bbf99e54$export$a7a9523472993e97(value) {
    const result = $2812db53bbf99e54$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $2812db53bbf99e54$export$226b3eccf92c9ed9(value) {
    const result = $2812db53bbf99e54$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $2812db53bbf99e54$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('product' in value)) errors.push({
            path: 'value["product"]',
            expected: '"jira" | "confluence" | "jira-confluence"',
            value: undefined
        });
        else {
            let value__product___valid = false;
            if (!value__product___valid) {
                const value__product___errors_0 = [];
                if (value["product"] !== "jira") value__product___errors_0.push({
                    path: 'value["product"]',
                    expected: "jira",
                    value: value["product"]
                });
                if (value__product___errors_0.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) {
                const value__product___errors_1 = [];
                if (value["product"] !== "confluence") value__product___errors_1.push({
                    path: 'value["product"]',
                    expected: "confluence",
                    value: value["product"]
                });
                if (value__product___errors_1.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) {
                const value__product___errors_2 = [];
                if (value["product"] !== "jira-confluence") value__product___errors_2.push({
                    path: 'value["product"]',
                    expected: "jira-confluence",
                    value: value["product"]
                });
                if (value__product___errors_2.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) errors.push({
                path: 'value["product"]',
                expected: '"jira" | "confluence" | "jira-confluence"',
                value: value["product"]
            });
        }
        if (!('cloudId' in value)) errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["cloudId"] !== 'string') errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: value["cloudId"]
        });
        if ('orgId' in value && value['orgId'] !== undefined) {
            if (typeof value["orgId"] !== 'string') errors.push({
                path: 'value["orgId"]',
                expected: 'string',
                value: value["orgId"]
            });
        }
        if ('twcEntitlementId' in value && value['twcEntitlementId'] !== undefined) {
            if (typeof value["twcEntitlementId"] !== 'string') errors.push({
                path: 'value["twcEntitlementId"]',
                expected: 'string',
                value: value["twcEntitlementId"]
            });
        }
        if ('redirectTo' in value && value['redirectTo'] !== undefined) {
            let value__redirectTo___valid = false;
            if (!value__redirectTo___valid) {
                const value__redirectTo___errors_0 = [];
                if (value["redirectTo"] !== "jira") value__redirectTo___errors_0.push({
                    path: 'value["redirectTo"]',
                    expected: "jira",
                    value: value["redirectTo"]
                });
                if (value__redirectTo___errors_0.length === 0) value__redirectTo___valid = true;
            }
            if (!value__redirectTo___valid) {
                const value__redirectTo___errors_1 = [];
                if (value["redirectTo"] !== "confluence") value__redirectTo___errors_1.push({
                    path: 'value["redirectTo"]',
                    expected: "confluence",
                    value: value["redirectTo"]
                });
                if (value__redirectTo___errors_1.length === 0) value__redirectTo___valid = true;
            }
            if (!value__redirectTo___valid) errors.push({
                path: 'value["redirectTo"]',
                expected: '"jira" | "confluence"',
                value: value["redirectTo"]
            });
        }
        if (!('recommendedApp' in value)) errors.push({
            path: 'value["recommendedApp"]',
            expected: '"confluence" | "jira" | "loom"',
            value: undefined
        });
        else {
            let value__recommendedApp___valid = false;
            if (!value__recommendedApp___valid) {
                const value__recommendedApp___errors_0 = [];
                if (value["recommendedApp"] !== "confluence") value__recommendedApp___errors_0.push({
                    path: 'value["recommendedApp"]',
                    expected: "confluence",
                    value: value["recommendedApp"]
                });
                if (value__recommendedApp___errors_0.length === 0) value__recommendedApp___valid = true;
            }
            if (!value__recommendedApp___valid) {
                const value__recommendedApp___errors_1 = [];
                if (value["recommendedApp"] !== "jira") value__recommendedApp___errors_1.push({
                    path: 'value["recommendedApp"]',
                    expected: "jira",
                    value: value["recommendedApp"]
                });
                if (value__recommendedApp___errors_1.length === 0) value__recommendedApp___valid = true;
            }
            if (!value__recommendedApp___valid) {
                const value__recommendedApp___errors_2 = [];
                if (value["recommendedApp"] !== "loom") value__recommendedApp___errors_2.push({
                    path: 'value["recommendedApp"]',
                    expected: "loom",
                    value: value["recommendedApp"]
                });
                if (value__recommendedApp___errors_2.length === 0) value__recommendedApp___valid = true;
            }
            if (!value__recommendedApp___valid) errors.push({
                path: 'value["recommendedApp"]',
                expected: '"confluence" | "jira" | "loom"',
                value: value["recommendedApp"]
            });
        }
        if (!('actionTier' in value)) errors.push({
            path: 'value["actionTier"]',
            expected: '"high" | "medium" | "low"',
            value: undefined
        });
        else {
            let value__actionTier___valid = false;
            if (!value__actionTier___valid) {
                const value__actionTier___errors_0 = [];
                if (value["actionTier"] !== "high") value__actionTier___errors_0.push({
                    path: 'value["actionTier"]',
                    expected: "high",
                    value: value["actionTier"]
                });
                if (value__actionTier___errors_0.length === 0) value__actionTier___valid = true;
            }
            if (!value__actionTier___valid) {
                const value__actionTier___errors_1 = [];
                if (value["actionTier"] !== "medium") value__actionTier___errors_1.push({
                    path: 'value["actionTier"]',
                    expected: "medium",
                    value: value["actionTier"]
                });
                if (value__actionTier___errors_1.length === 0) value__actionTier___valid = true;
            }
            if (!value__actionTier___valid) {
                const value__actionTier___errors_2 = [];
                if (value["actionTier"] !== "low") value__actionTier___errors_2.push({
                    path: 'value["actionTier"]',
                    expected: "low",
                    value: value["actionTier"]
                });
                if (value__actionTier___errors_2.length === 0) value__actionTier___valid = true;
            }
            if (!value__actionTier___valid) errors.push({
                path: 'value["actionTier"]',
                expected: '"high" | "medium" | "low"',
                value: value["actionTier"]
            });
        }
        if ('targetTenantId' in value && value['targetTenantId'] !== undefined) {
            if (typeof value["targetTenantId"] !== 'string') errors.push({
                path: 'value["targetTenantId"]',
                expected: 'string',
                value: value["targetTenantId"]
            });
        }
        if ('collectionEntitlementId' in value && value['collectionEntitlementId'] !== undefined) {
            if (typeof value["collectionEntitlementId"] !== 'string') errors.push({
                path: 'value["collectionEntitlementId"]',
                expected: 'string',
                value: value["collectionEntitlementId"]
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}



var $7avaU = parcelRequire("7avaU");

const $7f5087a3fe7759b8$var$normalizeEntitlementId = (value)=>(0, $7avaU.AnyAri).check(value) ? (0, $7avaU.AnyAri).parse(value).resourceId : value;
const $7f5087a3fe7759b8$export$cf98bfae195146d6 = async (requestContext, orgId, entitlementId, tenantId, messageInstanceId, messageTemplateId)=>{
    const { logger: logger, graphqlClients: graphqlClients } = requestContext;
    if (!orgId) {
        logger.error({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId
        }, 'Org ID not available');
        return undefined;
    }
    if (!entitlementId) {
        logger.error({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId
        }, 'Entitlement ID not available');
        return undefined;
    }
    const normalizedEntitlementId = $7f5087a3fe7759b8$var$normalizeEntitlementId(entitlementId);
    const resolvedTenantId = tenantId ?? requestContext.orchestrationContext.tenantId;
    const filter = {
        entitlementId: normalizedEntitlementId,
        ...resolvedTenantId ? {
            tenantId: resolvedTenantId
        } : {}
    };
    try {
        const orgProfile = await graphqlClients.growthUnifiedProfile.getOrgProfile(orgId, filter);
        const [onboardingContext] = orgProfile.twcOnboardingContext ?? [];
        if (!onboardingContext) {
            logger.error({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                orgId: orgId,
                entitlementId: entitlementId
            }, 'No TWC onboarding context found in GUPS profile');
            return undefined;
        }
        const { onboardingUrl: onboardingUrl } = onboardingContext;
        if (!onboardingUrl) {
            logger.error({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                orgId: orgId,
                entitlementId: entitlementId
            }, 'No onboarding URL found in TWC onboarding context');
            return undefined;
        }
        logger.info({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            orgId: orgId,
            entitlementId: entitlementId,
            onboardingUrl: onboardingUrl
        }, 'Successfully fetched onboarding URL from GUPS');
        return onboardingUrl;
    } catch (error) {
        logger.error({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            orgId: orgId,
            entitlementId: entitlementId,
            error: error
        }, 'Error fetching onboarding URL from GUPS');
        return undefined;
    }
};



var $9zrom = parcelRequire("9zrom");

const $925790e456956de0$var$LOOM_ONBOARDING_URL_PROD = 'https://www.loom.com/meetings';
const $925790e456956de0$var$LOOM_ONBOARDING_URL_NON_PROD = 'https://stage.loom.com/meetings';
// Unified Rovo create surface — tenant-agnostic, AI-first Confluence create experience.
const $925790e456956de0$var$CONFLUENCE_CREATE_WITH_ROVO_URL = 'https://create.rovo.com';
const $925790e456956de0$export$7abc4e1301ef2c74 = (environmentType)=>{
    return environmentType === 'Production' ? $925790e456956de0$var$LOOM_ONBOARDING_URL_PROD : $925790e456956de0$var$LOOM_ONBOARDING_URL_NON_PROD;
};
const $925790e456956de0$export$69576aae579b51af = (env)=>{
    switch(env){
        case 'Production':
            return 'https://home.atlassian.com';
        case 'Staging':
            return 'https://home.stg.atlassian.com';
        case 'Development':
            return 'http://localhost';
        default:
            {
                const _exhaustive = env;
                return _exhaustive;
            }
    }
};
const $925790e456956de0$export$3ed1a38fca957822 = async ({ redirectTo: redirectTo, requestContext: requestContext, messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, orgId: orgId, twcEntitlementId: twcEntitlementId, tenantId: tenantId })=>{
    switch(redirectTo){
        case 'jira':
            return (0, $7f5087a3fe7759b8$export$cf98bfae195146d6)(requestContext, orgId, twcEntitlementId, tenantId, messageInstanceId, messageTemplateId);
        case 'confluence':
            return $925790e456956de0$var$CONFLUENCE_CREATE_WITH_ROVO_URL;
        default:
            {
                const _exhaustive = redirectTo;
                return _exhaustive;
            }
    }
};





var $2QUz2 = parcelRequire("2QUz2");

const $dd0a9f9e7dd1dca6$var$MISSING_APP_EXPERIMENT = 'twcg_missing_app_activation_banner';
const $dd0a9f9e7dd1dca6$export$e7843a8f64a8d87c = (0, $1828eaa171622856$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $jKE9w.noValidation)(),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    }
                })
        },
        hydrate: {
            validate: (0, $2812db53bbf99e54$export$a7a9523472993e97),
            stage: async ({ message: message, request: request })=>{
                const { logger: logger, orchestrationContext: orchestrationContext, statsig: statsig } = request;
                const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, triggerId: triggerId } = message;
                const { cloudId: tenantId } = message.context;
                const { locale: locale } = orchestrationContext;
                const { recommendedApp: recommendedApp, actionTier: actionTier, targetTenantId: targetTenantId, collectionEntitlementId: collectionEntitlementId, orgId: orgId, twcEntitlementId: twcEntitlementId } = message.context;
                if (!tenantId || typeof tenantId !== 'string') {
                    logger.error({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        triggerId: triggerId
                    }, 'Tenant ID not available');
                    request.metrics.counter('twc-sidenav-banner.conf.error.count', {
                        reason: 'tenant-id-not-available'
                    }).incr();
                    throw new Error('Tenant ID not available');
                }
                const armValue = statsig.getExperimentValue({
                    identifiers: {
                        tenantId: tenantId
                    }
                }, {
                    name: $dd0a9f9e7dd1dca6$var$MISSING_APP_EXPERIMENT,
                    parameter: 'arm',
                    defaultValue: 'control'
                });
                const arm = armValue === 'generic' || armValue === 'personalized' ? armValue : 'control';
                const env = request.executionRuntime.getEnvironmentType();
                const homeUrl = ()=>(0, $925790e456956de0$export$69576aae579b51af)(env);
                const resolvedTenantId = typeof targetTenantId === 'string' ? targetTenantId : tenantId;
                const commonReturn = {
                    ...message.context,
                    arm: arm,
                    recommendedApp: recommendedApp,
                    actionTier: actionTier,
                    targetTenantId: targetTenantId,
                    collectionEntitlementId: collectionEntitlementId,
                    messageInstanceId: messageInstanceId,
                    locale: locale
                };
                switch(arm){
                    case 'control':
                        logger.info({
                            messageInstanceId: messageInstanceId,
                            messageTemplateId: messageTemplateId,
                            triggerId: triggerId,
                            arm: arm
                        }, "Control arm \u2014 aborting hydration");
                        request.metrics.counter('twc-sidenav-banner.conf.info.count', {
                            reason: 'control-arm'
                        }).incr();
                        throw new (0, $2QUz2.HydrationAbortError)('Control cohort - abort hydration');
                    case 'generic':
                        {
                            const redirectTo = (0, $9zrom.resolveRedirectTo)(message.context.redirectTo);
                            let onboardingUrl = await (0, $925790e456956de0$export$3ed1a38fca957822)({
                                redirectTo: redirectTo,
                                requestContext: request,
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                orgId: orgId,
                                twcEntitlementId: twcEntitlementId,
                                tenantId: resolvedTenantId
                            });
                            if (!onboardingUrl) {
                                onboardingUrl = homeUrl();
                                logger.info({
                                    messageTemplateId: messageTemplateId,
                                    messageInstanceId: messageInstanceId,
                                    triggerId: triggerId,
                                    arm: arm
                                }, "No onboarding URL found for generic arm \u2014 defaulting to Atlassian Home");
                                request.metrics.counter('twc-sidenav-banner.conf.info.count', {
                                    reason: 'generic-defaulted-to-atlassian-home'
                                }).incr();
                            }
                            request.metrics.counter('twc-sidenav-banner.conf.success.count', {
                                arm: arm
                            }).incr();
                            return {
                                ...commonReturn,
                                redirectTo: redirectTo,
                                onboardingUrl: onboardingUrl
                            };
                        }
                    case 'personalized':
                        {
                            const isLoomPersonalized = recommendedApp === 'loom';
                            const redirectTo = recommendedApp === 'confluence' ? 'confluence' : 'jira';
                            let onboardingUrl;
                            if (isLoomPersonalized) onboardingUrl = (0, $925790e456956de0$export$7abc4e1301ef2c74)(env);
                            else onboardingUrl = await (0, $925790e456956de0$export$3ed1a38fca957822)({
                                redirectTo: redirectTo,
                                requestContext: request,
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                orgId: orgId,
                                twcEntitlementId: twcEntitlementId,
                                tenantId: resolvedTenantId
                            });
                            if (!onboardingUrl) {
                                onboardingUrl = homeUrl();
                                logger.info({
                                    messageTemplateId: messageTemplateId,
                                    messageInstanceId: messageInstanceId,
                                    triggerId: triggerId,
                                    recommendedApp: recommendedApp
                                }, "No onboarding URL found for personalized arm \u2014 defaulting to Atlassian Home");
                                request.metrics.counter('twc-sidenav-banner.conf.info.count', {
                                    reason: 'personalized-defaulted-to-atlassian-home'
                                }).incr();
                            }
                            request.metrics.counter('twc-sidenav-banner.conf.success.count', {
                                arm: arm
                            }).incr();
                            return {
                                ...commonReturn,
                                redirectTo: redirectTo,
                                onboardingUrl: onboardingUrl
                            };
                        }
                }
            }
        }
    }));
const $dd0a9f9e7dd1dca6$export$fa9bb46961aca2cc = (0, $1828eaa171622856$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $2812db53bbf99e54$export$a7a9523472993e97),
        Component: ({ handleOnDismissed: handleOnDismissed, onboardingUrl: onboardingUrl, messageInstanceId: messageInstanceId, locale: locale, arm: arm, redirectTo: redirectTo, recommendedApp: recommendedApp, experimentKey: experimentKey, actionTier: actionTier, targetTenantId: targetTenantId, collectionEntitlementId: collectionEntitlementId })=>{
            const { handleDismiss: handleDismiss } = (0, $ac74b4b866724298$export$f83734c268a0a1ff)({
                onDismissed: handleOnDismissed,
                clickIdentifier: arm === 'personalized' ? 'twc-sidenav-banner-personalized-dismiss' : arm === 'generic' ? 'twc-sidenav-banner-generic-dismiss' : 'twc-sidenav-banner-dismiss'
            });
            if (arm === 'personalized' && recommendedApp && actionTier) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f255002101c7218b$export$44c5a4ad6d35d2bf), {
                locale: locale,
                recommendedApp: recommendedApp,
                onClose: handleDismiss,
                onCtaClick: handleDismiss,
                href: onboardingUrl,
                messageInstanceId: messageInstanceId,
                experimentKey: experimentKey,
                actionTier: actionTier,
                targetTenantId: targetTenantId,
                collectionEntitlementId: collectionEntitlementId,
                surfaceProduct: "confluence"
            });
            if (arm === 'generic') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f70a6a26cf486338$export$a350437cbfeb32d4), {
                locale: locale,
                product: redirectTo,
                onClose: handleDismiss,
                onCtaClick: handleDismiss,
                href: onboardingUrl,
                messageInstanceId: messageInstanceId,
                surfaceProduct: "confluence"
            });
            return null;
        }
    }
});






// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $37af7e2cc9512eda$export$a7a9523472993e97(value) {
    const result = $37af7e2cc9512eda$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $37af7e2cc9512eda$export$226b3eccf92c9ed9(value) {
    const result = $37af7e2cc9512eda$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $37af7e2cc9512eda$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('product' in value)) errors.push({
            path: 'value["product"]',
            expected: '"jira" | "confluence"',
            value: undefined
        });
        else {
            let value__product___valid = false;
            if (!value__product___valid) {
                const value__product___errors_0 = [];
                if (value["product"] !== "jira") value__product___errors_0.push({
                    path: 'value["product"]',
                    expected: "jira",
                    value: value["product"]
                });
                if (value__product___errors_0.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) {
                const value__product___errors_1 = [];
                if (value["product"] !== "confluence") value__product___errors_1.push({
                    path: 'value["product"]',
                    expected: "confluence",
                    value: value["product"]
                });
                if (value__product___errors_1.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) errors.push({
                path: 'value["product"]',
                expected: '"jira" | "confluence"',
                value: value["product"]
            });
        }
        if (!('orgId' in value)) errors.push({
            path: 'value["orgId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["orgId"] !== 'string') errors.push({
            path: 'value["orgId"]',
            expected: 'string',
            value: value["orgId"]
        });
        if (!('cloudId' in value)) errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["cloudId"] !== 'string') errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: value["cloudId"]
        });
        if (!('twcEntitlementId' in value)) errors.push({
            path: 'value["twcEntitlementId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["twcEntitlementId"] !== 'string') errors.push({
            path: 'value["twcEntitlementId"]',
            expected: 'string',
            value: value["twcEntitlementId"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $0abd37ec59656bff$export$e7843a8f64a8d87c = (0, $1828eaa171622856$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $jKE9w.noValidation)(),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    }
                })
        },
        hydrate: {
            validate: (0, $37af7e2cc9512eda$export$a7a9523472993e97),
            stage: async ({ message: message, request: request })=>{
                const { logger: logger, statsig: statsig } = request;
                const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, triggerId: triggerId } = message;
                const { cloudId: tenantId } = message.context;
                if (!tenantId || typeof tenantId !== 'string') {
                    logger.error({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        triggerId: triggerId
                    }, 'Tenant ID not available');
                    throw new Error('Tenant ID not available');
                }
                statsig.getExperimentValue({
                    identifiers: {
                        tenantId: tenantId
                    }
                }, {
                    name: 'twcg-991-jtbd-onboarding-a-a-fo',
                    parameter: 'isEnabled',
                    defaultValue: false
                });
                throw Error('Control cohort - abort hydration');
            }
        }
    }));
const $0abd37ec59656bff$export$fa9bb46961aca2cc = (0, $1828eaa171622856$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $37af7e2cc9512eda$export$a7a9523472993e97),
        Component: ()=>null
    }
});






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $bGVJw = parcelRequire("bGVJw");





























/**
 * Derives environment type from the current hostname (for use in browser).
 * Prod -> admin.atlassian.com; staging/dev/other -> admin.stg.atlassian.com (org path appended when building URLs).
 */ function $b71b4122edb08878$export$469d38ee9e6df4c6(hostname) {
    if (typeof hostname !== 'string') return 'prod';
    const h = hostname.toLowerCase();
    if (h.includes('dev.') || h.includes('.dev')) return 'dev';
    if (h.includes('stg') || h.includes('staging')) return 'staging';
    return 'prod';
}
function $b71b4122edb08878$export$76bb37a926058cca(envType) {
    return envType === 'prod' ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
}
function $b71b4122edb08878$export$1f35d872aef2b7bd(orgId, envType) {
    const base = envType === 'prod' ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
    return `${base}/o/${orgId}/rovo`;
}
function $b71b4122edb08878$export$d3d28c6fd94dcc27(orgId, envType) {
    if (orgId && orgId.trim() !== '') return $b71b4122edb08878$export$1f35d872aef2b7bd(orgId, envType);
    return $b71b4122edb08878$export$76bb37a926058cca(envType);
}





var $55e17c13b3f501ec$exports = {};
$55e17c13b3f501ec$exports = new URL("rovo-icon.999e8c7b.png", import.meta.url).toString();


const $0d8e967d277692e7$export$5b537697406f44db = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($55e17c13b3f501ec$exports))),
        alt: "Rovo",
        width: 32,
        height: 32
    });


const $2f85f798a65797eb$var$i18n = (0, $kSwu1.defineMessages)({
    headingLabel: {
        id: "post-office.confluence-rovo-onboarding-banner.heading",
        defaultMessage: "Rovo is ready for you"
    },
    bodyLabel: {
        id: "post-office.confluence-rovo-onboarding-banner.body",
        defaultMessage: "Power up your workspace. Set up and configure connectors to unlock all Rovo's potential."
    },
    callToActionLabel: {
        id: "post-office.confluence-rovo-onboarding-banner.call.to.action",
        defaultMessage: "Get started"
    },
    whyAmISeeingThisModalMessage: {
        id: "post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.message",
        defaultMessage: "We think setting up Rovo and connecting apps will improve your team's productivity. You're seeing this because Rovo is available to your team, and as an organizational admin you can extend Rovo's features by configuring connectors."
    },
    whyAmISeeingThisModalReason: {
        id: "post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.reason",
        defaultMessage: "Rovo is available to your team and you are an organizational admin"
    }
});
const $2f85f798a65797eb$var$styles = {
    root: "_2rko1mok _kqswh2mm _16jlkb7n _bfhk1s93",
    primaryContentContainer: "_1yt4pxbi _16jlkb7n",
    headingContainer: "_zulpu2gc _1e0c1txw _4cvr1h6o",
    iconContainer: "_1o9zidpf _1bsbzwfg _4t3izwfg",
    ctaWrapper: "_19pk1b66",
    adControlsContainer: "_kqswstnw _154iu2gc _1xi2u2gc"
};
const $2f85f798a65797eb$export$badffec00386b3b8 = ({ action: action, orgId: orgIdFromMessage, onPrimaryActionClick: onPrimaryActionClick, onDismissClick: onDismissClick })=>{
    const postOfficeContext = (0, $bGVJw.usePostOfficeContext)(); // Use orgId from message context first; fallback to product/placement context (e.g. when message payload omits it but event context has it)
    const orgId = orgIdFromMessage ?? (typeof postOfficeContext?.orgId === 'string' ? postOfficeContext.orgId : undefined);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $5jiof.useMessageInstanceEvent)();
    (0, $cozmU.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'ConfluenceRovoOnboardingBanner'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireMessageInstanceClicked = ({ actionType: actionType, clickedElement: clickedElement })=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: actionType
            },
            additionalMetadataFromFrontend: {}
        });
    };
    const rovoAdminUrl = (0, $cozmU.useMemo)(()=>{
        if (!globalThis.location) return '#';
        const envType = (0, $b71b4122edb08878$export$469d38ee9e6df4c6)(globalThis.location.hostname);
        return (0, $b71b4122edb08878$export$d3d28c6fd94dcc27)(orgId, envType);
    }, [
        orgId
    ]);
    const handleOnPrimaryActionClick = ()=>{
        fireMessageInstanceClicked({
            actionType: 'open',
            clickedElement: {
                clickIdentifier: 'getStarted',
                clickedElement: 'button',
                buttonType: 'primary'
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoOnboardingBannerCta'
        });
        onPrimaryActionClick?.(action);
        if (rovoAdminUrl && rovoAdminUrl !== '#' && globalThis.location) globalThis.location.href = rovoAdminUrl;
    };
    const handleOnDismissed = (_dismissedMessageInstanceId)=>{
        onDismissClick?.();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
        data: {
            source: 'confluence-rovo-onboarding-banner'
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.default), {
            xcss: $2f85f798a65797eb$var$styles.root,
            testId: "confluence-rovo-onboarding-banner",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.default), {
                    xcss: $2f85f798a65797eb$var$styles.primaryContentContainer,
                    gap: "space.100",
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.default), {
                            xcss: $2f85f798a65797eb$var$styles.headingContainer,
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                                    xcss: $2f85f798a65797eb$var$styles.iconContainer,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0d8e967d277692e7$export$5b537697406f44db), {})
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                        ...$2f85f798a65797eb$var$i18n.headingLabel
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.default), {
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...$2f85f798a65797eb$var$i18n.bodyLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                            xcss: $2f85f798a65797eb$var$styles.ctaWrapper,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                                href: rovoAdminUrl,
                                onClick: handleOnPrimaryActionClick,
                                spacing: "compact",
                                target: "_self",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...$2f85f798a65797eb$var$i18n.callToActionLabel
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                    xcss: $2f85f798a65797eb$var$styles.adControlsContainer,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c25Cq.AdControls), {
                        iconSize: "small",
                        spacing: "compact",
                        onDismissed: handleOnDismissed,
                        showWhyAmISeeingThis: true,
                        whyAmISeeingThisModalContent: {
                            message: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...$2f85f798a65797eb$var$i18n.whyAmISeeingThisModalMessage
                            }),
                            reasons: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...$2f85f798a65797eb$var$i18n.whyAmISeeingThisModalReason
                                }, "reason")
                            ]
                        }
                    })
                })
            ]
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $a39afc97b428a247$export$a7a9523472993e97(value) {
    const result = $a39afc97b428a247$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $a39afc97b428a247$export$226b3eccf92c9ed9(value) {
    const result = $a39afc97b428a247$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $a39afc97b428a247$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: undefined
        });
        else {
            let value__nextBestActionType___valid = false;
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_0 = [];
                if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_SPACE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_1 = [];
                if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_PAGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_2 = [];
                if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WHITEBOARD",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_3 = [];
                if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                    path: 'value["nextBestActionType"]',
                    expected: "1_ON_1_LOOM_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_4 = [];
                if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                    path: 'value["nextBestActionType"]',
                    expected: "LOOM_AI_MEETING_NOTES",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_5 = [];
                if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                    path: 'value["nextBestActionType"]',
                    expected: "RESURRECTED_USER_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_6 = [];
                if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WITH_ROVO_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_7 = [];
                if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_7.push({
                    path: 'value["nextBestActionType"]',
                    expected: "ROVO_EXTENSION_CTA",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_8 = [];
                if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_8.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CONNECT_3P_TOOLS_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) errors.push({
                path: 'value["nextBestActionType"]',
                expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
                value: value["nextBestActionType"]
            });
        }
        if ('tenantId' in value && value['tenantId'] !== undefined) {
            if (typeof value["tenantId"] !== 'string') errors.push({
                path: 'value["tenantId"]',
                expected: 'string',
                value: value["tenantId"]
            });
        }
        if ('orgId' in value && value['orgId'] !== undefined) {
            if (typeof value["orgId"] !== 'string') errors.push({
                path: 'value["orgId"]',
                expected: 'string',
                value: value["orgId"]
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $47369909a9ad2616$var$PLACEMENT_LABEL = 'Confluence Rovo onboarding banner';
const $47369909a9ad2616$var$MESSAGE_TEMPLATE_ID = 'confluence-rovo-onboarding-banner';
const $47369909a9ad2616$var$hydrateStage = async ({ message: message, request: request })=>{
    request.logger.info({
        messageInstanceId: message.messageInstanceId,
        messageTemplateId: message.messageTemplateId ?? $47369909a9ad2616$var$MESSAGE_TEMPLATE_ID,
        placementLabel: $47369909a9ad2616$var$PLACEMENT_LABEL
    }, 'Rovo onboarding banner hydrated successfully');
    return message.context;
};
const $47369909a9ad2616$export$aa90bc928dfe5f3c = $47369909a9ad2616$var$hydrateStage;
const $47369909a9ad2616$export$e7843a8f64a8d87c = (0, $1828eaa171622856$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $a39afc97b428a247$export$a7a9523472993e97),
            stage: (input)=>{
                const context = input.message.context;
                return {
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    },
                    nextBestAction: context.nextBestActionType
                };
            }
        },
        hydrate: {
            validate: (0, $a39afc97b428a247$export$a7a9523472993e97),
            stage: $47369909a9ad2616$var$hydrateStage
        }
    }));
const $47369909a9ad2616$export$fa9bb46961aca2cc = (0, $1828eaa171622856$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $a39afc97b428a247$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, orgId: orgId, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2f85f798a65797eb$export$badffec00386b3b8), {
                action: nextBestActionType,
                orgId: orgId,
                onPrimaryActionClick: onSideNavClick,
                onDismissClick: handleOnDismissed
            });
        }
    }
});


// integrated-teams/{your-team}/message-templates/{message-template}/src/placements/in-app-v2/{placement-id}/index.tsx










// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $d4f5199df5bbc1c0$export$a7a9523472993e97(value) {
    const result = $d4f5199df5bbc1c0$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $d4f5199df5bbc1c0$export$226b3eccf92c9ed9(value) {
    const result = $d4f5199df5bbc1c0$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $d4f5199df5bbc1c0$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: undefined
        });
        else {
            let value__nextBestActionType___valid = false;
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_0 = [];
                if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_SPACE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_1 = [];
                if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_PAGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_2 = [];
                if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WHITEBOARD",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_3 = [];
                if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                    path: 'value["nextBestActionType"]',
                    expected: "1_ON_1_LOOM_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_4 = [];
                if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                    path: 'value["nextBestActionType"]',
                    expected: "LOOM_AI_MEETING_NOTES",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_5 = [];
                if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                    path: 'value["nextBestActionType"]',
                    expected: "RESURRECTED_USER_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_6 = [];
                if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WITH_ROVO_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_7 = [];
                if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_7.push({
                    path: 'value["nextBestActionType"]',
                    expected: "ROVO_EXTENSION_CTA",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_8 = [];
                if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_8.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CONNECT_3P_TOOLS_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) errors.push({
                path: 'value["nextBestActionType"]',
                expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
                value: value["nextBestActionType"]
            });
        }
        if (!('cohort' in value)) errors.push({
            path: 'value["cohort"]',
            expected: '"single-connect-in-onboarding" | "multi-connect-in-onboarding" | "control"',
            value: undefined
        });
        else {
            let value__cohort___valid = false;
            if (!value__cohort___valid) {
                const value__cohort___errors_0 = [];
                if (value["cohort"] !== "single-connect-in-onboarding") value__cohort___errors_0.push({
                    path: 'value["cohort"]',
                    expected: "single-connect-in-onboarding",
                    value: value["cohort"]
                });
                if (value__cohort___errors_0.length === 0) value__cohort___valid = true;
            }
            if (!value__cohort___valid) {
                const value__cohort___errors_1 = [];
                if (value["cohort"] !== "multi-connect-in-onboarding") value__cohort___errors_1.push({
                    path: 'value["cohort"]',
                    expected: "multi-connect-in-onboarding",
                    value: value["cohort"]
                });
                if (value__cohort___errors_1.length === 0) value__cohort___valid = true;
            }
            if (!value__cohort___valid) {
                const value__cohort___errors_2 = [];
                if (value["cohort"] !== "control") value__cohort___errors_2.push({
                    path: 'value["cohort"]',
                    expected: "control",
                    value: value["cohort"]
                });
                if (value__cohort___errors_2.length === 0) value__cohort___valid = true;
            }
            if (!value__cohort___valid) errors.push({
                path: 'value["cohort"]',
                expected: '"single-connect-in-onboarding" | "multi-connect-in-onboarding" | "control"',
                value: value["cohort"]
            });
        }
        if (!('cloudId' in value)) errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["cloudId"] !== 'string') errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: value["cloudId"]
        });
        if (!('userId' in value)) errors.push({
            path: 'value["userId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["userId"] !== 'string') errors.push({
            path: 'value["userId"]',
            expected: 'string',
            value: value["userId"]
        });
        if (!('unconnectedApps' in value)) errors.push({
            path: 'value["unconnectedApps"]',
            expected: '("google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint")[]',
            value: undefined
        });
        else {
            if (!Array.isArray(value["unconnectedApps"])) errors.push({
                path: 'value["unconnectedApps"]',
                expected: 'array',
                value: value["unconnectedApps"]
            });
            if (Array.isArray(value["unconnectedApps"])) value["unconnectedApps"].forEach((element, index)=>{
                {
                    let element_valid = false;
                    if (!element_valid) {
                        const element_errors_0 = [];
                        if (element !== "google-drive") element_errors_0.push({
                            path: 'element',
                            expected: "google-drive",
                            value: element
                        });
                        if (element_errors_0.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_1 = [];
                        if (element !== "slack") element_errors_1.push({
                            path: 'element',
                            expected: "slack",
                            value: element
                        });
                        if (element_errors_1.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_2 = [];
                        if (element !== "figma") element_errors_2.push({
                            path: 'element',
                            expected: "figma",
                            value: element
                        });
                        if (element_errors_2.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_3 = [];
                        if (element !== "github") element_errors_3.push({
                            path: 'element',
                            expected: "github",
                            value: element
                        });
                        if (element_errors_3.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_4 = [];
                        if (element !== "onedrive") element_errors_4.push({
                            path: 'element',
                            expected: "onedrive",
                            value: element
                        });
                        if (element_errors_4.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_5 = [];
                        if (element !== "sharepoint") element_errors_5.push({
                            path: 'element',
                            expected: "sharepoint",
                            value: element
                        });
                        if (element_errors_5.length === 0) element_valid = true;
                    }
                    if (!element_valid) errors.push({
                        path: 'element',
                        expected: '"google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint"',
                        value: element
                    });
                }
            });
        }
        if (!('topApps' in value)) errors.push({
            path: 'value["topApps"]',
            expected: '("google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint")[]',
            value: undefined
        });
        else {
            if (!Array.isArray(value["topApps"])) errors.push({
                path: 'value["topApps"]',
                expected: 'array',
                value: value["topApps"]
            });
            if (Array.isArray(value["topApps"])) value["topApps"].forEach((element, index)=>{
                {
                    let element_valid = false;
                    if (!element_valid) {
                        const element_errors_0 = [];
                        if (element !== "google-drive") element_errors_0.push({
                            path: 'element',
                            expected: "google-drive",
                            value: element
                        });
                        if (element_errors_0.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_1 = [];
                        if (element !== "slack") element_errors_1.push({
                            path: 'element',
                            expected: "slack",
                            value: element
                        });
                        if (element_errors_1.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_2 = [];
                        if (element !== "figma") element_errors_2.push({
                            path: 'element',
                            expected: "figma",
                            value: element
                        });
                        if (element_errors_2.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_3 = [];
                        if (element !== "github") element_errors_3.push({
                            path: 'element',
                            expected: "github",
                            value: element
                        });
                        if (element_errors_3.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_4 = [];
                        if (element !== "onedrive") element_errors_4.push({
                            path: 'element',
                            expected: "onedrive",
                            value: element
                        });
                        if (element_errors_4.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_5 = [];
                        if (element !== "sharepoint") element_errors_5.push({
                            path: 'element',
                            expected: "sharepoint",
                            value: element
                        });
                        if (element_errors_5.length === 0) element_valid = true;
                    }
                    if (!element_valid) errors.push({
                        path: 'element',
                        expected: '"google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint"',
                        value: element
                    });
                }
            });
        }
        if (!('department' in value)) errors.push({
            path: 'value["department"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["department"] !== 'string') errors.push({
            path: 'value["department"]',
            expected: 'string',
            value: value["department"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 




































var $dZ3U4 = parcelRequire("dZ3U4");


var $fR63l = parcelRequire("fR63l");

var $dAuCI = parcelRequire("dAuCI");


var $8dynS = parcelRequire("8dynS");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $ad7Ou = parcelRequire("ad7Ou");







var $7aRdF = parcelRequire("7aRdF");

var $aRGok = parcelRequire("aRGok");









var $4YcXR = parcelRequire("4YcXR");


var $g9AoR = parcelRequire("g9AoR");


var $f7AuD = parcelRequire("f7AuD");


var $9VQ5f = parcelRequire("9VQ5f");




// split-screen modal experience is based on.
const $0c400621843075ac$var$ACCOUNT_SETUP_MODAL_DESKTOP_HEIGHT = '665px';
const $0c400621843075ac$var$styles = {
    closeButtonContainer: "_kqswstnw _1xi2pxbi _154ipxbi",
    modalBody: "_2rko1kw7 _1reo15vq _18m915vq _1xlokvcq",
    dynamicComponentContainer: "_1reo15vq _18m915vq _4cvr1h6o _bfhk1dy8 _5fbc1kw7 _1ein1kw7 _vchhusvi _1e0c1txw _4t3i1osq _1bah1h6o _n3td1epz _kqswh2mm _1bsb1osq"
};
const $0c400621843075ac$var$i18n = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.title",
        defaultMessage: "Connect your most-used apps"
    },
    modalSubtitle: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.subtitle",
        defaultMessage: "<strong>Bring your team\u2019s work</strong> into Confluence pages with rich, interactive previews \u2013 no tab-switching needed."
    },
    modalTeammatesEmpty: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.teammates.empty",
        defaultMessage: "Teams stay in sync by seeing live updates directly in Confluence."
    },
    modalTeammatesFew: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.teammates.few",
        defaultMessage: "Your team is already using {appName} to work smarter."
    },
    modalTeammatesMany: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.teammates.many",
        defaultMessage: "\uD83D\uDE4C <strong>{numTeammates} teammates</strong> already connected {appName} to Confluence."
    },
    modalTeammatesLots: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.teammates.lots",
        defaultMessage: "\uD83D\uDE4C <strong>50+ teammates</strong> already connected {appName} to Confluence."
    },
    modalClose: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.close",
        defaultMessage: "Close"
    },
    modalDismiss: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $0c400621843075ac$export$2586b970714caf78 = ({ isOpen: isOpen, onClose: onClose, connectorResources: connectorResources, onConnectorConnected: onConnectorConnected, numTeammates: numTeammates, appName: appName, topApps: topApps, department: department })=>{
    const intl = (0, $kSwu1.useIntl)();
    const AnimationSvg = (0, $cozmU.useMemo)(()=>(0, $g9AoR.getAnimationSvg)({
            topApps: topApps,
            department: department
        }), [
        topApps,
        department
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
        children: isOpen && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7aRdF.default), {
            onClose: onClose,
            testId: "confluence-connect-3p-tools-modal",
            width: "x-large",
            label: intl.formatMessage($0c400621843075ac$var$i18n.modalTitle),
            shouldCloseOnOverlayClick: false,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                xcss: $0c400621843075ac$var$styles.modalBody,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f7AuD.SplitScreen), {
                    screen: "confluence-connect-3p-tools-modal",
                    title: intl.formatMessage($0c400621843075ac$var$i18n.modalTitle),
                    subtitle: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...$0c400621843075ac$var$i18n.modalSubtitle,
                        values: {
                            strong: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)("strong", {
                                    children: chunks
                                })
                        }
                    }),
                    isDynamicComponentEdgeToEdge: true,
                    logoVariant: "icon",
                    dynamicComponent: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.default), {
                        xcss: $0c400621843075ac$var$styles.dynamicComponentContainer,
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                                xcss: $0c400621843075ac$var$styles.closeButtonContainer,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                    appearance: "subtle",
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                                    label: intl.formatMessage($0c400621843075ac$var$i18n.modalClose),
                                    onClick: onClose,
                                    spacing: "compact",
                                    testId: "confluence-connect-3p-tools-modal-close-button"
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
                                fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {}),
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)(AnimationSvg, {})
                            })
                        ]
                    }),
                    imageAlt: "",
                    footer: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.default), {
                        justifyContent: "start",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...$0c400621843075ac$var$i18n.modalDismiss
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.default), {
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9VQ5f.ThirdPartyConnectorList), {
                                connectorResources: connectorResources,
                                onConnectorConnected: onConnectorConnected,
                                showIconTile: true,
                                touchpoint: (0, $4YcXR.SMARTLINK_CONNECTION_TOUCHPOINTS).sideNav,
                                screenName: "confluence-connect-3p-tools-modal"
                            }),
                            numTeammates !== undefined && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                                paddingBlockStart: "space.200",
                                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4aRua.default), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    children: [
                                        numTeammates === 0 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...$0c400621843075ac$var$i18n.modalTeammatesEmpty
                                        }),
                                        numTeammates >= 1 && numTeammates <= 20 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...$0c400621843075ac$var$i18n.modalTeammatesFew,
                                            values: {
                                                appName: appName
                                            }
                                        }),
                                        numTeammates >= 21 && numTeammates <= 50 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...$0c400621843075ac$var$i18n.modalTeammatesMany,
                                            values: {
                                                numTeammates: numTeammates,
                                                appName: appName,
                                                strong: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)("strong", {
                                                        children: chunks
                                                    })
                                            }
                                        }),
                                        numTeammates > 50 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...$0c400621843075ac$var$i18n.modalTeammatesLots,
                                            values: {
                                                appName: appName,
                                                strong: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)("strong", {
                                                        children: chunks
                                                    })
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};


const $56a230f6276f4d1e$var$APP_CONFIG = {
    'google-drive': {
        displayName: 'Google Drive',
        productKey: (0, $fR63l.ProductKeys3P).GoogleDrive
    },
    slack: {
        displayName: 'Slack',
        productKey: (0, $fR63l.ProductKeys3P).Slack
    },
    figma: {
        displayName: 'Figma',
        productKey: (0, $fR63l.ProductKeys3P).Figma
    },
    github: {
        displayName: 'GitHub',
        productKey: (0, $fR63l.ProductKeys3P).Github
    },
    onedrive: {
        displayName: 'OneDrive',
        productKey: (0, $fR63l.ProductKeys3P).OneDrive
    },
    sharepoint: {
        displayName: 'SharePoint',
        productKey: (0, $fR63l.ProductKeys3P).Sharepoint
    }
};
const $56a230f6276f4d1e$var$i18n = (0, $kSwu1.defineMessages)({
    headingLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.heading",
        defaultMessage: "See more at a glance"
    },
    multiAppBodyLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.multi-app-body",
        defaultMessage: "Connect your apps to embed rich links in this space."
    },
    singleAppBodyLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.single-app-body",
        defaultMessage: "Connect {appName} to embed rich links in this space."
    },
    callToActionForMultiAppLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.multi-app.call.to.action",
        defaultMessage: "Connect apps"
    },
    callToActionForSingleAppLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.single-app.call.to.action",
        defaultMessage: "Connect {appName}"
    },
    dismissLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $56a230f6276f4d1e$var$styles = {
    root: "_2rko1mok _kqswh2mm _16jlkb7n _bfhk1s93",
    primaryContentContainer: "_1yt4pxbi _16jlkb7n",
    callToActionContainer: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _bfhk1j28 _9oik1r31 _1bnx8stv _jf4cnqa1 _9h8h12zz",
    iconsColumn: "_16jlidpf _1o9zidpf _i0dl1wug _19bvpxbi _ca0qpxbi",
    iconWrapper: "_2rko12b0 _1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg",
    iconWrapperOverlap: "_2rko12b0 _1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _18u0x0bf",
    closeButtonContainer: "_kqswstnw _154iu2gc _1xi2u2gc"
};
// `defaults.ts`. Used only when the component is rendered without
// `unconnectedApps` (Storybook / standalone usage). In production the creator
// always emits a non-empty list, so this default rarely fires.
const $56a230f6276f4d1e$var$FALLBACK_APPS = (0, $8dynS.DEFAULT_FALLBACK_APPS); /**
                                                                                    * Recognised cohort values for the `cc-connect-your-3p-tools-in-onboarding`
                                                                                    * experiment. Any other value (including `undefined`, `''`, `'control'`,
                                                                                    * `'not-enrolled'`, or unknown strings) is treated as a Statsig anomaly and
                                                                                    * suppresses the banner.
                                                                                    */ 
const $56a230f6276f4d1e$var$COHORT_SINGLE = 'single-connect-in-onboarding';
const $56a230f6276f4d1e$var$COHORT_MULTI = 'multi-connect-in-onboarding';
function $56a230f6276f4d1e$var$cohortToLimit(cohort) {
    switch(cohort){
        case $56a230f6276f4d1e$var$COHORT_SINGLE:
            return 1;
        case $56a230f6276f4d1e$var$COHORT_MULTI:
            return 3;
        default:
            return null;
    }
} // Matches the largest cohort limit; one hook call serves every cohort.
const $56a230f6276f4d1e$var$MAX_CONNECTORS = 3;
const $56a230f6276f4d1e$export$6cced77b2ab4e73e = ({ // `action` + `onPrimaryActionClick` are part of the placement contract
// but intentionally unused here (invoking the latter unmounts us via
// `messages.slice(1)` — see `handleOnPrimaryActionClick`).
action: _action, unconnectedApps: unconnectedApps = $56a230f6276f4d1e$var$FALLBACK_APPS, cohort: cohort, cloudId: cloudId, userId: userId, topApps: topApps, department: department, numTeammates: numTeammates, appName: appName, onPrimaryActionClick: _onPrimaryActionClick, onDismissClick: onDismissClick })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $5jiof.useMessageInstanceEvent)();
    const [appIcons, setAppIcons] = (0, $cozmU.useState)(new Map());
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)(); // Suppression check runs against the top-3 (not the cohort slice) so
    // eligibility is identical across single- and multi-connect cohorts.
    const top3RecommendedApps = unconnectedApps.slice(0, $56a230f6276f4d1e$var$MAX_CONNECTORS); // Pin the connector hook to the banner's resolved recommendation so the
    // icons and modal rows can't diverge. Without this, the hook's internal
    // cascade (which has no team-type signal here) may return a different
    // top-3 and the modal silently drops any non-matching apps.
    const productKeysFromBanner = top3RecommendedApps.map((app)=>$56a230f6276f4d1e$var$APP_CONFIG[app].productKey); // `cloudId ?? ''` keeps Storybook working (renders `null` initially).
    const { connectorResources: connectorResources, isLoading: isConnectorLoading, onConnectorConnected: onConnectorConnected } = (0, $dZ3U4.use3pConnectorResources)({
        cloudId: cloudId ?? '',
        userId: userId,
        // In Confluence session-data, `userId` is the Atlassian Account ID —
        // the same value the outbound-auth gateway expects.
        aaId: userId,
        maxConnectors: $56a230f6276f4d1e$var$MAX_CONNECTORS,
        productKeys: productKeysFromBanner
    });
    const connectedProductKeys = new Set(connectorResources.filter((r)=>r.isAuthenticated).map((r)=>r.productKey));
    const hasAnyRecommendedAppConnected = top3RecommendedApps.some((app)=>connectedProductKeys.has($56a230f6276f4d1e$var$APP_CONFIG[app].productKey));
    const cohortLimit = $56a230f6276f4d1e$var$cohortToLimit(cohort);
    const appsToRender = cohortLimit !== null ? unconnectedApps.slice(0, cohortLimit) : []; // Gates `messageInstanceViewed` so exposure fires only for eligible
    // mounts. Omits `isModalOpen` on purpose — the viewed event should
    // fire once per fresh mount, not re-fire when the modal closes.
    const willRender = cohortLimit !== null && !isConnectorLoading && !hasAnyRecommendedAppConnected && unconnectedApps.length >= cohortLimit;
    const hasFiredViewedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!willRender || hasFiredViewedRef.current) return;
        hasFiredViewedRef.current = true;
        if (messageInstanceViewed) messageInstanceViewed({
            ...cohort !== undefined && {
                cohort: cohort
            }
        });
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'ConfluenceConnect3pToolsSideNavNudge'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally only re-runs when `willRender` flips
    }, [
        willRender
    ]); // Load icons from ThirdPartyConfigs on mount / when unconnectedApps changes
    (0, $cozmU.useEffect)(()=>{
        let cancelled = false;
        const loadIcons = async ()=>{
            const iconMap = new Map();
            for (const app of appsToRender){
                const config = await (0, $dAuCI.ThirdPartyConfigs).get($56a230f6276f4d1e$var$APP_CONFIG[app].productKey);
                if (config && !cancelled) iconMap.set(app, config.icon);
            }
            if (!cancelled) setAppIcons(iconMap);
        };
        loadIcons();
        return ()=>{
            cancelled = true;
        }; // eslint-disable-next-line react-hooks/exhaustive-deps -- appsToRender identity is derived; we want to re-run only when its membership changes
    }, [
        appsToRender.join(',')
    ]);
    const fireMessageInstanceClicked = ({ actionType: actionType, clickedElement: clickedElement })=>messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: actionType
            },
            additionalMetadataFromFrontend: {
                ...cohort !== undefined && {
                    cohort: cohort
                }
            }
        });
    const handleOnPrimaryActionClick = ()=>{
        fireMessageInstanceClicked({
            actionType: 'open',
            clickedElement: {
                clickIdentifier: 'showMeHow',
                clickedElement: 'button',
                buttonType: 'primary'
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connect3pToolsSideNavNudgeCta'
        }); // NOTE: do not call `onPrimaryActionClick?.(action)` here. The
        // `confluence-side-nav` placement reacts to it by slicing this
        // message out of its `messages` state (see `placement-v2/src/
        // confluence-side-nav/index.tsx` → `handleOnSideNavClick`), which
        // unmounts this component before React can flush the
        // `setIsModalOpen(true)` update — so the modal never renders.
        // The placement notification is instead deferred to
        // `handleOnModalClose`, which fires `onDismissClick?.()` once the
        // user has actually finished with the modal.
        setIsModalOpen(true);
    };
    const handleOnConnectorConnected = (productKey)=>{
        fireMessageInstanceClicked({
            actionType: 'dismiss',
            clickedElement: {
                clickIdentifier: 'connectAppDismiss',
                clickedElement: 'button',
                buttonType: 'primary'
            }
        }).catch(()=>{});
        onConnectorConnected?.(productKey);
    }; // Shared dismiss: fires the TAP trait update, then unmounts via the placement callback.
    const dismissBanner = (clickedElement)=>{
        // Fire-and-forget: the client buffers the event and flushes it on a
        // window-level timer, so it survives this component unmounting.
        fireMessageInstanceClicked({
            actionType: 'dismiss',
            clickedElement: clickedElement
        }).catch(()=>{});
        onDismissClick?.();
    };
    const handleOnModalClose = ()=>{
        setIsModalOpen(false);
        dismissBanner({
            clickIdentifier: 'modalClose',
            clickedElement: 'button',
            buttonType: 'secondary'
        });
    };
    const handleOnDismissClick = ()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connect3pToolsSideNavNudgeDismiss'
        });
        dismissBanner({
            clickIdentifier: 'dismiss',
            clickedElement: 'cross-icon'
        });
    }; // Invalid cohort always suppresses, even mid-modal — a flipped cohort
    // would otherwise render a banner/modal with no apps.
    if (cohortLimit === null) return null;
     // Other guards are skipped while the modal is open so an in-flight
    // OAuth success doesn't unmount before the user sees it.
    if (!isModalOpen && (isConnectorLoading || hasAnyRecommendedAppConnected || unconnectedApps.length < cohortLimit)) return null;
    const isSingleApp = appsToRender.length === 1;
    const bodyMessage = isSingleApp ? $56a230f6276f4d1e$var$i18n.singleAppBodyLabel : $56a230f6276f4d1e$var$i18n.multiAppBodyLabel;
    const ctaMessage = isSingleApp ? $56a230f6276f4d1e$var$i18n.callToActionForSingleAppLabel : $56a230f6276f4d1e$var$i18n.callToActionForMultiAppLabel;
    const firstApp = appsToRender[0];
    const messageValues = isSingleApp && firstApp ? {
        appName: $56a230f6276f4d1e$var$APP_CONFIG[firstApp].displayName
    } : undefined;
    const modalConnectorResources = appsToRender.flatMap((app)=>{
        const productKey = $56a230f6276f4d1e$var$APP_CONFIG[app].productKey;
        const connectorResource = connectorResources.find((resource)=>resource.productKey === productKey);
        return connectorResource ? [
            connectorResource
        ] : [];
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $gBjHb.default), {
        data: {
            source: 'confluence-connect-3p-tools-nudge'
        },
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.default), {
                xcss: $56a230f6276f4d1e$var$styles.root,
                testId: "confluence-connect-3p-tools-nudge",
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.default), {
                        xcss: $56a230f6276f4d1e$var$styles.iconsColumn,
                        alignItems: "start",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.default), {
                            direction: "row",
                            alignItems: "center",
                            children: appsToRender.map((app, index)=>{
                                const Icon = appIcons.get(app);
                                if (!Icon) return null;
                                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                                    xcss: index === 0 ? $56a230f6276f4d1e$var$styles.iconWrapper : $56a230f6276f4d1e$var$styles.iconWrapperOverlap,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                                        label: "",
                                        size: "small"
                                    })
                                }, app);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.default), {
                        xcss: $56a230f6276f4d1e$var$styles.primaryContentContainer,
                        gap: "space.100",
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...$56a230f6276f4d1e$var$i18n.headingLabel
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...bodyMessage,
                                    values: messageValues
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.default), {
                                    xcss: $56a230f6276f4d1e$var$styles.callToActionContainer,
                                    onClick: handleOnPrimaryActionClick,
                                    testId: "connect-3p-tools-cta-button",
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.default), {
                                        color: "color.link",
                                        size: "medium",
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                            ...ctaMessage,
                                            values: messageValues
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
                        xcss: $56a230f6276f4d1e$var$styles.closeButtonContainer,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            icon: (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                                    ...props,
                                    size: "small"
                                }),
                            label: intl.formatMessage($56a230f6276f4d1e$var$i18n.dismissLabel),
                            isTooltipDisabled: false,
                            onClick: handleOnDismissClick
                        })
                    })
                ]
            }),
            numTeammates !== undefined && appName !== undefined ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0c400621843075ac$export$2586b970714caf78), {
                isOpen: isModalOpen,
                onClose: handleOnModalClose,
                connectorResources: modalConnectorResources,
                onConnectorConnected: handleOnConnectorConnected,
                numTeammates: numTeammates,
                appName: appName,
                topApps: topApps,
                department: department
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0c400621843075ac$export$2586b970714caf78), {
                isOpen: isModalOpen,
                onClose: handleOnModalClose,
                connectorResources: modalConnectorResources,
                onConnectorConnected: handleOnConnectorConnected,
                topApps: topApps,
                department: department
            })
        ]
    });
};





const $883a7fdce72ca7ce$var$ANIMATION_APPS = new Set((0, $g9AoR.ANIMATION_APP_KEYS));
const $883a7fdce72ca7ce$var$DEPARTMENTS = new Set((0, $g9AoR.DEPARTMENT_KEYS));
const $883a7fdce72ca7ce$export$e7843a8f64a8d87c = (0, $1828eaa171622856$export$d90b37843c84d1c3).createMessageBackend((0, $8ajDi.defaultMessageBackend));
const $883a7fdce72ca7ce$export$fa9bb46961aca2cc = (0, $1828eaa171622856$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $d4f5199df5bbc1c0$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, cohort: cohort, cloudId: cloudId, userId: userId, unconnectedApps: unconnectedApps, topApps: topApps, department: department, onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
            const narrowedTopApps = (0, $cozmU.useMemo)(()=>topApps.filter((app)=>$883a7fdce72ca7ce$var$ANIMATION_APPS.has(app)), [
                topApps
            ]);
            const narrowedDepartment = (0, $cozmU.useMemo)(()=>$883a7fdce72ca7ce$var$DEPARTMENTS.has(department) ? department : undefined, [
                department
            ]);
            // `unconnectedApps` is populated server-side by the implicit-message-creator
            // via a 3-tier cascade (team-type TAP trait → site-wide TAP trait → hardcoded
            // defaults). On total creator failure the message is suppressed entirely
            // (see implicit-message/index.ts outer catch), so this prop is always
            // non-empty in production.
            // `cloudId` and `userId` are required and used by Connect3pTools to call
            // `use3pConnectorResources` and suppress the nudge when the user is
            // already connected to enough of the recommended apps.
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $56a230f6276f4d1e$export$6cced77b2ab4e73e), {
                action: nextBestActionType,
                cohort: cohort,
                cloudId: cloudId,
                userId: userId,
                unconnectedApps: unconnectedApps,
                topApps: narrowedTopApps,
                department: narrowedDepartment,
                onPrimaryActionClick: onSideNavClick,
                onDismissClick: handleOnDismissed
            });
        }
    }
});










// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $7cb6923b7a90e03a$export$a7a9523472993e97(value) {
    const result = $7cb6923b7a90e03a$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $c2h0x.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $7cb6923b7a90e03a$export$226b3eccf92c9ed9(value) {
    const result = $7cb6923b7a90e03a$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $7cb6923b7a90e03a$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"ROVO_NON_MAU_CHAT_CTA"',
            value: undefined
        });
        else if (value["nextBestActionType"] !== "ROVO_NON_MAU_CHAT_CTA") errors.push({
            path: 'value["nextBestActionType"]',
            expected: "ROVO_NON_MAU_CHAT_CTA",
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


/* NonMauChatCtaMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $bltJZ = parcelRequire("bltJZ");













var $hdBxM = parcelRequire("hdBxM");













// https://switcheroo.atlassian.com/ui/gates/1e5123de-54d1-4f51-a02c-5bf53fc51402/key/rovo_chat_non_mau_cta_filter
// TAP trait-backed audience filter: is_rovo_enabled_for_tenant = true AND is_rovo_mau = false
const $a796a9658d77cbdd$export$9750bdf09969306d = 'rovo_chat_non_mau_cta_filter';
const $a796a9658d77cbdd$export$61c32d2af201fe88 = 'rovo_chat_non_mau_jira_confluence_cta_lifecycle';
const $a796a9658d77cbdd$export$da1c2aa533e7bd85 = 'rovo_chat_non_mau_jira_confluence_cta';
const $a796a9658d77cbdd$export$5ea3e58faa15e6d6 = 'rovo_chat_non_mau_jira_confluence_cta_treatment';
var $a796a9658d77cbdd$export$954a10199d623266 = /*#__PURE__*/ function(NonMauChatCtaCohort) {
    NonMauChatCtaCohort["CONTROL"] = "control";
    NonMauChatCtaCohort["V1"] = "v1";
    return NonMauChatCtaCohort;
}({});





const $d8a0eae0d87911a2$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ctaLinkText: {
        id: "rovo-non-mau-chat-cta-jira-confluence-left-nav.cta-link-text",
        defaultMessage: "Try Rovo now"
    },
    chatPrompt: {
        id: "rovo-non-mau-chat-cta-jira-confluence-left-nav.chat-prompt",
        defaultMessage: "Hi Rovo, list three things you can do right now for me based on my recent work"
    },
    whyAmISeeingThisReason1: {
        id: "rovo-non-mau-chat-cta-jira-confluence-left-nav.why-am-i-seeing-this.reason-1",
        defaultMessage: "your existing Atlassian products"
    },
    whyAmISeeingThisReason2: {
        id: "rovo-non-mau-chat-cta-jira-confluence-left-nav.why-am-i-seeing-this.reason-2",
        defaultMessage: "your organization having AI enabled"
    },
    heading: {
        id: "rovo-non-mau-chat-cta-jira-confluence-left-nav.heading.v1",
        defaultMessage: "Unlock your AI teammate"
    },
    description: {
        id: "rovo-non-mau-chat-cta-jira-confluence-left-nav.description.v1",
        defaultMessage: "Rovo connects your tools and knowledge so work gets done for you."
    }
});


const $0400440c0111cf4b$var$styles = {
    boxContainer: "_zulpu2gc _2rko1mok _ae4v1h6o _1bah1h6o _1e0c1txw _1bsb1osq _ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi _4cvr1y6m _bfhk19ip",
    contentStack: "_zulpu2gc _1bsb1osq",
    headerRow: "_1bah1yb4 _4cvr1h6o _1bsb1osq",
    ctaLink: "_1yt4ze3t _2rkolb4i _11c8wadc _4bfu1r31 _1hmsglyw _ajmmnqa1 _bfhksm61 _syaz13af _80omtlke _y3gn1e5h _9oik1r31 _1bnx8stv _jf4cnqa1 _9h8h12zz"
};
const $0400440c0111cf4b$var$ACTION_SUBJECT = 'rovoNonMauChatCta';
const $0400440c0111cf4b$export$e6a613b0fe78a30b = ({ context: context, handleOnDismissed: handleOnDismissed })=>{
    const { source: source } = context; // Exposure is already logged in the placements.
    // We call getExperimentValue here only to read the cohort for event metadata.
    const experimentCohort = (0, $cXtTj.default).getExperimentValue((0, $a796a9658d77cbdd$export$da1c2aa533e7bd85), (0, $a796a9658d77cbdd$export$5ea3e58faa15e6d6), (0, $a796a9658d77cbdd$export$954a10199d623266).V1, {
        fireExperimentExposure: false
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { messageClicked: messageClicked } = (0, $baFbJ.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $5jiof.useMessageInstanceEvent)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const chatEventPublish = (0, $hdBxM.usePublish)('ai-mate');
    (0, $cozmU.useEffect)(()=>{
        if (experimentCohort === (0, $a796a9658d77cbdd$export$954a10199d623266).CONTROL) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: $0400440c0111cf4b$var$ACTION_SUBJECT,
            attributes: {
                variant: experimentCohort,
                source: source
            }
        });
    }, [
        fireAnalyticsEvent,
        experimentCohort,
        source
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'dismissed',
            actionSubject: $0400440c0111cf4b$var$ACTION_SUBJECT,
            attributes: {
                variant: experimentCohort,
                source: source
            }
        });
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: source
            }
        });
        handleOnDismissed();
    }, [
        fireAnalyticsEvent,
        experimentCohort,
        source,
        messageClicked,
        messageInstanceClicked,
        handleOnDismissed
    ]);
    const handleCtaClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: $0400440c0111cf4b$var$ACTION_SUBJECT,
            attributes: {
                variant: experimentCohort,
                source: source
            }
        });
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'openRovoChat',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: source
            }
        });
        chatEventPublish({
            type: 'chat-new',
            source: 'rovoNonMauChatCta',
            data: {
                prompt: formatMessage((0, $d8a0eae0d87911a2$export$defe85febe8b728c).chatPrompt),
                dialogues: []
            }
        });
    }, [
        fireAnalyticsEvent,
        experimentCohort,
        source,
        messageClicked,
        messageInstanceClicked,
        chatEventPublish
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($0400440c0111cf4b$var$styles.boxContainer),
        testId: "rovo-non-mau-chat-cta",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.default), {
            xcss: (0, $w6R6I.cx)($0400440c0111cf4b$var$styles.contentStack),
            testId: "rovo-non-mau-chat-cta-content",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.default), {
                    xcss: (0, $w6R6I.cx)($0400440c0111cf4b$var$styles.headerRow),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bltJZ.RovoIcon), {
                            appearance: "brand",
                            size: "xsmall",
                            shouldUseHexLogo: true
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c25Cq.AdControls), {
                            showWhyAmISeeingThis: true,
                            whyAmISeeingThisModalContent: {
                                reasons: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                        ...(0, $d8a0eae0d87911a2$export$defe85febe8b728c).whyAmISeeingThisReason1
                                    }, "reason-1"),
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                        ...(0, $d8a0eae0d87911a2$export$defe85febe8b728c).whyAmISeeingThisReason2
                                    }, "reason-2")
                                ]
                            },
                            onDismissed: handleDismiss,
                            spacing: "compact"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                    size: "xsmall",
                    children: formatMessage((0, $d8a0eae0d87911a2$export$defe85febe8b728c).heading)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.default), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: formatMessage((0, $d8a0eae0d87911a2$export$defe85febe8b728c).description)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.default), {
                    onClick: handleCtaClick,
                    testId: "rovo-non-mau-chat-cta-link",
                    xcss: (0, $w6R6I.cx)($0400440c0111cf4b$var$styles.ctaLink),
                    children: formatMessage((0, $d8a0eae0d87911a2$export$defe85febe8b728c).ctaLinkText)
                })
            ]
        })
    });
};


const $4f052bcb77eb04d4$export$e7843a8f64a8d87c = (0, $1828eaa171622856$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $7cb6923b7a90e03a$export$a7a9523472993e97),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: (0, $6ecfff7fdeb1e5f7$export$7af8db49468f6ca0),
                            targetProduct: [
                                (0, $6ecfff7fdeb1e5f7$export$fe6a238b700ff48b)
                            ],
                            edition: [
                                (0, $6ecfff7fdeb1e5f7$export$de3613be25133e67)
                            ]
                        }
                    }
                })
        }
    }));
const $4f052bcb77eb04d4$export$fa9bb46961aca2cc = (0, $1828eaa171622856$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $jKE9w.noValidation)(),
        Component: ({ handleOnDismissed: handleOnDismissed })=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0400440c0111cf4b$export$e6a613b0fe78a30b), {
                handleOnDismissed: handleOnDismissed,
                context: {
                    source: 'confluence-side-nav'
                }
            });
        }
    }
});



const $fdf1f7cbd6d468a0$var$messageFrontends = [
    (0, $93005c5f407ff82c$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-create-a-space'
    }),
    (0, $3da87d263c14bca7$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-side-nav-create-a-space'
    }),
    (0, $ced9d9073f1b94b1$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-side-nav-1-on-1-loom-nudge'
    }),
    (0, $f19d0509615c2efa$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-resurrected-user-welcome-sidebar-nudge'
    }),
    (0, $a45ff7782c210ce6$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-create-with-rovo-side-nav-nudge'
    }),
    (0, $5e23b76fbc0262f2$export$fa9bb46961aca2cc)({
        messageTemplateId: 'rovo-extension-install-cta-left-nav'
    }),
    (0, $dd0a9f9e7dd1dca6$export$fa9bb46961aca2cc)({
        messageTemplateId: 'twc-sidenav-banner'
    }),
    (0, $0abd37ec59656bff$export$fa9bb46961aca2cc)({
        messageTemplateId: 'twc-sidenav-a-a-banner'
    }),
    (0, $47369909a9ad2616$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-rovo-onboarding-banner'
    }),
    (0, $883a7fdce72ca7ce$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-3p-tools-nudge-banner'
    }),
    (0, $4f052bcb77eb04d4$export$fa9bb46961aca2cc)({
        messageTemplateId: 'rovo-non-mau-chat-cta-jira-confluence-left-nav'
    })
];
const $fdf1f7cbd6d468a0$export$af2bcbdc04a2d456 = (0, $1828eaa171622856$export$55486c2b6964dcf2).createPlacementFrontendComponent({
    messageTemplates: $fdf1f7cbd6d468a0$var$messageFrontends
});



var $9oJIg = parcelRequire("9oJIg");

var $MyxIQ = parcelRequire("MyxIQ");


var $bZSO8 = parcelRequire("bZSO8");


var $bAyaS = parcelRequire("bAyaS");


var $luv00 = parcelRequire("luv00");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $eB1TF = parcelRequire("eB1TF");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $45373df583cce1d3$var$PO_CONFLUENCE_SIDE_NAV = 'poConfluenceSideNavCreate';
const $45373df583cce1d3$export$f78bffe31fffa115 = /*#__PURE__*/ (0, $cozmU.memo)(()=>{
    const [preloadedInitialData, setInitialData] = (0, $MyxIQ.usePlacementPreloadedData)('confluence-side-nav');
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { openDrawer: openDrawer } = (0, $bAyaS.useCreateSpaceStoreActions)();
    const sideNavRef = (0, $cozmU.useRef)(null);
    const currentRoute = (0, $dPJCf.useRouteUrl)({
        selector: (routeUrl)=>routeUrl || ''
    });
    const { setIsOpen: setIsUniversalCreateOpen } = (0, $eB1TF.useUniversalCreateActions)();
    const onDismiss = (0, $cozmU.useCallback)((data)=>{
        setInitialData(data);
    }, [
        setInitialData
    ]);
    const onSideNavClick = (0, $cozmU.useCallback)((nextBestActionType, data)=>{
        setInitialData(data);
        switch(nextBestActionType){
            case 'CREATE_PAGE':
                push((0, $bZSO8.buildCreationLink)({
                    contentType: 'page',
                    source: $45373df583cce1d3$var$PO_CONFLUENCE_SIDE_NAV
                }));
                break;
            case 'CREATE_WHITEBOARD':
                push((0, $bZSO8.buildCreationLink)({
                    contentType: 'whiteboard',
                    source: $45373df583cce1d3$var$PO_CONFLUENCE_SIDE_NAV
                }));
                break;
            case 'CREATE_SPACE':
                // The second argument for openDrawer is the location string, which can be undefined or 'topCreateNav'
                // Since we're using the side nav to open the drawer, undefined is passed here.
                openDrawer(sideNavRef, undefined);
                break;
            case 'CREATE_WITH_ROVO_NUDGE':
                setIsUniversalCreateOpen(true);
                (0, $17wUi.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).AIFC_CREATE_SPOTLIGHT_SESSION_KEY, 'true');
                break;
            case 'RESURRECTED_USER_NUDGE':
                push((0, $1NBp8.HOME).toUrl(undefined, {
                    query: {
                        feedType: 'POPULAR'
                    }
                }));
                break;
            default:
                return;
        }
    }, [
        openDrawer,
        push,
        setInitialData,
        setIsUniversalCreateOpen
    ]);
    const memoizedPlacementProps = (0, $cozmU.useMemo)(()=>({
            preloadedInitialData: preloadedInitialData,
            onDismiss: onDismiss,
            onSideNavClick: onSideNavClick,
            currentRoute: currentRoute,
            disableInitialData: Boolean(preloadedInitialData)
        }), [
        preloadedInitialData,
        onDismiss,
        onSideNavClick,
        currentRoute
    ]);
    /**
   * This is memoized to avoid any fetch calls getting cancelled inside `ConfluenceSideNav` due to
   * rerenders from changing context values (.ie usePostOfficeSideNavMessages).
   */ const PlacementInternals = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9oJIg.PlacementFetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fdf1f7cbd6d468a0$export$af2bcbdc04a2d456), memoizedPlacementProps)), [
        memoizedPlacementProps
    ]);
    if (!(0, $9wGTI.fg)('post-office-connie-side-nav-v4')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    if ((0, $9wGTI.fg)('post-office-confluence-side-nav-placement-rollout')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "confluence-side-nav-placement",
        "data-vc": "confluence-side-nav-placement",
        ...ssrPlaceholderIdProp
    }, PlacementInternals);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
});
module.exports["PostOfficeConfluenceSideNavPlacement"] = $45373df583cce1d3$export$f78bffe31fffa115;

});

parcelRegister("92JEG", function(module, exports) {

var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $d66becf3e4056778$export$8bcdb86a7ad5ef4b = ()=>{
    const { data: data } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED)
    ]);
    const { isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed } = (0, $ivb8S.deserializeState)(data);
    return {
        isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed
    };
};
module.exports["useHasDismissedNav4CollapseReminderSpotlight"] = $d66becf3e4056778$export$8bcdb86a7ad5ef4b;

});

parcelRegister("c2h0x", function(module, exports) {
"use strict";
var $8c32dd4b29124a64$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8c32dd4b29124a64$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8c32dd4b29124a64$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8c32dd4b29124a64$var$__exportStar((parcelRequire("kB4yd")), module.exports);

$8c32dd4b29124a64$var$__exportStar((parcelRequire("aePf0")), module.exports);

});

parcelRegister("9zrom", function(module, exports) {
const $d8b6dcfe7d7e8f9a$var$DEFAULT_REDIRECT_TO = 'jira';
function $d8b6dcfe7d7e8f9a$export$ef12ca92ab4cd865(value) {
    if (value === 'jira' || value === 'confluence') return value;
    return $d8b6dcfe7d7e8f9a$var$DEFAULT_REDIRECT_TO;
}
module.exports["resolveRedirectTo"] = $d8b6dcfe7d7e8f9a$export$ef12ca92ab4cd865;

});


//# sourceMappingURL=PageLayout.08bfb3bc.js.map
